import debounce$1 from 'lodash-es/debounce';
import identity from 'lodash-es/identity';
import noop from 'lodash-es/noop';
import { debounce as debounce$2, shuffle } from 'lodash-es';
import React__default, { Component, createElement, PureComponent, isValidElement, Children, cloneElement, useEffect } from 'react';
import { toastr } from 'react-redux-toastr';
import { Button, Collapse, ButtonDropdown, DropdownMenu, ModalBody, ModalFooter, ButtonToolbar, Form, Label, Col, UncontrolledTooltip, FormGroup, Row, Input, Alert, Badge, InputGroupAddon, UncontrolledDropdown, DropdownToggle, DropdownItem, ListGroup, ListGroupItem, PaginationItem, PaginationLink, Pagination, Dropdown, InputGroup, ModalHeader, Modal, NavbarBrand, Navbar, NavbarToggler, Nav, CardBody, Card, CardHeader } from 'reactstrap';
import { SubmissionError, Field, reduxForm, getFormValues, startSubmit, stopSubmit, getFormMeta, getFormInitialValues, autofill, change, formValueSelector } from 'redux-form';
import getProperty from 'lodash-es/get';
import setProperty from 'lodash-es/set';
import PropTypes__default, { string } from 'prop-types';
import classNames from 'classnames';
import { connect } from 'react-redux';
import NumberFormat from 'react-number-format';
import Autosuggest from 'react-autosuggest';
import IsolatedScroll from 'react-isolated-scroll';
import AdresaApi from 'mc/lib/api/gen/adresy/v1/AdresaApi';
import { K } from 'mc/lib/api/gen/adresy/v1/TypAdresy';
import ReactDOM from 'react-dom';
import scrollIntoView from 'dom-scroll-into-view';
import getValue from 'redux-form/lib/events/getValue';
import SpisovaSluzbaApi from 'mc/lib/api/gen/spisovaSluzba/v1/SpisovaSluzbaApi';
import OrganizacniJednotkaApi from 'mc/lib/api/gen/organizace/v1/OrganizacniJednotkaApi';
import ObjektApi from 'mc/lib/api/gen/objekty/v1/ObjektApi';
import PracovnikApi from 'mc/lib/api/gen/organizace/v1/PracovnikApi';
import PravniFormaApi from 'mc/lib/api/gen/subjekty/v1/PravniFormaApi';
import InfiniteScrollExternal from 'react-infinite-scroller';
import TypDokumentApi from 'mc/lib/api/gen/dokumenty/v1/TypDokumentApi';
import { Localization, DatePicker } from 'react-widgets';
import { DateLocalizer } from 'react-widgets/IntlLocalizer';
import ObalkaApi from 'mc/lib/api/gen/obalky/v1/ObalkaApi';
import AutofillApi from 'mc/lib/api/gen/uzn/AutofillApi';
import { bindActionCreators } from 'redux';
import MarbesAuthApi from 'mc/lib/api/gen/reactcore/MarbesAuthApi';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter, Switch, Route, Redirect } from 'react-router';
import { LegacyMapioApi } from '@mc/react-mapio';
import { NO, FOP, PO, FO } from 'mc/lib/api/gen/subjekty/v1/TypSubjektu';
import { CHYBA, ZTOTOZNEN, POZASTAVEN, NEZTOTOZNEN } from 'mc/lib/api/gen/subjekty/v1/StavZtotozneniZr';
import { ID as ID$1, P, OSTATNI, IR, VS, PS, RP } from 'mc/lib/api/gen/subjekty/v1/TypDokladu';
import KontaktOvereniApi from 'mc/lib/api/gen/subjekty/v1/KontaktOvereniApi';
import { DS } from 'mc/lib/api/gen/subjekty/v1/TypKontaktu';
import { getCaption } from 'mc/lib/api/gen/dokumenty/v1/StavSpisu';
import AutosizeInput from 'react-input-autosize';
import { VariableSizeList } from 'react-window';
import PdfViewerApi from 'mc/lib/api/gen/pdfviewer/PdfViewerApi';
import { Waypoint } from 'react-waypoint';
import { Page } from 'react-pdf';
import printJS from 'print-js';
import { Document } from 'react-pdf/dist/esm/entry.webpack';
import { ApiErrorIntent } from '@mc/axios-api';
import MomentLocalizer from 'react-widgets-moment';
import moment from 'moment';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

var cs = {
  'global.form.action.ok': 'OK',
  'global.form.action.store': 'Uložit',
  'global.form.action.yes': 'Ano',
  'global.form.action.create': 'Založit',
  'global.form.action.close': 'Zavřít',
  'global.form.action.cancel': 'Storno',
  'global.form.title.error.required': 'Pole je povinné',
  'global.form.title.contains.required.fields': 'Položky označené * jsou povinné',
  'global.json.error.unknown': 'Chyba',
  'global.json.error.500': 'Chyba',
  'global.json.error.404': 'Požadovaný objekt nebyl nalezen',
  'global.days.today': 'dnes',
  'global.days.short.mon': 'po',
  'global.days.short.tue': 'út',
  'global.days.short.wed': 'st',
  'global.days.short.thu': 'čt',
  'global.days.short.fri': 'pá',
  'global.days.short.sat': 'so',
  'global.days.short.sun': 'ne',
  'adresa.form.title.ulice': 'Ulice',
  'adresa.form.title.cisloOrientacni': 'Č. orientační',
  'adresa.form.title.cisloOrientacniPismeno': 'Písmeno čísla orientačního',
  'adresa.form.title.castObce': 'Část obce',
  'adresa.form.title.cisloDomovni': 'Č. domovní',
  'adresa.form.title.cisloDomovniZnak': 'Znak čísla domovního',
  'adresa.form.title.mestCast': 'Městská část',
  'adresa.form.title.obec': 'Obec',
  'adresa.form.title.psc': 'PSČ',
  'adresa.form.title.posta': 'Doručovací pošta',
  'adresa.form.title.okres': 'Okres',
  'adresa.form.title.kraj': 'Kraj',
  'adresa.form.title.stat': 'Stát',
  'adresa.form.title.nazevMop': 'Městský obvod Praha',
  'adresa.form.title.nazevKatastralniUzemi': 'Katastrální území',
  'adresa.form.title.overenaAdresa': 'Ověření',
  'adresa.form.title.overenaAdresa.overeno': 'Ověřeno',
  'adresa.form.title.overenaAdresa.overeno.tooltip': 'Adresa je ověřená oproti registru',
  'adresa.form.title.overenaAdresa.neovereno': 'Neověřeno',
  'adresa.form.title.overenaAdresa.neovereno.tooltip': 'Adresa není ověřená oproti registru',
  'adresa.form.title': 'Adresa',
  'adresa.form.action.ztotozniAdresu.title.neztotozneno': 'Adresu se nepodařilo podle zadaných údajů ověřit, doplňte nebo upravte údaje o adrese',
  'adresa.form.action.ztotozniAdresu': 'Ověřit',
  'adresa.form.action.ztotozniAdresu.tooltip': 'Ověřit adresu oproti registru',
  'adresa.form.validation.noCr.obec.required': 'V případě adresy mimo ČR je položka obec povinná.',
  'adresa.form.validation.cr.obec.required': 'V případě adresy v ČR je položka obec povinná.',
  'adresa.form.validation.cr.common.required': 'V případě adresy v ČR musí být vyplněno číslo domovní nebo ulice a číslo orientační.',
  'subjekt.form.title.subjektDokladIdentif': 'Č. OP',
  'subjekt.form.title.titulPred': 'Titul před',
  'subjekt.form.title.jmeno': 'Jméno',
  'subjekt.form.title.prijmeni': 'Příjmení',
  'subjekt.form.title.titulZa': 'Titul za',
  'subjekt.form.title.datumNarozeni': 'Datum narození',
  'subjekt.form.title.adresaTrvpobytSidlo': 'Adresa',
  'subjekt.form.title.kontaktVychTelefon': 'Telefon',
  'subjekt.form.title.kontaktVychEmail': 'Email',
  'subjekt.form.title.kontaktVychDs': 'Datová schránka',
  'subjekt.form.title.kontaktVychOsoba': 'Kontaktní osoba',
  'subjekt.form.title.nazev': 'Název',
  'subjekt.form.title.ico': 'IČO',
  'subjekt.form.title.cisPravniForma': 'Právní forma',
  'subjekt.form.title.overit.none': 'Nebyl nalezen žádný záznam',
  'subjekt.form.title.overit.none.description': 'Dle zadaných vstupních podmínek nebyl nalezen žádný záznam. Zkontrolujte zadané údaje a akci případně zopakujte.',
  'subjekt.form.title.overit.many': 'Bylo nalezeno více záznamů',
  'subjekt.form.title.overit.many.description': 'Proveďte upřesnění zadání a akci opakujte.',
  'subjekt.form.action.overit': 'Ověřit',
  'subjekt.form.action.overit.tooltip': 'Ověřit oproti registru',
  'subjekt.typSubjekt.FO': 'Fyzická osoba',
  'subjekt.typSubjekt.PO': 'Právnická osoba',
  'subjekt.typSubjekt.FOP': 'Podnikající fyzická osoba',
  'dateTimePicker.calendarButton': 'Vybrat datum',
  'dateTimePicker.timeButton': 'Vybrat čas',
  'dateTimePicker.moveBack': 'Předchozí',
  'dateTimePicker.moveForward': 'Další',
  'dateTimePicker.moveToday': 'Dnes'
};

var messages = /*#__PURE__*/_extends({}, cs, typeof window !== 'undefined' && window.messages ? window.messages : {});

if (typeof window !== 'undefined') {
  window.messages = messages;
}

function format(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return format.replace(/{(\d+)}/g, function (match, number) {
    return typeof args[number] != 'undefined' ? args[number] : match;
  });
}

function getForKey(key, resolveNullAsText) {
  for (var _len2 = arguments.length, params = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    params[_key2 - 2] = arguments[_key2];
  }

  if (key[0] == '^') {
    key = key.substring(1, key.length);
    var text = messages[key];
    return text != null ? format.apply(void 0, [text].concat(params)) : null;
  } else {
    var text = messages[key];

    if (!text && key.indexOf('[') > 0) {
      // pokus o odebr8ní všech polí, např. [3] a sestavení klíče bez nich (form.title.seznamKvalifikaci[0].umysl -> form.title.seznamKvalifikaci.umysl)
      while (true) {
        var i1 = key.indexOf('[');
        var i2 = key.indexOf(']');

        if (i1 >= 0 && i2 > 0 && i1 < i2) {
          key = key.substring(0, i1) + key.substring(i2 + 1);
        } else {
          break;
        }
      }

      if (key) {
        text = messages[key];
      }
    }

    if (resolveNullAsText) {
      return text != null ? format.apply(void 0, [text].concat(params)) : '[' + key + ']';
    } else {
      return text != null ? format.apply(void 0, [text].concat(params)) : null;
    }
  }
}

function i18n(key) {
  if (key) {
    for (var _len3 = arguments.length, params = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      params[_key3 - 1] = arguments[_key3];
    }

    // Key může být buď string nebo pole, pokud je pole, testují se postupně všechny klíče až se na nějaký narazí
    if (Array.isArray(key)) {
      // pole
      if (key.length === 0) {
        // nejsou definovány žádné klíče
        console.error('Resource text keys cannot be empty.');
        return null;
      }

      for (var a = 0; a < key.length; a++) {
        var oneKey = key[a];
        var text = getForKey(oneKey, false, params);

        if (text !== null) {
          // máme platný klíč
          return text;
        }
      } // Nenašli jsme platný klíč, vrátíme první jako nepřeložený text


      console.warn('Resource text for keys', key, 'not found.');
      return getForKey(key[0], true, params);
    } else {
      return getForKey(key, true, params);
    }
  } else {
    return '<null>';
  }
}

var END_OF_DAY = /*#__PURE__*/new Date(0, 0, 0, 23, 59, 59, 999);
var MS_PER_DAY = 1000 * 60 * 60 * 24;
var DAYS = ['sun', 'mon', 'tue', 'wed', 'thu', 'fri', 'sat'];
/**
 * Převod Obejct:Date do řetězce včetně času
 * @param date {Date} datum a čas
 * @return {String} datum
 */

var dateToDateTimeString = formatDateTime; // Alias pro zpětnou kompatibilitu

/**
 * Převod datumu do řetězce - v budoucnu při více locale nahradit metodou pracující s locale.
 * @param date {Date} datum
 * @return {String} datum
 */

var dateToDateString = formatDate; // Alias pro zpětnou kompatibilitu

/**
 * Převod Obejct:Date do řetězce obsahující čas
 * @param date {Date} datum a čas
 * @return {String} čas
 */

var dateToTimeString = formatTime; // Alias pro zpětnou kompatibilitu

/**
 * Naformátuje datum a čas na uživatelsky čitelný řetězec.
 *
 * @param {Date|string} [date] - instance Date nebo řetězec v ISO formátu obsahující datum a čas
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.useDayNames=false] - pro nejbližších 7 dní vrátí jednu z konstant 'dnes', 'po', 'út', ..., 'ne'
 * @param {boolean} [options.includeYear=true] - vrátí rok jako součást výsledného řetězce
 * @param {boolean} [options.includeSeconds=false] - vrátí sekundy jako součást výsledného řetězce
 * @return {String} naformátované datum nebo null pro null vstup
 */

function formatDateTime(dateTime, options) {
  if (!dateTime) {
    return null;
  }

  return formatDate(dateTime, options) + ' ' + formatTime(dateTime, options);
}
/**
 * Naformátuje datum na uživatelsky čitelný řetězec.
 *
 * @param {Date|string} [date] - instance Date nebo řetězec v ISO formátu obsahující datum
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.useDayNames=false] - pro nejbližších 7 dní vrátí jednu z konstant 'dnes', 'po', 'út', ..., 'ne'
 * @param {boolean} [options.includeYear=true] - vrátí rok jako součást výsledného řetězce
 * @param {boolean} [options.shortFormat=true] - vrací zkrácený formát čísel (např. 5. 3. 2017)
 * @return {String} naformátované datum nebo null pro null vstup
 */

function formatDate(date, options) {
  if (options === void 0) {
    options = {};
  }

  if (!date) {
    return null;
  }

  if (typeof date === 'string') {
    date = localUTCToDate(date);
  }

  var _options = options,
      _options$useDayNames = _options.useDayNames,
      useDayNames = _options$useDayNames === void 0 ? false : _options$useDayNames;

  if (useDayNames) {
    var dayDiff = dateDiffInDays(new Date(), date);

    if (dayDiff === 0) {
      return i18n('global.days.today');
    }

    if (dayDiff > 0 && dayDiff < 7) {
      return i18n('global.days.short.' + DAYS[date.getDay()]);
    }
  }

  var _options2 = options,
      _options2$shortFormat = _options2.shortFormat,
      shortFormat = _options2$shortFormat === void 0 ? true : _options2$shortFormat;
  var result;

  if (shortFormat) {
    result = date.getDate() + '. ' + (date.getMonth() + 1) + '.';
  } else {
    result = _dtpad(date.getDate()) + '.' + _dtpad(date.getMonth() + 1) + '.';
  }

  var _options3 = options,
      _options3$includeYear = _options3.includeYear,
      includeYear = _options3$includeYear === void 0 ? true : _options3$includeYear;

  if (includeYear) {
    if (shortFormat) {
      result += ' ';
    }

    result += date.getFullYear();
  }

  return result;
}
/**
 * Naformátuje čas na uživatelsky čitelný řetězec.
 *
 * @param {Date|string} [date] - instance Date nebo řetězec v ISO formátu obsahující čas
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.includeSeconds=false] - vrátí sekundy jako součást výsledného řetězce
 * @return {String} naformátovaný čas nebo null pro null vstup
 */

function formatTime(time, options) {
  if (options === void 0) {
    options = {};
  }

  if (!time) {
    return null;
  }

  if (typeof time === 'string') {
    time = localUTCToTime(time);
  }

  var result = time.getHours() + ':' + _dtpad(time.getMinutes());

  var _options4 = options,
      _options4$includeSeco = _options4.includeSeconds,
      includeSeconds = _options4$includeSeco === void 0 ? false : _options4$includeSeco;

  if (includeSeconds) {
    result += ':' + _dtpad(time.getSeconds());
  }

  return result;
}

function dateDiffInDays(a, b) {
  var utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
  var utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());
  return Math.floor((utc2 - utc1) / MS_PER_DAY);
}

function _dtpad(number, length) {
  if (length === void 0) {
    length = 2;
  }

  var r = String(number);

  while (r.length < length) {
    r = '0' + r;
  }

  return r;
}
/**
 * Převede datum na lokální datum v UTC.
 * @param date
 * @return {*}
 */


function dateToLocalUTC(date) {
  if (!date) {
    return date;
  }

  return _dtpad(date.getFullYear(), 4) + '-' + _dtpad(date.getMonth() + 1) + '-' + _dtpad(date.getDate()) + 'T' + '00' + ':' + '00' + ':' + '00' + '.' + '000';
}
/**
 * Převede datum a čas na lokální datum a čas v UTC.
 * @param date
 * @return {*}
 */

function dateTimeToLocalUTC(date) {
  if (!date) {
    return date;
  }

  return _dtpad(date.getFullYear(), 4) + '-' + _dtpad(date.getMonth() + 1) + '-' + _dtpad(date.getDate()) + 'T' + _dtpad(date.getHours()) + ':' + _dtpad(date.getMinutes()) + ':' + _dtpad(date.getSeconds()) + '.' + _dtpad(date.getMilliseconds());
}
/**
 * Převede čas na lokální čas v UTC.
 * @param date
 * @return {*}
 */

function timeToLocalUTC(date) {
  if (!date) {
    return date;
  }

  return _dtpad(date.getHours()) + ':' + _dtpad(date.getMinutes()) + ':' + _dtpad(date.getSeconds()) + '.' + _dtpad(date.getMilliseconds());
} // NECHAT - pro testování !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
// var x = new Date();
// console.log("@@@", x)
//
// console.log("@@@ DATE")
// var l = dateToLocalUTC(x);
// console.log("dateToLocalUTC", l);
// console.log("localUTCToDate", localUTCToDate(l));
// console.log("dateToLocalUTC", dateToLocalUTC(localUTCToDate(l)));
//
// console.log("@@@ DATE TIME")
// var m = dateTimeToLocalUTC(x);
// console.log("dateTimeToLocalUTC", m);
// console.log("localUTCToDateTime", localUTCToDateTime(m));
// console.log("dateTimeToLocalUTC", dateTimeToLocalUTC(localUTCToDateTime(m)));

/**
 * Převede utc zápis braný jako local date do Date instance javascriptu BEZ času.
 * @param str
 */

function localUTCToDate(str) {
  return localUTCToDateTime(str);
}
/**
 * Převede utc zápis braný jako local date time do Date instance javascriptu VČETNĚ času.
 * @param str
 */

function localUTCToDateTime(str) {
  if (!str) {
    return null;
  }

  if (str instanceof Date) {
    return str;
  }

  var dt = str.split(/[: T-]/).map(parseFloat);
  var seconds = dt[5] ? Math.floor(dt[5]) : 0;
  var milliseconds = dt[5] ? (dt[5] - seconds) * 1000 : 0;
  var result = new Date(dt[0], dt[1] - 1, dt[2], dt[3] || 0, dt[4] || 0, seconds, milliseconds);
  return result;
}
/**
 * Převede utc zápis braný jako local time do Date instance javascriptu.
 * @param str
 */

function localUTCToTime(str) {
  if (!str) {
    return null;
  }

  if (str instanceof Date) {
    return str;
  }

  if (str.indexOf('T') >= 0 || str.indexOf('-') >= 0) {
    // Vstup: datum nebo datum+cas
    var res = localUTCToDateTime(str);

    if (res instanceof Date) {
      res.setFullYear(0);
      res.setMonth(0);
      res.setDate(1);
    }

    return res;
  }

  if (str.indexOf(':') >= 0) {
    // Vstup: cas (bez data)
    var dt = str.split(/[:-]/).map(parseFloat);
    var seconds = dt[2] ? Math.floor(dt[2]) : 0;
    var milliseconds = dt[2] ? (dt[2] - seconds) * 1000 : 0;
    var result = new Date(0, 0, 1, dt[0], dt[1], seconds, milliseconds);
    return result;
  }

  return null;
}
/**
 * Zkombinuje datum a čas do jedné hodnoty.
 * @param {Date} [date] - datum
 * @param {Date} [time] - čas
 * @returns {Date} - datum a čas
 */

function combineDateTime(date, time) {
  if (!date || !time) {
    return date || time || null;
  }

  return new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes(), time.getSeconds(), time.getMilliseconds());
}
/**
 * Odstraní datum z datumu a času.
 * @param {Date} [dateTime] - datum a čas
 * @returns {Date} čas
 */

function removeDate(dateTime) {
  if (!dateTime) {
    return null;
  }

  return new Date(0, 0, 1, dateTime.getHours(), dateTime.getMinutes(), dateTime.getSeconds(), dateTime.getMilliseconds());
}
/**
 * Odstraní čas z datumu a času.
 * @param {Date} [dateTime] - datum a čas
 * @returns {Date} datum
 */

function removeTime(dateTime) {
  if (!dateTime) {
    return null;
  }

  return new Date(dateTime.getFullYear(), dateTime.getMonth(), dateTime.getDate(), 0, 0, 0, 0);
}
/**
 * Normalizace čísla - pouze povolené celé číslo
 * @param number string
 **/

function normalizeInt(number) {
  var pole = '' + number;
  var output = '';

  for (var i = 0, len = pole.length; i < len; i++) {
    if (i === 0 && pole[i] === '-' || pole[i] === '0' || parseInt(pole[i])) {
      output += pole[i];
    }
  }

  return output;
}
/**
 * Normalizace telefonního čísla - pouze povolené celé číslo a +
 * @param number string
 **/

function normalizePhone(number) {
  if (!number) {
    return number;
  }

  var pole = '' + number;
  var output = '';

  for (var i = 0, len = pole.length; i < len; i++) {
    if (i === 0 && pole[i] === '+' || pole[i] === '0' || parseInt(pole[i])) {
      output += pole[i];
    }
  }

  return output;
}
/**
 * Normalizace textu na delku výchozí 255 znaků
 * @param text String
 * @param allowedLength int
 **/

function normalizeString(text, allowedLength) {
  if (allowedLength === void 0) {
    allowedLength = 255;
  }

  if (text.length > allowedLength) {
    text = text.substr(0, allowedLength);
  }

  return text;
}
/**
 * Provede normalizaci hodnoty tak, aby byla čitelná pro uživatele, tedy naformátuje v jeho locales.
 * @param value hodnota
 * @return {*} hodnota pro uživatele
 */
// TODO [stanekpa] - vyřešit locales!!!

function normalizeDoubleForUser(value) {
  if (value) {
    if (typeof value === 'string') {
      return value.replace(/\./g, ',');
    } else {
      return '' + value;
    }
  } else {
    return value;
  }
}
/**
 * Normalizace čísla - lze pouze číslice a nahrazení ',' za '.' kdy náhodou - (přes string rychlejší než ukládat do pole)
 * @param number decimal(18,6)
 **/

function normalizeDouble(number) {
  var pole = '' + number;
  var output = '';
  var existComa = false;

  for (var i = 0, len = pole.length; i < len; i++) {
    if (i === 0 && pole[i] === '-' || parseInt(pole[i]) || pole[i] === '0' || (pole[i] == ',' || pole[i] == '.') && !existComa && (existComa = true)) {
      output += pole[i] == ',' ? '.' : pole[i];
    }
  }

  return output;
}
/**
 * High-order funkce, sloužící pro obalení handleru komponent.
 * Výsledná funkce zajistí vyvolání preventDefault() a stopPropagation() nad vstupním event.
 *
 * Tzn. namísto:
 *
 * <button onClick={e => { this.handleEvent(e); e.preventDefault(); e.stopPropagation(); }>Test</button>
 *
 * píšeme
 *
 * <button onClick={sinkEvent(this.handleEvent)}>Test</button>
 *
 * @param callback
 * @returns výsledná callback
 */

function sinkEvent(callback) {
  return function (event) {
    if (callback) {
      callback(event);
    }

    event.preventDefault();
    event.stopPropagation();
  };
}
/**
 * Naformátuje částku.
 * Částka je standardně zaokrouhlena na 2 desetinná místa.
 *
 * @param {number} [value] - hodnota čásky
 * @param {object} [options] - dodatečné parametry
 * @param {boolean} [options.includeZeroDecimalPart=false] - zda mít ve výsledku desetinnou část, pokud obsahuje pouze samé nuly
 * @param {boolean} [options.includeCurrencySymbol=true] - zda k výsledku připojit znak měny
 * @return {string} naformátované částka nebo null pro null vstup
 */

function formatCurrency(value, options) {
  if (options === void 0) {
    options = {};
  }

  if (value == null) {
    return value;
  }

  if (typeof value !== 'number') {
    throw new Error('Vstupem formatCurrency musí být číslo');
  }

  value = Math.round(100 * value) / 100; // Zaokrouhlení na 2 pevná desetinná místa

  value = value.toFixed(2); // Zobrazení na 2 desetinná místa s oddělovačem

  value = value.replace(/\d(?=(\d{3})+\.)/g, '$& '); // Oddělovač tisíců

  var _options5 = options,
      _options5$includeZero = _options5.includeZeroDecimalPart,
      includeZeroDecimalPart = _options5$includeZero === void 0 ? false : _options5$includeZero;

  if (!includeZeroDecimalPart) {
    value = value.replace(/\.0+$/g, ''); // Nuly za desetinným oddělovačem nezobrazujeme
  }

  value = value.replace('.', ','); // Desettiný oddělovač

  var _options6 = options,
      _options6$includeCurr = _options6.includeCurrencySymbol,
      includeCurrencySymbol = _options6$includeCurr === void 0 ? true : _options6$includeCurr;

  if (includeCurrencySymbol) {
    value += ' Kč';
  }

  return value;
}

var commons = {
  __proto__: null,
  END_OF_DAY: END_OF_DAY,
  dateToDateTimeString: dateToDateTimeString,
  dateToDateString: dateToDateString,
  dateToTimeString: dateToTimeString,
  formatDateTime: formatDateTime,
  formatDate: formatDate,
  formatTime: formatTime,
  dateToLocalUTC: dateToLocalUTC,
  dateTimeToLocalUTC: dateTimeToLocalUTC,
  timeToLocalUTC: timeToLocalUTC,
  localUTCToDate: localUTCToDate,
  localUTCToDateTime: localUTCToDateTime,
  localUTCToTime: localUTCToTime,
  combineDateTime: combineDateTime,
  removeDate: removeDate,
  removeTime: removeTime,
  normalizeInt: normalizeInt,
  normalizePhone: normalizePhone,
  normalizeString: normalizeString,
  normalizeDoubleForUser: normalizeDoubleForUser,
  normalizeDouble: normalizeDouble,
  sinkEvent: sinkEvent,
  formatCurrency: formatCurrency
};

function apiErrorsTransform(errors) {
  var result = {};

  for (var index in errors) {
    if (errors.hasOwnProperty(index)) {
      var error = errors[index];
      var attrs = error.field.split('.');
      var obj = result;

      for (var a = 0; a < attrs.length; a++) {
        var attr = attrs[a];

        if (a + 1 == attrs.length) {
          // poslední
          if (obj[attr]) {
            if (typeof obj[attr] === 'string') {
              obj[attr] = [obj[attr], error.message];
            } else if (Array.isArray(obj[attr])) {
              obj[attr] = [].concat(obj[attr], [error.message]);
            }
          } else {
            obj[attr] = error.message;
          }
        } else {
          if (!obj[attr]) {
            obj[attr] = {};
          }

          obj = obj[attr];
        }
      }
    }
  }

  return result;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

/**
 * Výčet možných stavů načítání jedné položky.
 *
 * @enum {string}
 */

var LoadState = {
  LOADING: 'LOADING',
  LOADED: 'LOADED',
  ERROR: 'ERROR',
  CANCELED: 'CANCELED'
};

var getItemData = function getItemData(item) {
  return item.data;
};
/**
 * Utilita pro asynchronní načítání dle dle příslušného klíče.
 * - Načtená data jsou dle klíče interně cachována.
 * - Umí notifikovat o změně průběhu načítání.
 * - Umí vracet načtená data a stav průběhu načítání.
 */


var CachingLoader = /*#__PURE__*/function () {
  /**
   * Konstruktor.
   *
   * @param {function} itemLoader - callback pro synchronní či asynchronní načtení dat jedné položky dle jejího klíče
   * @param {Object} [options] - volitelné parametry
   * @param {function} [options.resultDataExtractor] - callback pro získání dat položky z výsledku jejího načtení
   * @param {function} [options.onLoadStateChange] - callback volaný při změně stavu načítání položek
   * @param {number} [options.loadDelay] - spoždění načítání (debounce)
   */
  function CachingLoader(itemLoader, options) {
    if (options === void 0) {
      options = {};
    }

    this.items = new Map();
    this.itemLoader = itemLoader;
    this.resultDataExtractor = options.resultDataExtractor || identity;
    this.onLoadStateChange = options.onLoadStateChange || noop;
    var _options = options,
        loadDelay = _options.loadDelay;

    if (loadDelay != null) {
      this.loadItems = debounce$1(this.loadItems.bind(this), loadDelay);
    }
  }
  /**
   * Spustí načítání položek s příslušnými klíči.
   * - Průběh načítání každé položky je uložen dle klíče do interní cache
   * - Pro položky nalezené dle klíče v cache se použije existující stav načítání.
   * - Z cache jsou odstraněny položky, na jejichž klíče se nedotazujeme.
   *
   * @param {Array<*>} keys - pole klíčů položek
   * @param {Object} [options] - volitelé parametry
   * @param {boolean} [options.reloadErrors=false] -  příznak, zda vynutit opětovné načtení položek v cache,
   *                                                  u nichž skončilo přechozí načítání chybou
   */


  var _proto = CachingLoader.prototype;

  _proto.loadItems = function loadItems(keys, options) {
    if (options === void 0) {
      options = {};
    }

    var _options2 = options,
        _options2$reloadError = _options2.reloadErrors,
        reloadErrors = _options2$reloadError === void 0 ? false : _options2$reloadError;
    var loadStateChanged = false; // Odstraníme nepotřebné položky z cache

    for (var _iterator = _createForOfIteratorHelperLoose(this.items.keys()), _step; !(_step = _iterator()).done;) {
      var key = _step.value;

      if (keys.indexOf(key) <= 0) {
        this._deleteItem(key);

        loadStateChanged = true;
      }
    } // Přidáme nové položky do cache


    for (var _iterator2 = _createForOfIteratorHelperLoose(keys), _step2; !(_step2 = _iterator2()).done;) {
      var _key = _step2.value;

      if (!this.items.has(_key)) {
        this.items.set(_key, {});
      }
    } // Spustíme načítání u některých položek


    for (var _iterator3 = _createForOfIteratorHelperLoose(this.items), _step3; !(_step3 = _iterator3()).done;) {
      var _step3$value = _step3.value,
          _key2 = _step3$value[0],
          item = _step3$value[1];
      var state = item.state;

      if (state == null || reloadErrors && state === LoadState.ERROR) {
        this._loadItem(_key2, item);

        loadStateChanged = true;
      }
    }

    if (loadStateChanged) {
      this.onLoadStateChange();
    }
  }
  /**
   * Spustí načítání jedné položky.
   *
   * @param {*} key - klíč položky
   * @param {Object} item - záznam položky
   * @private
   */
  ;

  _proto._loadItem = function _loadItem(key, item) {
    var _this = this;

    item.state = LoadState.LOADING;

    try {
      Promise.resolve(this.itemLoader(key)).then(function (result) {
        return _this._onItemLoadSuccess(item, result);
      })["catch"](function (error) {
        return _this._onItemLoadError(item, error);
      });
    } catch (error) {
      this._onItemLoadError(item, error);
    }
  }
  /**
   * Callback volaný při úspěšném načtení položky.
   *
   * @param {*} item - záznam položky
   * @param {*} result - výsledek načtení
   * @private
   */
  ;

  _proto._onItemLoadSuccess = function _onItemLoadSuccess(item, result) {
    if (item.state === LoadState.CANCELED) {
      return;
    }

    try {
      item.state = LoadState.LOADED;
      item.data = this.resultDataExtractor(result);
    } catch (error) {
      item.state = LoadState.ERROR;
      item.error = error;
    }

    this.onLoadStateChange();
  }
  /**
   * Callback volaný při chybě načtení položky.
   *
   * @param {*} item - záznam položky
   * @param {*} error - chyba načtení
   * @private
   */
  ;

  _proto._onItemLoadError = function _onItemLoadError(item, error) {
    if (item.state === LoadState.CANCELED) {
      return;
    }

    item.state = LoadState.ERROR;
    item.error = error;
    this.onLoadStateChange();
  }
  /**
   * Smaže záznam položky z cache.
   *
   * @param {*} key - klíč položky
   * @private
   */
  ;

  _proto._deleteItem = function _deleteItem(key) {
    var item = this.items.get(key);

    if (item) {
      item.state = LoadState.CANCELED;
      this.items["delete"](key);
    }
  }
  /**
   * Otestuje, zda právě probíhá načítání.
   *
   * @returns {boolean} true, pokud se načítá alespoň jedna položka, jinak false
   */
  ;

  _proto.isLoading = function isLoading() {
    return this._existItemsWithState(LoadState.LOADING);
  }
  /**
   * Vrátí iterátor, který projde data načtených položek.
   *
   * @returns {IterableIterator<*>} iterátor
   */
  ;

  _proto.getLoadedData = function getLoadedData() {
    return this._getItemsWithState(LoadState.LOADED, getItemData);
  }
  /**
   * Otestuje, zda exsituje alespoň jedna položka v daném stavu.
   *
   * @param {LoadState} state - stav načítání
   * @returns {boolean} true, pokud existuje alespoň jedna položka v daném stavu, jinak false
   * @private
   */
  ;

  _proto._existItemsWithState = function _existItemsWithState(state) {
    return !this._getItemsWithState(state).next().done;
  }
  /**
   * Vrátí iterátor nad položkami v daném stavu.
   *
   * @param {LoadState} state - stav načítání
   * @param {function} mapFunction - mapovací funkce pro každou z položek
   * @returns {IterableIterator<*>} iterátor
   * @private
   */
  ;

  _proto._getItemsWithState =
  /*#__PURE__*/
  runtime_1.mark(function _getItemsWithState(state, mapFunction) {
    var _iterator4, _step4, item;

    return runtime_1.wrap(function _getItemsWithState$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (mapFunction === void 0) {
              mapFunction = identity;
            }

            _iterator4 = _createForOfIteratorHelperLoose(this.items.values());

          case 2:
            if ((_step4 = _iterator4()).done) {
              _context.next = 9;
              break;
            }

            item = _step4.value;

            if (!(item.state === state)) {
              _context.next = 7;
              break;
            }

            _context.next = 7;
            return mapFunction(item);

          case 7:
            _context.next = 2;
            break;

          case 9:
          case "end":
            return _context.stop();
        }
      }
    }, _getItemsWithState, this);
  });
  return CachingLoader;
}();

/**
 * Pomocný objekt pro odesílání focus/blur událostí ze složeného formulářového pole.
 */

var CompositeFocusBlur = /*#__PURE__*/function () {
  /**
   * Konstruktor.
   *
   * @param {object} target - nadřazená react komponenta, která má v props callback onFocus a onBlur
   * @param {object} [options] - extra parametry
   * @param {number} [options.delay=100] - prodleva (v ms) před vyvoláním onFocus/onBlur nadřazené komponenty
   */
  function CompositeFocusBlur(target, options) {
    var _this = this;

    if (options === void 0) {
      options = {};
    }

    /**
     * Handlery, které se předají polím nadřazené komponenty.
     */
    this.handlers = {
      onFocus: function onFocus() {
        _this.counter++;

        _this.checkLater();
      },
      onBlur: function onBlur() {
        _this.counter--;

        _this.checkLater();
      }
    };
    var _options = options,
        _options$delay = _options.delay,
        delay = _options$delay === void 0 ? 100 : _options$delay;
    this.target = target;
    this.counter = 0;
    this.prevCounter = 0;
    this.checkLater = debounce$2(function () {
      return _this.check();
    }, delay);
  }

  var _proto = CompositeFocusBlur.prototype;

  _proto.check = function check() {
    var counter = this.counter;

    if (counter !== this.prevCounter) {
      this.prevCounter = counter;

      if (counter > 0) {
        this.target.props.onFocus();
      } else {
        this.target.props.onBlur();
      }
    }
  };

  return CompositeFocusBlur;
}();

function defaultImport(module) {
  if (module.__esModule && module["default"]) {
    return module["default"];
  } else {
    return module;
  }
}

var ToastrMoreInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ToastrMoreInfo, _Component);

  function ToastrMoreInfo(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.handleToggle = function () {
      var isOpen = _this.state.isOpen;

      _this.setState({
        isOpen: !isOpen
      });
    };

    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = ToastrMoreInfo.prototype;

  _proto.render = function render() {
    var isOpen = this.state.isOpen;
    return React__default.createElement("div", {
      className: "show-more"
    }, !isOpen && React__default.createElement(Button, {
      color: "link",
      onClick: this.handleToggle
    }, "Zobrazit podrobnosti"), React__default.createElement(Collapse, {
      isOpen: isOpen
    }, this.props.children));
  };

  return ToastrMoreInfo;
}(Component);

var process200 = function process200(e, resolve, reject) {
  //const contentType = e.headers.get('Content-Type'); TODO json a text a další při správných datech
  //const contentLength = e.headers.get('Content-Length');
  //if (contentType && contentType.indexOf('application/json') === 0) {} else if (contentLength && contentLength == 0) {}
  var contentType = e.headers.get('content-type');
  e.text().then(function (text) {
    if (contentType && contentType.toLowerCase().indexOf('application/json') >= 0) {
      if (text && text.length > 0) {
        try {
          var json = JSON.parse(text);
          resolve(json);
        } catch (err) {
          console.error('err #1', e.url, err, e);
          reject(err);
        }
      } else {
        resolve(null);
      }
    } else {
      resolve(text);
    }
  })["catch"](function (err) {
    console.error('err #1', e.url, err, e);
    reject(e);
  });
};

function showErrorMessage(errorTypeText, message) {
  if (message && message.length > 0) {
    toastr.error(errorTypeText, message, {
      timeOut: 100000
    });
  } else {
    toastr.error(errorTypeText, null, {
      timeOut: 100000
    });
  }
}

var knownProps = {
  message: null,
  id: 'Id záznamu',
  kod: 'Kód záznamu',
  code: 'Kód záznamu',
  typ: 'Typ záznamu',
  type: 'Typ záznamu',
  systemMessage: 'Systémová chyba'
};
/** Seznam proměnných, které budou implicitně zavbalené. */

var hiddenProps = {
  systemMessage: true
};

function getLabel(key) {
  var label;

  if (typeof knownProps[key] === 'undefined') {
    label = key;
  } else {
    label = knownProps[key];
  }

  return label;
}

function showAbstractExceptionMessage(ex) {
  var label = ex.message;
  var toastrProps = {};
  var altMessages = []; // dopňující zpráva

  var showMoreDetails;

  if (Object.keys(ex.properties).length > 0) {
    // Doplňující informace
    var messageDetails = []; // další doplňující informace
    // Základní doplňující informace

    Object.keys(ex.properties).forEach(function (key) {
      var usekey = key[0] === '#' ? key.substring(1) : key;

      if (key[0] === '#' || typeof knownProps[usekey] !== 'undefined') {
        // zobrazíme ji prioritně uživateli
        if (typeof knownProps[usekey] !== 'undefined' && !knownProps[usekey]) {
          // nemá label
          var add = hiddenProps[usekey] ? messageDetails : altMessages;
          add.push(React__default.createElement("div", null, ex.properties[key]));
        } else {
          var _add = hiddenProps[usekey] ? messageDetails : altMessages;

          _add.push(React__default.createElement("dl", {
            className: "row"
          }, React__default.createElement("dt", {
            className: "col-12"
          }, getLabel(usekey), ":"), React__default.createElement("dd", {
            className: "col-12"
          }, ex.properties[key])));
        }
      } else {
        // doplňující hláška, zobrazíme na rozbalení
        var _add2 = hiddenProps[usekey] ? messageDetails : altMessages;

        _add2.push(React__default.createElement("dl", {
          className: "row"
        }, React__default.createElement("dt", {
          className: "col-12"
        }, getLabel(usekey), ":"), React__default.createElement("dd", {
          className: "col-12"
        }, ex.properties[key])));
      }
    }); // Object.keys(knownProps).forEach(key => {
    //     if (typeof ex.properties[key] !== 'undefined') {    // známá hláška, zobrazíme přednostně uživateli
    //         if (!knownProps[key]) { // nemá label, půjde do obecných zpráv
    //             altMessages.push(<div>{ex.properties[key]}</div>)
    //         } else {
    //             let label;
    //             let value = ex.properties[key];
    //             if (typeof knownProps[key] === 'undefined') {
    //                 label = key;
    //             } else {
    //                 label = knownProps[key];
    //             }
    //             messageDetails.push(<div>
    //                 <dl className="row">
    //                     <dt className="col-12">{label}:</dt>
    //                     <ds className="col-12">{value}</ds>
    //                 </dl>
    //             </div>)
    //         }
    //     } else {
    //
    //     }
    // });

    if (messageDetails.length > 0) {
      showMoreDetails = React__default.createElement(ToastrMoreInfo, null, messageDetails);
    }
  }

  var showToastr;

  switch (ex.level) {
    case 'DANGER':
      showToastr = toastr.error;
      toastrProps.timeOut = 0;
      toastrProps.removeOnHover = false; // show = false;   // POUZE pro prezentaci TODO [stanekpa] - odebrat po prezentaci!

      break;

    case 'WARNING':
      showToastr = toastr.warning;
      toastrProps.timeOut = 0;
      toastrProps.removeOnHover = false;
      break;

    case 'INFO':
      showToastr = toastr.info;
      break;

    case 'SUCCESS':
      showToastr = toastr.success;
      break;
  }

  if (altMessages.length > 0 || showMoreDetails) {
    toastrProps.timeOut = 0;
    toastrProps.removeOnHover = false;
    toastrProps.component = React__default.createElement("div", null, altMessages, showMoreDetails);
  }

  {
    showToastr(label, toastrProps);
  }
}

var processDefault = function processDefault(e, resolve, reject, globalErrorResolverEnabled) {
  console.error('err #3', e.url, e.statusText, e);
  var errorTypeText;

  switch (e.status) {
    case 500:
    case 404:
      errorTypeText = i18n("global.json.error." + e.status);
      break;

    default:
      errorTypeText = i18n("global.json.error.unknown");
      break;
  }

  if (globalErrorResolverEnabled) {
    var contentType = e.headers.get('Content-Type');

    if (contentType && contentType.indexOf('application/json') === 0) {
      e.json().then(function (message) {
        return showAbstractExceptionMessage(message);
      })["catch"](function () {
        return showErrorMessage(errorTypeText, null);
      });
    } else {
      e.text().then(function (message) {
        return showErrorMessage(errorTypeText, message);
      })["catch"](function () {
        return showErrorMessage(errorTypeText, null);
      });
    }
  }

  reject(e);
};

var process422 = function process422(e, resolve, reject) {
  e.json().then(function (errorData) {
    var errorInfo = {
      validation: true,
      errors: errorData.errors
    };
    reject(new SubmissionError(apiErrorsTransform(errorInfo.errors)));
  })["catch"](function (err) {
    console.error('err #4', e.url, e.statusText, e, err);
    reject(e);
  });
};
/**
 * Vykoná middleware funkce k vlastnímu zpracování response ze serveru.
 * @param {object} e response
 * @param {array} resolveMiddlewareList pole funkcí ke zpracování response
 * @returns {(object|Array)} pokud se vykoná middleware funkce a po její vykonání není vhodné pokračovat se zpracováním response, tak se vrátí null.
 */


function processMiddlewareList(e, resolveMiddlewareList) {
  var response = e;

  for (var _iterator = _createForOfIteratorHelperLoose(resolveMiddlewareList), _step; !(_step = _iterator()).done;) {
    var middleware = _step.value;

    if (typeof middleware === 'function') {
      response = middleware(response);

      if (!response) {
        return null;
      }
    } else {
      console.error('resolveMiddleware není funkce', e.url, e.statusText, e);
    }
  }

  return response;
}

var _resolveMiddlewareList = [];

var ErrorApi = /*#__PURE__*/function () {
  function ErrorApi() {}

  /**
   * Přidá middleware funkci do pole _resolveMiddlewareList
   * @param {function} resolveMiddlewareCallback pokud není potřeba response zpracovávat dále (např. nahrazuje stávající process funkci),
   * měla by tato funkce vrátit null jinak by měla vracet response.
   *
   */
  ErrorApi.addResolveMiddleware = function addResolveMiddleware(resolveMiddlewareCallback) {
    _resolveMiddlewareList.push(resolveMiddlewareCallback);
  }
  /**
   * Zpracuje Promise z volání fetch().
   *
   * @param {Promise} promise - výsledek volání fetch()
   * @param {boolean} globalErrorResolverEnabled - true pro zapnutí vyhodnocení případné chyby pomocí globálního resolveru
   * @returns {Promise} výsledný promise
   */
  ;

  ErrorApi.responseResolver = function responseResolver(promise, globalErrorResolverEnabled) {
    if (globalErrorResolverEnabled === void 0) {
      globalErrorResolverEnabled = true;
    }

    return new Promise(function (resolve, reject) {
      promise.then(function (e) {
        var res = processMiddlewareList(e, _resolveMiddlewareList);

        if (res) {
          switch (res.status) {
            case 200:
              process200(res, resolve, reject);
              break;

            case 422:
              process422(res, resolve, reject);
              break;

            default:
              processDefault(res, resolve, reject, globalErrorResolverEnabled);
              break;
          }
        }
      })["catch"](function (e) {
        //TODO doplnit toaster
        reject(e);
      });
    });
  };

  return ErrorApi;
}(); // const ErrorComponent = (props) => <div>

/* global __DEVTOOLS__ */
require('es6-promise').polyfill();

require('universal-fetch');

var Fetch = /*#__PURE__*/function () {
  function Fetch() {}

  Fetch.defaultHeaders = function defaultHeaders() {
    return new Headers();
  };

  Fetch.get = function get(url, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    return fetch(new Request(url), _extends({}, Fetch.defaultProps, customProps, {
      headers: customHeaders,
      method: 'GET'
    }));
  };

  Fetch.post = function post(url, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    return fetch(new Request(url), _extends({}, Fetch.defaultProps, customProps, {
      headers: customHeaders,
      body: data,
      method: 'POST'
    }));
  };

  Fetch.put = function put(url, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    return fetch(new Request(url), _extends({}, Fetch.defaultProps, customProps, {
      headers: customHeaders,
      body: data,
      method: 'PUT'
    }));
  };

  Fetch["delete"] = function _delete(url, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    return fetch(new Request(url), _extends({}, Fetch.defaultProps, customProps, {
      headers: customHeaders,
      body: data,
      method: 'DELETE'
    }));
  };

  Fetch.patch = function patch(url, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    return fetch(new Request(url), _extends({}, Fetch.defaultProps, customProps, {
      headers: customHeaders,
      body: data,
      method: 'PATCH'
    }));
  };

  return Fetch;
}();
Fetch.defaultProps = {
  credentials: 'same-origin'
};

function filterObjectsByPropertyFulltext(list, value, attrName, everywhere) {
  if (attrName === void 0) {
    attrName = 'name';
  }

  if (everywhere === void 0) {
    everywhere = true;
  }

  if (value === null || value.length === 0) {
    return list;
  }

  var inputValue = value.trim().toLowerCase();

  if (inputValue.length === 0) {
    return list;
  }

  if (everywhere) {
    // kdekoli
    return list.filter(function (item) {
      if (typeof attrName === 'string') {
        return item[attrName] && item[attrName].toLowerCase().indexOf(inputValue) >= 0;
      } else {
        for (var a = 0; a < attrName.length; a++) {
          if (item[attrName[a]] && item[attrName[a]].toLowerCase().indexOf(inputValue) >= 0) {
            return true;
          }
        }

        return false;
      }
    });
  } else {
    // jen od začátku
    return list.filter(function (item) {
      if (typeof attrName === 'string') {
        return item[attrName].toLowerCase() && item[attrName].toLowerCase().indexOf(inputValue) === inputValue;
      } else {
        for (var a = 0; a < attrName.length; a++) {
          if (item[attrName[a]] && item[attrName[a]].toLowerCase().indexOf(inputValue) === inputValue) {
            return true;
          }
        }

        return false;
      }
    });
  }
}

/**
 * Provede aktualizaci query parametru v adrese.
 * @param {string} uri - Upravovaná adresa
 * @param {string} key - Klíč parametru
 * @param {string} value - Hodnota parametru
 * @returns {string} upravená adresa
 */
function updateQueryStringParameter(uri, key, value) {
  if (value == null || value == undefined) {
    return uri;
  }

  var upValue = encodeURIComponent(value);
  var re = new RegExp('([?&])' + key + '=.*?(&|$)', 'i');
  var separator = uri.indexOf('?') !== -1 ? '&' : '?';

  if (uri.match(re)) {
    return uri.replace(re, '$1' + key + '=' + upValue + '$2');
  } else {
    return uri + separator + key + '=' + upValue;
  }
}
/**
 * Provede aktualizaci všech query parametrů v adrese.
 *
 * @param {string} uri - Upravovaná adresa
 * @param {Object} params - Object query parametrů -> klíč: hodnota
 * @param appendTimestamp pokud je true, přidá se časová značka do url jako parametr _t
 * @returns {string} upravená adresa
 */


function generateUrl(uri, params, appendTimestamp) {
  if (appendTimestamp === void 0) {
    appendTimestamp = false;
  }

  var useParams;

  if (params || appendTimestamp) {
    var timeParams = appendTimestamp ? {
      _t: new Date().getTime()
    } : {};
    useParams = params ? _extends({}, params, timeParams) : timeParams;
  }

  if (useParams) {
    for (var key in useParams) {
      var value = useParams[key];
      uri = updateQueryStringParameter(uri, key, value);
    }
  }

  return uri;
}

/**
 * Načtení dat pro konkrétní otečkovanou cestu z objektu.
 * @param obj objekt
 * @param path cesta k datům, např. a.b.c
 */
function getDeepData(obj, path) {
  var attrs = path.split('.');
  var o = obj;

  for (var a = 0; a < attrs.length; a++) {
    var attr = attrs[a];

    if (a + 1 < attrs.length) {
      // není poslední
      if (!o[attr]) {
        return null; // vnořený objekt není definován
      }

      o = o[attr];
    } else {
      // je poslední - konkrétní hodnota
      return o[attr];
    }
  }

  return null;
}

function getMapFromList(list, attrName) {
  if (attrName === void 0) {
    attrName = 'id';
  }

  var map = {};
  list && list.forEach(function (x) {
    map[x[attrName]] = x;
  });
  return map;
}

var _scrollbarWidth = null;
function calculateScrollbarWidth() {
  var inner = document.createElement('p');
  inner.style.width = '100%';
  inner.style.height = '200px';
  var outer = document.createElement('div');
  outer.style.position = 'absolute';
  outer.style.top = '0px';
  outer.style.left = '0px';
  outer.style.visibility = 'hidden';
  outer.style.width = '200px';
  outer.style.height = '150px';
  outer.style.overflow = 'hidden';
  outer.appendChild(inner);
  document.body.appendChild(outer);
  var w1 = inner.offsetWidth;
  outer.style.overflow = 'scroll';
  var w2 = inner.offsetWidth;
  if (w1 == w2) w2 = outer.clientWidth;
  document.body.removeChild(outer);
  _scrollbarWidth = w1 - w2;
  return _scrollbarWidth;
}
function getScrollbarWidth() {
  if (_scrollbarWidth === null) {
    return calculateScrollbarWidth();
  }

  return _scrollbarWidth;
}

function getSetFromIdsList(list) {
  var map = {};
  list && list.forEach(function (x) {
    map[x] = true;
  });
  return map;
}

function highlightText(search, text) {
  if (!search) {
    return text;
  }

  var searchLen = search.length;

  if (searchLen === 0) {
    return text;
  }

  var textLower = text.toLocaleLowerCase();
  var searchLower = search.toLocaleLowerCase();
  var arr = textLower.split(searchLower);
  var result = [];
  var i = 0;

  for (var a = 0; a < arr.length; a++) {
    var partLen = arr[a].length;

    if (partLen > 0) {
      result.push(text.substring(i, i + partLen));
      i += partLen;
    }

    result.push(React__default.createElement("strong", null, text.substring(i, i + searchLen)));
    i += searchLen;
  }

  return result;
}

function indexById(arr, id, attrName) {
  if (attrName === void 0) {
    attrName = 'id';
  }

  if (arr == null) {
    return null;
  }

  var leng = arr.length;

  for (var a = 0; a < leng; a++) {
    if (arr[a][attrName] == id) {
      return a;
    }
  }

  return null;
}

function getJsonString(data) {
  if (typeof data === 'string') {
    return data;
  } else {
    return JSON.stringify(data);
  }
}

var JsonFetch = /*#__PURE__*/function () {
  function JsonFetch() {}

  JsonFetch.defaultHeaders = function defaultHeaders() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
  };

  JsonFetch.get = function get(url, params, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = JsonFetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params, true);
    return Fetch.get(urlWithParams, customProps, customHeaders);
  };

  JsonFetch.post = function post(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = JsonFetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.post(urlWithParams, getJsonString(data), customProps, customHeaders);
  };

  JsonFetch.put = function put(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = JsonFetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.put(urlWithParams, getJsonString(data), customProps, customHeaders);
  };

  JsonFetch["delete"] = function _delete(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = JsonFetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch["delete"](urlWithParams, getJsonString(data), customProps, customHeaders);
  };

  JsonFetch.patch = function patch(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = JsonFetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.patch(urlWithParams, getJsonString(data), customProps, customHeaders);
  };

  return JsonFetch;
}();

/**
 * Wrapper kolem Storage interface z Web Storage API (https://developer.mozilla.org/en-US/docs/Web/API/Storage).
 * Umožňuje typově bezpečné uložení/načtení objektů.
 */
var StorageWrapper = /*#__PURE__*/function () {
  /**
   * Konstruktor.
   *
   * @param storage implementace storage
   */
  function StorageWrapper(storage) {
    this.storage = storage;
  }
  /**
   * Uloží hodnotu napřímo, bez jakékoliv typové kontroly.
   *
   * @param {string} key - klíč
   * @param {*} value - hodnota jakéhokoliv typu, kterou lze reprezentovat jako JSON, tzn. ne undefined nebo function
   */


  var _proto = StorageWrapper.prototype;

  _proto.set = function set(key, value) {
    if (typeof key !== 'string') {
      throw new Error('Key is not a string');
    }

    if (value === undefined) {
      // JSON.stringify by vrátilo undefined a to by se uložilo jako string 'undefined'
      throw new Error('Cannot save undefined value into Storage');
    }

    if (typeof value === 'function') {
      // Ukládat funkci do storage je blbost
      throw new Error('Cannot save function into Storage');
    } // Konveze do JSON zajistí zachování datoveho typu


    this.storage.setItem(key, JSON.stringify(value));
  }
  /**
   * Uloží hodnotu s typovou konverzí.
   * Pro undefined/null hodnotu namísto toho smaže danou položku.
   * Pouze pro interní použití!
   *
   * @param key - klíč
   * @param [value] - hodnota
   * @param valueConverter - funkce, která zajistí správné přetypování hodnoty
   * @private
   */
  ;

  _proto._setTyped = function _setTyped(key, value, valueConverter) {
    // null nemá cenu ukládat, vzhledem k tomu, že Storage vrací null i pro nenalezenou hodnotu
    if (value != null) {
      this.set(key, valueConverter(value));
    } else {
      this.remove(key);
    }
  }
  /**
   * Uloží hodnotu jako boolean.
   * Pozor hodnota bude násilně zkonvertována na boolean i když může být jiného typu.
   * Pro undefined/null hodnotu namísto toho smaže danou položku.
   *
   * @param {string} key - klíč
   * @param {boolean} [value] - hodnota
   */
  ;

  _proto.setBoolean = function setBoolean(key, value) {
    this._setTyped(key, value, Boolean);
  }
  /**
   * Uloží hodnotu jako číslo.
   * Pozor hodnota bude násilně zkonvertována na číslo i když může být jiného typu.
   * Pro undefined/null hodnotu namísto toho smaže danou položku.
   *
   * @param {string} key - klíč
   * @param {number} [value] - hodnota
   */
  ;

  _proto.setNumber = function setNumber(key, value) {
    this._setTyped(key, value, Number);
  }
  /**
   * Uloží hodnotu jako string.
   * Pozor hodnota bude násilně zkonvertována na string i když může být jiného typu.
   * Pro undefined/null hodnotu namísto toho smaže danou položku.
   *
   * @param {string} key - klíč
   * @param {string} [value] - hodnota
   */
  ;

  _proto.setString = function setString(key, value) {
    this._setTyped(key, value, String);
  }
  /**
   * Uloží hodnotu jako objekt.
   * Pozor hodnota bude násilně zkonvertována na objekt i když může být jiného typu.
   * Pro undefined/null hodnotu namísto toho smaže danou položku.
   *
   * @param {string} key - klíč
   * @param {Object} [value] - hodnota
   */
  ;

  _proto.setObject = function setObject(key, value) {
    this._setTyped(key, value, Object);
  }
  /**
   * Vrátí uloženou hodnotu napřímo, bez jakékoliv typové kontroly.
   *
   * @param {string} key - klíč
   * @returns {*} hodnota nebo null v případě nenelezení položky či chyby její deserializace
   */
  ;

  _proto.get = function get(key) {
    var value = this.storage.getItem(key);

    try {
      return JSON.parse(value);
    } catch (error) {
      return null;
    }
  }
  /**
   * Vrátí hodnotu s typovou konverzí.
   * Pouze pro interní použití!
   *
   * @param {string} key - klíč
   * @param {string} expectedType - očekávaný typ hodnoty
   * @param {*} defaultValue - výchozí hodnota vrácená v případě nenalezení nebo v případě,
   *                           že uložená hodnota nebyla požadovaného typu.
   *                           Lze předat i funkci pro lazy vygenerování hodnoty.
   * @returns {*} hodnota
   * @private
   */
  ;

  _proto._getTyped = function _getTyped(key, expectedType, defaultValue) {
    var value = this.get(key);

    if (value != null && typeof value === expectedType) {
      return value;
    }

    if (typeof defaultValue === 'function') {
      return defaultValue();
    }

    return defaultValue;
  }
  /**
   * Vrátí hodnotu jako boolean.
   *
   * @param {string} key - klíč
   * @param {boolean} [defaultValue] - výchozí hodnota vrácená v případě nenalezení nebo v případě,
   *                                   že uložená hodnota nebyla boolean. Lze předat i funkci pro
   *                                   lazy vygenerování hodnoty.
   * @returns {boolean} hodnota
   */
  ;

  _proto.getBoolean = function getBoolean(key, defaultValue) {
    return this._getTyped(key, 'boolean', defaultValue);
  }
  /**
   * Vrátí hodnotu jako číslo.
   *
   * @param {string} key - klíč
   * @param {number} [defaultValue] - výchozí hodnota vrácená v případě nenalezení nebo v případě,
   *                                  že uložená hodnota nebyla číslo. Lze předat i funkci pro
   *                                  lazy vygenerování hodnoty.
   * @returns {number} hodnota
   */
  ;

  _proto.getNumber = function getNumber(key, defaultValue) {
    return this._getTyped(key, 'number', defaultValue);
  }
  /**
   * Vrátí hodnotu jako string.
   *
   * @param {string} key - klíč
   * @param {string} [defaultValue] - výchozí hodnota vrácená v případě nenalezení nebo v případě,
   *                                  že uložená hodnota nebyla string. Lze předat i funkci pro
   *                                  lazy vygenerování hodnoty.
   * @returns {string} hodnota
   */
  ;

  _proto.getString = function getString(key, defaultValue) {
    return this._getTyped(key, 'string', defaultValue);
  }
  /**
   * Vrátí hodnotu jako objekt.
   *
   * @param {string} key - klíč
   * @param {Object} [defaultValue] - výchozí hodnota vrácená v případě nenalezení nebo v případě,
   *                                  že uložená hodnota nebyla objekt. Lze předat i funkci pro
   *                                  lazy vygenerování hodnoty.
   * @returns {Object} hodnota
   */
  ;

  _proto.getObject = function getObject(key, defaultValue) {
    return this._getTyped(key, 'object', defaultValue);
  }
  /**
   * Odstraní hodnotu.
   *
   * @param {string} key - klíč
   */
  ;

  _proto.remove = function remove(key) {
    this.storage.removeItem(key);
  };

  return StorageWrapper;
}();

var localStorageWrapper = /*#__PURE__*/new StorageWrapper(localStorage);

function mergeAddons(propsAddons, customAddons, customsAtBegin) {

  var newAddons;

  if (!propsAddons) {
    newAddons = customAddons;
  } else {
    newAddons = [customAddons, propsAddons];
  }

  return newAddons;
}

function objectById(arr, id, attrName) {
  if (attrName === void 0) {
    attrName = 'id';
  }

  if (arr == null) {
    return null;
  }

  var len = arr.length;

  for (var a = 0; a < len; a++) {
    if (arr[a][attrName] == id) {
      return arr[a];
    }
  }

  return null;
}

var ParamsFetch = /*#__PURE__*/function () {
  function ParamsFetch() {}

  ParamsFetch.defaultHeaders = function defaultHeaders() {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return headers;
  };

  ParamsFetch.get = function get(url, params, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.get(urlWithParams, customProps, customHeaders);
  };

  ParamsFetch.post = function post(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.post(urlWithParams, data, customProps, customHeaders);
  };

  ParamsFetch.put = function put(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.put(urlWithParams, data, customProps, customHeaders);
  };

  ParamsFetch["delete"] = function _delete(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch["delete"](urlWithParams, data, customProps, customHeaders);
  };

  ParamsFetch.patch = function patch(url, params, data, customProps, customHeaders) {
    if (customProps === void 0) {
      customProps = Fetch.defaultProps;
    }

    if (customHeaders === void 0) {
      customHeaders = Fetch.defaultHeaders();
    }

    var urlWithParams = generateUrl(url, params);
    return Fetch.patch(urlWithParams, data, customProps, customHeaders);
  };

  return ParamsFetch;
}();

/*
 ///////////////////////////////////////////////////////////////
 /// The tests
 ///////////////////////////////////////////////////////////////
 var printResult = function (x) {
 if (x) { document.write('<div style="color: green;">Passed</div>'); }
 else { document.write('<div style="color: red;">Failed</div>'); }
 };
 var assert = { isTrue: function (x) { printResult(x); }, isFalse: function (x) { printResult(!x); } }
 assert.isTrue(objectEquals(null,null));
 assert.isFalse(objectEquals(null,undefined));
 assert.isFalse(objectEquals(/abc/, /abc/));
 assert.isFalse(objectEquals(/abc/, /123/));
 var r = /abc/;
 assert.isTrue(objectEquals(r, r));

 assert.isTrue(objectEquals("hi","hi"));
 assert.isTrue(objectEquals(5,5));
 assert.isFalse(objectEquals(5,10));

 assert.isTrue(objectEquals([],[]));
 assert.isTrue(objectEquals([1,2],[1,2]));
 assert.isFalse(objectEquals([1,2],[2,1]));
 assert.isFalse(objectEquals([1,2],[1,2,3]));

 assert.isTrue(objectEquals({},{}));
 assert.isTrue(objectEquals({a:1,b:2},{a:1,b:2}));
 assert.isTrue(objectEquals({a:1,b:2},{b:2,a:1}));
 assert.isFalse(objectEquals({a:1,b:2},{a:1,b:3}));

 assert.isTrue(objectEquals({1:{name:"mhc",age:28}, 2:{name:"arb",age:26}},{1:{name:"mhc",age:28}, 2:{name:"arb",age:26}}));
 assert.isFalse(objectEquals({1:{name:"mhc",age:28}, 2:{name:"arb",age:26}},{1:{name:"mhc",age:28}, 2:{name:"arb",age:27}}));

 Object.prototype.equals = function (obj) { return objectEquals(this, obj); };
 var assertFalse = assert.isFalse,
 assertTrue = assert.isTrue;

 assertFalse({}.equals(null));
 assertFalse({}.equals(undefined));

 assertTrue("hi".equals("hi"));
 assertTrue(new Number(5).equals(5));
 assertFalse(new Number(5).equals(10));
 assertFalse(new Number(1).equals("1"));

 assertTrue([].equals([]));
 assertTrue([1,2].equals([1,2]));
 assertFalse([1,2].equals([2,1]));
 assertFalse([1,2].equals([1,2,3]));
 assertTrue(new Date("2011-03-31").equals(new Date("2011-03-31")));
 assertFalse(new Date("2011-03-31").equals(new Date("1970-01-01")));

 assertTrue({}.equals({}));
 assertTrue({a:1,b:2}.equals({a:1,b:2}));
 assertTrue({a:1,b:2}.equals({b:2,a:1}));
 assertFalse({a:1,b:2}.equals({a:1,b:3}));

 assertTrue({1:{name:"mhc",age:28}, 2:{name:"arb",age:26}}.equals({1:{name:"mhc",age:28}, 2:{name:"arb",age:26}}));
 assertFalse({1:{name:"mhc",age:28}, 2:{name:"arb",age:26}}.equals({1:{name:"mhc",age:28}, 2:{name:"arb",age:27}}));

 var a = {a: 'text', b:[0,1]};
 var b = {a: 'text', b:[0,1]};
 var c = {a: 'text', b: 0};
 var d = {a: 'text', b: false};
 var e = {a: 'text', b:[1,0]};
 var i = {
 a: 'text',
 c: {
 b: [1, 0]
 }
 };
 var j = {
 a: 'text',
 c: {
 b: [1, 0]
 }
 };
 var k = {a: 'text', b: null};
 var l = {a: 'text', b: undefined};

 assertTrue(a.equals(b));
 assertFalse(a.equals(c));
 assertFalse(c.equals(d));
 assertFalse(a.equals(e));
 assertTrue(i.equals(j));
 assertFalse(d.equals(k));
 assertFalse(k.equals(l));

 // from comments on stackoverflow post
 assert.isFalse(objectEquals([1, 2, undefined], [1, 2]));
 assert.isFalse(objectEquals([1, 2, 3], { 0: 1, 1: 2, 2: 3 }));
 assert.isFalse(objectEquals(new Date(1234), 1234));

 // no two different function is equal really, they capture their context variables
 // so even if they have same toString(), they won't have same functionality
 var func = function (x) { return true; };
 var func2 = function (x) { return true; };
 assert.isTrue(objectEquals(func, func));
 assert.isFalse(objectEquals(func, func2));
 assert.isTrue(objectEquals({ a: { b: func } }, { a: { b: func } }));
 assert.isFalse(objectEquals({ a: { b: func } }, { a: { b: func2 } }));
 */
function processStore2(store, action) {
  if (!store.reducer) {
    console.error('Store nemá definovanou metodu reducer', store, action);
  }

  return store.reducer(store, action);
}

var StoreUtils = /*#__PURE__*/function () {
  function StoreUtils() {}

  StoreUtils.consolidateState = function consolidateState(prevState, newState) {
    return StoreUtils.stateEquals(prevState, newState) ? prevState : newState;
  };

  StoreUtils.processStore = function processStore(name, state, action) {
    var _extends2;

    return _extends({}, state, (_extends2 = {}, _extends2[name] = processStore2(state[name], action), _extends2));
  };

  StoreUtils.processAllStores = function processAllStores(state, action) {
    var result = _extends({}, state);

    Object.keys(state).forEach(function (key) {
      if (state[key].reducer) {
        result[key] = processStore2(state[key], action);
      }
    });
    return result;
  };

  StoreUtils.propsEquals = function propsEquals(x, y, attrs) {
    if (typeof attrs !== 'undefined' && attrs !== null) {
      for (var a = 0; a < attrs.length; a++) {
        var p = attrs[a];
        if (!x.hasOwnProperty(p)) continue; // other properties were tested using x.constructor === y.constructor

        if (!y.hasOwnProperty(p)) {
          return false;
        } // allows to compare x[ p ] and y[ p ] when set to undefined


        if (x[p] === y[p]) continue; // if they have the same strict value or identity then they are equal

        if (typeof x[p] !== 'object') {
          return false;
        } // Numbers, Strings, Functions, Booleans must be strictly equal


        if (x[p] !== y[p]) {
          return false;
        }
      }

      return true;
    } else {
      return StoreUtils.stateEquals(x, y);
    }
  };

  StoreUtils.stateEquals = function stateEquals(x, y) {
    for (var p in x) {
      if (!x.hasOwnProperty(p)) continue; // other properties were tested using x.constructor === y.constructor

      if (!y.hasOwnProperty(p)) return false; // allows to compare x[ p ] and y[ p ] when set to undefined

      if (x[p] === y[p]) continue; // if they have the same strict value or identity then they are equal

      if (typeof x[p] !== 'object') return false; // Numbers, Strings, Functions, Booleans must be strictly equal

      if (x[p] !== y[p]) {
        //console.log(p)
        return false;
      }
    }

    return true;
  };

  StoreUtils.objectEquals = function objectEquals(x, y) {
    if (x === null || x === undefined || y === null || y === undefined) {
      return x === y;
    } // after this just checking type of one would be enough


    if (x.constructor !== y.constructor) {
      return false;
    } // if they are functions, they should exactly refer to same one (because of closures)


    if (x instanceof Function) {
      return x === y;
    } // if they are regexps, they should exactly refer to same one (it is hard to better equality check on current ES)


    if (x instanceof RegExp) {
      return x === y;
    }

    if (x === y || x.valueOf() === y.valueOf()) {
      return true;
    }

    if (Array.isArray(x) && x.length !== y.length) {
      return false;
    } // if they are dates, they must had equal valueOf


    if (x instanceof Date) {
      return false;
    } // if they are strictly equal, they both need to be object at least


    if (!(x instanceof Object)) {
      return false;
    }

    if (!(y instanceof Object)) {
      return false;
    } // recursive object equality check


    var p = Object.keys(x);
    return Object.keys(y).every(function (i) {
      return p.indexOf(i) !== -1;
    }) && p.every(function (i) {
      return StoreUtils.objectEquals(x[i], y[i]);
    });
  };

  return StoreUtils;
}();

/**
 * Načtení store pro konkrétní areu.
 * @param store root store aplikace, pod kterým je očekáván store app!
 * @param area area
 * @param showErrors mají se zobrazovat chyby v případě něnalezení store?
 * @return {*}
 */
function storeFromArea(store, area, showErrors) {
  if (showErrors === void 0) {
    showErrors = true;
  }

  var st;

  if (area.indexOf('shared.') === 0) {
    var useArea = area.substring('shared.'.length);

    if (!store.app.shared) {
      if (showErrors) {
        console.error("Store shared is not defined in", store.app);
      }

      return null;
    } else {
      var useStore = store.app.shared.stores[useArea];

      if (!useStore) {
        if (showErrors) {
          console.error("Store shared.stores[" + useArea + "] is not defined in", store.app.shared);
        }

        return null;
      } else {
        st = useStore;
      }
    }
  } else {
    var areaItems = area.split('.');
    st = store.app;

    for (var a = 0, len = areaItems.length; a < len; a++) {
      var item = areaItems[a];
      var subStore = st[item];

      if (subStore) {
        st = subStore;
      } else {
        var path = areaItems.slice(a).join('.');

        if (showErrors) {
          console.error("Store " + path + " is not defined in", st, "Cannot resolve full path 'app." + area + "' in root store", store);
        }

        return null;
      }
    }
  }

  return st;
}

var INIT_REDUCER = 'shared.initReducer';
/**
 * Inicializace shared store.
 * @param area oblast
 * @param konkrétní store
 */

function init(area, store) {
  return {
    type: INIT_REDUCER,
    area: area,
    store: store
  };
}
function initIfNeeded(area, redudcer) {
  return function (dispatch, getState) {
    var currentStore = storeFromArea(getState(), area, false);

    if (currentStore === null) {
      var newStore = redudcer();
      dispatch(init(area, newStore));
    }
  };
}
/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */

function is(action) {
  switch (action.type) {
    case INIT_REDUCER:
      return true;

    default:
      return false;
  }
}

var SharedActions = {
  __proto__: null,
  INIT_REDUCER: INIT_REDUCER,
  init: init,
  initIfNeeded: initIfNeeded,
  is: is
};

/**
 * Provede zpracování store, který může obsahovat area a vrátí upraený store.
 * Musí být voláno jen s platnou areou.
 * @param state state
 * @param action akce
 * @return upravený store
 */

function processAreaStores(state, action) {
  var areaItems = action.area.split('.');

  var newAction = _extends({}, action, {
    area: areaItems.slice(1).join('.')
  });

  if (areaItems[0] === '*') {
    return StoreUtils.processAllStores(state, newAction);
  } else if (state[areaItems[0]]) {
    return StoreUtils.processStore(areaItems[0], state, newAction);
  } else if (action.type === INIT_REDUCER) {
    // inicializace shared reduceru pod nějakým area group
    if (areaItems.length > 1) {
      // je jich víc, zatím nemáme implementováno, měl by se založit podřízený area group reducer
      throw 'Neimplementováno';
    } else {
      var _extends2;

      return _extends({}, state, (_extends2 = {}, _extends2[areaItems[0]] = _extends({}, action.store), _extends2)); // inicializujeme ten z akce
    }
  } else {
    return state;
  }
}

var removeEmptyObjects = function removeEmptyObjects(obj) {
  if (Object.keys(obj).length === 0) {
    return obj;
  }

  for (var key in obj) {
    if (obj.hasOwnProperty(key) && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
      obj[key] = removeEmptyObjects(obj[key]);

      if (Object.keys(obj[key]).length === 0) {
        delete obj[key];
      }
    }
  }

  return obj;
};

function renderFieldWithAddons(field, addonsBefore, addonsAfter) {
  var hasAddonsBefore = addonsBefore && (!(addonsBefore instanceof Array) || addonsBefore instanceof Array && addonsBefore.length > 0);
  var hasAddonsAfter = addonsAfter && (!(addonsAfter instanceof Array) || addonsAfter instanceof Array && addonsAfter.length > 0);

  if (hasAddonsBefore || hasAddonsAfter) {
    return React__default.createElement("div", {
      className: "input-group"
    }, addonsBefore, field, addonsAfter);
  } else {
    return field;
  }
}

/**
 * Validační funkce generovaná funkcí requireFields.
 *
 * @callback requireFieldsValidator
 * @param {Object} values - formulářové hodnoty pro zvalidování
 * @param {Object} [errors={}] - objekt pro zápis chyb polí
 * @return {Object} objekt se zapsanými chybami polí
 */

/**
 * Vytvoří validační funkci povinných polí formuláře.
 * Výslednou funkci lze použít v rámci validace přes redux-form.
 *
 * Použití:
 * ```
 * // Konstrukce validároru
 * const validator = requireFields(['jmeno', 'adresa.ulice']);
 *
 * // 1. Způsob použití
 * const errors = validator(formValues);
 *
 * // 2. Způsob použití
 * const errors: any = {};
 * validator(formValues, errors);
 * ```
 *
 * Použití (konfigurační volby):
 * ```
 * const validator = requireFields(['jmeno', 'adresa.ulice'], {
 *      errorMessage: 'Moje vlastní chybová zpráva',
 *      trimStrings: true, // Řetězce obsahující pouze mezery budou reportovány jako chyby
 * });
 * ```
 *
 * @param {string[]} paths - seznam názvů polí, které chceme validovat. Lze uvéset i otečkované cesty
 *                           pro specifikaci polí v zanořených datových strukturách, např. 'subjekt.adresa.ulice'
 *                           zvaliduje vyplněnost pole ve struktuře `{subjekt: {adresa: {ulice: ???}}}`
 * @param {Object} [options] - volitelné parametry
 * @param {string} [options.errorMessage] - volitelná chybová zpráva, použitá pro nevyplněná povinná pole
 * @param {boolean} [options.trimStrings=false] - příznak, zda string hodnoty trimovat, tzn. zda je
 *                                                string obsahující poze mezery považován za validační chybu
 * @returns {requireFieldsValidator} výsledná validační funkce
 */

function requireFields(paths, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === 'string') {
    options = {
      errorMessage: options
    }; // Zpětná kompatibilita, druhý parametr dříve představoval errorMessage
  }

  var _options = options,
      _options$errorMessage = _options.errorMessage,
      errorMessage = _options$errorMessage === void 0 ? i18n('global.form.title.error.required') : _options$errorMessage,
      _options$trimStrings = _options.trimStrings,
      trimStrings = _options$trimStrings === void 0 ? false : _options$trimStrings;
  return function (values, errors) {
    if (errors === void 0) {
      errors = {};
    }

    for (var _iterator = _createForOfIteratorHelperLoose(paths), _step; !(_step = _iterator()).done;) {
      var path = _step.value;
      var value = getProperty(values, path);

      if (trimStrings && typeof value === 'string') {
        value = value.trim();
      } // Podmínka nesmí být !value, protože chceme akceptovat číselnou hodnotu 0 a boolean hodnotu false


      if (value == null || value === '') {
        setProperty(errors, path, errorMessage);
      }
    }

    return errors;
  };
}

function getVisible(array) {
  if (Array.isArray(array)) {
    return array.filter(function (i) {
      return i.style['visibility'] !== 'hidden' && i.style['display'] !== 'none' && i.style['opacity'] !== 0 && i.style['opacity'] !== '0';
    });
  } else {
    return [];
  }
}

function getEnabled(array) {
  if (Array.isArray(array)) {
    return array.filter(function (i) {
      return !i.disabled;
    });
  } else {
    return [];
  }
}

function getFirstElement(array) {
  return array.length > 0 ? array[0] : null;
}

function toArray(array) {
  return [].slice.call(array);
}

function closestClassName(elem, className, parent) {
  if (parent === void 0) {
    parent = null;
  }

  var x = elem.parentNode;

  while (x !== parent && x !== null) {
    if (x.className.indexOf(className) !== -1) {
      return x;
    }

    x = x.parentNode ? x.parentNode : null;
  }

  return null;
}
/**
 * Nastavení focusu na první viditelný nezakázaný element pro editaci.
 * @param el {Object} container
 * @param selectContent {bool} true, pokud má být obsah vybraný (např. u input type text)
 * @return {bool} true, pokud se podařilo najít a nastavit focus
 */


function setInputFocus(el, selectContent) {
  if (selectContent === void 0) {
    selectContent = false;
  }

  if (!el) {
    // console.log("CANNOT FIND FOCUS EL, PARENT el is null")
    return false;
  } //var elem = $('input:visible:enabled:not([type=radio])', el).get(0);


  var elem = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('input'))))); // var select = $('select:visible:enabled', el).get(0);

  var select = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('select')))));
  elem = chooseInputEl(elem, select); // var textarea = $('textarea:visible:enabled', el).get(0);

  var textarea = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('textarea')))));
  elem = chooseInputEl(elem, textarea); //var button = $('button:visible:enabled:not([data-toggle=dropdown])', el).get(0);

  var button = getFirstElement(getEnabled(getVisible(toArray(el.querySelectorAll('button')))).filter(function (i) {
    return i.getAttribute('data-toggle') !== 'dropdown';
  })); //if (button && button.closest(".card-header") === null)

  if (button && closestClassName(button, '.card-header', el) === null) {
    // chceme jen tlačítka, která nejsou v card header
    elem = chooseInputEl(elem, button);
  }

  elem = chooseInputEl(elem, button); // Vlastní prvky podle definovaného tab indexu

  var custom = getFirstElement(toArray(el.querySelectorAll('div,shortcut')).filter(function (i) {
    var tabIndex = i.getAttribute('tabIndex');

    if (tabIndex === null) {
      return false;
    }

    var num = parseInt(tabIndex);
    return !isNaN(num) && num >= 0;
  }));
  elem = chooseInputEl(elem, custom);

  if (elem) {
    // console.log("SET_FOCUS", elem)
    elem.focus();

    if (selectContent) {
      elem.select && elem.select();
    }

    return true;
  }

  return false;
}

function chooseInputEl(el1, el2) {
  var result = null;

  if (el1 && el2) {
    var el1Rect = el1.getBoundingClientRect();
    var el2Rect = el2.getBoundingClientRect();

    if (el1Rect.top < el2Rect.top) {
      result = el1;
    } else if (el1Rect.top === el2Rect.top && el1Rect.left < el2Rect.left) {
      result = el1;
    } else {
      result = el2;
    }
  } else if (!el1 && el2) {
    result = el2;
  } else if (el1 && !el2) {
    result = el1;
  }

  return result;
}

/**
 * Zaregistruje se pro detekci změn v dané oblasti store.
 * Lze se zaregistrovat jak pro jednu, tak i pro více oblastí najednou.
 *
 * @param store - store
 * @param areas - oblast nebo pole oblastí, které chceme ve store sledovat
 * @param onChange - callback s parametry (newState, oldState, area), volaný při změně hodnot v oblastech store
 * @param initial - zda se má callback ihned vyvolat pro prvotní hodnoty ve store
 */

function subscribeToAreaChanges(store, areas, onChange, initial) {
  if (!Array.isArray(areas)) {
    areas = [areas]; // Vstupem není pole ale jediná oblast
  }

  if (!areas.length) {
    return; // Optimalizace
  }

  var states = areas.map(function (area) {
    return storeFromArea(store.getState(), area);
  });

  if (initial) {
    for (var i = 0; i < areas.length; i++) {
      onChange(states[i], undefined, areas[i]);
    }
  }

  store.subscribe(function () {
    var newStates = areas.map(function (area) {
      return storeFromArea(store.getState(), area);
    });

    for (var _i = 0; _i < areas.length; _i++) {
      var state = states[_i];
      var newState = newStates[_i];

      if (state !== newState) {
        states[_i] = newState;
        onChange(newState, state, areas[_i]);
      }
    }
  });
}

var TRANS = [];
window.MISSING_TRANSLATIONS = [];

var Translate = /*#__PURE__*/function () {
  function Translate() {}

  Translate.simpleMessage = function simpleMessage(toTranslate) {
    if (TRANS[toTranslate]) {
      return TRANS[toTranslate];
    } else {
      window.MISSING_TRANSLATIONS.indexOf(toTranslate) === -1 && window.MISSING_TRANSLATIONS.push(toTranslate);
      console.error('Message "' + toTranslate + '" not found');
      return 'NotFound';
    }
  };

  return Translate;
}();

function webDavOpen(webdavUrl) {
  var activeX = null;

  try {
    activeX = new ActiveXObject('SharePoint.OpenDocuments.3');

    if (activeX === null) {
      activeX = new ActiveXObject('SharePoint.OpenDocuments.2');
    }

    if (activeX === null) {
      activeX = new ActiveXObject('SharePoint.OpenDocuments.1');
    }
  } catch (e) {}

  var errorMessage = 'Nelze otevřít dokument';

  if (activeX !== null) {
    if (!activeX.EditDocument2(window, webdavUrl)) {
      try {
        console.error(errorMessage + ' ' + webdavUrl);
      } catch (e) {}

      return false;
    }
  } else {
    //Chrome 42 definitivně zakazalo NSAPI, tedy pluginy včetně Office webdav pluginu.
    //Naštestí podporuje 'aplikační protokoly'. Protokoly i plugin fungovaly v Chrome od verze Office 2010,
    //takže zádné omezení oproti pluginu by neměli nastat.
    //Tento způsob by fungoval by i pro IE, ale přestaly by fungovat Office 2007, kde funguje pouze ActiveX.
    var url = webdavUrl.split('.');
    var openUrl;
    var extension = url && url.length > 0 ? url[url.length - 1].toLowerCase() : null;

    switch (extension) {
      case 'rtf':
      case 'doc':
      case 'docx':
        openUrl = 'ms-word:ofe|u|' + webdavUrl;
        break;

      case 'xls':
      case 'xlsx':
        openUrl = 'ms-excel:ofe|u|' + webdavUrl;
        break;

      case 'ppt':
      case 'pptx':
        openUrl = 'ms-powerpoint:ofe|u|' + webdavUrl;
        break;

      default:
        console.warn('Nepodporavý typ pro webdav:' + extension);
        return false;
    }

    window.location = openUrl;
    return true;
  }

  return true;
}



var index = {
  __proto__: null,
  commons: commons,
  apiErrorsTransform: apiErrorsTransform,
  CachingLoader: CachingLoader,
  CompositeFocusBlur: CompositeFocusBlur,
  defaultImport: defaultImport,
  ErrorApi: ErrorApi,
  Fetch: Fetch,
  filterObjectsByPropertyFulltext: filterObjectsByPropertyFulltext,
  generateUrl: generateUrl,
  getDeepData: getDeepData,
  getMapFromList: getMapFromList,
  getScrollbarWidth: getScrollbarWidth,
  getSetFromIdsList: getSetFromIdsList,
  highlightText: highlightText,
  indexById: indexById,
  JsonFetch: JsonFetch,
  localStorageWrapper: localStorageWrapper,
  mergeAddons: mergeAddons,
  objectById: objectById,
  ParamsFetch: ParamsFetch,
  processAreaStores: processAreaStores,
  removeEmptyObjects: removeEmptyObjects,
  renderFieldWithAddons: renderFieldWithAddons,
  requireFields: requireFields,
  setInputFocus: setInputFocus,
  storeFromArea: storeFromArea,
  StoreUtils: StoreUtils,
  subscribeToAreaChanges: subscribeToAreaChanges,
  Translate: Translate,
  webDavOpen: webDavOpen
};

var SELECT = 'detail.select';
var REQUEST = 'detail.request';
var RESPONSE = 'detail.response';
var INVALIDATE = 'detail.invalidate';
var UPDATE_VALUE = 'detail.update_value';
var FILTER = 'detail.simple.filter';
var RESET = 'detail.simple.reset';
/**
 * Zneplatnění dat.
 * @param area oblast
 * @param id objektu pro invalidaci
 * @returns {{type: string, area: *, data: *}}
 */

function invalidate(area, id) {
  return {
    type: INVALIDATE,
    area: area,
    id: id
  };
}
/**
 * Filtrování detailu.
 * @param area oblast
 * @param filter filtr
 * @returns {{type: string, area: *, filter: *}}
 */

function filter(area, filter) {
  return {
    type: FILTER,
    area: area,
    filter: filter
  };
}
/**
 * Reset reduceru na původní initial values a stav.
 * @param area oblast
 * @returns {{type: string, area: *}}
 */

function reset(area) {
  return {
    type: RESET,
    area: area
  };
}
/**
 * Nastavení konkrétních dat předanými, nastavením se aktualizuje i stav fetched a isFetching tak, aby byl výsledek stejný jako po reálném načtení dat ze serveru
 * @param area oblast
 * @param id dat
 *
 * @param data data
 */

function setData(area, id, data) {
  return function (dispatch, getState) {
    // Načtení aktuálního store
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebné id, dáme ho tam, aby se nám správně spočetl data key

    if (store.id !== id) {
      dispatch(select(area, id));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)(); // Simulace request dat

    dispatch(request(area, dataKey)); // Response dat

    dispatch(response(area, data));
  };
}
/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param id id objektu, které má být ve store
 * @param getData metoda která má vrátit promise pro načtení, vstupem dostane id, předpis: (id, filter) => {}
 */

function fetchIfNeeded(area, id, getData) {
  return function (dispatch, getState) {
    // Načtení aktuálního store
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebné id, dáme ho tam, aby se nám správně spočetl data key

    if (JSON.stringify(store.id) !== JSON.stringify(id)) {
      dispatch(select(area, id));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)();

    if (store.currentDataKey !== dataKey) {
      // pokus se data key neschoduje, provedeme fetch
      dispatch(request(area, dataKey));
      var _filter = store.filter;

      if (id !== null) {
        // pokud chceme reálně načíst objekt, provedeme fetch přes getData
        getData(id, _filter).then(function (json) {
          var newStore = storeFromArea(getState(), area);
          var newDataKey = newStore.getDataKey.bind(newStore)();

          if (newDataKey === dataKey) {
            // jen pokud příchozí objekt odpovídá dtům, které chceme ve store
            dispatch(response(area, json));
          }
        }); // TODO [stanekpa] - řešit catch a vrácení datakey!
      } else {
        // Response s prázdným objektem
        dispatch(response(area, null));
      }
    }
  };
}
/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */

function is$1(action) {
  switch (action.type) {
    case REQUEST:
    case RESPONSE:
    case SELECT:
    case INVALIDATE:
    case FILTER:
    case RESET:
    case UPDATE_VALUE:
      return true;

    default:
      return false;
  }
}
/**
 * Úprava hodnoty ve store - vykonána uživatelem/programem
 * @param area oblast
 * @param data nová data
 * @returns {{type: string, area: *, data: *}}
 */

function updateValue(area, data) {
  return {
    type: UPDATE_VALUE,
    area: area,
    data: data
  };
}
/**
 * Výběr nového detailu, volá se i v případě, že je zavoláno fetchIfNeeded s jiným id něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */

function select(area, id) {
  return {
    type: SELECT,
    area: area,
    id: id
  };
}
/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */


function request(area, dataKey) {
  return {
    type: REQUEST,
    area: area,
    dataKey: dataKey
  };
}
/**
 * Response dat.
 * @param area oblast
 * @param data nová data
 * @returns {{type: string, area: *, data: *}}
 */


function response(area, data) {
  return {
    type: RESPONSE,
    area: area,
    data: data
  };
}

var DetailActions = {
  __proto__: null,
  SELECT: SELECT,
  REQUEST: REQUEST,
  RESPONSE: RESPONSE,
  INVALIDATE: INVALIDATE,
  UPDATE_VALUE: UPDATE_VALUE,
  FILTER: FILTER,
  RESET: RESET,
  invalidate: invalidate,
  filter: filter,
  reset: reset,
  setData: setData,
  fetchIfNeeded: fetchIfNeeded,
  is: is$1,
  updateValue: updateValue
};

/**
 * Implicitní funkce pro načtení data key.
 * @returns {*|null|number|string}
 */

function getDataKey() {
  var dataKey = ''; // Filter
  //@ts-ignore

  dataKey += JSON.stringify(this.filter); // Parent id
  //@ts-ignore

  dataKey += '_' + this.id; // ---

  return dataKey;
}

var initialState = {
  data: null,
  id: null,
  isFetching: false,
  fetched: false,
  currentDataKey: '',
  filter: {},
  // pokud je detai zobrazován na základě filtru
  getDataKey: getDataKey,
  reducer: detail
};
function detail(state, action, config) {
  if (state === void 0) {
    state = initialState;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  // Konfigurace
  if (config) {
    state = _extends({}, state);

    if (config.filter) {
      // inicializační filtr
      state.filter = config.filter;
    }
  }

  switch (action.type) {
    case REQUEST:
      return _extends({}, state, {
        isFetching: true,
        currentDataKey: action.dataKey
      });

    case RESPONSE:
      {
        return _extends({}, state, {
          isFetching: false,
          fetched: true,
          data: action.data
        });
      }

    case FILTER:
      {
        return _extends({}, state, {
          filter: action.filter
        });
      }

    case SELECT:
      {
        return _extends({}, state, {
          id: action.id,
          data: state.id === action.id ? state.data : null,
          fetched: state.id === action.id ? state.fetched : false
        });
      }

    case INVALIDATE:
      {
        if (action.id === state.id) {
          return _extends({}, state, {
            currentDataKey: initialState.currentDataKey
          });
        } else {
          return state;
        }
      }

    case UPDATE_VALUE:
      {
        return _extends({}, state, {
          data: action.data
        });
      }

    case RESET:
      {
        return _extends({}, initialState, {
          filter: config && config.filter ? config.filter : initialState.filter
        });
      }

    default:
      return state;
  }
}

/**
 * Společný store pro různá data, např. pro globální čísleníky pro fieldy atp. Převážně využíván např. fieldy z shared (jako StatField atp.).
 */

var initialState$1 = {
  stores: {},
  // mapa název reduceru na jeho store
  reducer: shared
};
function shared(state, action) {
  if (state === void 0) {
    state = initialState$1;
  }

  if (action === void 0) {
    action = {};
  }

  switch (action.type) {
    case INIT_REDUCER:
      {
        var _extends2;

        var area = action.area;
        return _extends({}, state, {
          stores: _extends({}, state.stores, (_extends2 = {}, _extends2[area] = action.store, _extends2))
        });
      }

    default:
      if (action.area) {
        var store = state.stores[action.area];

        if (store) {
          var _extends3;

          var newStore = store.reducer(store, action);
          return _extends({}, state, {
            stores: _extends({}, state.stores, (_extends3 = {}, _extends3[action.area] = newStore, _extends3))
          });
        } else {
          return state;
        }
      } else {
        return state;
      }

  }
}

function baseReducer() {
  return {
    shared: shared(),
    // Shared reducer, který používají některé fieldy v shared - auto konfigurace store
    authInfo: detail()
  };
}

var index$1 = {
  __proto__: null,
  baseReducer: baseReducer
};

var COMPONENT_CHILDREN = /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.array, PropTypes__default.node]);
var COMPONENT_LEVELS = ['default', 'primary', 'success', 'info', 'info2', 'warning', 'danger'];
function getComponentLevelClassName(prefix, level) {
  if (COMPONENT_LEVELS.indexOf(level) === -1) {
    return '';
  }

  return prefix + "-" + level;
}

var Utils2 = {
  __proto__: null,
  COMPONENT_CHILDREN: COMPONENT_CHILDREN,
  COMPONENT_LEVELS: COMPONENT_LEVELS,
  getComponentLevelClassName: getComponentLevelClassName
};

var BoxBody = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BoxBody, _Component);

  function BoxBody() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BoxBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    className = classNames('box-body', className);
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), children);
  };

  return BoxBody;
}(Component);
BoxBody.propTypes = {
  className: PropTypes__default.string,
  children: COMPONENT_CHILDREN
};

var BoxFooter = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BoxFooter, _Component);

  function BoxFooter() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BoxFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    className = classNames('box-footer', className);
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), children);
  };

  return BoxFooter;
}(Component);
BoxFooter.propTypes = {
  className: PropTypes__default.string,
  children: COMPONENT_CHILDREN
};

var BoxHeader = /*#__PURE__*/function (_Component) {
  _inheritsLoose(BoxHeader, _Component);

  function BoxHeader() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BoxHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        border = _this$props.border,
        className = _this$props.className,
        children = _this$props.children,
        pull = _this$props.pull,
        title = _this$props.title,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["border", "className", "children", "pull", "title"]);

    className = classNames('box-header', className, {
      border: border
    });
    var boxToolsClassName = classNames('box-tools', {
      'pull-left': pull === 'left',
      'pull-right': pull === 'right'
    });
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), React__default.createElement("h3", {
      className: "box-title"
    }, title), React__default.createElement("div", {
      className: boxToolsClassName
    }, children));
  };

  return BoxHeader;
}(Component);
BoxHeader.propTypes = {
  border: PropTypes__default.bool,
  className: PropTypes__default.string,
  children: COMPONENT_CHILDREN,
  pull: /*#__PURE__*/PropTypes__default.oneOf(['left', 'right']),
  title: PropTypes__default.string
};
BoxHeader.defaultProps = {
  border: false
};

var Box = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Box, _Component);

  function Box() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Box.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        level = _this$props.level,
        solid = _this$props.solid,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["className", "children", "level", "solid"]);

    className = classNames('box', getComponentLevelClassName('box', level), {
      'box-solid': solid
    }, className);
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), children);
  };

  return Box;
}(Component);
Box.propTypes = {
  className: PropTypes__default.string,
  children: COMPONENT_CHILDREN,
  level: /*#__PURE__*/PropTypes__default.oneOf(COMPONENT_LEVELS),
  solid: PropTypes__default.bool
};



var index$2 = {
  __proto__: null,
  BoxBody: BoxBody,
  BoxFooter: BoxFooter,
  BoxHeader: BoxHeader,
  Box: Box
};

var SHOW = 'contextMenu.show';
var HIDE = 'contextMenu.hide';
/**
 * Zobrazení kontextového menu.
 * @param component komponenta pro zobrazení menu
 * @param componentProps vstupní props komponenty
 * @param JS event na kontext menu
 * @param customHide pokud je true, tak se při kliknutí na cokoli pod menu menu samo nezavře a musí ho zavřít někdo zvenčí (např. pro menu s checkbxama)
 * @return {{type: string, component: *, componentProps: *, position: *}}
 */

function show(component, componentProps, event, customHide) {
  if (customHide === void 0) {
    customHide = false;
  }

  event.stopPropagation();
  event.preventDefault();
  return {
    type: SHOW,
    component: component,
    componentProps: componentProps,
    customHide: customHide,
    position: {
      x: event.clientX,
      y: event.clientY
    }
  };
}
function hide() {
  return function (dispatch, getState) {
    var state = getState().contextMenu;

    if (state.visible) {
      dispatch({
        type: HIDE
      });
    }
  };
}

var contextMenuActions = {
  __proto__: null,
  SHOW: SHOW,
  HIDE: HIDE,
  show: show,
  hide: hide
};

var ContextMenuContainer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ContextMenuContainer, _React$Component);

  function ContextMenuContainer() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.refMenu = React__default.createRef();
    _this.state = {
      left: 0,
      top: 0
    };

    _this.handleKeyDown = function (e) {
      var visible = _this.props.contextMenu.visible;

      if (visible && e.keyCode == 27) {
        e.preventDefault();
        e.stopPropagation();

        _this.hideMenu();
      }
    };

    _this.hideMenu = function () {
      _this.props.dispatch(hide());
    };

    _this.handleClickUp = function () {};

    _this.handleClickDown = function (e) {
      var _this$props$contextMe = _this.props.contextMenu,
          customHide = _this$props$contextMe.customHide,
          visible = _this$props$contextMe.visible;

      if (!visible) {
        return;
      }

      var source = e.target;
      var found = false;
      var node = _this.refMenu.current;

      while (source) {
        // console.log(source, contextMenuDomNode, source === contextMenuDomNode, source == contextMenuDomNode)
        found = source === node;

        if (found) {
          if (!customHide) {
            setTimeout(function () {
              _this.hideMenu();
            }, 80);
          }

          return;
        }

        source = source.parentNode;
      }

      _this.hideMenu();
    };

    _this.setPosition = function () {
      var _this$props$contextMe2 = _this.props.contextMenu,
          visible = _this$props$contextMe2.visible,
          position = _this$props$contextMe2.position;

      if (visible) {
        var node = _this.refMenu.current;
        var ww = window.innerWidth;
        var wh = window.innerHeight;
        var menuHeight = node.offsetHeight;
        var menuWidth = node.offsetWidth;
        var x = position.x;
        var y = position.y; // Spočtení umístění menu

        var top;
        var left;

        if (y + menuHeight > wh) {
          // nevejde se dolu, dáme ho nahoru
          top = y - menuHeight;
        } else {
          // dáme ho dolu
          top = y;
        }

        if (x + menuWidth > ww) {
          // nevejde se vpravo, dáme ho vlevo
          left = x - menuWidth;
        } else {
          // dáme ho vpravo
          left = x;
        }

        _this.setState({
          left: left,
          top: top
        });
      }
    };

    return _this;
  }

  var _proto = ContextMenuContainer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleClickDown);
    document.addEventListener('keydown', this.handleKeyDown);
    document.addEventListener('mouseup', this.handleClickUp);
    document.addEventListener('touchstart', this.handleClickDown);
    document.addEventListener('touchend', this.handleClickUp);
    window.addEventListener('resize', this.hideMenu);
    document.addEventListener('scroll', this.hideMenu);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickDown);
    document.removeEventListener('keydown', this.handleKeyDown);
    document.removeEventListener('mouseup', this.handleClickUp);
    document.removeEventListener('touchstart', this.handleClickDown);
    document.removeEventListener('touchend', this.handleClickUp);
    window.removeEventListener('resize', this.hideMenu);
    document.removeEventListener('scroll', this.hideMenu);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // Nastavení chceme jen při změně props, nikoli state!
    if (prevProps !== this.props) {
      this.setPosition();
    }
  };

  _proto.render = function render() {
    var _this$props$contextMe3 = this.props.contextMenu,
        visible = _this$props$contextMe3.visible,
        component = _this$props$contextMe3.component,
        componentProps = _this$props$contextMe3.componentProps;

    var _this$props = this.props,
        className = _this$props.className,
        other = _objectWithoutPropertiesLoose(_this$props, ["customHide", "className", "dispatch", "contextMenu"]);

    var _this$state = this.state,
        left = _this$state.left,
        top = _this$state.top;

    if (!visible) {
      return null;
    }

    var wrapperClassNames = classNames(className, 'context-menu-container', {
      open: visible
    });
    var comp = createElement(component, componentProps);
    var style = {
      left: left,
      top: top
    };
    return React__default.createElement("div", Object.assign({
      style: style,
      ref: this.refMenu,
      className: wrapperClassNames
    }, other), comp);
  };

  return ContextMenuContainer;
}(React__default.Component);

ContextMenuContainer.propTypes = {};
ContextMenuContainer.defaultProps = {// customHide: false
};

function mapStateToProps(state) {
  return {
    contextMenu: state.contextMenu
  };
}

var ContextMenuContainer$1 = /*#__PURE__*/connect(mapStateToProps)(ContextMenuContainer);

var ContextMenu = function ContextMenu(_ref) {
  var children = _ref.children;
  return createElement(ButtonDropdown, {
    isOpen: true,
    toggle: function toggle() {},
    className: "context-menu-container"
  }, createElement(DropdownMenu, null, children));
};

var initialState$2 = {
  visible: false,
  component: null,
  componentProps: null,
  position: null,
  customHide: false
};
function contextMenuReducer(state, action) {
  if (state === void 0) {
    state = initialState$2;
  }

  if (action === void 0) {
    action = {};
  }

  switch (action.type) {
    case SHOW:
      return _extends({}, state, {
        visible: true,
        component: action.component,
        componentProps: action.componentProps,
        position: action.position,
        customHide: action.customHide
      });

    case HIDE:
      return _extends({}, initialState$2);

    default:
      return state;
  }
}



var index$3 = {
  __proto__: null,
  actions: contextMenuActions,
  ContextMenuContainer: ContextMenuContainer$1,
  ContextMenu: ContextMenu,
  reducer: contextMenuReducer
};

/**
 * Komponenta řádku detailu, který má akce, může obsahovat i celý obsah panelu, nebo být použit např. na část s akcemi nebo nadpis s akcemi.
 */

function ActionsRow(_ref) {
  var visibleActions = _ref.visibleActions,
      noCenter = _ref.noCenter,
      actions = _ref.actions,
      children = _ref.children,
      className = _ref.className,
      other = _objectWithoutPropertiesLoose(_ref, ["visibleActions", "noCenter", "actions", "children", "className"]);

  var wrapperClassNames = classNames(className, 'action-row-container', {
    'center-items': !noCenter,
    'actions-visible': visibleActions,
    'actions-hover': !visibleActions
  });
  return createElement("div", Object.assign({
    className: wrapperClassNames
  }, other), createElement("div", {
    className: "action-row-label"
  }, children), createElement("div", {
    className: "action-row-actions"
  }, actions));
}

/**
 * Komponenta, která obaluje obsah, který má vlevo na deailku velikou ikonu, slouží i pro ostatní řádky pod, které nemají ikonu, ale mají být správně odsazené.
 */

function DetailLeftIcon(_ref) {
  var icon = _ref.icon,
      children = _ref.children,
      className = _ref.className,
      leftClassName = _ref.leftClassName,
      rightClassName = _ref.rightClassName,
      other = _objectWithoutPropertiesLoose(_ref, ["icon", "children", "className", "leftClassName", "rightClassName"]);

  var wrapperClassNames = classNames('detail-left-icon-container', className);
  var leftClassNames = classNames('detail-left-icon', leftClassName);
  var rightClassNames = classNames('detail-left-content', rightClassName);
  return createElement("div", Object.assign({
    className: wrapperClassNames
  }, other), createElement("div", {
    className: leftClassNames
  }, icon), createElement("div", {
    className: rightClassNames
  }, children));
}

/**
 * Má nějaké potomky, které se budou renderovat?
 * @return {boolean} true, pokud má nějaké potomky, které se budou renderovat
 */

function hasChildren(children) {
  if (typeof children === 'number') {
    return true;
  }

  if (children) {
    if (Array.isArray(children)) {
      var hasNotNull = false;

      for (var a = 0; a < children.length; a++) {
        if (typeof children[a] === 'number' || children[a]) {
          hasNotNull = true;
          break;
        }
      }

      return hasNotNull;
    } else {
      return true;
    }
  } else {
    return false;
  }
}
/**
 * Komponenta pro label a hodnotu pro použití na detailech.
 * Pokud je obsahem řetězec (text) a ten obsahuje \n, jsou pro render použity <span> oddělené pomocí <br/>.
 */


function DetailValue(_ref) {
  var title = _ref.title,
      horizontal = _ref.horizontal,
      valueTitle = _ref.valueTitle,
      textOverflow = _ref.textOverflow,
      _ref$emptyValue = _ref.emptyValue,
      emptyValue = _ref$emptyValue === void 0 ? '-' : _ref$emptyValue,
      label = _ref.label,
      children = _ref.children,
      className = _ref.className;
  var wrapperClassNames = classNames(className, {
    'text-overflow': textOverflow,
    'detail-value-horizontal': horizontal
  });
  var content;

  if (hasChildren(children)) {
    if (typeof children === 'string') {
      content = children.split('\n').map(function (item, key) {
        return createElement("span", {
          key: key
        }, item, createElement("br", null));
      });
    } else {
      content = children;
    }
  } else {
    content = emptyValue;
  }

  return createElement("dl", {
    className: wrapperClassNames,
    title: title
  }, label && createElement("dt", null, label), content !== null && createElement("dd", {
    title: valueTitle
  }, content));
}

var CurrencyValue = function CurrencyValue(props) {
  var value = props.value,
      otherProps = _objectWithoutPropertiesLoose(props, ["value"]);

  return React__default.createElement(NumberFormat, Object.assign({
    value: value === null || value === '' ? undefined : value
  }, otherProps));
};

CurrencyValue.defaultProps = {
  suffix: ' Kč',
  displayType: 'text',
  thousandSeparator: ' ',
  defaultValue: '-'
};



var index$4 = {
  __proto__: null,
  DetailActions: DetailActions,
  ActionsRow: ActionsRow,
  DetailLeftIcon: DetailLeftIcon,
  DetailReducer: detail,
  DetailValue: DetailValue,
  CurrencyValue: CurrencyValue
};

var AbstractField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AbstractField, _React$Component);

  function AbstractField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.renderFieldWithAddons = function (field, addonsBefore, addonsAfter) {
      return renderFieldWithAddons(field, addonsBefore, addonsAfter);
    };

    return _this;
  }

  return AbstractField;
}(React__default.Component);

AbstractField.propTypes = {
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

/**
 * Ikona z Marbes ikonfontu.
 */

var IconSizeEnum;

(function (IconSizeEnum) {
  IconSizeEnum["LG"] = "lg";
  IconSizeEnum["X2"] = "2x";
  IconSizeEnum["X3"] = "3x";
  IconSizeEnum["X4"] = "4x";
  IconSizeEnum["X5"] = "5x";
})(IconSizeEnum || (IconSizeEnum = {}));

var IconRotateEnum;

(function (IconRotateEnum) {
  IconRotateEnum["A_90"] = "90";
  IconRotateEnum["A_180"] = "180";
  IconRotateEnum["A_270"] = "270";
  IconRotateEnum["horizontal"] = "horizontal";
  IconRotateEnum["vertical"] = "vertical";
})(IconRotateEnum || (IconRotateEnum = {}));

var IconColorEnum;

(function (IconColorEnum) {
  IconColorEnum["primary"] = "primary";
  IconColorEnum["success"] = "success";
  IconColorEnum["warning"] = "warning";
  IconColorEnum["danger"] = "danger";
  IconColorEnum["info"] = "info";
})(IconColorEnum || (IconColorEnum = {}));

var IconPullEnum;

(function (IconPullEnum) {
  IconPullEnum["left"] = "left";
  IconPullEnum["right"] = "right";
})(IconPullEnum || (IconPullEnum = {}));

var IconAnimationEnum;

(function (IconAnimationEnum) {
  IconAnimationEnum["pulse"] = "pulse";
  IconAnimationEnum["spin"] = "spin";
})(IconAnimationEnum || (IconAnimationEnum = {}));

var Icon = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Icon, _PureComponent);

  function Icon() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.baseClassName = 'icon';
    return _this;
  }

  var _proto = Icon.prototype;

  _proto.render = function render() {
    var _classNames;

    var _this$props = this.props,
        animation = _this$props.animation,
        border = _this$props.border,
        className = _this$props.className,
        fixedWidth = _this$props.fixedWidth,
        icon = _this$props.icon,
        pull = _this$props.pull,
        rotate = _this$props.rotate,
        size = _this$props.size,
        color = _this$props.color,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["animation", "border", "className", "fixedWidth", "icon", "pull", "rotate", "size", "color"]);

    var baseClassNames = [this.baseClassName];

    if (this.baseClassName !== 'icon') {
      baseClassNames.push('icon');
    }

    className = classNames([].concat(baseClassNames, [this.baseClassName + "-" + icon]), animation ? this.baseClassName + "-" + animation : '', (_classNames = {}, _classNames[this.baseClassName + '-border'] = border, _classNames[this.baseClassName + '-fw'] = fixedWidth, _classNames[this.baseClassName + '-pull-left'] = pull === Icon.pull.left, _classNames[this.baseClassName + '-pull-right'] = pull === Icon.pull.right, _classNames[this.baseClassName + '-rotate-90'] = rotate === Icon.rotate.A_90, _classNames[this.baseClassName + '-rotate-180'] = rotate === Icon.rotate.A_180, _classNames[this.baseClassName + '-rotate-270'] = rotate === Icon.rotate.A_270, _classNames[this.baseClassName + '-rotate-horizontal'] = rotate === Icon.rotate.horizontal, _classNames[this.baseClassName + '-rotate-vertical'] = rotate === Icon.rotate.vertical, _classNames[this.baseClassName + '-lg'] = size === Icon.size.LG, _classNames[this.baseClassName + '-2x'] = size === Icon.size.X2, _classNames[this.baseClassName + '-3x'] = size === Icon.size.X3, _classNames[this.baseClassName + '-4x'] = size === Icon.size.X4, _classNames[this.baseClassName + '-5x'] = size === Icon.size.X5, _classNames['text-' + color] = color != null, _classNames), className);
    return createElement("i", Object.assign({
      className: className
    }, otherProps));
  };

  return Icon;
}(PureComponent);
Icon.animation = IconAnimationEnum;
Icon.animationList = /*#__PURE__*/Object.values(IconAnimationEnum);
Icon.pull = IconPullEnum;
Icon.pullList = /*#__PURE__*/Object.values(IconPullEnum);
Icon.rotate = IconRotateEnum;
Icon.rotateList = /*#__PURE__*/Object.values(IconRotateEnum);
Icon.size = IconSizeEnum;
Icon.sizeList = /*#__PURE__*/Object.values(IconSizeEnum);
Icon.color = IconColorEnum;
Icon.propTypes = {
  animation: /*#__PURE__*/PropTypes__default.oneOf(Icon.animationList),
  border: PropTypes__default.bool,
  className: PropTypes__default.string,
  fixedWidth: PropTypes__default.bool,
  icon: PropTypes__default.string.isRequired,
  pull: /*#__PURE__*/PropTypes__default.oneOf(Icon.pullList),
  rotate: /*#__PURE__*/PropTypes__default.oneOf(Icon.rotateList),
  size: /*#__PURE__*/PropTypes__default.oneOf(Icon.sizeList),
  color: /*#__PURE__*/PropTypes__default.oneOf( /*#__PURE__*/Object.keys(Icon.color))
};
Icon.defaultProps = {
  border: false,
  fixedWidth: false
};

var FAIcon = /*#__PURE__*/function (_Icon) {
  _inheritsLoose(FAIcon, _Icon);

  function FAIcon() {
    var _this;

    _this = _Icon.apply(this, arguments) || this;
    /** @override **/

    _this.baseClassName = 'fa';
    return _this;
  }

  return FAIcon;
}(Icon);

var SUGGEST_THEME = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'form-control react-autosuggest__input',
  inputOpen: 'react-autosuggest__input--open',
  inputFocused: 'react-autosuggest__input--focused',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestionsContainerOpen: 'react-autosuggest__suggestions-container--open',
  suggestionsList: 'react-autosuggest__suggestions-list',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFirst: 'react-autosuggest__suggestion--first',
  suggestionHighlighted: 'react-autosuggest__suggestion--highlighted',
  sectionContainer: 'react-autosuggest__section-container',
  sectionContainerFirst: 'react-autosuggest__section-container--first',
  sectionTitle: 'react-autosuggest__section-title'
};
/**
 * Object Suggest field
 *
 * Alias autocomplete
 * Vrací objekty jako hodnoty hodnoty
 */

var ObjectSuggestField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(ObjectSuggestField, _AbstractField);

  function ObjectSuggestField(props) {
    var _this;

    _this = _AbstractField.call(this, props) || this;
    _this.autosuggestRef = React__default.createRef();

    _this.updateSuggestions = function (inputValue, items) {
      var _this$props = _this.props,
          minCharsForFilter = _this$props.minCharsForFilter,
          filterSuggestions = _this$props.filterSuggestions,
          getItemValue = _this$props.getItemValue,
          itemValueAttrName = _this$props.itemValueAttrName,
          dropdown = _this$props.dropdown;

      if (minCharsForFilter === 0 || inputValue && inputValue.length >= minCharsForFilter || _this.dropdownClick && dropdown) {
        filterSuggestions(inputValue, items, getItemValue, itemValueAttrName || 'name').then(function (suggestions) {
          if (!_this.componentIsUnmounting) {
            _this.setState({
              suggestions: suggestions
            });
          }
        })["catch"](function () {
          if (!_this.componentIsUnmounting) {
            _this.setState({
              suggestions: []
            });
          }
        });
      } else {
        _this.setState({
          suggestions: []
        });
      }
    };

    _this.handleInputChange = function (e, _ref) {
      var newValue = _ref.newValue,
          method = _ref.method;
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value,
          onInputChange = _this$props2.onInputChange;

      switch (method) {
        case 'type':
          if (onInputChange) {
            onInputChange(newValue);
          }

          if (value) {
            onChange(null);
          }

          _this.setState({
            inputValue: newValue,
            inputValueChanged: true
          }, function () {
            if (!_this.componentIsUnmounting) {
              if (value) {
                // console.log("virtual blur!")
                _this.ignoreBlur = true;

                _this.autosuggestRef.current.input.blur();

                _this.autosuggestRef.current.input.focus();

                _this.ignoreBlur = false;
              }
            }
          });

          break;
      }
    };

    _this.handleSuggestionSelected = function (event, _ref2) {
      var suggestion = _ref2.suggestion;
      var _this$props3 = _this.props,
          tags = _this$props3.tags,
          onChange = _this$props3.onChange;
      var inputValue = _this.state.inputValue;
      event.stopPropagation();
      event.preventDefault();
      onChange && onChange(suggestion, inputValue);

      if (tags) {
        // vynulujeme hodnotu
        _this.setState({
          inputValue: '',
          inputValueChanged: false,
          hasFocus: false
        }, function () {// this.ignoreBlur = true;
          // this.autosuggest.input.blur();
          //this.hasFocus = false;
          // setTimeout(() => {
          //     this.autosuggest.input.focus();
          //     this.ignoreBlur = false;
          //     this.hasFocus = true;
          // }, 100);
        });
      }
    };

    _this.handleBlur = function (e) {
      if (_this.ignoreBlur) {
        return;
      }

      var _this$props4 = _this.props,
          onBlur = _this$props4.onBlur,
          value = _this$props4.value;
      var inputValueChanged = _this.state.inputValueChanged; // this.hasFocus = false;

      _this.dropdownClick = false;
      _this.renderSuggestions = false;

      _this.setState({
        hasFocus: false
      });

      if (inputValueChanged) {
        // hodnota inputu byla zmněněná a nebyla znovu vybrána položka z menu, nastavíme vybranou položku na null
        onBlur && onBlur(null);
      } else {
        onBlur && onBlur(value ? value : null);
      }
    };

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    _this.handleRenderSuggestions = function (item, _ref3) {
      var _this$props5 = _this.props,
          value = _this$props5.value,
          itemValueAttrName = _this$props5.itemValueAttrName,
          renderSuggestion = _this$props5.renderSuggestion,
          getItemValue = _this$props5.getItemValue;
      var inputValue = _this.state.inputValue;
      var selected = value ? value.id === item.id : false;
      return renderSuggestion(item, selected, getItemValue, itemValueAttrName || 'name', value ? null : inputValue);
    };

    _this.handleSuggestionsUpdateRequested = function (_ref4) {
      var value = _ref4.value;
      // console.log("handleSuggestionsUpdateRequested", value)
      var items = _this.props.items;

      _this.updateSuggestions(value, items);
    };

    _this.handleRenderSuggestionsContainer = function (_ref5) {
      var containerProps = _ref5.containerProps,
          children = _ref5.children;

      var ref = containerProps.ref,
          restContainerProps = _objectWithoutPropertiesLoose(containerProps, ["ref"]);

      var callRef = function callRef(isolatedScroll) {
        if (isolatedScroll !== null) {
          ref(isolatedScroll.component);
        }
      };

      return React__default.createElement(IsolatedScroll, Object.assign({}, restContainerProps, {
        ref: callRef
      }), children);
    };

    _this.handleClear = function (e) {
      e.stopPropagation();
      e.preventDefault();
      var onChange = _this.props.onChange;
      onChange(null);

      _this.setState({
        inputValue: '',
        inputValueChanged: true
      }, function () {
        if (!_this.componentIsUnmounting) {
          _this.ignoreBlur = true;

          _this.autosuggestRef.current.input.blur();

          _this.autosuggestRef.current.input.focus();

          _this.ignoreBlur = false;
        }
      });
    };

    _this.handleDropdown = function (e) {
      //console.log("handleDropdown", this.hasFocus, this.renderSuggestions);
      _this.dropdownClick = true;

      if (!_this.renderSuggestions || !_this.state.hasFocus) {
        e.stopPropagation();
        e.preventDefault();
        _this.ignoreBlur = true;

        _this.autosuggestRef.current.input.blur();

        _this.autosuggestRef.current.input.focus();

        _this.ignoreBlur = false; //this.hasFocus = true;

        _this.setState({
          hasFocus: true
        });
      } else {
        _this.renderSuggestions = false;
      }
    };

    _this.handleFocus = function (e) {
      var onFocus = _this.props.onFocus; //this.hasFocus = true;

      _this.setState({
        hasFocus: true
      });

      onFocus && onFocus(e);
    };

    _this.shouldRenderSuggestions = function (value) {
      var _this$state = _this.state,
          inputValue = _this$state.inputValue,
          inputValueChanged = _this$state.inputValueChanged;
      var _this$props6 = _this.props,
          shouldRenderSuggestions = _this$props6.shouldRenderSuggestions,
          minCharsForFilter = _this$props6.minCharsForFilter; // TODO NOPEPARTS

      var shouldRenderSuggestionsFc;

      shouldRenderSuggestionsFc = function shouldRenderSuggestionsFc() {
        return !inputValue || inputValue && inputValueChanged;
      }; //console.warn(minCharsForFilter === 0, inputValue, value, !!inputValue, inputValue.length >= minCharsForFilter);


      var result = shouldRenderSuggestionsFc(value) && shouldRenderSuggestions(value) && (_this.dropdownClick ? true : minCharsForFilter === 0 || !!value && value.length >= minCharsForFilter);
      _this.renderSuggestions = result;
      return result;
    };

    var inputValue = props.value ? props.getItemValue(props.value, props.itemValueAttrName || 'name') : ''; //this.hasFocus = false;

    _this.alwaysRenderSuggestions = false;
    _this.ignoreBlur = false;
    _this.componentIsUnmounting = false;
    _this.dropdownClick = false;
    _this.renderSuggestions = false;
    _this.state = {
      hasFocus: false,
      suggestions: [],
      inputValue: inputValue,
      inputValueChanged: false
    };
    return _this;
  }

  var _proto = ObjectSuggestField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props7 = this.props,
        items = _this$props7.items,
        value = _this$props7.value,
        itemValueAttrName = _this$props7.itemValueAttrName,
        getItemValue = _this$props7.getItemValue;
    var inputValue = value ? getItemValue(value, itemValueAttrName || 'name') : '';
    this.updateSuggestions(inputValue, items);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentIsUnmounting = true;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.autosuggestRef.current && (document.activeElement !== this.autosuggestRef.current.input || nextProps.value)) {
      var inputValue = nextProps.value ? nextProps.getItemValue(nextProps.value, nextProps.itemValueAttrName || 'name') : '';

      if (this.props.value !== nextProps.value || this.state.inputValue !== inputValue && !nextProps.persistInput && nextProps.touched) {
        this.setState({
          inputValue: nextProps.value ? nextProps.getItemValue(nextProps.value, nextProps.itemValueAttrName || 'name') : '',
          inputValueChanged: false
        }, function () {
          _this2.updateSuggestions(inputValue, nextProps.items);
        });
      }
    }
  };

  _proto.render = function render() {
    var _this3 = this;

    var _this$state2 = this.state,
        inputValue = _this$state2.inputValue,
        suggestions = _this$state2.suggestions;

    var _this$props8 = this.props,
        className = _this$props8.className,
        getItemValue = _this$props8.getItemValue,
        addonsBefore = _this$props8.addonsBefore,
        addonsAfter = _this$props8.addonsAfter,
        value = _this$props8.value,
        disabled = _this$props8.disabled,
        placeholder = _this$props8.placeholder,
        dropdown = _this$props8.dropdown,
        removable = _this$props8.removable,
        minCharsForFilter = _this$props8.minCharsForFilter,
        title = _this$props8.title,
        inputId = _this$props8.inputId,
        otherProps = _objectWithoutPropertiesLoose(_this$props8, ["renderSuggestion", "itemValueAttrName", "shouldRenderSuggestions", "filterSuggestions", "className", "getItemValue", "addonsBefore", "addonsAfter", "value", "disabled", "onChange", "onFocus", "onBlur", "items", "placeholder", "dropdown", "removable", "minCharsForFilter", "title", "inputRef", "inputId"]); // TODO NOPEPARTS
    // Vynucení zobrazení nabídky, pokud se má zobrazovat


    var alwaysRenderSuggestions;
    alwaysRenderSuggestions = this.alwaysRenderSuggestions ? true : false; // if (this.shouldRenderSuggestions()) {
    // } else {
    //     alwaysRenderSuggestions = false;
    // }

    this.alwaysRenderSuggestions = false; // console.log(222, this.autosuggest)
    // console.log(111, "inputValue", inputValue, "inputValueChanged", inputValueChanged, "shouldRenderSuggestions", this.shouldRenderSuggestions(), "alwaysRenderSuggestions", alwaysRenderSuggestions)
    // Pokud není title zvenku definované, zobrazíme v title vybranou hodnotu

    var useTitle = title || inputValue;
    var displayedInputValue = inputValue || '';

    if (this.props.persistInput) {
      // Pokud focus máme je použito správně -> inputValue || ""
      if (!this.state.hasFocus && !value) {
        displayedInputValue = '';
      }
    }

    var field = React__default.createElement("div", {
      className: "autosuggest-container " + className
    }, React__default.createElement(Autosuggest, Object.assign({
      ref: this.autosuggestRef,
      alwaysRenderSuggestions: alwaysRenderSuggestions,
      theme: SUGGEST_THEME,
      getSuggestionValue: getItemValue,
      renderSuggestion: this.handleRenderSuggestions,
      shouldRenderSuggestions: this.shouldRenderSuggestions,
      suggestions: minCharsForFilter === 0 || inputValue && inputValue.length >= minCharsForFilter || this.dropdownClick && dropdown ? suggestions : [],
      onSuggestionsClearRequested: function onSuggestionsClearRequested() {
        _this3.handleSuggestionsUpdateRequested({
          value: ''
        });
      },
      onSuggestionsFetchRequested: this.handleSuggestionsUpdateRequested,
      onSuggestionSelected: this.handleSuggestionSelected,
      renderSuggestionsContainer: this.handleRenderSuggestionsContainer
    }, otherProps, {
      inputProps: {
        id: inputId,
        title: useTitle,
        value: displayedInputValue,
        onChange: this.handleInputChange,
        onBlur: this.handleBlur,
        onFocus: this.handleFocus,
        //onKeyDown: this.handleKeyDown,
        disabled: disabled,
        placeholder: placeholder
      }
    })));
    var hasAddonInline = false;
    var editAddons = [];
    var inlineAddon;

    if (dropdown) {
      if (value) {
        if (!disabled) {
          hasAddonInline = true;
          inlineAddon = React__default.createElement("div", {
            className: "input-group-btn input-addon-inline"
          }, React__default.createElement(Button, {
            type: "button",
            tabIndex: -1,
            ref: "dropdownButton",
            onMouseDown: this.handleClear
          }, React__default.createElement(FAIcon, {
            fixedWidth: true,
            icon: "remove"
          })));
        }
      } else {
        hasAddonInline = true;
        inlineAddon = React__default.createElement("div", {
          className: "input-group-btn input-addon-inline"
        }, React__default.createElement(Button, {
          type: "button",
          tabIndex: -1,
          ref: "dropdownButton",
          onMouseDown: this.handleDropdown
        }, React__default.createElement(FAIcon, {
          fixedWidth: true,
          icon: "caret-down"
        })));
      }
    } else if (removable) {
      if (value && !disabled) {
        hasAddonInline = true;
        inlineAddon = React__default.createElement("div", {
          className: "input-group-btn input-addon-inline"
        }, React__default.createElement(Button, {
          type: "button",
          tabIndex: -1,
          ref: "dropdownButton",
          onMouseDown: this.handleClear
        }, React__default.createElement(FAIcon, {
          fixedWidth: true,
          icon: "remove"
        })));
      }
    } // editAddons.push(<div className="input-group-btn"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button></div>);
    // editAddons.push(<div className="input-group-btn"><Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='plus' /></Button></div>);


    var fieldWrapper = React__default.createElement("div", {
      className: "autosuggest-dropdown-field " + (hasAddonInline ? 'has-addon-inline' : '')
    }, field, inlineAddon);
    return this.renderFieldWithAddons(fieldWrapper, addonsBefore, mergeAddons(addonsAfter, editAddons)); // if (dropdown) {
    //     return <div className="autosuggest-dropdown-input-wrapper">
    //         {this.renderFieldWithAddons(field, addonsBefore, addonsAfter)}
    //         <div className="input-group-btn dropdown-caret2">
    //             {!value && <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleDropdown}><Icon fixedWidth icon='caret-down'/></Button>}
    //             {value &&
    //             <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button>}
    //         </div>
    //     </div>
    // } else if (removable) {
    //     return <div className={value ? "autosuggest-dropdown-input-wrapper" : ""}>
    //         {this.renderFieldWithAddons(field, addonsBefore, addonsAfter)}
    //         {value && <div className="input-group-btn dropdown-caret2">
    //             <Button type="button" tabIndex={-1} ref="dropdownButton" onMouseDown={this.handleClear}><Icon fixedWidth icon='remove' /></Button>
    //         </div>}
    //     </div>
    // } else {
    //     return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
    // }
  };

  return ObjectSuggestField;
}(AbstractField);

ObjectSuggestField.propTypes = /*#__PURE__*/_extends({
  dropdown: PropTypes__default.bool,
  removable: PropTypes__default.bool,
  // render funkce jedné položky, předpis: (i, active, getItemValue, itemValueAttrName) => {}
  renderSuggestion: PropTypes__default.func,
  filterSuggestions: PropTypes__default.func,
  // název atributu v objekt, který je možné použít jako název pro zobrazení uživateli - je možné definovat jen atribut místo celé metody getItemValue, implicitně má hodnotu name
  itemValueAttrName: PropTypes__default.string,
  // funkce pro načtení hodnoty pro zobrazení uživateli - název položky, předpis: (i, itemValueAttrName) => {}
  getItemValue: PropTypes__default.func,
  shouldRenderSuggestions: PropTypes__default.func,
  items: PropTypes__default.array.isRequired,
  // po zadani hodnoty se vymaže
  tags: PropTypes__default.bool,
  // minimální počet znaků, od kterých se bude filtrovat, standardně 0
  minCharsForFilter: PropTypes__default.number,
  // Bude zachovávat hodnotu inputu mimo focus chvíli
  persistInput: PropTypes__default.bool,
  // Dodává informaci že input byl modifikován uživatelem
  touched: PropTypes__default.bool,
  // callback pro textovou hodnotu
  onInputChange: PropTypes__default.func
}, AbstractField.propTypes);
ObjectSuggestField.defaultProps = {
  tags: false,
  itemValueAttrName: 'name',
  dropdown: false,
  removable: false,
  minCharsForFilter: 0,
  renderSuggestion: function renderSuggestion(i, active, getItemValue, itemValueAttrName, inputValue) {
    var text = getItemValue(i, itemValueAttrName || 'name');
    return React__default.createElement("div", {
      className: active ? 'active' : ''
    }, highlightText(inputValue, text));
  },
  filterSuggestions: function filterSuggestions(value, list, getItemValue, itemValueAttrName) {
    return new Promise(function (resolve, reject) {
      if (value === null || value.length === 0) {
        resolve(list);
        return list;
      }

      var inputValue = value.trim().toLowerCase();
      var inputLength = inputValue.length;
      var result = inputLength === 0 ? [] : list.filter(function (item // getItemValue(item, itemValueAttrName || "name").toLowerCase().slice(0, inputLength) === inputValue
      ) {
        return getItemValue(item, itemValueAttrName || 'name').toLowerCase().indexOf(inputValue) !== -1;
      });
      resolve(result);
    });
  },
  getItemValue: function getItemValue(i, itemValueAttrName) {
    if (itemValueAttrName === void 0) {
      itemValueAttrName = 'name';
    }

    return i ? i[itemValueAttrName] : '';
  },
  shouldRenderSuggestions: function shouldRenderSuggestions(value) {
    return true;
  },
  persistInput: false
};

/**
 * ApiObjectSuggestField
 *
 * Field pro API suggest
 *
 * Komunikuje s API a načítá objekty, které renderuje pomocí funkce z props
 * (Včetně debouncingu)
 *
 * Ukázka viz. AdresaField.jsx
 */

var ApiObjectSuggestField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ApiObjectSuggestField, _React$Component);

  function ApiObjectSuggestField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.timer = 0;
    _this.timerPromiseReject = 0;

    _this.handleFilterSuggestions = function (value, list, getItemValue) {
      var _this$props = _this.props,
          filterSuggestions = _this$props.filterSuggestions,
          apiRequestDelay = _this$props.apiRequestDelay;

      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = 0;
      }

      if (_this.timerPromiseReject) {
        // @ts-ignore
        _this.timerPromiseReject();

        _this.timerPromiseReject = 0;
      }

      if (apiRequestDelay) {
        _this.timerPromise = new Promise(function (resolve, reject) {
          _this.timerPromiseReject = reject;
          _this.timer = setTimeout(function () {
            filterSuggestions(value).then(function (data) {
              return resolve(data);
            });
          }, apiRequestDelay);
        });
        return _this.timerPromise;
      } else {
        return filterSuggestions(value);
      }
    };

    return _this;
  }

  var _proto = ApiObjectSuggestField.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        getItemValue = _this$props2.getItemValue,
        renderSuggestion = _this$props2.renderSuggestion,
        shouldRenderSuggestions = _this$props2.shouldRenderSuggestions,
        other = _objectWithoutPropertiesLoose(_this$props2, ["getItemValue", "renderSuggestion", "shouldRenderSuggestions", "filterSuggestions"]);

    return React__default.createElement(ObjectSuggestField, Object.assign({
      filterSuggestions: this.handleFilterSuggestions,
      getItemValue: getItemValue,
      renderSuggestion: renderSuggestion,
      shouldRenderSuggestions: shouldRenderSuggestions,
      items: []
    }, other));
  };

  return ApiObjectSuggestField;
}(React__default.Component);

ApiObjectSuggestField.propTypes = {
  dropdown: PropTypes__default.bool,
  removable: PropTypes__default.bool,
  renderSuggestion: PropTypes__default.func,
  // render funkce jedné položky, předpis: (i, active, getItemValue, itemValueAttrName) => {}
  filterSuggestions: PropTypes__default.func,
  itemValueAttrName: PropTypes__default.string,
  // název atributu v objekt, který je možné použít jako název pro zobrazení uživateli - je možné definovat jen atribut místo celé metody getItemValue, implicitně má hodnotu name
  getItemValue: PropTypes__default.func,
  shouldRenderSuggestions: PropTypes__default.func,
  apiRequestDelay: PropTypes__default.number,
  tags: PropTypes__default.bool,
  // po zadani hodnoty se vymaže
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN,
  minCharsForFilter: PropTypes__default.number
};
ApiObjectSuggestField.defaultProps = {
  tags: false,
  dropdown: false,
  removable: false,
  renderSuggestion: ObjectSuggestField.defaultProps.renderSuggestion,
  getItemValue: ObjectSuggestField.defaultProps.getItemValue,
  items: [],
  apiRequestDelay: 100,
  shouldRenderSuggestions: ObjectSuggestField.defaultProps.shouldRenderSuggestions,
  minCharsForFilter: ObjectSuggestField.defaultProps.minCharsForFilter
};

var McTranslateFormContext = /*#__PURE__*/React__default.createContext({});

var FormBody = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FormBody, _React$Component);

  function FormBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        cards = _this$props.cards,
        children = _this$props.children,
        required = _this$props.required,
        style = _this$props.style,
        fieldLabelPrefix = _this$props.fieldLabelPrefix,
        formPath = _this$props.formPath;
    var isModal = this.context.isModal;
    var requiredInfo;

    if (required) {
      requiredInfo = React__default.createElement("div", {
        className: "required-fields-info"
      }, i18n('global.form.title.contains.required.fields'));
    }

    var cls = classNames('form-content-container', {
      cards: cards
    });
    var contextVal = {
      fieldLabelPrefix: fieldLabelPrefix,
      formPath: formPath
    };

    if (isModal) {
      return React__default.createElement(McTranslateFormContext.Provider, {
        value: contextVal
      }, React__default.createElement(ModalBody, {
        className: cls,
        style: style
      }, children, requiredInfo));
    } else {
      return React__default.createElement(McTranslateFormContext.Provider, {
        value: contextVal
      }, React__default.createElement("div", {
        className: cls,
        style: style
      }, children, requiredInfo));
    }
  };

  return FormBody;
}(React__default.Component);
FormBody.contextTypes = {
  isModal: PropTypes__default.bool
};
FormBody.propTypes = {
  fieldLabelPrefix: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array]),
  formPath: PropTypes__default.string,
  required: PropTypes__default.bool,
  cards: PropTypes__default.bool,
  // pokud je tru, jedná se o dialog, na kterém jsou logické sekce jako karty
  children: COMPONENT_CHILDREN
};
FormBody.defaultProps = {
  formPath: ''
};

/**
 * Komponenta pro akce u formulářů, akce mohou být buď součástí patičky dialogu nebo jako samostatný div kontejner.
 * Určení se provádí automaticky na základě kontektu.
 */

var FormActions = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FormActions, _React$Component);

  function FormActions() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.renderActions = function () {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          submitDisabled = _this$props.submitDisabled,
          onClose = _this$props.onClose,
          onSubmit = _this$props.onSubmit,
          closeButton = _this$props.closeButton,
          submitButton = _this$props.submitButton,
          okButton = _this$props.okButton,
          storeButton = _this$props.storeButton,
          cancelButton = _this$props.cancelButton,
          createButton = _this$props.createButton;
      var result = [];
      var commonsSubmit = {
        disabled: disabled || submitDisabled
      };
      var commonsCancel = {
        disabled: disabled
      };

      if (submitButton) {
        if (submitButton === true) {
          result.push(createElement(Button, Object.assign({
            key: 'submit'
          }, commonsSubmit, {
            color: "primary",
            type: "submit",
            onClick: onSubmit
          }), i18n('global.form.action.ok')));
        } else {
          result.push(createElement(Button, Object.assign({
            key: 'submit'
          }, commonsSubmit, {
            color: "primary",
            type: "submit",
            onClick: onSubmit
          }), submitButton));
        }
      }

      okButton && result.push(createElement(Button, Object.assign({
        key: 'ok'
      }, commonsSubmit, {
        color: "primary",
        type: "submit",
        onClick: onSubmit
      }), i18n('global.form.action.ok')));
      storeButton && result.push(createElement(Button, Object.assign({
        key: 'store'
      }, commonsSubmit, {
        color: "primary",
        type: "submit",
        onClick: onSubmit
      }), i18n('global.form.action.store')));
      createButton && result.push(createElement(Button, Object.assign({
        key: 'create'
      }, commonsSubmit, {
        color: "primary",
        type: "submit",
        onClick: onSubmit
      }), i18n('global.form.action.create')));
      closeButton && result.push(createElement(Button, Object.assign({
        key: 'close'
      }, commonsCancel, {
        type: "button",
        onClick: onClose
      }), i18n('global.form.action.close')));

      if (cancelButton) {
        if (cancelButton === true) {
          result.push(createElement(Button, Object.assign({
            key: 'cancel'
          }, commonsCancel, {
            type: "button",
            onClick: onClose
          }), i18n('global.form.action.cancel')));
        } else {
          result.push(createElement(Button, Object.assign({
            key: 'cancel'
          }, commonsCancel, {
            type: "button",
            onClick: onClose
          }), cancelButton));
        }
      }

      return result;
    };

    return _this;
  }

  var _proto = FormActions.prototype;

  _proto.render = function render() {
    var children = this.props.children;
    var length = 0;

    if (children) {
      if (Array.isArray(children)) {
        length = children.length;
      } else {
        length = 1;
      }
    }

    var actions = this.renderActions();
    length += actions.length;
    var isModal = this.context.isModal;

    if (isModal) {
      return createElement(ModalFooter, {
        className: "form-actions-container"
      }, children, this.renderActions());
    } else {
      return createElement("div", {
        className: "form-actions-container"
      }, length > 1 ? createElement(ButtonToolbar, null, children, actions) : createElement("div", null, children, actions));
    }
  };

  return FormActions;
}(Component);

FormActions.contextTypes = {
  isModal: PropTypes__default.bool
};
FormActions.propTypes = {
  onClose: PropTypes__default.func,
  onSubmit: PropTypes__default.func,
  closeButton: PropTypes__default.bool,
  submitButton: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string]),
  disabled: PropTypes__default.bool,
  // zakázání všech tlačítek
  submitDisabled: PropTypes__default.bool,
  // zakázání submit tlačítek
  okButton: PropTypes__default.bool,
  storeButton: PropTypes__default.bool,
  cancelButton: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string]),
  createButton: PropTypes__default.bool,
  children: COMPONENT_CHILDREN
};

/**
 * Akce pro modální dialog.
 * @type {string}
 */

var SHOW$1 = 'ModalDialog.show';
var HIDE$1 = 'ModalDialog.hide';
var CHANGE_SIZE = 'ModalDialog.changeSize';
var CHANGE_TITLE = 'ModalDialog.changeTitle';
/**
 * Zobrazení modálního dialogu. Pokud je nějaký dialog zobrazen, zobrazáí se nad ním další.
 * @param component reference na komponentu
 * @param componentProps props, které budou předávány při renderování komponenty
 * @param title titulek dialogu
 * @param modalProps doplňující props pro dialog, všechny kromě níže uvedených se předají na <Modal/>
 *                  podporované props:
 *                      noBackdrop pokud je true, nezobrazuje se pod tímto dialogem černé pozadí, ale jen průhledné, hodí se např. na donačítací async loading dialogy
 *                      className (doplňující třída)
 *                      onClose (on close callback)
 *                      size (md, lg, xl nebo full (skoro přes celou obrazovku) a fullscreen (pres celou obrazovku))
 *                      noHeader (true, pokud nechceme header dialogu
 *
 * @returns {{type: string, component: *, componentProps: *, title: *}}
 */

function show$1(component, componentProps, title, modalProps) {
  if (modalProps === void 0) {
    modalProps = {};
  }

  return {
    type: SHOW$1,
    component: component,
    componentProps: componentProps,
    title: title,
    modalProps: modalProps
  };
}
/**
 * Funkce pro změnu velikosti aktuálního dialogu.
 * @param size nová velikost dialog, může být null pro použití výchozí, se kterou bylo voláno zobrazení dialogu, velikosti viz metoda show
 */

function changeSize(size) {
  return {
    type: CHANGE_SIZE,
    size: size
  };
}
/**
 * Funkce pro změnu titulku aktuálního dialogu.
 * @param title nový titulek
 */

function changeTitle(title) {
  return {
    type: CHANGE_TITLE,
    title: title
  };
}

var getRenderableElement = function getRenderableElement(element) {
  if (typeof element === 'string' || isValidElement(element)) {
    return element;
  } else {
    return createElement(element);
  }
};
/**
 * Informativní dialog s titulkem a textem
 * @param message
 * @param dispatch
 * @param onClose on close callback
 * @param cards jedná se o info dialog s kartičkami, implicitně false
 */


var infoDialog = function infoDialog(message, dispatch, _onClose, cards) {
  if (cards === void 0) {
    cards = false;
  }

  var msg = getRenderableElement(message);
  return function () {
    return React__default.createElement("div", null, React__default.createElement(FormBody, {
      cards: cards
    }, msg), React__default.createElement(FormActions, {
      closeButton: true,
      onClose: function onClose() {
        dispatch(hide$1());
        _onClose && _onClose();
      }
    }));
  };
};

var confirmDialog = function confirmDialog(message, dispatch, onSubmit, confirmButtonText, cancelButtonText) {
  var handleSubmit = function handleSubmit() {
    dispatch(hide$1());
    onSubmit();
  };

  return function (props) {
    var msg = getRenderableElement(message);
    return React__default.createElement("div", null, React__default.createElement(FormBody, null, msg), React__default.createElement(FormActions, {
      onSubmit: handleSubmit,
      submitButton: confirmButtonText ? confirmButtonText : i18n('global.form.action.yes'),
      cancelButton: cancelButtonText ? cancelButtonText : true,
      onClose: props.onClose
    }));
  };
};

var AsyncWaitingDialog = /*#__PURE__*/connect()( /*#__PURE__*/function (_Component) {
  _inheritsLoose(_class, _Component);

  function _class(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    var dispatch = props.dispatch,
        callAsync = props.callAsync,
        resultCallback = props.resultCallback,
        errorCallback = props.errorCallback;
    callAsync.then(function () {
      dispatch(hide$1());
      resultCallback && resultCallback.apply(void 0, arguments);
    })["catch"](function () {
      dispatch(hide$1());

      for (var _len = arguments.length, error = new Array(_len), _key = 0; _key < _len; _key++) {
        error[_key] = arguments[_key];
      }

      console.error(error);
      errorCallback && errorCallback.apply(void 0, error);
    });
    return _this;
  }

  var _proto = _class.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        message = _this$props.message;
    var tit = getRenderableElement(title);
    var msg = getRenderableElement(message);
    return React__default.createElement("div", null, React__default.createElement(FormBody, null, tit && React__default.createElement("h2", null, tit), msg));
  };

  return _class;
}(Component));
/**
 * Zobrazení dialogu pro asynchronní operace, např. čekání na data nebo čekání na tisk apod.
 * @param title titulek zprávy pro uživatele, není povinné
 * @param message text zprávy
 * @param callAsync asynchronní operace, která má být zavolána, reference na funkci
 * @param resultCallback callbak po úspěšném zavolání callAsync
 * @param errorCallback callback po chybě po zavolání callback
 * @return {function(*, *)}
 */

function showAsyncWaiting(title, message, callAsync, resultCallback, errorCallback) {
  return function (dispatch, getState) {
    dispatch(show$1(AsyncWaitingDialog, {
      title: title,
      message: message,
      callAsync: callAsync,
      resultCallback: resultCallback,
      errorCallback: errorCallback
    }, null, {
      noHeader: true,
      noBackdrop: true
    }));
  };
}
/**
 * Zobrazí informativní dialog s titulkem a textem
 * @param title
 * @param message
 * @param onClose on close callback
 * @param cards jedná se o info dialog s kartičkami, implicitně false
 * @param modalProps viz metoda show
 */

function showInfo(title, message, onClose, cards, modalProps) {
  if (cards === void 0) {
    cards = false;
  }

  if (modalProps === void 0) {
    modalProps = {};
  }

  return function (dispatch, getState) {
    var useModalProps = _extends({}, modalProps, {
      onClose: onClose
    });

    dispatch(show$1(infoDialog(message, dispatch, onClose, cards), null, title, useModalProps));
  };
}
/**
 * Zobrazí potvrzovací dialog s titulkem a textem
 * @param title
 * @param message
 * @param onSubmit potvrzení dialogu
 * @param onCancel zrušení dialogu
 * @param confirmButtonText pokud je definováno, definuje text potvrzovacího tlačítka
 * @param cancelButtonText pokud je definováno, definuje text uzavíracího tlačítka
 */

function showConfirm(title, message, onSubmit, onCancel, confirmButtonText, cancelButtonText) {
  return function (dispatch, getState) {
    dispatch(show$1(confirmDialog(message, dispatch, onSubmit, confirmButtonText, cancelButtonText), {
      onClose: onCancel
    }, title));
  };
}
/**
 * Zavření aktuálního dialogu. Pokud je jich otevřeno více, zavře se poslední otevřený.
 * @returns {function(*, *)}
 */

function hide$1() {
  return function (dispatch, getState) {
    if (getState().modalDialog.components.length > 0) {
      dispatch({
        type: HIDE$1
      });
    }
  };
}

var ModalActions = {
  __proto__: null,
  SHOW: SHOW$1,
  HIDE: HIDE$1,
  CHANGE_SIZE: CHANGE_SIZE,
  CHANGE_TITLE: CHANGE_TITLE,
  show: show$1,
  changeSize: changeSize,
  changeTitle: changeTitle,
  showAsyncWaiting: showAsyncWaiting,
  showInfo: showInfo,
  showConfirm: showConfirm,
  hide: hide$1
};

/**
 * Form obal - poskytuje context pro Fieldy (FieldGrid,...)
 */

var CustomForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose(CustomForm, _Component);

  function CustomForm() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = CustomForm.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline;
    return {
      horizontal: horizontal ? true : false,
      inline: inline ? true : false,
      form: true
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        other = _objectWithoutPropertiesLoose(_this$props2, ["form", "horizontal"]);

    return React__default.createElement(Form, Object.assign({}, other));
  };

  return CustomForm;
}(Component);

CustomForm.childContextTypes = {
  form: PropTypes__default.bool,
  horizontal: PropTypes__default.bool,
  inline: PropTypes__default.bool
};

var TranslateComponent = function TranslateComponent(_ref) {
  var component = _ref.component,
      message = _ref.message,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["component", "message"]);

  var _React$useContext = React__default.useContext(McTranslateFormContext),
      fieldLabelPrefix = _React$useContext.fieldLabelPrefix,
      formPath = _React$useContext.formPath;

  var text;

  if (!message) {
    throw new Error('Message for translate not specified!!');
  } else if (Array.isArray(message)) {
    throw new Error('Array message not supported!!');
  }

  if (fieldLabelPrefix) {
    if (Array.isArray(fieldLabelPrefix)) {
      var keys = fieldLabelPrefix.map(function (key) {
        return formPath ? key + message.substring(formPath.length) : key + message;
      });
      text = i18n(keys);
    } else {
      if (formPath) {
        text = i18n(fieldLabelPrefix + message.substring(formPath.length));
      } else {
        text = i18n(fieldLabelPrefix + message);
      }
    }
  } else if (typeof message === 'string') {
    text = i18n('^' + message);

    if (text === null) {
      text = message;
    }
  }

  return React__default.createElement(component, otherProps, text);
};

TranslateComponent.propTypes = {
  message: PropTypes__default.string.isRequired
};
TranslateComponent.defaultProps = {
  component: Label
};

var lastId = 0;
/**
 * Funkce, která generuje unikátní id, např. pro tooltipy apod.
 *
 * Použití:
 * import newId from "....newId";
 *
 * constructor(props) {
 *   super(props);
 *   this.uniqueId = newId();
 * }
 *
 * @param prefix
 * @return {string}
 */

function newId (prefix) {
  if (prefix === void 0) {
    prefix = 'id';
  }

  lastId++;
  return "" + prefix + lastId;
}

var DEFAULT_INPUT_CLASS = {
  xs: 12,
  sm: 8,
  md: 8,
  lg: 8,
  xl: 8
};
var DEFAULT_OFFSETS_INPUT_CLASS = {
  xsOffset: 0,
  smOffset: 4,
  mdOffset: 4,
  lgOffset: 4,
  xlOffset: 4
};

var FieldGrid = /*#__PURE__*/function (_Component) {
  _inheritsLoose(FieldGrid, _Component);

  function FieldGrid(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.uniqueId = newId();
    return _this;
  }

  var _proto = FieldGrid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inlineErrorText = _this$props.inlineErrorText,
        className = _this$props.className,
        required = _this$props.required,
        check = _this$props.check,
        label = _this$props.label,
        checkboxLabel = _this$props.checkboxLabel,
        labelPosition = _this$props.labelPosition,
        children = _this$props.children,
        labelClass = _this$props.labelClass,
        inputClass = _this$props.inputClass,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["inlineErrorText", "className", "required", "check", "label", "checkboxLabel", "labelPosition", "children", "labelClass", "inputClass"]);

    var _this$context = this.context,
        form = _this$context.form,
        horizontal = _this$context.horizontal;

    var componentProps = _extends({}, otherProps, {
      className: classNames(className, {
        required: required
      })
    });

    if (form && horizontal) {
      componentProps.row = true;
    }

    var componentClass = form ? FormGroup : Row; // Input / Children

    var child;

    var customInputClass = _extends({}, inputClass); // Pokud není label a je nastavena výchozí hodnota inputClass z defaultProps


    if (inputClass === null) {
      if (check || label === false) {
        customInputClass = _extends({}, DEFAULT_INPUT_CLASS, DEFAULT_OFFSETS_INPUT_CLASS);
      } else {
        customInputClass = _extends({}, DEFAULT_INPUT_CLASS);
      }
    }

    if (label === false && (!check || check && checkboxLabel == null)) {
      if (inlineErrorText) {
        child = createElement(Col, Object.assign({}, customInputClass), createElement(UncontrolledTooltip, {
          tether: {
            classes: {
              enabled: 'show form-error-field-tether'
            }
          },
          className: "error-text",
          target: this.uniqueId
        }, inlineErrorText), createElement("div", {
          id: this.uniqueId
        }, children));
      } else {
        child = createElement(Col, Object.assign({}, customInputClass), children);
      }

      return createElement(componentClass, componentProps, child);
    } /// Label


    var labelComponent;
    var useLabel = label || checkboxLabel;

    if (Array.isArray(useLabel) || typeof useLabel === 'string') {
      var labelProps = {
        message: useLabel,
        component: check ? 'span' : Label
      };

      if (horizontal) {
        labelProps = _extends({}, labelProps, labelClass);
      }

      labelComponent = createElement(TranslateComponent, Object.assign({}, labelProps));
    } else {
      labelComponent = createElement(Col, Object.assign({}, labelClass), useLabel);
    }

    var wrapComponent = horizontal ? Col : 'div';

    if (!check) {
      // child = <Col {...customInputClass}>{children}</Col>;
      child = createElement(wrapComponent, customInputClass, children);
    } else {
      var childrenWithProps = Children.map(this.props.children, function (child) {
        return child ? cloneElement(child, {
          label: labelComponent
        }) : child;
      }); // child = <Col {...customInputClass}>{childrenWithProps}</Col>;

      child = createElement(wrapComponent, customInputClass, childrenWithProps); // labelComponent = <Col {...labelClass}></Col>;

      labelComponent = createElement(wrapComponent, labelClass);
    }

    if (labelPosition === FieldGrid.labelPosition.left) {
      return createElement(componentClass, componentProps, labelComponent, child);
    } else if (labelPosition === FieldGrid.labelPosition.right) {
      return createElement(componentClass, componentProps, child, labelComponent);
    } else {
      throw new Error('Unknown label position.');
    }
  };

  return FieldGrid;
}(Component);

FieldGrid.propTypes = {
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.element, PropTypes__default.bool]).isRequired,
  checkboxLabel: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.element, PropTypes__default.bool]),
  children: PropTypes__default.node.isRequired,
  labelPosition: PropTypes__default.string,
  required: PropTypes__default.bool,
  check: PropTypes__default.bool,
  // pokud je true, jedná se o field typu checkbox
  labelClass: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),
  inputClass: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.object])
};
FieldGrid.labelPosition = {
  left: 'left',
  right: 'right'
};
FieldGrid.defaultProps = {
  labelPosition: FieldGrid.labelPosition.left,
  labelClass: {
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4,
    xl: 4,
    className: 'label-part'
  },
  inputClass: null,
  className: 'field-grid',
  required: false
};
FieldGrid.contextTypes = {
  form: PropTypes__default.bool,
  horizontal: PropTypes__default.bool
};

var FieldForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FieldForm, _React$Component);

  function FieldForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.uniqueId = newId();
    return _this;
  }

  var _proto = FieldForm.prototype;

  _proto.render = function render() {
    var _classNames;

    // Je dostupný i `formPath`
    var horizontal = this.context.horizontal;

    var _this$props = this.props,
        color = _this$props.color,
        state = _this$props.state,
        input = _this$props.input,
        error = _this$props.error,
        check = _this$props.check,
        meta = _this$props.meta,
        name = _this$props.name,
        label = _this$props.label,
        checkboxLabel = _this$props.checkboxLabel,
        title = _this$props.title,
        field = _this$props.field,
        inline = _this$props.inline,
        required = _this$props.required,
        labelInField = _this$props.labelInField,
        labelClass = _this$props.labelClass,
        inputClass = _this$props.inputClass,
        hasFeedback = _this$props.hasFeedback,
        fieldLabelText = _this$props.fieldLabelText,
        other = _objectWithoutPropertiesLoose(_this$props, ["color", "state", "input", "error", "check", "meta", "name", "label", "checkboxLabel", "title", "field", "inline", "required", "labelInField", "labelClass", "inputClass", "hasFeedback", "fieldLabelText"]);

    var labelInFieldComponent;

    if (labelInField === true) {
      labelInFieldComponent = fieldLabelText;
    } else if (labelInField) {
      labelInFieldComponent = labelInField;
    } else {
      labelInFieldComponent = null;
    }

    var hasError = (this.props.meta && this.props.meta.touched && this.props.meta.error ? true : false) || (this.props.error ? true : false);
    var errorText; // const hasError = (meta && meta.touched && meta.error) || (error);

    if (hasError) {
      errorText = error || (meta ? meta.error : null);
    }

    if (typeof errorText === 'object') {
      console.error('Chyba při zobrazení chybové hlášky k fieldu', this.props, 'pravděpodobně je na formuláři validace na field, který není zobrazen');
      errorText = '???';
    } // Feedback


    var showFeedback = false;
    var feedbackColor;
    var feedbackState;

    if (hasFeedback) {
      if (meta.touched && !errorText) {
        if (meta.active) {
          showFeedback = true;
          feedbackColor = 'success';
        } else {
          showFeedback = true;
          feedbackColor = 'success';
          feedbackState = 'success';
        }
      } else if (errorText) {
        showFeedback = true;
        feedbackColor = 'danger';
        feedbackState = 'danger';
      }
    }

    var useState;
    var useColor;

    if (showFeedback) {
      useState = state || feedbackState;
      useColor = color || feedbackColor;
    } else {
      useState = state;
      useColor = color;
    } // --


    if (horizontal) {
      var _this$props2 = this.props,
          _label = _this$props2.label,
          _check = _this$props2.check,
          _labelClass = _this$props2.labelClass,
          labelPosition = _this$props2.labelPosition,
          _inline = _this$props2.inline,
          _inputClass = _this$props2.inputClass,
          noLabelInputClass = _this$props2.noLabelInputClass,
          _field = _this$props2.field,
          _required = _this$props2.required,
          _title = _this$props2.title,
          className = _this$props2.className,
          _input = _this$props2.input,
          otherProps = _objectWithoutPropertiesLoose(_this$props2, ["label", "color", "check", "labelInField", "labelClass", "labelPosition", "meta", "groupClass", "inline", "inputClass", "noLabelInputClass", "field", "required", "title", "className", "input"]);

      var useInputClass = _label === false ? noLabelInputClass : _inputClass;
      return createElement(FieldGrid, {
        label: _label === true ? _input.name : _label,
        check: _check,
        title: _title,
        inlineErrorText: _inline ? errorText : null,
        inputClass: useInputClass,
        checkboxLabel: checkboxLabel,
        labelPosition: labelPosition,
        required: _required,
        labelClass: _labelClass,
        className: classNames(className, {
          error: hasError,
          inline: _inline,
          required: _required
        })
      }, createElement(_field, _extends({}, _input, otherProps, {
        // Není potřeba
        //inputClass: useInputClass,
        //labelClass,
        state: useState
      })), !_inline && hasError && createElement("span", {
        className: "error-text"
      }, errorText));
    } // let titleComponent;
    // if (title === true) {
    //     titleComponent = fieldLabelText ? fieldLabelText : null;
    // } else if (title) {
    //     titleComponent = title;
    // }
    // if (inline && hasError) {
    //     titleComponent = errorText; // TODO spojit error a titulek
    // }
    // ----------------------------------


    var inlineErrorText = inline ? errorText : null;
    var customFieldProps = {}; // další doplňující, např. pro checkbox apod.

    var labelComponent;
    var useLabel = label || checkboxLabel;

    if (Array.isArray(useLabel) || typeof useLabel === 'string') {
      labelComponent = createElement(TranslateComponent, {
        title: title,
        message: useLabel,
        component: check ? 'span' : Label
      });
    } else if (useLabel === true) {
      var useName = name || (input ? input.name : null);

      if (!useName) {
        throw new Error('Field has no name!!');
      }

      labelComponent = createElement(TranslateComponent, {
        title: title,
        message: useName,
        component: check ? 'span' : Label
      });
    } else {
      labelComponent = useLabel;
    }

    if (check) {
      customFieldProps.label = labelComponent;
      labelComponent = null;
    }

    if (inlineErrorText) {
      customFieldProps.id = this.uniqueId;
    }

    var fieldProps = _extends({}, input, other, customFieldProps, {
      title: title,
      labelInFieldComponent: labelInFieldComponent,
      labelClass: labelClass,
      inputClass: inputClass
    });

    fieldProps.className = classNames(fieldProps.className, (_classNames = {}, _classNames[useState ? "form-control-" + useState : ""] = useState ? true : false, _classNames));
    var childField = createElement(field, fieldProps);

    if (inlineErrorText) {
      childField = createElement("div", null, createElement(UncontrolledTooltip, {
        tether: {
          classes: {
            enabled: 'show form-error-field-tether'
          }
        },
        className: "error-text",
        target: this.uniqueId
      }, inlineErrorText), childField);
    }

    return createElement(FormGroup, {
      color: useColor,
      check: check,
      className: classNames({
        error: hasError,
        required: required,
        inline: inline
      })
    }, !inline && labelComponent, childField, !inline && hasError && createElement("span", {
      className: "error-text"
    }, errorText));
  };

  return FieldForm;
}(Component);

FieldForm.contextTypes = {
  formPath: PropTypes__default.string,
  horizontal: PropTypes__default.bool,
  inline: PropTypes__default.bool
};
FieldForm.propTypes = {
  hasFeedback: PropTypes__default.bool,
  // pokud je true, zobrazuje se prvek s feedbackem podle toho, zda je chybný nebo ne, pokud je prvek upraven a je bez chyby, zobrazuje se jako success, pokud má focus, není zobrazena ikona check, pokud má chybu, zobrazuje se jako danger
  color: PropTypes__default.string,
  // barva/stav pro form group, např. success
  state: PropTypes__default.string,
  // stav pro input, např. success
  inputLabelOffset: PropTypes__default.bool,
  // pokud je uvedeno a je label na false, dá se do inpit class offset z label tak, aby byl input zarovnaný s ostatními hodnotami, které mají label, pokud je false, vezme se pro input class hodnota definovaná v noLabelInputClass
  inline: PropTypes__default.bool,
  required: PropTypes__default.bool,
  error: PropTypes__default.string,
  // překrytí chyby - v případě vlastního zpracování chyb
  check: PropTypes__default.bool,
  // pokud je true, jedná se o field typu checkbox
  groupClass: PropTypes__default.object,
  labelRight: PropTypes__default.bool,
  // má být label fieldu napravo od něj?
  labelInField: PropTypes__default.bool,
  // má být label renderovaný až ve fieldu, bude pak předaný jako label do fieldu přes props?
  labelClass: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.object]),
  inputClass: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.object]),
  noLabelInputClass: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.object]),
  field: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.func]),
  row: PropTypes__default.bool,
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string]),
  title: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.bool, PropTypes__default.string])
};
FieldForm.defaultProps = {
  labelInField: false,
  groupClass: {},
  inline: false,
  label: true,
  labelClass: {
    xs: 12,
    sm: 4,
    md: 4,
    lg: 4,
    xl: 4
  },
  inputClass: {
    xs: 12,
    sm: 8,
    md: 8,
    lg: 8,
    xl: 8
  },
  noLabelInputClass: {
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
  }
};

/**
 * @deprecated
 */

var McField = function McField(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? FieldForm : _ref$component,
      other = _objectWithoutPropertiesLoose(_ref, ["component"]);

  return React__default.createElement(Field, Object.assign({
    component: component
  }, other));
};

var StringField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(StringField, _AbstractField);

  function StringField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = StringField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        addonsAfter = _this$props.addonsAfter,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter"]);

    var field = React__default.createElement(Input, Object.assign({
      type: "text"
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return StringField;
}(AbstractField);

/**
 * Klasický select
 */

var SelectField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(SelectField, _AbstractField);

  function SelectField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = SelectField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        addonsAfter = _this$props.addonsAfter,
        children = _this$props.children,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter", "children", "meta"]);

    var field = React__default.createElement(Input, Object.assign({
      type: "select"
    }, props), children);
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return SelectField;
}(AbstractField);

var NumberField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(NumberField, _AbstractField);

  function NumberField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.handleChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value,
          _double = _this$props["double"],
          _int = _this$props["int"];
      var textValue = e.target.value;
      var normalizeFunc;

      if (_double) {
        normalizeFunc = normalizeDouble;
      } else if (_int) {
        normalizeFunc = normalizeInt;
      } else {
        normalizeFunc = normalizeInt;
      }

      var normalizedValue = normalizeFunc(textValue);
      normalizedValue !== value && onChange(normalizedValue);
    };

    _this.handleBlur = function () {
      var _this$props2 = _this.props,
          onBlur = _this$props2.onBlur,
          value = _this$props2.value;

      if (onBlur) {
        onBlur(value);
      }
    };

    return _this;
  }

  var _proto = NumberField.prototype;

  _proto.render = function render() {
    var _this$props3 = this.props,
        addonsBefore = _this$props3.addonsBefore,
        addonsAfter = _this$props3.addonsAfter,
        value = _this$props3.value,
        _double2 = _this$props3["double"],
        _int2 = _this$props3["int"],
        props = _objectWithoutPropertiesLoose(_this$props3, ["addonsBefore", "addonsAfter", "value", "double", "int", "onBlur", "onChange"]);

    var inputValue;

    if (_double2) {
      inputValue = normalizeDoubleForUser(value);
    } else if (_int2) {
      inputValue = value;
    } else {
      inputValue = value;
    }

    var field = React__default.createElement(Input, Object.assign({
      type: "text",
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      value: inputValue
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return NumberField;
}(AbstractField);

NumberField.propTypes = /*#__PURE__*/_extends({
  "int": PropTypes__default.bool,
  "double": PropTypes__default.bool
}, AbstractField.propTypes);
NumberField.defaultProps = {
  "int": false,
  "double": false
};



var index$5 = {
  __proto__: null,
  FAIcon: FAIcon,
  Icon: FAIcon,
  MCIcon: Icon
};

/**
 * Třída pro zobrazení globálních validačních chyb na formuláři.
 *
 * Použití:
 * const {error} = this.props;
 * {error && <ValidationErrors error={error}/>}
 */

var ValidationErrors = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ValidationErrors, _React$Component);

  function ValidationErrors() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ValidationErrors.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        error = _this$props.error,
        className = _this$props.className;

    if (Array.isArray(error)) {
      var rows = error.map(function (err) {
        return React__default.createElement("div", null, err);
      });
      return React__default.createElement(Alert, {
        color: "danger",
        className: className
      }, rows);
    } else {
      return React__default.createElement(Alert, {
        color: "danger",
        className: className
      }, error);
    }
  };

  return ValidationErrors;
}(React__default.Component);
ValidationErrors.propTypes = {
  error: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array])
};

/**
 * Porovnání dvou řetězců pomocí ignore case s přihlédnutím na locale.
 * @param x řetězec 1
 * @param y řetězec 2
 * @return {boolean} true, pokud jsou řetězce stejné
 */

var localeEqualsIgnoreEquals = function localeEqualsIgnoreEquals(x, y) {
  if (x === y) {
    return true;
  }

  if (!x && y || x && !y) {
    return false;
  }

  return x.toLocaleLowerCase().localeCompare(y.toLocaleLowerCase()) === 0;
};
/**
 * Test, zda zadaný stát je česká republika - implementace převzata z cz.marbes.commons.formatter.adresa.AdresaTools.
 * @param nazevStat název stát, nemusí být zadaný
 * @return {boolean} true, pokud je zadaný stát ČR
 */


var isCR = function isCR(nazevStat) {
  if (!nazevStat) {
    // pokud není uveden, bere se implcitně ČR
    return true;
  }

  return  localeEqualsIgnoreEquals('Česká republika', nazevStat) || localeEqualsIgnoreEquals('Česko', nazevStat) || localeEqualsIgnoreEquals('ČR', nazevStat) || localeEqualsIgnoreEquals('CZE', nazevStat) || localeEqualsIgnoreEquals('CZ', nazevStat);
};
/** Validace formuláře adresy. */


var validate = function validate(formData, _) {
  var errors = {};
  var errorMessages = [];

  if (isCR(formData.stat)) {
    // adresa v ČR
    if (!formData.obec) {
      errorMessages.push(i18n('adresa.form.validation.cr.obec.required'));
    }

    if (!formData.cisloDomovni && (!formData.ulice || !formData.cisloOrientacni)) {
      errorMessages.push(i18n('adresa.form.validation.cr.common.required'));
    }
  } else {
    // adresa mimo ČR
    if (!formData.obec) {
      errorMessages.push(i18n('adresa.form.validation.noCr.obec.required'));
    }
  }

  if (errorMessages.length > 0) {
    errors['_error'] = errorMessages.join(' ');
  }

  return errors;
};
/**
 * Komponenta pro vlastní formulář, může být buď součástí těla dialogu nebo jako samostatný div kontejner.
 * Určení se provádí automaticky na základě kontextu.
 */


var AdresaForm = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AdresaForm, _React$Component);

  function AdresaForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.renderForm = function (disabled) {
      var _this$props = _this.props,
          error = _this$props.error,
          defaultFieldLabelPrefix = _this$props.defaultFieldLabelPrefix,
          fieldLabelPrefix = _this$props.fieldLabelPrefix,
          formData = _this$props.formData,
          overeniDisabled = _this$props.overeniDisabled;
      var _this$state = _this.state,
          showOvereniError = _this$state.showOvereniError,
          verifying = _this$state.verifying;
      var overenaAdresa = formData && formData.registrId != null;
      var commons = {
        label: true,
        disabled: disabled
      };
      var overeniAdresy;

      if (!overeniDisabled) {
        if (overenaAdresa) {
          overeniAdresy = createElement(Badge, {
            color: "success",
            title: i18n('adresa.form.title.overenaAdresa.overeno.tooltip')
          }, i18n('adresa.form.title.overenaAdresa.overeno'));
        } else {
          var valid = Object.keys(validate(formData || {})).length === 0;
          overeniAdresy = createElement("div", null, createElement("div", null, createElement(Badge, {
            color: "danger",
            title: i18n('adresa.form.title.overenaAdresa.neovereno.tooltip')
          }, i18n('adresa.form.title.overenaAdresa.neovereno')), createElement(Button, {
            className: "pull-right",
            disabled: !valid || !formData || disabled,
            onClick: _this.handleVerify,
            title: i18n('adresa.form.action.ztotozniAdresu.tooltip')
          }, verifying && createElement(FAIcon, {
            icon: "refresh",
            animation: "spin"
          }), i18n('adresa.form.action.ztotozniAdresu'))), error && createElement("div", null, createElement("br", null), createElement(ValidationErrors, {
            error: error
          })));
        }
      }

      return createElement(FormBody, {
        fieldLabelPrefix: [fieldLabelPrefix, defaultFieldLabelPrefix]
      }, createElement(Row, null, createElement(Col, null, createElement(McField, Object.assign({
        name: 'ulice',
        field: StringField,
        maxLength: 48
      }, commons)), createElement(McField, Object.assign({
        name: 'cisloOrientacni',
        field: NumberField,
        "int": true
      }, commons)), createElement(McField, Object.assign({
        name: 'cisloOrientacniPismeno',
        field: StringField,
        maxLength: 1
      }, commons, {
        title: true
      })))), createElement(Row, null, createElement(Col, null, createElement(McField, Object.assign({
        name: 'castObce',
        field: StringField,
        maxLength: 48
      }, commons)), createElement(McField, Object.assign({
        name: 'cisloDomovni',
        field: NumberField,
        "int": true
      }, commons)), createElement(McField, Object.assign({
        name: 'cisloDomovniZnak',
        field: SelectField
      }, commons, {
        title: true
      }), createElement("option", null), createElement("option", {
        value: "E"
      }, "E")), createElement(McField, Object.assign({
        name: 'mestCast',
        field: StringField,
        maxLength: 48
      }, commons)), createElement(McField, Object.assign({
        row: true,
        name: 'nazevMop',
        field: StringField,
        maxLength: 240
      }, commons)), createElement(McField, Object.assign({
        row: true,
        name: 'nazevKatastralniUzemi',
        field: StringField,
        maxLength: 240
      }, commons)))), createElement(McField, Object.assign({
        row: true,
        name: 'obec',
        field: StringField,
        maxLength: 48
      }, commons)), createElement(Row, null, createElement(Col, null, createElement(McField, Object.assign({
        name: 'psc',
        field: StringField,
        maxLength: 10
      }, commons)), createElement(McField, Object.assign({
        name: 'posta',
        field: StringField,
        maxLength: 48
      }, commons)))), createElement(McField, Object.assign({
        row: true,
        name: 'okres',
        field: StringField,
        maxLength: 32
      }, commons)), createElement(McField, Object.assign({
        row: true,
        name: 'kraj',
        field: StringField,
        maxLength: 32
      }, commons)), createElement(McField, Object.assign({
        row: true,
        name: 'stat',
        field: StringField,
        maxLength: 240
      }, commons)), !overeniDisabled && createElement(FieldGrid, Object.assign({}, commons, {
        label: "overenaAdresa",
        error: showOvereniError ? i18n('adresa.form.action.ztotozniAdresu.title.neztotozneno') : null
      }), overeniAdresy));
    };

    _this.handleVerify = function () {
      var _this$props2 = _this.props,
          form = _this$props2.form,
          initialize = _this$props2.initialize,
          formData = _this$props2.formData;

      if (formData) {
        _this.setState({
          verifying: true
        });

        startSubmit(form);
        AdresaApi.ztotozniAdresu(formData).then(function (data) {
          if (data) {
            _this.setState({
              showOvereniError: false
            });

            initialize(data);
          } else {
            _this.setState({
              showOvereniError: true
            });
          }

          stopSubmit(form);

          _this.setState({
            verifying: false
          });
        })["catch"](function (err) {
          stopSubmit(form);

          _this.setState({
            verifying: false
          });

          err && console.error(err);
          throw err;
        });
      }
    };

    _this.customHandleSubmit = function (e) {
      var _this$props3 = _this.props,
          form = _this$props3.form,
          formData = _this$props3.formData,
          onSubmit = _this$props3.onSubmit,
          handleSubmit = _this$props3.handleSubmit,
          change = _this$props3.change;
      e.preventDefault();
      e.stopPropagation();

      if (formData) {
        startSubmit(form);
        AdresaApi.aktualizujPopisAdresy(formData).then(function (data) {
          _this.props.dispatch(change('popis', data.popis));

          handleSubmit(onSubmit)()["catch"](function () {
            stopSubmit(form);
          });
        })["catch"](function () {
          stopSubmit(form);
        });
      }
    };

    _this.state = {
      showOvereniError: false,
      verifying: false
    };
    return _this;
  }

  var _proto = AdresaForm.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var change = nextProps.change,
        newFormData = nextProps.formData;
    var prevFormData = this.props.formData;
    var showOvereniError = this.state.showOvereniError;

    if (!prevFormData && newFormData || prevFormData && !newFormData) ; else {
      if (nextProps.formData !== this.props.formData && !StoreUtils.objectEquals(prevFormData, newFormData)) {
        // něco se na formuláři změnilo
        // Při jakékoli změně nechceme již zobrazovat chybu posledního ověření
        if (showOvereniError) {
          this.setState({
            showOvereniError: false
          });
        } // Změna dat na formuláři


        if (prevFormData && newFormData && !prevFormData.registrId && newFormData.registrId) ; else {
          // u jiné změny resetujeme ověření
          if (newFormData) {
            // newFormData.overenaAdresa !== null && this.props.dispatch(change("overenaAdresa", false));
            newFormData.registrId !== null && this.props.dispatch(change('registrId', null)); // newFormData.idObecRegistr !== null && this.props.dispatch(change("idObecRegistr", null));
          }
        }
      }
    }
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        preview = _this$props4.preview,
        onClose = _this$props4.onClose,
        submitting = _this$props4.submitting;
    var verifying = this.state.verifying;
    var disabled = submitting || verifying || preview;
    return createElement(CustomForm, {
      horizontal: true,
      onSubmit: this.customHandleSubmit
    }, this.renderForm(disabled), !preview && createElement(FormActions, {
      onClose: onClose,
      disabled: disabled,
      onSubmit: this.customHandleSubmit,
      okButton: true,
      cancelButton: true
    }), preview && createElement(FormActions, {
      onClose: onClose,
      closeButton: true
    }));
  };

  return AdresaForm;
}(Component);

AdresaForm.formName = 'adresaForm';
AdresaForm.propTypes = {
  fieldLabelPrefix: PropTypes__default.string,
  preview: PropTypes__default.bool,
  // pokud je true, je formulář zobrazen pouze pro náhled
  overeniDisabled: PropTypes__default.bool
};
AdresaForm.defaultProps = {
  defaultFieldLabelPrefix: 'adresa.form.title.',
  // neměnit, jedná se o výchozí prefix pro formulář, pro který jsou texty definované v shared
  fieldLabelPrefix: 'adresa.form.title.',
  overeniDisabled: false
};
var reduxAdresaForm = /*#__PURE__*/reduxForm({
  form: AdresaForm.formName,
  validate: validate
})(AdresaForm);

function mapStateToProps$1(state, props) {
  var formName = props.formName || AdresaForm.formName;
  return {
    formData: getFormValues(formName)(state)
  };
}

var AdresaForm$1 = /*#__PURE__*/connect(mapStateToProps$1)(reduxAdresaForm);

/**
 * Adresa Field
 *
 * Použití pro dohledání / ztotožnění adres
 *
 * Lze vyvolat dialog s editací
 *
 * TODO @compel/@stanekpa možná udělat verzi bez connectu
 */

var AdresaField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(AdresaField, _AbstractField);

  function AdresaField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      var _this$props = _this.props,
          typyAdres = _this$props.typyAdres,
          obecIds = _this$props.obecIds,
          api = _this$props.api;
      var params = {
        fulltext: value,
        typyAdres: typyAdres,
        obecIds: obecIds,
        max: 20,
        '@class': 'FindAdresyParamsVO'
      };
      return api ? api(params) : AdresaApi.findAdresy(params);
    };
    /**
     * Zobrazení náhledu adresy.
     */


    _this.handleShow = function () {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          disabled = _this$props2.disabled;
      var useValue = typeof value === 'string' ? {} : value; // při prázdné dává redux form string!

      _this.props.dispatch(show$1(AdresaForm$1, {
        preview: disabled,
        initialValues: useValue
      }, i18n('adresa.form.title'), {
        size: 'md'
      }));
    };

    _this.handleEdit = function () {
      var _this$props3 = _this.props,
          value = _this$props3.value,
          offlineMode = _this$props3.offlineMode;
      var useValue = typeof value === 'string' ? {} : value; // při prázdné dává redux form string!

      _this.props.dispatch(show$1(AdresaForm$1, {
        onSubmit: _this.handleAdresaFormSubmit,
        overeniDisabled: offlineMode,
        initialValues: _extends({
          '@class': 'AdresaVO'
        }, useValue)
      }, i18n('adresa.form.title'), {
        size: 'md'
      }));
    };

    _this.handleClear = function () {
      _this.props.onChange(null);
    };

    _this.handleAdresaFormSubmit = function (data) {
      var onChange = _this.props.onChange;

      _this.props.dispatch(hide$1());

      if (data && !data.typAdresy) {
        data.typAdresy = K; // field je pouze pro klasické adresy a je třeba je vyplnit, pokud nejsou
      }

      onChange(data);
    };

    return _this;
  }

  var _proto = AdresaField.prototype;

  _proto.render = function render() {
    var _this$props4 = this.props,
        addonsAfter = _this$props4.addonsAfter,
        dispatch = _this$props4.dispatch,
        apiRequestDelay = _this$props4.apiRequestDelay,
        value = _this$props4.value,
        offlineMode = _this$props4.offlineMode,
        other = _objectWithoutPropertiesLoose(_this$props4, ["addonsAfter", "typyAdres", "dispatch", "obecIds", "apiRequestDelay", "value", "offlineMode"]);

    var disabled = this.props.disabled;
    var editAddons = [];

    if (!disabled && offlineMode) {
      editAddons.push(React__default.createElement("div", {
        className: "input-group-btn",
        key: "clear-btn"
      }, React__default.createElement(Button, {
        disabled: disabled,
        onClick: this.handleClear
      }, React__default.createElement(FAIcon, {
        icon: "times"
      }))));
    }

    editAddons.push(React__default.createElement("div", {
      className: "input-group-btn",
      key: "edit-btn"
    }, disabled && value ? // je zakázán a má hodnotu, zobrazíme akci pro zobrazení náhledu
    React__default.createElement(Button, {
      type: "button",
      onClick: this.handleShow
    }, React__default.createElement(FAIcon, {
      icon: "eye"
    })) // standardní zobrazení pro editaci, může být zakázané, pokud je zakázán a nemá hodnotu
    : React__default.createElement(Button, {
      type: "button",
      disabled: disabled,
      onClick: this.handleEdit
    }, React__default.createElement(FAIcon, {
      icon: "edit"
    }))));
    var finalAddonsAfter = mergeAddons(addonsAfter, editAddons);

    if (offlineMode) {
      var field = React__default.createElement("input", Object.assign({
        type: "text",
        className: "form-control",
        readOnly: true,
        value: value && value.popis
      }, other));
      return this.renderFieldWithAddons(field, null, finalAddonsAfter);
    }

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      value: value,
      minCharsForFilter: 3,
      placeholder: "Vyhledat adresu...",
      filterSuggestions: this.handleFilterSuggestions,
      itemValueAttrName: "popis",
      apiRequestDelay: apiRequestDelay,
      addonsAfter: finalAddonsAfter,
      dispatch: dispatch,
      persistInput: false
    }, other));
  };

  return AdresaField;
}(AbstractField);

AdresaField.propTypes = {
  api: PropTypes__default.func,
  typyAdres: PropTypes__default.array,
  obecIds: PropTypes__default.array,
  apiRequestDelay: PropTypes__default.number,
  offlineMode: PropTypes__default.bool,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN,
  persistInput: PropTypes__default.bool
};
AdresaField.defaultProps = {
  api: AdresaApi.findAdresy,
  // Api k použití
  obecIds: [],
  apiRequestDelay: 250,
  typyAdres: [K],
  // Aktualne je vychozi hodnota offline mode resena velmi jednoduse pres globalni konfiguraci aplikace.
  // Pokud neni parametr v globalni konfiguraci nastaven, predpokladame jeho hodnotu true (tzn. online mode),
  // kvuli zpetne kompatibilite.
  offlineMode: window.appConfig && window.appConfig.xrnConfigured === false,
  persistInput: true
};
var AdresaField$1 = /*#__PURE__*/connect()(AdresaField); // export default AdresaField;

/**
 * Komponenta pro text input - definována pro překrytí a kontrolu shouldComponentUpdate. Pokud se v autocomplete
 * dovyplní a označí zbytek textu a input se překreslil, zmizel daný text. Tato komponenta tomu zzabrání - testuje změnu value.
 */

var Autocomplete = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Autocomplete, _React$Component);

  function Autocomplete(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._ignoreBlur = false;
    _this.requestId = 1;
    _this.inputRef = React__default.createRef();
    _this.menuRef = React__default.createRef();
    _this.menuParentRef = React__default.createRef();
    /**
     * Získání indexu další možné položky pro focus.
     * @param index aktuální index
     * @param loop pokud je true, focus na položkách cykluje
     * @return další možná položka nebo index, pokud jiná není
     */

    _this.getNextFocusableItem = function (index, loop) {
      var _this$props = _this.props,
          allowFocusItem = _this$props.allowFocusItem,
          getItemId = _this$props.getItemId;

      var items = _this.getFilteredItems();

      if (items == null) {
        return null;
      }

      var start = index !== null ? index : 0;
      var ii = index != null ? start + 1 : start;

      if (ii >= items.length) {
        // na konci přejdeme na začátek
        if (!loop) return null;
        ii = 0;
      }

      while (true) {
        var item = items[ii];

        if (_this.callAllowFocusItem(allowFocusItem, getItemId(item), item)) {
          return ii;
        }

        ii++;

        if (ii >= items.length) {
          // na konci přejdeme na začátek
          if (!loop) return null;
          ii = 0;
        }

        if (ii === start) {
          // udělali jsme celé kolečko a nenalezli položku, na kterou se může dát další focus
          return index;
        }
      }

      return null;
    };

    _this.callAllowFocusItem = function (allowFocusItem, itemId, item) {
      if (item && item._titleLabel) {
        return false;
      }

      return allowFocusItem ? allowFocusItem(itemId, item) : true;
    };

    _this.callAllowSelectItem = function (allowSelectItem, itemId, item) {
      if (item && item._titleLabel) {
        return false;
      }

      return allowSelectItem ? allowSelectItem(itemId, item) : true;
    };
    /**
     * Získání indexu předchozí možné položky pro focus.
     * @param index aktuální index
     * @param loop pokud je true, focus na položkách cykluje
     * @return další možná položka nebo index, pokud jiná není
     */


    _this.getPrevFocusableItem = function (index, loop) {
      var _this$props2 = _this.props,
          allowFocusItem = _this$props2.allowFocusItem,
          getItemId = _this$props2.getItemId;

      var items = _this.getFilteredItems();

      if (items == null) {
        return null;
      }

      var start = index !== null ? index : items.length - 1;
      var ii = index !== null ? index - 1 : start;

      if (ii < 0) {
        // na konci přejdeme na začátek
        if (!loop) return null;
        ii = items.length - 1;
      }

      while (true) {
        var item = items[ii];

        if (_this.callAllowFocusItem(allowFocusItem, getItemId(item), item)) {
          return ii;
        }

        ii--;

        if (ii < 0) {
          // na konci přejdeme na začátek
          if (!loop) return null;
          ii = items.length - 1;
        }

        if (ii === start) {
          // udělali jsme celé kolečko a nenalezli položku, na kterou se může dát další focus
          return index;
        }
      }

      return null;
    };

    _this.getItemsTitleItem = function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var _props = props,
          itemsTitle = _props.itemsTitle;
      return !itemsTitle ? null : {
        _titleLabel: true,
        _items: true,
        name: itemsTitle
      };
    };

    _this.getNoItemsFoundItem = function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var _props2 = props,
          noItemsFound = _props2.noItemsFound;
      return !noItemsFound ? null : {
        _titleLabel: true,
        _noItemsFound: true,
        name: noItemsFound
      };
    };

    _this.getFavoriteItemsTitleItem = function (props) {
      if (props === void 0) {
        props = _this.props;
      }

      var _props3 = props,
          favoriteItemsTitle = _props3.favoriteItemsTitle;
      return !favoriteItemsTitle ? null : {
        _titleLabel: true,
        _favoriteItems: true,
        name: favoriteItemsTitle
      };
    };
    /**
     * Rozbalení nebo zabalení položky ve stromu.
     * @param node položka
     * @param expand true, pokud se má rozbalit
     */


    _this.expandNode = function (node, expand) {
      var _this$state = _this.state,
          changed = _this$state.changed,
          expandedIds = _this$state.expandedIds,
          inputStrValue = _this$state.inputStrValue,
          shouldItemRender = _this$state.shouldItemRender;
      var _this$props3 = _this.props,
          favoriteItems = _this$props3.favoriteItems,
          alwaysExpanded = _this$props3.alwaysExpanded,
          items = _this$props3.items,
          tree = _this$props3.tree,
          getItemId = _this$props3.getItemId,
          getItemName = _this$props3.getItemName,
          allowSelectItem = _this$props3.allowSelectItem,
          allowFocusItem = _this$props3.allowFocusItem;

      var noItemsFoundItem = _this.getNoItemsFoundItem();

      var favoriteItemsTitleItem = _this.getFavoriteItemsTitleItem();

      var itemsTitleItem = _this.getItemsTitleItem();

      var id = _this.props.getItemId(node);

      var newExpandedIds;

      if (expand) {
        var _extends2;

        newExpandedIds = _extends({}, expandedIds, (_extends2 = {}, _extends2[id] = true, _extends2));
      } else {
        newExpandedIds = _extends({}, expandedIds);
        delete newExpandedIds[id];
      }

      var filterText = changed ? inputStrValue : '';
      var favoriteInfo = {
        favoriteItems: favoriteItems,
        itemsTitleItem: itemsTitleItem,
        favoriteItemsTitleItem: favoriteItemsTitleItem
      };

      var newItemsInfo = _this.getNewFilteredItems(items, favoriteInfo, null, shouldItemRender, filterText, tree, newExpandedIds, getItemId, getItemName, allowSelectItem, allowFocusItem, false, alwaysExpanded, noItemsFoundItem);

      _this.changeState({
        expandedIds: newExpandedIds,
        items: newItemsInfo.items,
        itemsDepth: newItemsInfo.itemsDepth
      });
    };
    /**
     * Metoda pro změnu stavu - měla by se volat místo this.setState, protože kontroluje, zda se mají položky přefiltrovat.
     * @param nextState
     * @param callback
     */


    _this.changeState = function (nextState, callback) {
      _this.setState(nextState, callback);
    };

    _this.focus = function () {
      _this.inputRef.current.focus();
    };

    _this.getStateFromProps = function (props, nextProps, state) {
      var shouldItemRender;
      var changed = state.changed;

      if (nextProps.shouldItemRender) {
        shouldItemRender = nextProps.shouldItemRender;
      } else {
        shouldItemRender = function shouldItemRender(item, value) {
          return nextProps.getItemName(item).toLowerCase().indexOf(value.toLowerCase()) !== -1;
        };
      } // ---


      var inputStrValue;

      var prevRealValue = _this.getRealValue(props.value, props);

      var nextRealValue = _this.getRealValue(nextProps.value, nextProps);

      var prevId = props.getItemId ? props.getItemId(prevRealValue) : nextProps.getItemId(prevRealValue);
      var newId = nextProps.getItemId(nextRealValue);

      if (prevId != newId) {
        // Změna stavu, při které byla vybrána jiná položka.
        changed = false;
        inputStrValue = nextProps.getItemName(nextRealValue);

        if (typeof inputStrValue === 'undefined') {
          inputStrValue = '';
        }
      } else if (prevId === newId && !state.changed && !nextProps.keepChangedInput) {
        /* pokud došlo ke změně stavu, při které zůstala vybrána stejná položka
         a nebyl změněn vyhledávaný text ručně.*/
        inputStrValue = nextProps.getItemName(nextRealValue);
      } else {
        inputStrValue = state.inputStrValue;
      } // ---
      // Pokud se jedná o první zobrazení nebo změnu položek items, přefiltrujeme položky


      var filterResult;

      if (props.items !== nextProps.items) {
        filterResult = _this.getFilteredResult(inputStrValue, state.changed, nextProps, state, nextProps.items);
      } else {
        filterResult = {
          items: state.items
        };
      } // ---


      var highlightedIndex = state.highlightedIndex;

      if (nextRealValue) {
        var showHighlightedIndex = _this.getHighlightedIndexByValue(nextRealValue, filterResult.items, nextProps.getItemId);

        if (highlightedIndex !== showHighlightedIndex) {
          highlightedIndex = showHighlightedIndex;
        }
      } // ---


      var result = _extends({}, filterResult, {
        shouldItemRender: shouldItemRender,
        highlightedIndex: highlightedIndex,
        value: nextRealValue,
        inputStrValue: inputStrValue,
        changed: changed
      });
      return result;
    };

    _this.getRealValue = function (value, props) {
      if (props === void 0) {
        props = _this.props;
      }

      var _props4 = props,
          useIdAsValue = _props4.useIdAsValue;

      if (!useIdAsValue) {
        return value;
      }

      if (value == null || value == '') {
        return value;
      }

      var _props5 = props,
          getItemId = _props5.getItemId;
      return _this.getRealValueInTree(value, props.items, getItemId);
    };

    _this.getRealValueInTree = function (value, items, getItemId) {
      for (var _iterator = _createForOfIteratorHelperLoose(items), _step; !(_step = _iterator()).done;) {
        var item = _step.value;

        if (getItemId(item) === value) {
          return item;
        }

        if (item.children) {
          var res = _this.getRealValueInTree(value, item.children, getItemId);

          if (res) {
            return res;
          }
        }
      }

      return null;
    };

    _this.handleDocumentClick = function (e) {
      var el1 = _this.inputRef.current;
      var el2 = _this.menuParentRef.current;
      var el3 = ReactDOM.findDOMNode(_this.refs.openClose);
      var el4 = ReactDOM.findDOMNode(_this.refs.actions);
      var el = e.target;
      var inside = false;

      while (el !== null) {
        if (el === el1 || el === el2 || el === el3 || el === el4) {
          inside = true;
          break;
        }

        el = el.parentNode;
      }

      if (!inside) {
        var _el = _this.inputRef.current;

        if (_this.state.hasFocus && document.activeElement !== _el) {
          // víme, že má focus, ale nemá focus vlastní input, budeme simulovat blur
          _this._ignoreBlur = true;

          _el.focus();

          _this._ignoreBlur = false;

          _el.blur();
        }

        _this._ignoreBlur = false;

        _this.closeMenu(false, true, false);
      } else if (_this.state.hasFocus && (_this.isUnderEl(el2, e.target) || _this.isUnderEl(el3, e.target) || _this.isUnderEl(el4, e.target))) {
        _this._ignoreBlur = true;
      } else {
        _this._ignoreBlur = false;
      }
    };

    _this.maybeScrollItemIntoView = function () {
      if (_this.state.isOpen === true && _this.state.highlightedIndex !== null) {
        // Pro scroll použijeme (pokud možno) předchozí položku, aby byl vidět i label např. oblíbených, pokud je použit
        var favoriteItemsTitleItem = _this.getFavoriteItemsTitleItem();

        var scrollIndex;

        if (favoriteItemsTitleItem && _this.state.highlightedIndex === 1) {
          scrollIndex = _this.state.highlightedIndex - 1;
        } else {
          scrollIndex = _this.state.highlightedIndex;
        }

        var itemNode = ReactDOM.findDOMNode(_this.refs["item-" + scrollIndex]);

        if (!itemNode) {
          return;
        }

        var menuNode = _this.menuRef.current.parentNode;
        scrollIntoView(itemNode, menuNode, {
          onlyScrollIfNeeded: true
        });
      }
    };

    _this.handleKeyDown = function (event) {
      var fnKey = 'KeyDown' + event.key;

      if (_this[fnKey]) {
        _this[fnKey].call(_assertThisInitialized(_this), event);
      }
    };

    _this.handleKeyUp = function (event) {
      var fnKey = 'KeyUp' + event.key;

      if (_this[fnKey]) {
        _this[fnKey].call(_assertThisInitialized(_this), event);
      }
    };

    _this.getFilteredResult = function (filterText, changed, props, state, items) {
      var shouldItemRender = state.shouldItemRender;
      var result = {};

      var realValue = _this.getRealValue(props.value, props);

      var includeInViewItemId = realValue && !changed ? props.getItemId(realValue) : null; // od položky, která se má ve výsledku object - např. pro strom atp.

      var favoriteInfo = {
        favoriteItems: props.favoriteItems,
        itemsTitleItem: _this.getItemsTitleItem(props),
        favoriteItemsTitleItem: _this.getFavoriteItemsTitleItem(props)
      };

      var newItemsInfo = _this.getNewFilteredItems(items, favoriteInfo, includeInViewItemId, shouldItemRender, filterText, props.tree, null, props.getItemId, props.getItemName, props.allowSelectItem, props.allowFocusItem, true, props.alwaysExpanded, _this.getNoItemsFoundItem(props));

      result.items = newItemsInfo.items;
      result.itemsDepth = newItemsInfo.itemsDepth;
      result.expandedIds = newItemsInfo.newExpandedIds;
      return result;
    };

    _this.handleChange = function (event) {
      //const { onSearchCallback } = this.props;
      var value = event.target.value;
      var inputItems = _this.props.items;

      var result = _this.getFilteredResult(value, true, _this.props, _this.state, inputItems);

      _this.requestId++; //const rid = this.requestId++;
      // Přednastavení aktivně označené položky, TODO - musí upravit pro strom atp. - musí brát v úvahu unselected položky atp.

      var highlightedIndex;

      if (value) {
        // vyplněný nějaký filtr
        // Vybereme vybíratelnou položku, pokud je právě jedna
        var allowFocusIndex = null;
        var allowSelectIndex = null;
        var allowFocusCount = 0;
        var allowSelectCount = 0;
        var _this$props4 = _this.props,
            getItemId = _this$props4.getItemId,
            allowSelectItem = _this$props4.allowSelectItem,
            allowFocusItem = _this$props4.allowFocusItem;

        for (var a = 0; a < result.items.length; a++) {
          var item = result.items[a];
          var id = getItemId(item);

          if (_this.callAllowFocusItem(allowFocusItem, id, item)) {
            allowFocusCount++;

            if (allowFocusIndex === null) {
              allowFocusIndex = a;
            }
          }

          if (_this.callAllowSelectItem(allowSelectItem, id, item)) {
            allowSelectCount++;

            if (allowSelectIndex === null) {
              allowSelectIndex = a;
            }
          }
        }

        if (allowSelectCount > 0) {
          highlightedIndex = allowSelectIndex;
        } else if (allowFocusCount > 0) {
          highlightedIndex = allowFocusIndex;
        } else {
          highlightedIndex = null;
        }
      } else {
        // pokud není vyplněný filtr, nebudeme žádnou položku vybírat
        highlightedIndex = null;
      }

      _this.changeState(_extends({}, result, {
        inputStrValue: value,
        changed: true,
        highlightedIndex: highlightedIndex
      }), function () {
        _this.openMenu(false);
      });

      if (_this.props.onTextChange) {
        _this.props.onTextChange(value);
      }

      if (_this.props.onInputChange) {
        _this.props.onInputChange(value);
      }
    };

    _this.getFilteredItems = function () {
      return _this.state.items;
    };
    /**
     * Sestavuje strom pro daný node a jeho podstrom.
     * @param node node
     * @param includeInViewItemId TODO
     * @param lowerFilterText filtr
     * @param newExpandedIds mapa id na true, do kterého se přidají aktuálně rozbalené položky - ty co mají pod sebou ty, co odpovídají filtru
     * @param getItemId funkce pro načtení id z node
     * @param getItemName funkce pro načtení name z node
     * @param shouldItemRender funkce pro filtr
     * @param allowSelectItem funkce, která vrací true, pokud lze položku vybrat
     * @param allowFocusItem funkce, která vrací true, pokud lze na dát focus - ostatní jsou např. informační atp.
     * @param alwaysExpanded pokud je true, budou node označené jako expanded
     * @return {*}
     */


    _this.getFilteredTreeNode = function (node, includeInViewItemId, lowerFilterText, newExpandedIds, getItemId, getItemName, shouldItemRender, allowSelectItem, allowFocusItem, alwaysExpanded) {
      // Podřízené nody
      var someChildrenIncludedInView = false;
      var nodeChildren = [];
      node.children && node.children.forEach(function (subNode) {
        var newSubNode = _this.getFilteredTreeNode(subNode, includeInViewItemId, lowerFilterText, newExpandedIds, getItemId, getItemName, shouldItemRender, allowSelectItem, allowFocusItem, alwaysExpanded);

        if (newSubNode) {
          if (newSubNode.includeInView) {
            someChildrenIncludedInView = true;
          }

          nodeChildren.push(newSubNode);
        }
      });
      var id = getItemId(node);
      var includeInView = lowerFilterText ? false : includeInViewItemId === id;

      if (nodeChildren.length === 0 && nodeChildren.length === 0) {
        // nemá potomky, chceme ho jen v případě, že je sám slectable a vyhovuje hledanému výrazu nebo že je allowFocusItem na false - ty dáváme vždy
        var selectable = _this.callAllowSelectItem(allowSelectItem, id, node);

        var focusable = _this.callAllowFocusItem(allowFocusItem, id, node);

        var show = shouldItemRender(node, lowerFilterText || '');

        if (!focusable || (selectable || focusable) && show || includeInView) {
          // Pokud potomci neodpovídají hledanému výrazu, můžeme je všechny přidat - hledám podle nadřazeného node a můžu se podívat na potomky - pokud to nebude někde třeba, dáme na konfiguraci
          return _extends({}, node, {
            includeInView: includeInView || someChildrenIncludedInView
          }); // Jen node, bez přidání potomků
          // return {
          //     ...node,
          //     children: null,
          // }
        } else {
          return null;
        }
      } // Má potomky, bude vždy rozbalený (nebo je nastaveno vždy mít rozbaleno), pokud je nastaven nějaký filtr - má položky, které filtru odpovídají


      if (lowerFilterText || alwaysExpanded || someChildrenIncludedInView) {
        newExpandedIds[getItemId(node)] = true;
      }

      return _extends({}, node, {
        expanded: lowerFilterText || alwaysExpanded || someChildrenIncludedInView ? true : false,
        children: [].concat(nodeChildren),
        includeInView: includeInView || someChildrenIncludedInView
      });
    }; // @param alwaysExpanded pokud je true, budou node označené jako expanded


    _this.getFilteredTree = function (items, includeInViewItemId, expandedIds, getItemId, getItemName, filterText, newExpandedIds, shouldItemRender, allowSelectItem, allowFocusItem, alwaysExpanded) {
      var result = [];
      var lowerFilterText = filterText ? filterText.toLocaleLowerCase() : filterText;
      items.forEach(function (node) {
        var newNode = _this.getFilteredTreeNode(node, includeInViewItemId, lowerFilterText, newExpandedIds, getItemId, getItemName, shouldItemRender, allowSelectItem, allowFocusItem, alwaysExpanded);

        if (newNode) {
          result.push(newNode);
        }
      });
      return result;
    };
    /**
     * Provede novou filtraci položek, převede případný stromu na plochý seznam a načte hloubku jednotlivých položek ve stromu.
     * @param items seznam položek
     * @param favoriteInfo informace o oblibenych polozkach, pokud jsou
     * @param includeInViewItemId jaké id se má ve výsledku zobrazit
     * @param shouldItemRender metoda, která vrací informaci, zda se má položka renderovat v případě ne externalFilter
     * @param inputStrValue zadaný vyhledávací výraz
     * @param tree jedná se stromovou komponentu?
     * @param expandedIds mapa aktuálně rozbalených id
     * @param getItemId metoda pro načtení id z položky
     * @param getItemName metoda pro načtení name z položky
     * @param allowSelectItem funkce, která vrací true, pokud lze položku vybrat
     * @param allowFocusItem funkce, která vrací true, pokud lze položku dát focus
     * @param modifyExpanded pokud je true, bude se brát expanded na základě hledání ve stromu, jinak se použije ten předaný jako expandedIds
     * @param alwaysExpanded pokud je true, budou node označené jako expanded (pouze pokud je modifyExpanded === true)
     * @return v případě stromu vrací: { items: [], itemsDepth: [], newExpandedIds: {}}, jinak vrací { items: [] }
     */


    _this.getNewFilteredItems = function (items, favoriteInfo, includeInViewItemId, shouldItemRender, inputStrValue, tree, expandedIds, getItemId, getItemName, allowSelectItem, allowFocusItem, modifyExpanded, alwaysExpanded, noItemsFoundItem) {
      // Sploštění stromu, pokud je potřeba a jeho filtrování
      var result;

      if (tree) {
        // Filtrování stromu
        var filteredItems;
        var newExpandedIds;

        if (shouldItemRender) {
          newExpandedIds = {};
          filteredItems = _this.getFilteredTree(items, includeInViewItemId, expandedIds, getItemId, getItemName, inputStrValue, newExpandedIds, shouldItemRender, allowSelectItem, allowFocusItem, modifyExpanded && alwaysExpanded); // filteredItems = items;
        } else {
          filteredItems = items;
        }

        var flatTree;

        if (modifyExpanded) {
          flatTree = _this.getFlatTree(filteredItems, newExpandedIds, getItemId);
        } else {
          flatTree = _this.getFlatTree(filteredItems, expandedIds, getItemId);
        }

        result = {
          items: flatTree.list,
          itemsDepth: flatTree.depthList,
          newExpandedIds: newExpandedIds
        };
      } else {
        result = {
          items: items
        }; // Jendoduchý filtr - pouze v případě plochého seznamu - ne stromu, strom se filtruje jinak

        if (shouldItemRender) {
          var _filteredItems = [];
          var filteredItemsDepth = [];
          result.items.forEach(function (item, index) {
            if (shouldItemRender(item, inputStrValue || '')) {
              _filteredItems.push(item);

              tree && filteredItemsDepth.push(result.itemsDepth[index]);
            }
          });
          result.items = _filteredItems;
          result.itemsDepth = filteredItemsDepth;
        }
      } // Pokud má favorite info a není nastaven filtr, vložíme favorite položky


      var beforeTreeCount = 0; // počet položek, které jsou před stromovými položkami - musíme o ně posunout informace o depth

      if (!inputStrValue && favoriteInfo.favoriteItems && favoriteInfo.favoriteItems.length > 0) {
        var _items = result.items;
        result.items = [];

        if (favoriteInfo.favoriteItemsTitleItem) {
          beforeTreeCount++;
          result.items.push(favoriteInfo.favoriteItemsTitleItem);
        }

        result.items = [].concat(result.items, favoriteInfo.favoriteItems);
        beforeTreeCount += favoriteInfo.favoriteItems.length;

        if (favoriteInfo.itemsTitleItem) {
          beforeTreeCount++;
          result.items.push(favoriteInfo.itemsTitleItem);
        }

        result.items = [].concat(result.items, _items); // beforeTreeCount += 2;   // oba titulky
        // result.items = [
        //     favoriteInfo.favoriteItemsTitleItem,
        //     ...favoriteInfo.favoriteItems,
        //     favoriteInfo.itemsTitleItem,
        //     ...result.items,
        // ];
      }

      if (tree) {
        // posun depth pole
        var arr = [];

        for (var a = 0; a < beforeTreeCount; a++) {
          arr.push(0);
        }

        result.itemsDepth = [].concat(arr, result.itemsDepth);
      } // Pokud je filtr a nevrátil žádné položky, vypíšeme alespoň noItemsFoundItem, pokud ji máme


      if (result.items.length === 0 && noItemsFoundItem) {
        result.items = [noItemsFoundItem];
      }

      return result;
    };
    /**
     * Zavolání on change s předanou hodnotou.
     * Reálné volání on change zavolá podle konfigurace buď s objektem nebo jeho id.
     *
     * @param value hodnota nebo null
     */


    _this.callOnChange = function (value) {
      var _this$props5 = _this.props,
          getItemId = _this$props5.getItemId,
          useIdAsValue = _this$props5.useIdAsValue,
          onChange = _this$props5.onChange;

      if (useIdAsValue) {
        onChange(getItemId(value));
      } else {
        onChange(value);
      }
    };
    /**
     * Zavolání on blur s předanou hodnotou.
     * Reálné volání on blur zavolá podle konfigurace buď s objektem nebo jeho id.
     *
     * @param value hodnota nebo null
     */


    _this.callOnBlur = function (value) {
      var _this$props6 = _this.props,
          getItemId = _this$props6.getItemId,
          useIdAsValue = _this$props6.useIdAsValue,
          onBlur = _this$props6.onBlur;

      if (onBlur) {
        if (useIdAsValue) {
          onBlur(getItemId(value));
        } else {
          onBlur(value);
        }
      }
    };

    _this.getFlatTree = function (rows, expandedIds, getItemId) {
      var prop = {
        index: 0,
        list: [],
        depthList: []
      };
      rows.forEach(function (node) {
        return _this._getFlatTree(node, prop, expandedIds, getItemId, 0);
      });
      return prop;
    };

    _this._getFlatTree = function (node, prop, expandedIds, getItemId, depth) {
      prop.list.push(node);
      prop.depthList.push(depth);

      if (expandedIds ? expandedIds[getItemId(node)] : node.expanded) {
        node.children && node.children.forEach(function (ch) {
          return _this._getFlatTree(ch, prop, expandedIds, getItemId, depth + 1);
        });
      }
    };

    _this.handleExpandCollapse = function (node, index, e) {
      e.stopPropagation();
      e.preventDefault();
      var expandedIds = _this.state.expandedIds;
      var getItemId = _this.props.getItemId;
      var expanded = expandedIds[getItemId(node)];

      _this.expandNode(node, expanded ? false : true);
    };

    _this.handleInputBlur = function () {

      if (!_this._ignoreBlur) {
        var newState = {
          hasFocus: false
        }; // Pokud byla hodnota v input změněná a nepotvrdil ji, budeme brát, jako že ji smazal

        var changed = _this.state.changed;
        var callback;

        if (changed) {
          if (!_this.props.keepChangedInput) {
            newState.inputStrValue = '';
          }

          newState.value = null;
          newState.changed = false;
          newState.highlightedIndex = null;

          callback = function callback() {
            _this.callOnChange(null);
          };
        }

        _this.changeState(newState, callback);

        _this.closeMenu(true, false, true);
      } else {
        _this._ignoreBlur = false;
      }

      return true;
    };

    _this.handleInputFocus = function () {

      if (_this.state.hasFocus) {
        return;
      }

      _this.changeState({
        hasFocus: true
      });

      var onFocus = _this.props.onFocus;

      if (!_this._ignoreBlur) {
        onFocus && onFocus();
      } else {
        _this._ignoreBlur = false;
      }

      return true;
    };

    _this.openMenu = function (proceedFilter) {
      if (proceedFilter === void 0) {
        proceedFilter = true;
      }

      if (_this.state.isOpen) {
        return;
      }

      var result;
      var items;

      if (proceedFilter) {
        var filterText = _this.state.changed ? _this.state.inputStrValue : '';
        result = _this.getFilteredResult(filterText, _this.state.changed, _this.props, _this.state, _this.props.items);
        items = result.items;
      } else {
        items = _this.getFilteredItems();
      } // Pokud je vybrána nějaká hodnota, zobrazíme menu s označením dané položky jako highlighted, ale jen pokud nebyla změna v input textu!
      //const { getItemId } = this.props;


      var value = _this.state.value;
      var highlightedIndex = null;

      if (!_this.state.changed) {
        var getItemId = _this.props.getItemId;
        highlightedIndex = _this.getHighlightedIndexByValue(value, items, getItemId);
      } else {
        highlightedIndex = _this.state.highlightedIndex;
      }

      _this.changeState(_extends({}, result, {
        highlightedIndex: highlightedIndex
      }), function () {
        _this.changeState({
          isOpen: true
        });

        _this.focus();
      });
    };

    _this.getHighlightedIndexByValue = function (value, items, getItemId) {
      var index = null;

      if (value) {
        var selectedId = getItemId(value);

        for (var a = 0; a < items.length; a++) {
          if (getItemId(items[a]) === selectedId) {
            index = a; // break;   // nemůže být, chceme tu poslení, protože chceme přeskočit oblíbené položky
          }
        }
      }

      return index;
    };

    _this.closeMenu = function (callBlurAfterSetState, changeHighlightedIndex, callFocusOnInput) {
      if (callBlurAfterSetState === void 0) {
        callBlurAfterSetState = false;
      }

      if (changeHighlightedIndex === void 0) {
        changeHighlightedIndex = false;
      }

      if (callFocusOnInput === void 0) {
        callFocusOnInput = false;
      }

      if (!_this.state.isOpen && _this.state.highlightedIndex === null && _this.state.inputStrValue === _this.props.getItemName(_this.state.value)) {
        // Není třeba nastavovat state
        if (callBlurAfterSetState) {
          var _value = _this.state.value;

          _this.callOnBlur(_value);
        }

        return;
      }

      var _this$props7 = _this.props,
          getItemId = _this$props7.getItemId,
          value = _this$props7.value;

      var items = _this.getFilteredItems();

      var realValue = _this.getRealValue(value);

      var addState = {
        isOpen: false,
        menuParentStyle: {}
      };

      if (!_this.props.keepChangedInput) {
        addState.inputStrValue = _this.props.getItemName(_this.state.value);
      }

      if (changeHighlightedIndex) {
        addState.highlightedIndex = _this.getHighlightedIndexByValue(realValue, items, getItemId);
      }

      _this.changeState(addState, function () {
        //this.inputRef.current!.select()
        if (callBlurAfterSetState) {
          var _value2 = _this.state.value;

          _this.callOnBlur(_value2);
        }
      });

      if (callFocusOnInput && !callBlurAfterSetState) {
        _this.focus();
      }
    };

    _this.showDropdown = function () {
      return true;
    };

    _this.handleInputClick = function (e) {
      var hasFocus = _this.state.hasFocus;

      if (!hasFocus) {
        e.stopPropagation();
        e.preventDefault();

        _this.inputRef.current.select(); // this.focus();

      }
    };

    _this.KeyDownArrowRight = function (event) {
      var tree = _this.props.tree;

      if (tree) {
        var highlightedIndex = _this.state.highlightedIndex;

        if (highlightedIndex != null) {
          event.preventDefault(); // u stromu nechceme posouvat po inputu, pokud je highlightedIndex = má focus list s položkami a klávesy fungují na rozbalení a zabalení stromu

          event.stopPropagation();
        }

        var expandedIds = _this.state.expandedIds;

        if (highlightedIndex !== null) {
          var items = _this.getFilteredItems();

          var node = items[highlightedIndex];

          var id = _this.props.getItemId(node);

          if (node.children && node.children.length > 0) {
            if (expandedIds[id]) {
              // je rozbalený, přejdeme na potomka
              if (highlightedIndex + 1 < items.length) {
                // this._performAutoCompleteOnKeyUp = true;
                _this.changeState({
                  highlightedIndex: highlightedIndex + 1
                });
              }
            } else {
              // není rozbalený, rozbalíme
              _this.expandNode(node, true);
            }
          }
        }
      }
    };

    _this.KeyDownArrowLeft = function (event) {
      var tree = _this.props.tree;

      if (tree) {
        var highlightedIndex = _this.state.highlightedIndex;

        if (highlightedIndex != null) {
          event.preventDefault(); // u stromu nechceme posouvat po inputu, pokud je highlightedIndex = má focus list s položkami a klávesy fungují na rozbalení a zabalení stromu

          event.stopPropagation();
        }

        var expandedIds = _this.state.expandedIds;

        if (highlightedIndex !== null) {
          var items = _this.getFilteredItems();

          var node = items[highlightedIndex];

          var id = _this.props.getItemId(node);

          if (node.children && node.children.length > 0 && expandedIds[id]) {
            // je rozbalený, zablíme
            _this.expandNode(node, false);
          } else {
            // není rozbalený, přejmede na parenta
            var currDepth = _this.state.itemsDepth[highlightedIndex];
            var index = highlightedIndex - 1;

            while (index >= 0 && _this.state.itemsDepth[index] >= currDepth) {
              index--;
            }

            if (index >= 0) {
              _this.changeState({
                highlightedIndex: index
              });
            }
          }
        }
      }
    };

    _this.KeyDownArrowDown = function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (event.altKey) {
        if (_this.showDropdown()) {
          _this.openMenu();
        }
      } else {
        var _this$state2 = _this.state,
            isOpen = _this$state2.isOpen,
            highlightedIndex = _this$state2.highlightedIndex;
        var tree = _this.props.tree;

        var index = _this.getNextFocusableItem(highlightedIndex, !tree);

        _this.changeState({
          highlightedIndex: index
        });

        if (!isOpen) {
          var value = _this.props.value;

          var realValue = _this.getRealValue(value);

          var items = _this.getFilteredItems();

          var newValue = index != null ? items[index] : null;

          if (newValue !== realValue) {
            _this.callOnChange(newValue);
          }
        }
      }
    };

    _this.KeyDownArrowUp = function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (event.altKey) {
        _this.closeMenu(false, true, true);
      } else {
        var _this$state3 = _this.state,
            isOpen = _this$state3.isOpen,
            highlightedIndex = _this$state3.highlightedIndex;
        var tree = _this.props.tree;

        var index = _this.getPrevFocusableItem(highlightedIndex, !tree);

        _this.changeState({
          highlightedIndex: index
        });

        if (!isOpen) {
          var value = _this.props.value;

          var realValue = _this.getRealValue(value);

          var items = _this.getFilteredItems();

          var newValue = index != null ? items[index] : null;

          if (newValue !== realValue) {
            _this.callOnChange(newValue);
          }
        }
      }
    };

    _this.KeyDownEnter = function (event) {
      if (_this.state.isOpen === false && !_this.state.changed) {
        // already selected this, do nothing
        return;
      }

      if (_this.props.tags) {
        event.stopPropagation();
        event.preventDefault();
        var id, item;

        if (_this.state.highlightedIndex == null) {
          id = null;
          item = {
            name: _this.state.inputStrValue
          };
        } else {
          item = _this.getFilteredItems()[_this.state.highlightedIndex];
          id = _this.props.getItemId(item);
        }

        if (_this.callAllowSelectItem(_this.props.allowSelectItem, id, item)) {
          _this.changeState({
            inputStrValue: '',
            value: '',
            isOpen: false,
            menuParentStyle: {}
          }, function () {
            _this.callOnChange(item);
          });

          if (_this.props.onInputChange) {
            _this.props.onInputChange('');
          }
        }
      } else {
        if (_this.state.highlightedIndex == null) {
          event.stopPropagation();
          event.preventDefault(); // hit enter after focus but before typing anything so no autocomplete attempt yet

          _this.changeState({
            isOpen: false,
            menuParentStyle: {},
            inputStrValue: '',
            value: null
          }, function () {
            _this.inputRef.current.select();

            _this.callOnChange(null);
          });

          if (_this.props.onInputChange) {
            _this.props.onInputChange('');
          }
        } else {
          event.stopPropagation();
          event.preventDefault();

          var _item = _this.getFilteredItems()[_this.state.highlightedIndex];

          var _id = _this.props.getItemId(_item);

          if (_this.callAllowSelectItem(_this.props.allowSelectItem, _id, _item)) {
            _this.changeState({
              inputStrValue: _this.props.getItemName(_item),
              value: _item,
              isOpen: false,
              menuParentStyle: {},
              highlightedIndex: null,
              changed: false
            }, function () {
              //this.inputRef.current!.focus() // TODO: file issue
              _this.inputRef.current.setSelectionRange(_this.state.inputStrValue.length, _this.state.inputStrValue.length);

              _this.callOnChange(_item);
            });

            if (_this.props.onInputChange) {
              _this.props.onInputChange(_this.props.getItemName(_item));
            }
          }
        }
      }
    };

    _this.KeyUpEscape = function (event) {
      if (_this.state.isOpen) {
        event.stopPropagation();
        event.preventDefault();
        var changed = _this.state.changed;

        if (changed) {
          _this.changeState({
            changed: false
          });
        }

        _this.closeMenu(false, true, true);
      }
    };

    var inputStrValue = '';

    if (props.initialValue != null) {
      var realInitiaValue = _this.getRealValue(props.initialValue, props);

      if (realInitiaValue != null) {
        inputStrValue = props.getItemName(realInitiaValue) || '';
      }
    }

    _this.state = _extends({}, _this.getStateFromProps({}, props, {
      inputStrValue: inputStrValue,
      changed: false,
      items: []
    }), {
      isOpen: false,
      menuParentStyle: {},
      highlightedIndex: null,
      hasFocus: false,
      changed: false
    });
    return _this;
  }

  var _proto = Autocomplete.prototype;

  _proto.isUnderEl = function isUnderEl(parentEl, el) {
    while (el !== null) {
      if (el === parentEl) {
        return true;
      }

      el = el.parentNode;
    }

    return false;
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var newState = this.getStateFromProps(this.props, nextProps, this.state);
    this.setState(newState);
  };

  _proto.componentDidMount = function componentDidMount() {
    document.addEventListener('mousedown', this.handleDocumentClick, false);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleDocumentClick, false);
  };

  _proto.renderMenuContainer = function renderMenuContainer(items) {
    var _this$state4 = this.state,
        highlightedIndex = _this$state4.highlightedIndex,
        menuParentStyle = _this$state4.menuParentStyle;
    var _this$props8 = this.props,
        header = _this$props8.header,
        footer = _this$props8.footer;
    var cls = 'autocomplete-menu-container' + (highlightedIndex != null ? ' active' : '');
    var headerComp;

    if (header) {
      cls += ' has-header';
      headerComp = React__default.createElement("div", {
        className: "autocomplete-menu-header"
      }, header);
    }

    var footerComp;

    if (footer) {
      cls += ' has-footer';
      footerComp = React__default.createElement("div", {
        className: "autocomplete-menu-footer"
      }, footer);
    }

    return React__default.createElement("div", {
      ref: this.menuParentRef,
      className: cls,
      style: menuParentStyle
    }, headerComp, React__default.createElement("div", {
      className: "autocomplete-menu-wrapper"
    }, React__default.createElement("div", {
      ref: this.menuRef,
      className: "autocomplete-menu"
    }, items)), footerComp);
  };

  _proto.componentWillMount = function componentWillMount() {
    this._ignoreBlur = false;
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (prevState.items !== this.state.items || prevState.isOpen !== this.state.isOpen) {
      // pokud nastala změna zobrazení (zobrazení menu) nebo se změnil počet položek (fulltextové hledání), musíme správně napozicovat
      this.setMenuPositions();
    }

    this.maybeScrollItemIntoView();
  };

  _proto.setMenuPositions = function setMenuPositions() {
    if (!this.state.isOpen) {
      // jen pokud je menu zobrazeno
      return;
    }

    var node = this.inputRef.current;
    var rect = node.getBoundingClientRect();
    var computedStyle = getComputedStyle(node);
    var marginBottom = parseInt(computedStyle.marginBottom, 10);
    var marginLeft = parseInt(computedStyle.marginLeft, 10);
    var position = {
      x: rect.left + marginLeft,
      y: rect.bottom + marginBottom
    };
    var inputHeight = rect.height;

    if (this.menuParentRef.current) {
      // renderují se nějaké položky
      var elementNode = this.menuParentRef.current; // const element = $(elementNode);

      var elementSize = {
        w: elementNode.offsetWidth,
        h: elementNode.offsetHeight
      };
      var windowSize = {
        w: window.innerWidth,
        h: window.innerHeight
      };
      var x = position.x;
      var y = position.y;

      if (y + elementSize.h > windowSize.h) {
        // nevejde se dolu, dáme ho nahoru
        y = y - elementSize.h - inputHeight - 2; // číslo 2 kvůli border 1px

        if (y < 0) {
          // nevejde se nahoru ani dolu, neřešíme
          y = position.y;
        }
      }

      this.setState({
        menuParentStyle: {
          top: y - 1 + 'px',
          left: x + 'px',
          maxWidth: windowSize.w - x + 'px',
          minWidth: rect.width + 'px'
        }
      });
    }
  };

  _proto.highlightItemFromMouse = function highlightItemFromMouse(index) {
    this.changeState({
      highlightedIndex: index
    });
  };

  _proto.selectItemFromMouse = function selectItemFromMouse(item) {
    var _this2 = this;

    var _this$props9 = this.props,
        getItemId = _this$props9.getItemId,
        allowSelectItem = _this$props9.allowSelectItem,
        allowFocusItem = _this$props9.allowFocusItem;
    var id = getItemId(item);
    var allowSelect = this.callAllowSelectItem(allowSelectItem, id, item);
    var allowFocus = this.callAllowFocusItem(allowFocusItem, id, item);

    if (allowSelect && allowFocus) {
      if (this.props.tags) {
        this.changeState({
          inputStrValue: '',
          value: '',
          isOpen: false,
          menuParentStyle: {},
          highlightedIndex: null,
          changed: false
        }, function () {
          _this2.callOnChange(item);
        });

        if (this.props.onInputChange) {
          this.props.onInputChange('');
        }
      } else {
        this.changeState({
          inputStrValue: this.props.getItemName(item),
          value: item,
          isOpen: false,
          menuParentStyle: {},
          // highlightedIndex: null,
          changed: false
        }, function () {
          _this2.callOnChange(item);

          _this2.inputRef.current.focus();

          _this2.setIgnoreBlur(false);
        });

        if (this.props.onInputChange) {
          this.props.onInputChange(this.props.getItemName(item));
        }
      }
    }
  };

  _proto.setIgnoreBlur = function setIgnoreBlur(ignore) {
    this._ignoreBlur = ignore;
  };

  _proto.renderMenu = function renderMenu() {
    var _this3 = this;

    var _this$props10 = this.props,
        getItemId = _this$props10.getItemId,
        getItemName = _this$props10.getItemName,
        renderTitleItemContent = _this$props10.renderTitleItemContent,
        renderItemContent = _this$props10.renderItemContent,
        renderItem = _this$props10.renderItem,
        tree = _this$props10.tree,
        allowSelectItem = _this$props10.allowSelectItem,
        allowFocusItem = _this$props10.allowFocusItem;
    var changed = this.state.changed;
    var items = this.getFilteredItems().map(function (item, index) {
      var id = getItemId(item);
      var name = item._titleLabel ? item.name : getItemName(item);

      var allowSelect = _this3.callAllowSelectItem(allowSelectItem, id, item);

      var allowFocus = _this3.callAllowFocusItem(allowFocusItem, id, item);

      var treeInfo = tree ? {
        expanded: _this3.state.expandedIds[id],
        depth: _this3.state.itemsDepth[index],
        onExpandCollapse: function onExpandCollapse(e) {
          return _this3.handleExpandCollapse(item, index, e);
        }
      } : null;
      var element = renderItem(item, id, name, item._titleLabel ? renderTitleItemContent : renderItemContent, _this3.state.highlightedIndex === index, !changed && _this3.state.value && getItemId(_this3.state.value) === id, allowSelect, allowFocus, treeInfo, _this3.props.getItemRenderClass);
      return cloneElement(element, {
        onMouseDown: function onMouseDown() {
          return _this3.setIgnoreBlur(true);
        },
        onMouseEnter: function onMouseEnter() {
          return _this3.highlightItemFromMouse(index);
        },
        onClick: function onClick() {
          return _this3.selectItemFromMouse(item);
        },
        ref: "item-" + index,
        key: "item-" + index
      });
    });

    if (items.length > 0) {
      return this.renderMenuContainer(items);
    } else {
      return null;
    }
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props11 = this.props,
        error = _this$props11.error,
        title = _this$props11.title,
        touched = _this$props11.touched,
        inline = _this$props11.inline;
    var hasError = touched && error;
    var inlineProps = {};

    if (inline) {
      error && (inlineProps.title = title ? title + '/' + error : error);
    }

    var clsMain = 'autocomplete-control-container';

    if (this.props.className) {
      clsMain += ' ' + this.props.className;
    }

    var glyph = this.state.isOpen ? 'angle-up' : 'angle-down';
    // var cls = bootInfo.cls;

    var cls = '';
    return React__default.createElement("div", {
      className: clsMain
    }, React__default.createElement("div", {
      className: "autocomplete-control-box"
    }, React__default.createElement("div", {
      className: cls
    }, this.props.label && React__default.createElement("label", {
      className: "control-label"
    }, this.props.label), React__default.createElement("div", {
      key: "inputWrapper",
      className: 'autocomplete-input-container form-group' + (hasError ? ' has-error' : '')
    }, renderFieldWithAddons(React__default.createElement(Input, Object.assign({
      key: "input",
      type: "text"
    }, inlineProps, this.props.inputProps, {
      label: this.props.label,
      disabled: this.props.disabled,
      role: "combobox",
      "aria-autocomplete": "both",
      innerRef: this.inputRef,
      onFocus: this.handleInputFocus,
      onBlur: this.handleInputBlur,
      onChange: this.handleChange,
      onKeyDown: this.handleKeyDown,
      onKeyUp: this.handleKeyUp,
      onMouseDown: this.handleInputClick,
      value: this.state.inputStrValue,
      placeholder: this.props.placeholder
    })), this.props.addonsBefore, this.props.addonsAfter), this.showDropdown() && React__default.createElement("div", {
      //@ts-ignore
      disabled: this.props.disabled,
      ref: "openClose",
      className: (this.state.isOpen ? 'btn btn-default opened' : 'btn btn-default closed') + (this.props.disabled ? ' disabled' : ''),
      onClick: function onClick() {
        if (!_this4.props.disabled) {
          _this4.state.isOpen ? _this4.closeMenu(false, true, true) : _this4.openMenu();
        }
      }
    }, React__default.createElement(FAIcon, {
      className: "dropdown-button",
      icon: glyph
    })), this.props.actions && React__default.createElement("div", {
      ref: "actions"
    }, this.props.actions)), this.state.isOpen && this.renderMenu(), this.props.hasFeedback && React__default.createElement("span", {
      className: 'glyphicon form-control-feedback glyphicon-'
    }), this.props.help && React__default.createElement("span", {
      className: "help-block"
    }, this.props.help))));
  };

  return Autocomplete;
}(React__default.Component);
Autocomplete.propTypes = {
  initialValue: PropTypes__default.any,
  onFocus: PropTypes__default.func,
  onBlur: PropTypes__default.func,
  getItemId: PropTypes__default.func,
  // načtení id položky, předpis: (item @Nullable) => {}
  getItemName: PropTypes__default.func,
  // načtení textu položky (např. do inputu po výběru), předpis: (item @Nullable) => {}
  renderItemContent: PropTypes__default.func,
  // render obsahu položky - jen samotný obsah bez rozbalovátka u stromu, stylů na focus a select apod., předpis: (item, name) => {}
  renderTitleItemContent: PropTypes__default.func,
  // render obsahu title (itemsTitle a favoriteItemsTitle) položky - jen samotný obsah bez stylů na focus a select apod., předpis: (item, name) => {}
  onChange: PropTypes__default.func,
  onTextChange: PropTypes__default.func,
  // callback volaný při změně zapsaného textu v poli (jen tehdy když uživatel něco píše)
  onInputChange: PropTypes__default.func,
  // callback volaný při změně obsahu vstupního pole (když uživatel něco píše nebo provedl výběr nějaké položky)
  keepChangedInput: PropTypes__default.bool,
  // Zda nechat změněné vstupní pole, ačkoliv neodpovídá žádné vybrané položce
  useIdAsValue: PropTypes__default.bool,
  // pokud je true, pracuje navenek komponenta tak, že jeko hodnotu nemá objekt, ale jeho id - stejně jako html select
  shouldItemRender: PropTypes__default.func,
  // pokud je uvedená, jedná se o metodu, která filtruje jednu položku, předpis: (item, value) => {true|false}
  renderItem: PropTypes__default.func,
  getItemRenderClass: PropTypes__default.func,
  // načtení doplňující class pro položku - aby nebylo nutné měnit kvůli class celý renderItem
  alwaysExpanded: PropTypes__default.bool,
  // pokud je true, budou vždy všechny položky ve stromu rozbalené ()
  inputProps: PropTypes__default.object,
  actions: PropTypes__default.array,
  tags: PropTypes__default.bool,
  inline: PropTypes__default.bool,
  touched: PropTypes__default.bool,
  error: PropTypes__default.string,
  allowSelectItem: PropTypes__default.func,
  // vrací true, pokud je možné řádek vybrat jako hodnotu, předpis: (id, item) => {}
  allowFocusItem: PropTypes__default.func,
  // vrací true, pokud se na řádek dá najet focusem, např. přes klávesnici, předpis: (id, item) => {}
  tree: PropTypes__default.bool,
  // jedná se o stromovou reprezentaci dat?
  itemsTitle: PropTypes__default.string,
  // pokud je uvedena, jedná se o řádek, který uvozuje seznam položek pokud je favoriteItems
  favoriteItemsTitle: PropTypes__default.string,
  // pokud je uvedena, jedná se o řádek, který uvozuje seznam oblíbených položek pokud je favoriteItems
  noItemsFound: PropTypes__default.string,
  // pokud je uvedena, zobrazuje se pokud je nějaké hledání a nic se nevrátilo, obsahuje standardně implicitní text
  placeholder: PropTypes__default.string,
  addonsBefore: PropTypes__default.node,
  // InputGroupAddon(s) před input
  addonsAfter: PropTypes__default.node,
  items: PropTypes__default.array
};
Autocomplete.defaultProps = {
  useIdAsValue: false,
  noItemsFound: 'Pro zadaný řetězec nebyly nalezeny žádné záznamy',
  inputProps: {},
  onChange: function onChange(item) {},
  allowSelectItem: function allowSelectItem(id, item) {
    // vrati true, když může být daná položka vybrána
    return true;
  },
  allowFocusItem: function allowFocusItem(id, item) {
    // vrati true, když může na danou položku najet klávesnicí nebo myší a může být focusovatelná
    return true;
  },
  getItemId: function getItemId(item) {
    return item ? item.id : null;
  },
  getItemName: function getItemName(item) {
    return item ? item.name : '';
  },
  getItemRenderClass: function getItemRenderClass(item) {
    return null;
  },
  alwaysExpanded: false,
  renderItemContent: function renderItemContent(item, name) {
    if (name && name.length > 0) {
      return React__default.createElement("span", {
        className: "item-text"
      }, name);
    } else {
      return React__default.createElement("span", {
        className: "item-text"
      }, "\xA0");
    }
  },
  renderTitleItemContent: function renderTitleItemContent(item, name) {
    if (name && name.length > 0) {
      return React__default.createElement("span", {
        className: "item-text"
      }, name);
    } else {
      return React__default.createElement("span", {
        className: "item-text"
      }, "\xA0");
    }
  },
  renderItem: function renderItem(item, itemId, name, renderItemContent, isHighlighted, isSelected, allowSelect, allowFocus, treeInfo,
  /*{expanded, depth, onExpandCollapse}*/
  getItemRenderClass) {
    if (allowSelect === void 0) {
      allowSelect = true;
    }

    if (allowFocus === void 0) {
      allowFocus = true;
    }

    if (treeInfo === void 0) {
      treeInfo = null;
    }

    var cls = 'item';
    var itemCls = getItemRenderClass(item);

    if (itemCls) {
      cls += ' ' + itemCls;
    }

    if (isHighlighted) {
      cls += ' focus';
    }

    if (isSelected) {
      cls += ' active';
    }

    if (!allowSelect) {
      cls += ' not-selectable';
    }

    if (!allowFocus) {
      cls += ' not-focusable';
    }

    if (item.className) {
      cls += ' ' + item.className;
    }

    var itemContent = renderItemContent(item, name);
    var treeTogle;
    var depth;

    if (treeInfo) {
      var depthItems = [];

      for (var a = 0; a < treeInfo.depth; a++) {
        depthItems.push(React__default.createElement("div", {
          className: "depth-item"
        }));
      }

      depth = React__default.createElement("div", {
        className: "depth-container"
      }, depthItems);

      if (item.children && item.children.length > 0) {
        treeTogle = React__default.createElement("div", {
          className: "node-expand-collapse " + (treeInfo.expanded ? 'expanded' : 'collapsed'),
          onClick: treeInfo.onExpandCollapse
        }, React__default.createElement(FAIcon, {
          icon: treeInfo.expanded ? 'minus-square-o' : 'plus-square-o',
          className: "toggle-button"
        }));
      } else {
        treeTogle = React__default.createElement("div", {
          className: "node-expand-collapse"
        });
      }
    }

    return React__default.createElement("div", {
      className: cls,
      key: itemId
    }, depth, treeTogle, itemContent);
  },
  inline: false,
  error: null,
  touched: false,
  tree: false,
  placeholder: ''
};

/**
 * Field pro editaci částky včetně měny.
 */

var CastkaMenaField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(CastkaMenaField, _AbstractField);

  function CastkaMenaField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.selectFirstIfNeeded = function (props) {
      var meny = props.meny,
          onChange = props.onChange,
          value = props.value;

      var kodMeny = _this.getKodMenyValue(value);

      var castka = _this.getCastkaValue(value);

      if (!kodMeny) {
        onChange({
          kodMeny: meny[0].kodMeny,
          castka: castka
        });
      }
    };

    _this.getCastkaValue = function (value) {
      if (value == null) {
        return '';
      }

      if (typeof value === 'object') {
        return typeof value.castka !== 'undefined' ? value.castka : '';
      } else {
        return '';
      }
    };

    _this.getKodMenyValue = function (value) {
      if (value == null) {
        return '';
      }

      if (typeof value === 'object') {
        return value.kodMeny;
      } else {
        return '';
      }
    };

    _this.handleBlur = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          onBlur = _this$props.onBlur;
      onBlur && onBlur(value);
    };

    _this.handleChangeCurrency = function (kodMeny) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value;
      var newValue;

      if (value) {
        newValue = _extends({}, value ? value : {}, {
          kodMeny: kodMeny
        });
      } else {
        newValue = {
          kodMeny: kodMeny
        };
      }

      onChange(newValue);
    };

    _this.handleCastkaChange = function (eventOrValue) {
      var castkaValue = getValue(eventOrValue, false);
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;
      var newValue;

      if (value) {
        newValue = _extends({}, value ? value : {}, {
          castka: castkaValue
        });
      } else {
        newValue = {
          castka: castkaValue
        };
      }

      onChange(newValue);
    };

    return _this;
  }

  var _proto = CastkaMenaField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.selectFirstIfNeeded(this.props);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.selectFirstIfNeeded(nextProps);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        disabled = _this$props4.disabled,
        meny = _this$props4.meny,
        addonsBefore = _this$props4.addonsBefore,
        addonsAfter = _this$props4.addonsAfter,
        value = _this$props4.value,
        props = _objectWithoutPropertiesLoose(_this$props4, ["disabled", "meny", "addonsBefore", "addonsAfter", "onChange", "onBlur", "value"]);

    var kodMeny = this.getKodMenyValue(value);
    var castka = this.getCastkaValue(value);
    var menaObj = getMapFromList(meny, 'kodMeny')[kodMeny]; // TODO [stanekpa] optimalizovat pres store

    var menaAddons = createElement(InputGroupAddon, {
      addonType: "append"
    }, createElement(UncontrolledDropdown, {
      id: "meny",
      onBlur: this.handleBlur
    }, createElement(DropdownToggle, {
      caret: !menaObj
    }, menaObj ? menaObj.nazev : ''), createElement(DropdownMenu, null, meny.map(function (c, index) {
      return createElement(DropdownItem, {
        onClick: function onClick() {
          return _this2.handleChangeCurrency(c.kodMeny);
        },
        active: kodMeny === c.kodMeny,
        key: index
      }, c.nazev);
    }))));
    var field = createElement(NumberField, Object.assign({
      "double": true,
      onChange: this.handleCastkaChange,
      onBlur: this.handleBlur,
      value: castka,
      disabled: disabled
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, mergeAddons(addonsAfter, menaAddons));
  };

  return CastkaMenaField;
}(AbstractField);

CastkaMenaField.propTypes = {
  // Objekt typu SubjektDokladRO
  value: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string]),
  // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
  meny: PropTypes__default.array.isRequired,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

var CheckboxField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(CheckboxField, _AbstractField);

  function CheckboxField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = CheckboxField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        disabled = _this$props.disabled,
        addonsBefore = _this$props.addonsBefore,
        value = _this$props.value,
        addonsAfter = _this$props.addonsAfter,
        onClick = _this$props.onClick,
        props = _objectWithoutPropertiesLoose(_this$props, ["label", "disabled", "addonsBefore", "value", "addonsAfter", "onClick"]);

    var field;

    if (label) {
      field = React__default.createElement(Label, {
        check: true,
        className: disabled ? 'disabled' : '',
        onClick: onClick
      }, React__default.createElement(Input, Object.assign({
        type: "checkbox",
        disabled: disabled,
        checked: value,
        onClick: onClick
      }, props)), "\xA0", label);
    } else {
      field = React__default.createElement(Label, {
        check: true,
        className: disabled ? 'disabled' : '',
        onClick: onClick
      }, React__default.createElement(Input, Object.assign({
        type: "checkbox",
        disabled: disabled,
        checked: value,
        onClick: onClick
      }, props)));
    }

    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return CheckboxField;
}(AbstractField);

function debounce(func, wait, immediate) {
  if (!wait) return func;
  var timeout;
  return function () {
    // @ts-ignore
    var context = this,
        args = arguments;

    var later = function later() {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };

    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}
/**
 * Hledací field, který posílá hledaný text se spožděním, když uživatel nic nepíše nebo jen při stusku enter nebo hledacího tlačítka.
 */


var SearchField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(SearchField, _AbstractField);

  function SearchField(props) {
    var _this;

    _this = _AbstractField.call(this, props) || this;

    _this.handleSearchChange = function (e) {
      var _this$props = _this.props,
          searchOnChange = _this$props.searchOnChange,
          onChange = _this$props.onChange;
      var value = e.target.value;

      _this.setState({
        searchText: value
      });

      if (searchOnChange) {
        _this.doSearch(value, onChange);
      }
    };

    _this.handleSearch = function () {
      var onChange = _this.props.onChange;
      var searchText = _this.state.searchText;
      onChange(searchText);
    };

    _this.handleKeyDown = function (e) {
      if (e.keyCode == 13) {
        e.preventDefault();
        e.stopPropagation();

        _this.handleSearch();
      }
    };

    _this.doSearch = debounce(function (text, onSearch) {
      onSearch(text);
    }, props.debounceTime);
    _this.state = {
      searchText: props.value
    };
    return _this;
  }

  var _proto = SearchField.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({
        searchText: nextProps.value
      });
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        addonsAfter = _this$props2.addonsAfter,
        customButton = _this$props2.customButton,
        addonsBefore = _this$props2.addonsBefore,
        props = _objectWithoutPropertiesLoose(_this$props2, ["debounceTime", "searchOnChange", "disabled", "addonsAfter", "onChange", "value", "customButton", "addonsBefore"]);

    var searchText = this.state.searchText; // const wrapperClassNames = classNames(
    //     className,
    //     "search-field-container",
    // );

    var button = customButton ? customButton : React__default.createElement(Button, {
      disabled: disabled,
      onClick: this.handleSearch,
      type: "button"
    }, React__default.createElement(FAIcon, {
      icon: "search"
    }));
    var searchAddons = React__default.createElement("div", {
      key: "searchAddons",
      className: "input-group-btn"
    }, button);
    var field = React__default.createElement(Input, Object.assign({
      type: "text",
      disabled: disabled
    }, props, {
      onKeyDown: this.handleKeyDown,
      value: searchText,
      onChange: this.handleSearchChange
    }));
    return this.renderFieldWithAddons(field, addonsBefore, mergeAddons(addonsAfter, searchAddons));
  };

  return SearchField;
}(AbstractField);

SearchField.propTypes = /*#__PURE__*/_extends({
  debounceTime: PropTypes__default.number,
  searchOnChange: PropTypes__default.bool,
  // pokud je true, hledá se hned při psaní se spožděním debounceTime, pokud je false, hledá se při stisku hledat nebo enter
  customButton: PropTypes__default.node
}, AbstractField.propTypes);
SearchField.defaultProps = {
  debounceTime: 250,
  searchOnChange: false
};

/**
 * Hledací field s 2 režimy, první obdobný jako SearchField (komopnenta je pouze obal pro SearchField druhý je pro čtečku čárových kódů, přepíná se tlačítkem s čárovým kódem.
 * Čtečka simuluje klávesnici
 */

var CteckaField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(CteckaField, _AbstractField);

  function CteckaField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;
    _this.state = {
      cteckaMode: false
    };

    _this.handleModeSwitch = function () {
      _this.setState(function (prevState) {
        return {
          cteckaMode: !prevState.cteckaMode
        };
      });
    };

    return _this;
  }

  var _proto = CteckaField.prototype;

  _proto.render = function render() {
    var cteckaMode = this.state.cteckaMode;

    var _this$props = this.props,
        searchOnChange = _this$props.searchOnChange,
        disabled = _this$props.disabled,
        props = _objectWithoutPropertiesLoose(_this$props, ["searchOnChange", "disabled"]);

    var cteckaButtonColor = cteckaMode ? 'primary' : 'secondary';
    return React__default.createElement(SearchField, Object.assign({}, props, {
      disabled: disabled,
      searchOnChange: cteckaMode || searchOnChange,
      customButton: React__default.createElement(Button, {
        color: cteckaButtonColor,
        disabled: disabled,
        onClick: this.handleModeSwitch,
        type: "button"
      }, React__default.createElement(FAIcon, {
        icon: "barcode"
      }))
    }));
  };

  return CteckaField;
}(AbstractField);

CteckaField.propTypes = /*#__PURE__*/_extends({
  debounceTime: PropTypes__default.number,
  searchOnChange: PropTypes__default.bool
}, AbstractField.propTypes);
CteckaField.defaultProps = {
  debounceTime: 250,
  searchOnChange: false
};

function normalizeValue(value) {
  if (value == null) {
    return value;
  }

  value = value.replace(/[^\-\d\.,]/g, ''); // Odstranit vše kromě číslic, mínusu a desetinných oddělovačů

  value = value.replace(/,/g, '.'); // Normalizovat desetinný oddělovač

  value = value.substring(0, 1) + value.substring(1).replace(/-/g, ''); // Zachovat pouze úvodní mínus

  value = value.replace(/^(-?)0+/, '$10'); // Odstranit duplicitní počáteční nuly

  value = value.replace(/^(-?)0(\d)/, '$1$2'); // Odstranit nadbytečnou počáteční nulu

  var decimalPointIndex = value.indexOf('.');

  if (decimalPointIndex >= 0) {
    var mainPart = value.substring(0, decimalPointIndex + 1); // Včetně desetinného oddělovače

    var decimalPart = value.substring(decimalPointIndex + 1) // Vše za desetinným oddělovačem
    .replace(/\./g, '') // Odstranit všechny duplicitní desetinné oddělovače
    .substring(0, 2); // Ořežeme na maximálně 2 desetinná místa

    value = mainPart + decimalPart;
  }

  if (decimalPointIndex === 0) {
    value = '0' + value; // Doplnit chybějící nulu
  }

  return value;
}
function formatValue(value) {
  if (value == null) {
    return value;
  } // TODO Následující kód lze nahradit za Number(value).toLocaleString('cs-CS')
  //      Nutno nejprve důkladně otestovat funkčnost, value může být number i string.


  value = value.toString(); // Jako vstup může přijít i number
  // Oddělovač tisíců

  value = value.indexOf('.') >= 0 ? value.replace(/\d(?=(\d{3})+\.)/g, '$& ') // Zleva od desetinného oddělovače
  : value.replace(/\d(?=(\d{3})+$)/g, '$& '); // Zleva od konce

  value = value.replace('.', ','); // Desettiný oddělovač

  return value;
}
/**
 * Pole pro zadání částky.
 */

var CurrencyField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(CurrencyField, _PureComponent);

  function CurrencyField() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.inputRef = React__default.createRef();
    _this.state = {
      selectionStart: 0
    };

    _this.handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          value = _this$props.value;

      if (onChange) {
        var newRawValue = event.target.value;
        var newValue = normalizeValue(newRawValue);

        if (newValue !== value) {
          // Bude nutné aktualizovat pozici kurzoru kvůli změně přeformátované hodnoty.
          // Ta může nastat automatickým přidáním/odebráním oddělovače tisíců.
          var selectionStart = event.target.selectionStart;
          var decimalSeparatorIndex = newRawValue.indexOf(',');

          if (decimalSeparatorIndex < 0 || decimalSeparatorIndex >= selectionStart) {
            selectionStart += formatValue(newValue).length - newRawValue.length;
          }

          _this.setState({
            selectionStart: selectionStart
          }, function () {
            return onChange(newValue);
          });
        }
      }
    };

    _this.handleBlur = function () {
      var _this$props2 = _this.props,
          onBlur = _this$props2.onBlur,
          value = _this$props2.value;

      if (onBlur) {
        onBlur(value);
      }
    };

    return _this;
  }

  var _proto = CurrencyField.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    // Narovnání pozice kurzoru kvůli možnému automatickému přeformátování hodnoty.
    var inputRef = this.inputRef,
        value = this.props.value,
        selectionStart = this.state.selectionStart;

    if (inputRef.current && value && value !== prevProps.value) {
      inputRef.current.setSelectionRange(selectionStart, selectionStart);
    }
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        addonsBefore = _this$props3.addonsBefore,
        addonsAfter = _this$props3.addonsAfter,
        value = _this$props3.value,
        currencySymbol = _this$props3.currencySymbol,
        props = _objectWithoutPropertiesLoose(_this$props3, ["addonsBefore", "addonsAfter", "value", "currencySymbol", "onBlur", "onChange"]);

    var field = React__default.createElement(Input, Object.assign({
      ref: this.inputRef,
      type: "text",
      value: formatValue(value),
      onChange: this.handleChange,
      onBlur: this.handleBlur
    }, props));
    var finalAddonsAfter = [];

    if (currencySymbol) {
      finalAddonsAfter.push(React__default.createElement(InputGroupAddon, {
        addonType: "append",
        key: "currency"
      }, "K\u010D"));
    }

    if (Array.isArray(addonsAfter)) {
      finalAddonsAfter.push.apply(finalAddonsAfter, addonsAfter);
    } else if (addonsAfter) {
      finalAddonsAfter.push(addonsBefore);
    }

    return renderFieldWithAddons(field, addonsBefore, finalAddonsAfter);
  };

  return CurrencyField;
}(PureComponent);
CurrencyField.propTypes = {
  addonsBefore: PropTypes__default.node,
  addonsAfter: PropTypes__default.node,
  value: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.number]),
  currencySymbol: PropTypes__default.bool,
  // Zda zobrazit symbol měny
  onChange: PropTypes__default.func,
  onBlur: PropTypes__default.func
};
CurrencyField.defaultProps = {
  currencySymbol: true
};

/**
 * Custom select field
 */

var CustomSelectField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(CustomSelectField, _AbstractField);

  function CustomSelectField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.handleItemSelect = function (item, e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          getItemValue = _this$props.getItemValue;
      onChange(getItemValue(item));
    };

    return _this;
  }

  var _proto = CustomSelectField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        addonsBefore = _this$props2.addonsBefore,
        addonsAfter = _this$props2.addonsAfter,
        value = _this$props2.value,
        renderItem = _this$props2.renderItem,
        getItemValue = _this$props2.getItemValue,
        items = _this$props2.items,
        key = _this$props2.key,
        disabled = _this$props2.disabled,
        props = _objectWithoutPropertiesLoose(_this$props2, ["addonsBefore", "addonsAfter", "onChange", "onBlur", "onFocus", "value", "renderItem", "getItemValue", "items", "key", "disabled"]);

    var itemsEl = items.map(function (item, index) {
      var onClick = disabled ? undefined : _this2.handleItemSelect.bind(_this2, item);
      return React__default.createElement("div", {
        onClick: onClick,
        key: 'CustomSelectField-Item-' + index
      }, renderItem(item, getItemValue(item) === value));
    });
    var field = // @ts-ignore
    React__default.createElement("div", Object.assign({}, props, {
      key: key,
      disabled: disabled
    }), itemsEl);
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return CustomSelectField;
}(AbstractField);

CustomSelectField.propTypes = /*#__PURE__*/_extends({
  items: PropTypes__default.array.isRequired,
  renderItem: PropTypes__default.func,
  getItemValue: PropTypes__default.func
}, AbstractField.propTypes);
CustomSelectField.defaultProps = {
  renderItem: function renderItem(item, active) {
    return React__default.createElement("div", {
      className: active ? 'active' : ''
    }, active ? '#' : '', item.name);
  },
  getItemValue: function getItemValue(item) {
    return item ? item.id : null;
  }
};

var FileField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(FileField, _AbstractField);

  function FileField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = FileField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        addonsAfter = _this$props.addonsAfter,
        _onChange = _this$props.onChange,
        _onBlur = _this$props.onBlur,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter", "onChange", "onBlur", "value"]);

    var field = React__default.createElement(Input, Object.assign({
      type: "file",
      onChange: function onChange(e) {
        return _onChange(e.target.files[0]);
      },
      onBlur: function onBlur(e) {
        return _onBlur(e.target.files[0]);
      }
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return FileField;
}(AbstractField);

/**
 * Komponenta obrázku s možností jednu vybrat kliknutím na checkbox.
 */

function Image(_ref) {
  var imgProps = _ref.imgProps,
      className = _ref.className,
      disabled = _ref.disabled,
      checked = _ref.checked,
      onCheck = _ref.onCheck,
      renderItem = _ref.renderItem,
      onClick = _ref.onClick,
      src = _ref.src;
  var clsCont = classNames('image-container', className, {
    disabled: disabled
  });
  return createElement("div", {
    className: clsCont,
    onClick: onClick
  }, createElement("div", {
    className: 'check p-2 fa-stack fa-sm' + (checked ? ' active' : ''),
    onClick: disabled ? function () {} : function (e) {
      e.stopPropagation();
      onCheck(e);
    }
  }, checked && createElement(FAIcon, {
    fixedWidth: true,
    className: 'fa-stack-2x',
    icon: "circle"
  }), createElement(FAIcon, {
    fixedWidth: true,
    className: checked ? 'fa-stack-1x' : 'fa-stack-2x',
    icon: checked ? 'check' : 'circle-o'
  })), renderItem ? renderItem(src, checked) : createElement("img", Object.assign({}, imgProps, {
    src: src
  })));
}

/**
 * Komponenta seznamu položek - seznam obrázků s možností jednu vybrat kliknutím na checkbox.
 */

var ImageSelectField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(ImageSelectField, _AbstractField);

  function ImageSelectField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.handleChange = function (item) {
      var _this$props = _this.props,
          multiple = _this$props.multiple,
          idAttrName = _this$props.idAttrName,
          onChange = _this$props.onChange,
          value = _this$props.value;

      if (multiple) {
        var useValue = value || [];
        var map = getMapFromList(useValue);

        if (map[item[idAttrName]]) {
          delete map[item[idAttrName]];
        } else {
          map[item[idAttrName]] = item;
        }

        onChange(Object.values(map));
      } else {
        onChange(item);
      }
    };

    _this.renderImage = function (item, index, active) {
      var _this$props2 = _this.props,
          renderItem = _this$props2.renderItem,
          srcAttrName = _this$props2.srcAttrName,
          onClick = _this$props2.onClick,
          disabled = _this$props2.disabled;

      var onClickFc = function onClickFc() {
        return onClick(item, index);
      };

      var onCheckFc = function onCheckFc() {
        return _this.handleChange(item);
      };

      if (renderItem) {
        return renderItem(item, active, disabled, onClickFc, onCheckFc);
      } else {
        return React__default.createElement(Image, {
          checked: active,
          src: item[srcAttrName],
          disabled: disabled,
          onClick: onClickFc,
          onCheck: onCheckFc
        });
      }
    };

    return _this;
  }

  var _proto = ImageSelectField.prototype;

  _proto.render = function render() {
    var _this$props3 = this.props,
        fromIndex = _this$props3.fromIndex,
        count = _this$props3.count,
        colProps = _this$props3.colProps,
        multiple = _this$props3.multiple,
        className = _this$props3.className,
        classNameRow = _this$props3.classNameRow,
        idAttrName = _this$props3.idAttrName,
        value = _this$props3.value,
        items = _this$props3.items;
    var cls = classNames('image-select-field', className, classNameRow);
    var images = [];

    for (var a = fromIndex; (count === 0 || a < fromIndex + count) && a < items.length; a++) {
      var item = items[a];
      var active = void 0;

      if (item && value != null) {
        if (multiple) {
          var useValue = value || [];
          var map = getMapFromList(useValue);
          active = map[item[idAttrName]];
        } else {
          active = item[idAttrName] === value[idAttrName];
        }
      }

      var useColProp = void 0;

      if (Array.isArray(colProps)) {
        useColProp = colProps[a - fromIndex];
      } else {
        useColProp = colProps;
      }

      images.push(React__default.createElement(Col, Object.assign({}, useColProp, {
        key: item ? item[idAttrName] : -1,
        className: active ? 'active' : ''
      }), item && this.renderImage(item, a, active)));
    }

    var field; // TODO slapa: vyřešit lépe - správně

    if (count === 8) {
      var imagesA = [];
      var imagesB = [];
      images.forEach(function (i, c) {
        if (c < 4) {
          imagesA.push(i);
        } else {
          imagesB.push(i);
        }
      });
      field = React__default.createElement(Row, {
        className: cls
      }, React__default.createElement(Col, {
        xs: 12,
        md: 6
      }, React__default.createElement(Row, {
        className: cls
      }, imagesA)), React__default.createElement(Col, {
        xs: 12,
        md: 6
      }, React__default.createElement(Row, {
        className: cls
      }, imagesB)));
    } else {
      field = React__default.createElement(Row, {
        className: cls
      }, images);
    }

    return this.renderFieldWithAddons(field);
  };

  return ImageSelectField;
}(AbstractField);

ImageSelectField.propTypes = /*#__PURE__*/_extends({
  items: PropTypes__default.array.isRequired,
  // seznam položek
  idAttrName: PropTypes__default.string,
  // název atributu pro určení id
  renderItem: PropTypes__default.func,
  // render obrázku - předpis: () => {item, checked, disabled, onClick, onCheck}
  onClick: PropTypes__default.func,
  // klik na obrázek - např. pro možnost akce zobrazení náhledu apod.
  multiple: PropTypes__default.bool,
  // pokud je true, jedná se o výběr více položek
  fromIndex: 4,
  // od jakého indexu položky zobrazovat, pokud je 0, jsou zobrazovány od začátku, např pro stránkování
  count: 4
}, AbstractField.propTypes);
ImageSelectField.defaultProps = {
  multiple: false,
  idAttrName: 'id',
  srcAttrName: 'src',
  fromIndex: 0,
  count: 0,
  colProps: {
    xs: 12,
    md: 3
  }
};

/**
 * Field pro editaci jednotky s jejím typem.
 */

var JednotkaTypField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(JednotkaTypField, _AbstractField);

  function JednotkaTypField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;
    _this.state = {};

    _this.getJednotkaValue = function (value) {
      if (value == null) {
        return '';
      }

      if (typeof value === 'object') {
        return value.jednotka;
      } else {
        return '';
      }
    };

    _this.getTypValue = function (value) {
      if (value == null) {
        return '';
      }

      if (typeof value === 'object') {
        return typeof value.typ !== 'undefined' ? value.typ : '';
      } else {
        return '';
      }
    };

    _this.selectFirstIfNeeded = function (props) {
      var typy = props.typy,
          onChange = props.onChange,
          value = props.value;

      var typ = _this.getTypValue(value);

      var jednotka = _this.getJednotkaValue(value);

      if (!typ) {
        onChange({
          typ: typy[0].kod,
          jednotka: jednotka
        });
      }
    };

    _this.handleBlur = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          onBlur = _this$props.onBlur;
      onBlur(value);
    };

    _this.handleChangeTyp = function (typ) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          value = _this$props2.value;
      var newValue;

      if (value) {
        newValue = _extends({}, value, {
          typ: typ
        });
      } else {
        newValue = {
          typ: typ
        };
      }

      onChange(newValue);
    };

    _this.handleTypChange = function (eventOrValue) {
      var jednotkaValue = getValue(eventOrValue, false);
      var _this$props3 = _this.props,
          onChange = _this$props3.onChange,
          value = _this$props3.value;
      var newValue;

      if (value) {
        newValue = _extends({}, value, {
          jednotka: jednotkaValue
        });
      } else {
        newValue = {
          jednotka: jednotkaValue
        };
      }

      onChange(newValue);
    };

    return _this;
  }

  var _proto = JednotkaTypField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.selectFirstIfNeeded(this.props);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.selectFirstIfNeeded(nextProps);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props4 = this.props,
        disabled = _this$props4.disabled,
        _int = _this$props4["int"],
        _double = _this$props4["double"],
        typy = _this$props4.typy,
        addonsBefore = _this$props4.addonsBefore,
        addonsAfter = _this$props4.addonsAfter,
        value = _this$props4.value,
        props = _objectWithoutPropertiesLoose(_this$props4, ["disabled", "int", "double", "typy", "addonsBefore", "addonsAfter", "onChange", "onBlur", "typDoklad", "value"]);

    var typ = this.getTypValue(value);
    var jednotka = this.getJednotkaValue(value);
    var typObj = getMapFromList(typy, 'kod')[typ]; // TODO [stanekpa] optimalizovat pres store

    var customAddons = React__default.createElement("div", {
      className: "input-group-btn"
    }, React__default.createElement(UncontrolledDropdown, {
      disabled: disabled,
      id: "typy",
      title: typObj ? typObj.nazev : '',
      onBlur: this.handleBlur
    }, typy.map(function (c, index) {
      return React__default.createElement(DropdownItem, {
        onClick: function onClick() {
          return _this2.handleChangeTyp(c.kod);
        },
        active: typ === c.kod,
        eventKey: index,
        key: index
      }, c.nazev);
    })));
    var field = React__default.createElement(NumberField, Object.assign({
      "int": _int,
      "double": _double,
      onChange: this.handleTypChange,
      onBlur: this.handleBlur,
      value: jednotka,
      disabled: disabled
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, mergeAddons(addonsAfter, customAddons));
  };

  return JednotkaTypField;
}(AbstractField);

JednotkaTypField.propTypes = /*#__PURE__*/_extends({
  "int": PropTypes__default.bool,
  "double": PropTypes__default.bool,
  value: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string]),
  // string musí být, protože při prázdném poli dává redux prázdný string, místo objektu!
  typy: PropTypes__default.array.isRequired
}, AbstractField.propTypes);
JednotkaTypField.defaultProps = {
  "int": false,
  "double": false
};

/**
 * Komponenta fulltextového hledání kategorie úřední desky - našeptávač.
 */

var KategorieUredniDeskyField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(KategorieUredniDeskyField, _React$Component);

  function KategorieUredniDeskyField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      list: null
    };
    return _this;
  }

  var _proto = KategorieUredniDeskyField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var kodOrganizace = this.props.kodOrganizace;
    this.setState({
      list: null
    });
    SpisovaSluzbaApi.getKategorieUredniDesky(kodOrganizace).then(function (list) {
      _this2.setState({
        list: list
      });
    });
  };

  _proto.render = function render() {
    var list = this.state.list;

    var otherProps = _extends({}, this.props);

    return React__default.createElement(ObjectSuggestField, Object.assign({
      dropdown: true,
      removable: false,
      items: list,
      itemValueAttrName: "nazev"
    }, otherProps));
  };

  return KategorieUredniDeskyField;
}(React__default.Component);

KategorieUredniDeskyField.propTypes = {
  kodOrganizace: PropTypes__default.string.isRequired
};
KategorieUredniDeskyField.defaultProps = {};

var StateSuggestField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(StateSuggestField, _Component);

  function StateSuggestField() {
    var _this;

    _this = _Component.apply(this, arguments) || this;
    _this.state = {
      data: null
    };
    return _this;
  }

  var _proto = StateSuggestField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var apiCall = this.props.apiCall;
    apiCall().then(function (data) {
      _this2.setState({
        data: data
      });
    });
  };

  _proto.render = function render() {
    var data = this.state.data;

    var _this$props = this.props,
        other = _objectWithoutPropertiesLoose(_this$props, ["apiCall"]);

    if (!data) {
      return React__default.createElement(Input, {
        type: "text",
        disabled: true
      });
    }

    return React__default.createElement(Autocomplete, Object.assign({
      items: data
    }, other));
  };

  return StateSuggestField;
}(Component);

StateSuggestField.propTypes = {
  apiCall: PropTypes__default.func.isRequired
};

var OrgJednotkaField = function OrgJednotkaField(_ref) {
  var showKod = _ref.showKod,
      useIdAsValue = _ref.useIdAsValue,
      other = _objectWithoutPropertiesLoose(_ref, ["showKod", "useIdAsValue"]);

  return React__default.createElement(StateSuggestField, Object.assign({
    apiCall: function apiCall() {
      return OrganizacniJednotkaApi.getOrganizacniJednotky();
    },
    inputProps: {
      placeholder: 'Orgranizační jednotka'
    },
    getItemId: function getItemId(item) {
      return item ? useIdAsValue ? item.id : item : null;
    },
    getItemName: function getItemName(item) {
      return item ? showKod ? item.nazev + " (" + item.kod + ")" : item.nazev : '';
    },
    useIdAsValue: useIdAsValue
  }, other));
};

/**
 * Field pro editaci kontaktu.
 */

var KontaktField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(KontaktField, _AbstractField);

  function KontaktField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.getInputValue = function (value) {
      return value ? value.kontakt ? value.kontakt : '' : '';
    };

    _this.getObjValue = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          kontaktType = _this$props.kontaktType;
      var objValue;

      if (value) {
        objValue = _extends({
          typKontaktu: kontaktType
        }, value, {
          kontakt: e.target ? e.target.value : e,
          '@class': 'KontaktVO'
        });
      } else {
        objValue = {
          typKontaktu: kontaktType,
          vazbaZr: false,
          kontakt: e.target ? e.target.value : e,
          '@class': 'KontaktVO'
        };
      }

      return objValue;
    };

    _this.handleChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(_this.getObjValue(e));
    };

    _this.handleBlur = function (e) {
      var onBlur = _this.props.onBlur;
      onBlur(_this.getObjValue(e));
    };

    return _this;
  }

  var _proto = KontaktField.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        addonsBefore = _this$props2.addonsBefore,
        addonsAfter = _this$props2.addonsAfter,
        kontaktType = _this$props2.kontaktType,
        value = _this$props2.value,
        props = _objectWithoutPropertiesLoose(_this$props2, ["addonsBefore", "addonsAfter", "onChange", "onBlur", "kontaktType", "value"]);

    var field;

    if (kontaktType === 'INTDOR') {
      field = React__default.createElement(OrgJednotkaField, Object.assign({
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: parseInt(this.getInputValue(value)),
        useIdAsValue: true
      }, props));
    } else {
      field = React__default.createElement(Input, Object.assign({
        type: "text",
        onChange: this.handleChange,
        onBlur: this.handleBlur,
        value: this.getInputValue(value)
      }, props));
    }

    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return KontaktField;
}(AbstractField);

KontaktField.propTypes = /*#__PURE__*/_extends({
  // Typ kontaktu, konstanta z EnumTypKontakt
  kontaktType: PropTypes__default.string.isRequired,
  // Objekt typu KontaktRO
  value: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string])
}, AbstractField.propTypes);

/**
 * Komponenta seznamu položek s možností jednu vybrat. Jedná se o standardní field s onChange metodou.
 */

var ListSelectField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(ListSelectField, _AbstractField);

  function ListSelectField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = ListSelectField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        renderItem = _this$props.renderItem,
        className = _this$props.className,
        idAttrName = _this$props.idAttrName,
        onChange = _this$props.onChange,
        value = _this$props.value,
        items = _this$props.items;
    var cls = classNames('list-select-field', className);
    var field = React__default.createElement(ListGroup, {
      className: cls
    }, items.map(function (item) {
      var active;

      if (value != null) {
        if (item[idAttrName] != null && value[idAttrName] != null) {
          active = item === value;
        } else {
          active = item[idAttrName] === value[idAttrName];
        }
      }

      return React__default.createElement(ListGroupItem, {
        active: active,
        onClick: function onClick() {
          onChange && onChange(item);
        }
      }, renderItem(item));
    }));
    return this.renderFieldWithAddons(field);
  };

  return ListSelectField;
}(AbstractField);

ListSelectField.propTypes = /*#__PURE__*/_extends({
  items: PropTypes__default.array.isRequired,
  // seznam položek
  idAttrName: PropTypes__default.string,
  // název atributu pro určení id
  renderItem: PropTypes__default.func
}, AbstractField.propTypes);
ListSelectField.defaultProps = {
  idAttrName: 'id',
  renderItem: function renderItem(x) {
    return x.name;
  }
};

/**
 * Obec Field
 *
 * Obec Suggest field
 */

var ObecField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ObecField, _React$Component);

  function ObecField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      if (value && value.length > 1) {
        // hledáme až od dvou znaků!
        // @ts-ignore
        return AdresaApi.findObce(value);
      } else {
        return new Promise(function (resolve, reject) {
          resolve([]);
        });
      }
    };

    return _this;
  }

  var _proto = ObecField.prototype;

  _proto.render = function render() {
    var other = _extends({}, this.props);

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      minCharsForFilter: 3,
      placeholder: "Vyhledat obec...",
      removable: true,
      filterSuggestions: this.handleFilterSuggestions,
      getItemValue: function getItemValue(item) {
        return item ? item.nazevObec + ' (' + item.nazevOkres + ')' : '';
      },
      renderSuggestion: function renderSuggestion(i, active, getItemValue) {
        return React__default.createElement("div", {
          className: active ? 'active' : ''
        }, i.nazevObec + ' (' + i.nazevOkres + ')');
      }
    }, other));
  };

  return ObecField;
}(React__default.Component);

ObecField.propTypes = {};
ObecField.defaultProps = {
  apiRequestDelay: 250
};

var Tag = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tag, _Component);

  function Tag() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Tag.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["className", "children"]);

    className = classNames('tag-container', className);
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), children);
  };

  return Tag;
}(Component);
Tag.propTypes = {
  className: PropTypes__default.string
};

var TagItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(TagItem, _Component);

  function TagItem() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = TagItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onRemove = _this$props.onRemove,
        children = _this$props.children,
        className = _this$props.className,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["onRemove", "children", "className"]);

    className = classNames('tag-item', className);
    return React__default.createElement("div", Object.assign({
      className: className
    }, otherProps), React__default.createElement("div", {
      className: "tag-content"
    }, children), React__default.createElement(Button, {
      type: "button",
      className: "tag-action",
      color: "action",
      onClick: onRemove
    }, React__default.createElement(FAIcon, {
      icon: "times"
    })));
  };

  return TagItem;
}(Component);
TagItem.propTypes = {
  className: PropTypes__default.string,
  onRemove: PropTypes__default.func.isRequired
};

/**
 * Field, který umožňuje zadávat hodnoty pomocí seznamu tagů (seznam položek s křížkěm) jako seznam objektů.
 */

var ObjectTagField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(ObjectTagField, _AbstractField);

  function ObjectTagField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.handleAddTag = function (inputValue) {
      var _this$props = _this.props,
          equalsItems = _this$props.equalsItems,
          value = _this$props.value,
          onChange = _this$props.onChange;
      var found = false;

      for (var a = 0; a < value.length; a++) {
        if (equalsItems(value[a], inputValue)) {
          found = true;
          break;
        }
      }

      if (!found) {
        var newValue = [].concat(value, [inputValue]);
        onChange(newValue);
      }
    };

    _this.handleRemoveTag = function (index) {
      var _this$props2 = _this.props,
          value = _this$props2.value,
          onChange = _this$props2.onChange;
      var newValue = [].concat(value.slice(0, index), value.slice(index + 1));
      onChange(newValue);
    };

    return _this;
  }

  var _proto = ObjectTagField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        className = _this$props3.className,
        value = _this$props3.value,
        renderTagContent = _this$props3.renderTagContent,
        fieldComponent = _this$props3.fieldComponent,
        fieldProps = _this$props3.fieldProps,
        props = _objectWithoutPropertiesLoose(_this$props3, ["className", "getItemValue", "onBlur", "value", "onChange", "renderTagContent", "fieldComponent", "fieldProps"]); // const field = (
    //     <Input
    //         type="text"
    //         {...props}
    //     />
    // );


    var inputField = createElement(fieldComponent, _extends({}, fieldProps, {
      value: null,
      onChange: this.handleAddTag
    }));
    var tags;

    if (value) {
      tags = React__default.createElement(Tag, Object.assign({}, props), value.map(function (v, index) {
        return React__default.createElement(TagItem, {
          key: index,
          onRemove: function onRemove() {
            return _this2.handleRemoveTag(index);
          }
        }, renderTagContent(v));
      }));
    }

    return React__default.createElement("div", {
      className: className
    }, inputField, tags);
  };

  return ObjectTagField;
}(AbstractField);

ObjectTagField.propTypes = /*#__PURE__*/_extends({
  renderTagContent: PropTypes__default.func,
  equalsItems: PropTypes__default.func
}, AbstractField.propTypes);
ObjectTagField.defaultProps = {
  getItemValue: function getItemValue(i) {
    return i ? i.name : '';
  },
  equalsItems: function equalsItems(a, b) {
    return a === b;
  }
};

function propertyToArray(param) {
  if (Array.isArray(param)) {
    return param;
  }

  if (param != null) {
    return [param];
  }

  return null;
}
/**
 * Field pro fulltextové hledání objektů.
 */


var ObjektField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ObjektField, _React$Component);

  function ObjektField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.getItemValue = function (item) {
      var objekt = _this.props.unwrapObjekt ? item : item.objekt;
      return objekt && objekt.popis || '';
    };

    _this.filterSuggestions = function (text) {
      var promisedItems = _this.fetchItems(text);

      if (_this.props.unwrapObjekt) {
        return promisedItems.then(function (items) {
          if (!Array.isArray(items)) {
            throw new Error('fetch u ObjektField nevrátil pole hodnot');
          }

          return items.map(function (item) {
            return item.objekt;
          });
        });
      }

      return promisedItems;
    };

    return _this;
  }

  var _proto = ObjektField.prototype;

  _proto.fetchItems = function fetchItems(text) {
    if (!text) {
      return Promise.resolve([]);
    }

    var customFetch = this.props.customFetch;

    if (customFetch) {
      return customFetch(text, this.props);
    }

    var _this$props = this.props,
        obecKod = _this$props.obecKod,
        katarstralniUzemiKod = _this$props.katarstralniUzemiKod,
        objektZakladniTyp = _this$props.objektZakladniTyp,
        objektTypKod = _this$props.objektTypKod,
        zdroj = _this$props.zdroj;
    return ObjektApi.findObjektFulltext(text, obecKod, katarstralniUzemiKod, propertyToArray(objektZakladniTyp), propertyToArray(objektTypKod), propertyToArray(zdroj), 20);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["obecKod", "katarstralniUzemiKod", "objektZakladniTyp", "objektTypKod", "zdroj", "unwrapObjekt", "customFetch"]);

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      dropdown: true,
      minCharsForFilter: 3,
      placeholder: "Vyhledat objekt",
      filterSuggestions: this.filterSuggestions,
      getItemValue: this.getItemValue
    }, otherProps));
  };

  return ObjektField;
}(React__default.Component);
ObjektField.propTypes = /*#__PURE__*/_extends({}, ApiObjectSuggestField.propTypes, {
  obecKod: PropTypes__default.string,
  // Omezení hledání za kód obce
  katarstralniUzemiKod: PropTypes__default.number,
  // Omezení hledání za kód katastrálního území
  objektZakladniTyp: /*#__PURE__*/PropTypes__default.oneOfType([// Omezení hledání dle záklaního typu objektu
  PropTypes__default.string, /*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.string)]),
  objektTypKod: /*#__PURE__*/PropTypes__default.oneOfType([// Omezení hledání dle kódů typů objektů
  PropTypes__default.string, /*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.string)]),
  zdroj: /*#__PURE__*/PropTypes__default.oneOfType([// Omezení hledání na zdroj dat
  PropTypes__default.string, /*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.string)]),
  unwrapObjekt: PropTypes__default.bool,
  // true - field vrati primo data objektu / false - field vrati objekt zabaleny v search result
  customFetch: PropTypes__default.func
});
ObjektField.defaultProps = {
  obecKod: null,
  katarstralniUzemiKod: null,
  objektZakladniTyp: null,
  objektTypKod: null,
  zdroj: null,
  unwrapObjekt: false,
  customFetch: null
};

var _AutocompleteField$pr = Autocomplete.propTypes,
    autocompletePropTypes = /*#__PURE__*/_objectWithoutPropertiesLoose(_AutocompleteField$pr, ["items"]);
/**
 * Autocomplete field s podporou asynchronního načtení items.
 */


var AsyncAutocompleteField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(AsyncAutocompleteField, _PureComponent);

  function AsyncAutocompleteField() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.state = {
      text: '',
      items: [],
      fetching: false
    };
    _this.lastFetchId = 0;

    _this.handleTextChange = function (text) {
      if (_this.props.onTextChange) {
        _this.props.onTextChange(text);
      }

      _this.doHandleTextChange(text);
    };

    _this.doHandleTextChange = debounce$1(function (text) {
      text = text.trim();

      if (text.length >= _this.props.fetchMinChars) {
        var fetchId = ++_this.lastFetchId;

        _this.setState({
          text: text,
          fetching: true
        }, function () {
          _this.props.fetch(text).then(function (items) {
            if (fetchId === _this.lastFetchId) {
              _this.setState({
                items: items,
                fetching: false
              });
            }
          });
        });
      } else {
        _this.setState({
          text: text,
          items: [],
          fetching: false
        });
      }
    }, _this.props.fetchDelay);
    return _this;
  }

  var _proto = AsyncAutocompleteField.prototype;

  _proto.getNoItemsFound = function getNoItemsFound() {
    var fetchMinChars = this.props.fetchMinChars;

    if (this.state.text.length < fetchMinChars) {
      var charsLabel;

      if (fetchMinChars === 1) {
        charsLabel = 'znak';
      } else if (fetchMinChars >= 2 && fetchMinChars <= 4) {
        charsLabel = 'znaky';
      } else {
        charsLabel = 'znaků';
      }

      return "Zadejte alespo\u0148 " + fetchMinChars + " " + charsLabel + " pro vyhled\xE1n\xED";
    }

    if (this.state.fetching) {
      return 'Hledání...';
    }

    return this.props.noItemsFound;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["items", "fetch", "fetchDelay", "fetchMinChars"]);

    return React__default.createElement(Autocomplete, Object.assign({}, otherProps, {
      items: this.state.items,
      noItemsFound: this.getNoItemsFound(),
      onTextChange: this.handleTextChange
    }));
  };

  return AsyncAutocompleteField;
}(PureComponent);
AsyncAutocompleteField.propTypes = /*#__PURE__*/_extends({}, autocompletePropTypes, {
  // Podporujeme vše co AutocompleteField, až na výjimky výše.
  fetch: PropTypes__default.func.isRequired,
  // Asyncdhronní volání pro načtení items na základě textu.
  fetchDelay: PropTypes__default.number,
  // Prodleva mezi psaním a vyvoláním fetch.
  fetchMinChars: PropTypes__default.number
});
AsyncAutocompleteField.defaultProps = {
  fetchDelay: 0,
  fetchMinChars: 0
};

/**
 * Field pro fulltextové hledání pracovníků.
 */

var PracovnikField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PracovnikField, _React$Component);

  function PracovnikField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.fetch = function (text) {
      var proSpustenouAplikaci = _this.props.proSpustenouAplikaci;
      return PracovnikApi.findPracovnici(text, proSpustenouAplikaci, 100);
    };

    _this.getItemName = function (item) {
      return item && item.uplneJmeno || '';
    };

    _this.renderItemContent = function (item) {
      return React__default.createElement("span", {
        className: "item-text"
      }, item.uplneJmeno, item.organizacniJednotka && React__default.createElement("small", null, " (", item.organizacniJednotka.nazev, ")"));
    };

    return _this;
  }

  var _proto = PracovnikField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        addonsAfter = _this$props.addonsAfter,
        apiRequestDelay = _this$props.apiRequestDelay,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["proSpustenouAplikaci", "addonsBefore", "addonsAfter", "apiRequestDelay"]);

    var field = React__default.createElement(AsyncAutocompleteField, Object.assign({}, otherProps, {
      placeholder: "Vyhledat pracovn\xEDka...",
      getItemName: this.getItemName,
      renderItemContent: this.renderItemContent,
      fetch: this.fetch,
      fetchDelay: apiRequestDelay,
      fetchMinChars: 3
    }));
    return renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return PracovnikField;
}(React__default.Component);

PracovnikField.propTypes = {
  proSpustenouAplikaci: PropTypes__default.bool,
  // pokud je true, hledá jen mezi pracovníky aktuýálně spuštěné aplikace, jinak hledá mezi všemi pracovníky
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN,
  apiRequestDelay: PropTypes__default.number
};
PracovnikField.defaultProps = {
  apiRequestDelay: 250,
  proSpustenouAplikaci: true
};

var NEXT_PAGE = 'paging.nextPage';
var PREV_PAGE = 'paging.prevPage';
var HOME = 'paging.home';
var END = 'paging.end';
var GO_TO_PAGE = 'paging.goToPage';
var SET_PAGE_SIZE = 'paging.setPageSize';
var SET_ITEMS_COUNT = 'paging.setItemsCount';
function is$2(action) {
  switch (action.type) {
    case NEXT_PAGE:
    case PREV_PAGE:
    case HOME:
    case END:
    case GO_TO_PAGE:
    case SET_PAGE_SIZE:
    case SET_ITEMS_COUNT:
      return true;

    default:
      return false;
  }
}
function goToPage(area, pageIndex) {
  return {
    area: area,
    type: GO_TO_PAGE,
    pageIndex: pageIndex
  };
}
function setItemsCount(area, itemsCount) {
  return {
    area: area,
    type: SET_ITEMS_COUNT,
    itemsCount: itemsCount
  };
}

var REQUEST$1 = 'list.simple.request';
var RESPONSE$1 = 'list.simple.response';
var FILTER$1 = 'list.simple.filter';
var INVALIDATE$1 = 'list.simple.invalidate';
var SELECT_PARENT = 'list.simple.selectParent';
/**
 * Zneplatnění dat.
 * @param area oblast
 */

function invalidate$1(area, data) {
  return {
    type: INVALIDATE$1,
    area: area
  };
}
/**
 * Filtrování položek seznamu.
 * @param area oblast
 * @param filter filtr
 * @returns {{type: string, area: *, filter: *}}
 */

function filter$1(area, filter) {
  return {
    type: FILTER$1,
    area: area,
    filter: filter
  };
}
/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param parent parent data pro seznam, pokud je potřeba, např. id nadřazené entity, ke které se vztahuje seznam
 * @param getData promise pro načtení
 * @param forceFetch pokud je true, provede se vždy nové načtení
 */

function fetchIfNeeded$1(area, parent, getData, forceFetch) {
  if (forceFetch === void 0) {
    forceFetch = false;
  }

  return function (dispatch, getState) {
    // Spočtení data key
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebný parent, dáme ho tam, aby se nám správně spočetl data key

    if (store.parent !== parent) {
      dispatch(selectParent(area, parent));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)();

    if (forceFetch || store.currentDataKey !== dataKey) {
      dispatch(request$1(area, dataKey)); // Vstupní data pro request dat

      var storeForRequest = storeFromArea(getState(), area);
      var _filter = storeForRequest.filter;
      var pagingInfo;

      if (storeForRequest.supportPaging) {
        pagingInfo = {
          pageIndex: storeForRequest.paging.pageIndex,
          pageSize: storeForRequest.paging.pageSize
        };
      }

      getData(parent, _filter, pagingInfo).then(function (json) {
        var newStore = storeFromArea(getState(), area);
        var newDataKey = newStore.getDataKey.bind(newStore)();

        if (newDataKey === dataKey) {
          // jen pokud přídchozí objekt odpovídá datům, které chceme ve store
          // Upravení stránkování
          dispatch(setItemsCount(area, json.count)); // Načtená data

          if (json && json.rows) {
            dispatch(response$1(area, json.rows, json.count));
          } else if (json) {
            dispatch(response$1(area, json, 0));
          }
        }
      }) // TODO [stanekpa] - řešit catch a vrácení datakey!
      ["catch"](function (error) {// dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
      });
    }
  };
}
/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */

function is$3(action) {
  // Stránkování
  if (is$2(action)) {
    return true;
  } // Vlastní akce


  switch (action.type) {
    case FILTER$1:
    case REQUEST$1:
    case RESPONSE$1:
    case INVALIDATE$1:
      return true;

    default:
      return false;
  }
}
/**
 * Výběr nového parenta, volá se i v případě, že je zavoláno fetchIfNeeded s jiným parent něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */

function selectParent(area, parent) {
  return {
    type: SELECT_PARENT,
    area: area,
    parent: parent
  };
}
/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */


function request$1(area, dataKey) {
  return {
    type: REQUEST$1,
    area: area,
    dataKey: dataKey
  };
}
/**
 * Response dat.
 * @param area oblast
 * @param rows řádky
 * @param count celkový počet řádek, např. v db pro daný filter
 * @returns {{type: string, area: *, data: *}}
 */


function response$1(area, rows, count) {
  return {
    type: RESPONSE$1,
    area: area,
    rows: rows,
    count: count
  };
}

var AdvancedListActions = {
  __proto__: null,
  REQUEST: REQUEST$1,
  RESPONSE: RESPONSE$1,
  FILTER: FILTER$1,
  INVALIDATE: INVALIDATE$1,
  SELECT_PARENT: SELECT_PARENT,
  invalidate: invalidate$1,
  filter: filter$1,
  fetchIfNeeded: fetchIfNeeded$1,
  is: is$3
};

var TOGGLE = 'list.infinite.check.toggle';
var TOGGLE_ALL = 'list.infinite.check.toggleAll';
var CHECKED_ALL = 'list.infinite.check.checkedAll';
/**
 * Toggle položky.
 * @param area oblast
 * @param id id položky
 */

function toggle(area, id) {
  return {
    type: TOGGLE,
    area: area,
    id: id
  };
}
/**
 * Toggle all položek.
 * @param area oblast
 */

function toggleAll(area) {
  return {
    type: TOGGLE_ALL,
    area: area
  };
}
/**
 * Zaškrtnout vše.
 * @param area oblast
 * @param checked zaškrtnout/odškrtnout
 */

function checkedAll(area, checked) {
  if (checked === void 0) {
    checked = true;
  }

  return {
    type: CHECKED_ALL,
    checked: checked,
    area: area
  };
}

var InfiniteCheckListActions = {
  __proto__: null,
  TOGGLE: TOGGLE,
  TOGGLE_ALL: TOGGLE_ALL,
  CHECKED_ALL: CHECKED_ALL,
  toggle: toggle,
  toggleAll: toggleAll,
  checkedAll: checkedAll
};

/**
 * Akce pro nekonečný scroll - klientský.
 */
var REQUEST$2 = 'list.infinite.request';
var RESPONSE$2 = 'list.infinite.response';
var RELOAD = 'list.infinite.reload';
var FILTER$2 = 'list.infinite.filter';
var REMOVE = 'list.infinite.remove';
var INVALIDATE$2 = 'list.infinite.invalidate';
var CHANGES = 'list.infinite.changes';
var SELECT_PARENT$1 = 'list.infinite.selectParent';
var LOAD_MORE_REQUEST = 'list.infinite.loadMore.request';
var LOAD_MORE_RESPONSE = 'list.infinite.loadMore.response';
var CHECKING_MY_IDS_REQUEST = 'list.infinite.checkingMyIds.request';
var CHECKING_MY_IDS_RESPONSE = 'list.infinite.checkingMyIds.response';
var UPDATED_REQUEST = 'list.infinite.updated.request';
var UPDATED_META_REQUEST = 'list.infinite.updated.meta.request';
var UPDATED_RESPONSE = 'list.infinite.updated.response';
var UPDATED_META_RESPONSE = 'list.infinite.updated.meta.response';
var RESET$1 = 'list.infinite.reset';
/**
 * Zneplatnění dat.
 * @param area oblast
 */

function invalidate$2(area) {
  return {
    type: INVALIDATE$2,
    area: area
  };
}
/**
 * Aktualizace některých dat v načteném seznamu řádků - jedná se o ruční aktualizaci některých položek seznamu - např. jeden objekt ze seznamu chceme aktualizovat.
 * @param area oblast
 * @param rows seznam objektů po atualizaci, pokud bude obsahovat objekt s id ještě nenačteného objektu v seznamu, nic se nestane
 */

function updateRows(area, rows) {
  return {
    type: UPDATED_RESPONSE,
    area: area,
    rows: rows
  };
}
/**
 * Aktualizace některých dat v načteném seznamu řádků - jedná se o ruční aktualizaci některých položek seznamu - např. jeden objekt ze seznamu chceme aktualizovat.
 * @param area oblast
 * @param rows seznam objektů po atualizaci, pokud bude obsahovat objekt s id ještě nenačteného objektu v seznamu, nic se nestane
 */

function updateMeta(area, rows) {
  return {
    type: UPDATED_META_RESPONSE,
    area: area,
    rows: rows
  };
}
/**
 * Zneplatnění dat.
 * @param area oblast
 * @param updatedIds seznam id entit, které byly upraveny
 * @param createdIds seznam id entit, které byly vytvořeny
 * @param deletedIds seznam id entit, které smazány
 * @param removeDeleted true, pokud má odebrat smazané ze seznamu
 * @return {*}
 */

function changes(area, updatedIds, createdIds, deletedIds, removeDeleted) {
  return {
    type: CHANGES,
    area: area,
    updatedIds: updatedIds,
    createdIds: createdIds,
    deletedIds: deletedIds,
    removeDeleted: removeDeleted
  };
}
/**
 * Další donačtení dat.
 * @param area oblast
 * @param getRowsByIds, promis načtení seznamu objektů na základě seznamu id, předpis: (ids) => {}
 * @return {{type: string, area: *}}
 */

function loadMore(area, getRowsByIds) {
  return function (dispatch, getState) {
    var store = storeFromArea(getState(), area);

    if (!store.isFetching && !store.loadingMore) {
      // aktuálně nenačítá data ani more
      var ids = store.allIds.slice(store.rows.length, store.rows.length + store.loadMoreCount); // Začínáme načítat data

      dispatch({
        type: LOAD_MORE_REQUEST,
        area: area
      }); // Načtení dat

      getRowsByIds(ids).then(function (rows) {
        var newStore = storeFromArea(getState(), area);

        if (newStore.loadingMore) {
          // nic se nezměnilo, promítneme načtená data
          dispatch(loadMoreResponse(area, rows, ids));
        }
      });
    }
  };
}

function loadMoreResponse(area, rows, requiredIds) {
  return {
    type: LOAD_MORE_RESPONSE,
    area: area,
    rows: rows,
    requiredIds: requiredIds
  };
}
/**
 * Filtrování položek seznamu.
 * @param area oblast
 * @param filter filtr
 * @param resetData pokud je true, resetují se načtená data při aplikování filtru - fetched bude false a data nebudou načtena
 * @returns {{type: string, area: *, filter: *}}
 */


function filter$2(area, filter, resetData) {
  if (resetData === void 0) {
    resetData = false;
  }

  return {
    type: FILTER$2,
    area: area,
    filter: filter,
    resetData: resetData
  };
}
function remove(area, ids) {
  return {
    type: REMOVE,
    area: area,
    ids: ids
  };
}

function parseAllIdsData(data) {
  if (Array.isArray(data)) {
    return {
      ids: data,
      allMetaMap: null,
      count: data.length
    };
  } else {
    var ids;

    if (data.allIds) {
      ids = data.allIds;
    } else {
      ids = Object.keys(data.allMetaMap);
    }

    return {
      ids: ids,
      count: data.count || ids.length,
      allMetaMap: data.allMetaMap
    };
  }
}

function checkMyIds(area, getAllIds) {
  return function (dispatch, getState) {
    var store = storeFromArea(getState(), area);

    if (store.addedIds.length > 0 && !store.checkingMyIds && !store.hasNewIds) {
      dispatch({
        area: area,
        type: CHECKING_MY_IDS_REQUEST
      });
      getAllIds(store.parent, store.filter, false).then(function (data) {
        var newStore = storeFromArea(getState(), area);

        if (newStore.checkingMyIds) {
          // pořád platí
          var _parseAllIdsData = parseAllIdsData(data),
              ids = _parseAllIdsData.ids;

          var addedIdsMap = getSetFromIdsList(newStore.addedIds); // bereme aktuální seznam id, mohl se změnit

          var hasNewIds = false;

          for (var a = 0; a < ids.length; a++) {
            if (addedIdsMap[ids[a]]) {
              // bylo přidáno a měl by ho vidět
              hasNewIds = true;
              break;
            }
          }

          dispatch({
            area: area,
            type: CHECKING_MY_IDS_RESPONSE,
            hasNewIds: hasNewIds
          });
        }
      }) // TODO [stanekpa] - řešit catch a vrácení datakey!
      ["catch"](function (error) {// dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
      });
    }
  };
}
function reload(area, parent, getAllIds, getRowsByIds) {
  return function (dispatch, getState) {
    var store = storeFromArea(getState(), area);

    if (!store.isFetching && store.parent === parent) {
      // jen pokud již nenačítá seznam id
      var dataKey = store.getDataKey.bind(store)();
      dispatch(request$2(area, dataKey)); // Načtení seznamu id

      getAllIds(store.parent, store.filter, true).then(function (data) {
        var _parseAllIdsData2 = parseAllIdsData(data),
            ids = _parseAllIdsData2.ids,
            allMetaMap = _parseAllIdsData2.allMetaMap; // Donačtení objektů k idčkůmy - jen k tolika, kolik jsme jich předtím zobrazovali


        var requiredIds = ids.slice(0, store.rows.length);
        callGetRowsByIds(getRowsByIds, requiredIds).then(function (rows) {
          dispatch(reloadData(area, ids, requiredIds, rows, allMetaMap));
        });
      }) // TODO [stanekpa] - řešit catch a vrácení datakey!
      ["catch"](function (error) {// dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
      });
    }
  };
}

function reloadData(area, ids, requiredIds, rows, allMetaMap) {
  return {
    area: area,
    type: RELOAD,
    ids: ids,
    requiredIds: requiredIds,
    rows: rows,
    allMetaMap: allMetaMap
  };
}

function callGetRowsByIds(getRowsByIds, ids) {
  if (ids.length > 0) {
    return getRowsByIds(ids);
  } else {
    return Promise.resolve([]);
  }
}
/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param parent parent data pro seznam, pokud je potřeba, např. id nadřazené entity, ke které se vztahuje seznam
 * @param getAllIds promise pro načtení seznamu všech id odpovídajích filtru, předpis: (parent, filter) => {}
 * @param getRowsByIds, promis načtení seznamu objektů na základě seznamu id, předpis: (ids) => {}
 * @param forceFetch pokud je true, provede se vždy nové načtení
 */


function fetchIfNeeded$2(area, parent, getAllIds, getRowsByIds, forceFetch) {
  if (forceFetch === void 0) {
    forceFetch = false;
  }

  return function (dispatch, getState) {
    // Spočtení data key
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebný parent, dáme ho tam, aby se nám správně spočetl data key

    if (store.parent !== parent) {
      dispatch(selectParent$1(area, parent));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)();

    if (forceFetch || store.currentDataKey !== dataKey) {
      dispatch(request$2(area, dataKey)); // Vstupní data pro request dat

      var storeForRequest = storeFromArea(getState(), area);
      var _filter = storeForRequest.filter;
      getAllIds(parent, _filter, true).then(function (data) {
        var newStore = storeFromArea(getState(), area);
        var newDataKey = newStore.getDataKey.bind(newStore)();

        if (newDataKey === dataKey) {
          // jen pokud přídchozí objekt odpovídá datům, které chceme ve store
          var _parseAllIdsData3 = parseAllIdsData(data),
              ids = _parseAllIdsData3.ids,
              allMetaMap = _parseAllIdsData3.allMetaMap,
              count = _parseAllIdsData3.count;

          dispatch(response$2(area, ids, count, allMetaMap));
        }
      }) // TODO [stanekpa] - řešit catch a vrácení datakey!
      ["catch"](function (error) {// dispatch(invalidate(area))   // zatím ne, protože se to poté opakuje pořád dokola, nutné řešit opakování s prodlevou a po několika neúspěšných pokusem ukončit
      });
    } else {
      // pokud máme nějaké objekty k aktualizaci, provedeme ji
      // Objekty
      var needUpdateIds = Object.keys(store.needUpdateIds);

      if (needUpdateIds.length > 0) {
        // provedeme aktualizaci těchto dat
        dispatch({
          type: UPDATED_REQUEST,
          area: area
        });
        callGetRowsByIds(getRowsByIds, needUpdateIds).then(function (rows) {
          dispatch(updateRows(area, rows));
        });
      } // Meta k objektům


      if (store.allMetaMap) {
        var needUpdateMetaIds = Object.keys(store.needUpdateMetaIds);

        if (needUpdateMetaIds.length > 0) {
          // provedeme aktualizaci těchto dat
          dispatch({
            type: UPDATED_META_REQUEST,
            area: area
          });
          callGetRowsByIds(getRowsByIds, needUpdateIds).then(function (rows) {
            dispatch(updateMeta(area, rows));
          });
        }
      }
    }
  };
}
/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */

function is$4(action) {
  switch (action.type) {
    case FILTER$2:
    case REQUEST$2:
    case RESPONSE$2:
    case INVALIDATE$2:
      return true;

    default:
      return false;
  }
}
/**
 * Výběr nového parenta, volá se i v případě, že je zavoláno fetchIfNeeded s jiným parent něž ve store.
 * @param area oblast
 * @param id id
 * @returns {{type: string, area: *, id: *}}
 */

function selectParent$1(area, parent) {
  return {
    type: SELECT_PARENT$1,
    area: area,
    parent: parent
  };
}
/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */


function request$2(area, dataKey) {
  return {
    type: REQUEST$2,
    area: area,
    dataKey: dataKey
  };
}
/**
 * Response dat.
 * @param area oblast
 * @param rows řádky
 * @param count celkový počet řádek, např. v db pro daný filter
 * @param allMetaMap mapa meta ke všem řádkům
 * @returns {{type: string, area: *, data: *}}
 */


function response$2(area, rows, count, allMetaMap) {
  return {
    type: RESPONSE$2,
    area: area,
    rows: rows,
    count: count,
    allMetaMap: allMetaMap
  };
}
/**
 * Reset storu
 * @param area oblast
 * @returns {{type: string, area: *}}
 */


function reset$1(area, config) {
  return {
    type: RESET$1,
    area: area,
    config: config
  };
}

var InfiniteListActions = {
  __proto__: null,
  REQUEST: REQUEST$2,
  RESPONSE: RESPONSE$2,
  RELOAD: RELOAD,
  FILTER: FILTER$2,
  REMOVE: REMOVE,
  INVALIDATE: INVALIDATE$2,
  CHANGES: CHANGES,
  SELECT_PARENT: SELECT_PARENT$1,
  LOAD_MORE_REQUEST: LOAD_MORE_REQUEST,
  LOAD_MORE_RESPONSE: LOAD_MORE_RESPONSE,
  CHECKING_MY_IDS_REQUEST: CHECKING_MY_IDS_REQUEST,
  CHECKING_MY_IDS_RESPONSE: CHECKING_MY_IDS_RESPONSE,
  UPDATED_REQUEST: UPDATED_REQUEST,
  UPDATED_META_REQUEST: UPDATED_META_REQUEST,
  UPDATED_RESPONSE: UPDATED_RESPONSE,
  UPDATED_META_RESPONSE: UPDATED_META_RESPONSE,
  RESET: RESET$1,
  invalidate: invalidate$2,
  updateRows: updateRows,
  updateMeta: updateMeta,
  changes: changes,
  loadMore: loadMore,
  filter: filter$2,
  remove: remove,
  checkMyIds: checkMyIds,
  reload: reload,
  fetchIfNeeded: fetchIfNeeded$2,
  is: is$4,
  reset: reset$1
};

var REQUEST$3 = 'list.simple.request';
var RESPONSE$3 = 'list.simple.response';
var FILTER$3 = 'list.simple.filter';
var INVALIDATE$3 = 'list.simple.invalidate';
var SELECT_PARENT$2 = 'list.simple.selectParent';
var RESET$2 = 'list.simple.reset';
/**
 * Zneplatnění dat.
 * @param area oblast
 * @returns {{type: string, area: *}}
 */

function invalidate$3(area) {
  return {
    type: INVALIDATE$3,
    area: area
  };
}
/**
 * Filtrování položek seznamu.
 * @param area oblast
 * @param filter filtr
 * @returns {{type: string, area: *, filter: *}}
 */

function filter$3(area, filter) {
  return {
    type: FILTER$3,
    area: area,
    filter: filter
  };
}
/**
 * Načtení dat pokud je potřeba.
 * @param area oblast
 * @param parent parent data pro seznam, pokud je potřeba, např. id nadřazené entity, ke které se vztahuje seznam
 * @param getData promise pro načtení
 * @param forceFetch pokud je true, provede se vždy nové načtení
 */

function fetchIfNeeded$3(area, parent, getData, forceFetch) {
  if (forceFetch === void 0) {
    forceFetch = false;
  }

  return function (dispatch, getState) {
    // Spočtení data key
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebné parent, dáme ho tam, aby se nám správně spočetl data key

    if (JSON.stringify(store.parent) !== JSON.stringify(parent)) {
      dispatch(selectParent$2(area, parent));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)();

    if (forceFetch || store.currentDataKey !== dataKey) {
      dispatch(request$3(area, dataKey));
      var _filter = store.filter;
      getData(parent, _filter).then(function (json) {
        var newStore = storeFromArea(getState(), area);
        var newDataKey = newStore.getDataKey.bind(newStore)();

        if (newDataKey === dataKey) {
          // jen pokud přídchozí objekt odpovídá datům, které chceme ve store
          if (json && json.rows) {
            dispatch(response$3(area, json.rows, json.count));
          } else if (json) {
            dispatch(response$3(area, json, 0));
          }
        }
      }); // TODO [stanekpa] - řešit catch a vrácení datakey!
    }
  };
}
/**
 * Test, předaná akce je akcí pro tuto třídu.
 * @param action akce
 * @returns {boolean} true, pokud action odpovídá této třídě
 */

function is$5(action) {
  switch (action.type) {
    case FILTER$3:
    case REQUEST$3:
    case RESPONSE$3:
    case INVALIDATE$3:
      return true;

    default:
      return false;
  }
}
/**
 * Výběr nového parenta, volá se i v případě, že je zavoláno fetchIfNeeded s jiným parent něž ve store.
 * @param area oblast
 * @param parent parent id
 * @returns {{type: string, area: *, id: *}}
 */

function selectParent$2(area, parent) {
  return {
    type: SELECT_PARENT$2,
    area: area,
    parent: parent
  };
}
/**
 * Request dat.
 * @param area oblast
 * @param dataKey data key
 * @returns {{type: string, area: *, dataKey: *}}
 */


function request$3(area, dataKey) {
  return {
    type: REQUEST$3,
    area: area,
    dataKey: dataKey
  };
}
/**
 * Response dat.
 * @param area oblast
 * @param rows řádky
 * @param count celkový počet řádek, např. v db pro daný filter
 * @returns {{type: string, area: *, data: *}}
 */


function response$3(area, rows, count) {
  return {
    type: RESPONSE$3,
    area: area,
    rows: rows,
    count: count
  };
}
/**
 * Nastavení konkrétních dat předanými, nastavením se aktualizuje i stav fetched a isFetching tak, aby byl výsledek stejný jako po reálném načtení dat ze serveru
 * @param area oblast
 * @param parent parent id
 * @param rows data
 */


function setData$1(area, parent, rows) {
  return function (dispatch, getState) {
    // Načtení aktuálního store
    var store = storeFromArea(getState(), area); // Pokud ve store není potřebné id, dáme ho tam, aby se nám správně spočetl data key

    if (store.parent !== parent) {
      dispatch(selectParent$2(area, parent));
      store = storeFromArea(getState(), area);
    }

    var dataKey = store.getDataKey.bind(store)(); // Simulace request dat

    dispatch(request$3(area, dataKey)); // Response dat

    dispatch(response$3(area, rows, rows ? rows.length : 0));
  };
}
/**
 * Reset storu
 * @param area oblast
 * @returns {{type: string, area: *}}
 */

function reset$2(area, config) {
  return {
    type: RESET$2,
    area: area,
    config: config
  };
}

var SimpleListActions = {
  __proto__: null,
  REQUEST: REQUEST$3,
  RESPONSE: RESPONSE$3,
  FILTER: FILTER$3,
  INVALIDATE: INVALIDATE$3,
  SELECT_PARENT: SELECT_PARENT$2,
  RESET: RESET$2,
  invalidate: invalidate$3,
  filter: filter$3,
  fetchIfNeeded: fetchIfNeeded$3,
  is: is$5,
  setData: setData$1,
  reset: reset$2
};

var TOGGLE$1 = 'list.infinite.check.toggle';
var TOGGLE_ALL$1 = 'list.infinite.check.toggleAll';
var CHECKED_ALL$1 = 'list.infinite.check.checkedAll';
/**
 * Toggle položky.
 * @param area oblast
 * @param id id položky
 */

function toggle$1(area, id) {
  return {
    type: TOGGLE$1,
    area: area,
    id: id
  };
}
/**
 * Toggle all položek.
 * @param area oblast
 */

function toggleAll$1(area) {
  return {
    type: TOGGLE_ALL$1,
    area: area
  };
}
/**
 * Zaškrtnout vše.
 * @param area oblast
 * @param checked zaškrtnout/odškrtnout
 */

function checkedAll$1(area, checked) {
  if (checked === void 0) {
    checked = true;
  }

  return {
    type: CHECKED_ALL$1,
    checked: checked,
    area: area
  };
}

var SimpleCheckListActions = {
  __proto__: null,
  TOGGLE: TOGGLE$1,
  TOGGLE_ALL: TOGGLE_ALL$1,
  CHECKED_ALL: CHECKED_ALL$1,
  toggle: toggle$1,
  toggleAll: toggleAll$1,
  checkedAll: checkedAll$1
};

var initialState$3 = {
  pageIndex: 0,
  // aktuální index stránky
  pagesCount: 0,
  // celkový počet stránek
  itemsCount: 0,
  // počet záznamnů
  pageSize: 10,
  // počet záznamnů na stránku
  currentDataKey: '',
  getDataKey: getDataKey$1,
  reducer: paging
};

function getDataKey$1() {
  return JSON.stringify({
    // @ts-ignore
    pageIndex: this.pageIndex,
    // pagesCount: this.pagesCount,     // tyto NEHCEME!!!!!! nesouvisí s požadavkem na data!!!
    // itemsCount: this.itemsCount,
    // @ts-ignore
    pageSize: this.pageSize
  });
}

var getPagesCount = function getPagesCount(itemsCount, pageSize) {
  var pagesCount = Math.floor(itemsCount / pageSize);

  if (itemsCount % pageSize > 0) {
    pagesCount++;
  }

  return pagesCount;
};

function paging(state, action) {
  if (state === void 0) {
    state = initialState$3;
  }

  if (action === void 0) {
    action = {};
  }

  if (state === null) {
    // může nastat, např. pokud u tabulky není inicializované stránkování
    return state;
  }

  switch (action.type) {
    case NEXT_PAGE:
      if (state.pageIndex + 1 < state.pagesCount) {
        return _extends({}, state, {
          pageIndex: state.pageIndex + 1
        });
      } else {
        return state;
      }

    case PREV_PAGE:
      if (state.pageIndex > 0) {
        return _extends({}, state, {
          pageIndex: state.pageIndex - 1
        });
      } else {
        return state;
      }

    case HOME:
      return _extends({}, state, {
        pageIndex: 0
      });

    case END:
      return _extends({}, state, {
        pageIndex: state.pagesCount - 1
      });

    case GO_TO_PAGE:
      return _extends({}, state, {
        pageIndex: action.pageIndex
      });

    case SET_PAGE_SIZE:
      return _extends({}, state, {
        pageIndex: 0,
        pageSize: action.pageSize,
        pagesCount: getPagesCount(state.itemsCount, action.pageSize)
      });

    case SET_ITEMS_COUNT:
      var pagesCount = getPagesCount(action.itemsCount, state.pageSize);
      return _extends({}, state, {
        pageIndex: Math.max(0, Math.min(state.pageIndex, pagesCount - 1)),
        itemsCount: action.itemsCount,
        pagesCount: pagesCount
      });

    default:
      return state;
  }
}

function getDataKey$2() {
  var dataKey = ''; // @ts-ignore

  dataKey += JSON.stringify(this.filter); // @ts-ignore

  if (this.supportPaging) {
    // @ts-ignore
    dataKey += '_' + this.paging.getDataKey();
  } // @ts-ignore


  dataKey += '_' + this.parent;
  return dataKey;
}

var initialState$4 = {
  supportPaging: false,
  // je podporované stránkování?
  count: 0,
  // celkový počet řádek odpovídajících filtru, BEZ stránkování - slouží pro výpočet stránkování
  rows: [],
  // řádky, které odpovídají filtru a stránkování
  dirty: false,
  // pokud je true, neodpovídají data filtru, i když jsou načtená, při filtrování neodebráme data
  isFetching: false,
  fetched: false,
  filter: {},
  currentDataKey: '',
  getDataKey: getDataKey$2,
  reducer: list,
  parent: null
};
function list(state, action, config) {
  if (state === void 0) {
    state = initialState$4;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  // Konfigurace
  if (config) {
    state = _extends({}, state); // Inicializace na základě konfigu

    if (config.paging !== null && typeof config.paging !== 'undefined') {
      // podpora pro stránkování
      state.supportPaging = config.paging;
      state.paging = paging();
    }
  } // Stránkování


  if (state.supportPaging && is$2(action)) {
    return _extends({}, state, {
      paging: paging(state.paging, action)
    });
  } // Vlastní akce


  switch (action.type) {
    case INVALIDATE$1:
      return _extends({}, state, {
        currentDataKey: '',
        dirty: true
      });

    case REQUEST$1:
      return _extends({}, state, {
        isFetching: true,
        currentDataKey: action.dataKey
      });

    case SELECT_PARENT:
      return _extends({}, state, {
        parent: action.parent,
        dirty: true
      });

    case RESPONSE$1:
      {
        return _extends({}, state, {
          isFetching: false,
          fetched: true,
          dirty: false,
          rows: action.rows,
          count: action.count
        });
      }

    case FILTER$1:
      {
        return _extends({}, state, {
          filter: action.filter,
          dirty: true
        });
      }

    default:
      return state;
  }
}

var AdvancedPagination = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AdvancedPagination, _React$Component);

  function AdvancedPagination() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleSelectFirst = function () {
      _this.handleSelect(0);
    };

    _this.handleSelectPrev = function () {
      var pageIndex = _this.props.paging.pageIndex;

      _this.handleSelect(pageIndex - 1);
    };

    _this.handleSelectNext = function () {
      var pageIndex = _this.props.paging.pageIndex;

      _this.handleSelect(pageIndex + 1);
    };

    _this.handleSelectLast = function () {
      var pagesCount = _this.props.paging.pagesCount;

      _this.handleSelect(pagesCount - 1);
    };

    return _this;
  }

  var _proto = AdvancedPagination.prototype;

  _proto.handleSelect = function handleSelect(pageIndex) {
    var area = this.props.area;
    this.props.dispatch(goToPage(area, pageIndex));
  };

  _proto.renderButton = function renderButton(label, disabled, onClick, key) {
    return React__default.createElement(PaginationItem, {
      disabled: disabled,
      key: key
    }, React__default.createElement(PaginationLink, {
      href: "#",
      onClick: onClick
    }, label));
  };

  _proto.renderPageButton = function renderPageButton(page, activePage) {
    var _this2 = this;

    var disabled = page === activePage;

    var onClick = function onClick() {
      return _this2.handleSelect(page - 1);
    };

    return this.renderButton(page, disabled, onClick, page);
  };

  _proto.renderEllipsis = function renderEllipsis(key) {
    return this.renderButton("\u2026", true, null, key);
  };

  _proto.renderPageButtons = function renderPageButtons() {
    var _this$props$paging = this.props.paging,
        pagesCount = _this$props$paging.pagesCount,
        pageIndex = _this$props$paging.pageIndex;
    var maxButtons = 5;
    var activePage = pageIndex + 1;
    var pageButtons = [];
    var startPage;
    var endPage;

    if (maxButtons < pagesCount) {
      startPage = Math.max(Math.min( //@ts-ignore
      activePage - Math.floor(maxButtons / 2, 10), pagesCount - maxButtons + 1), 1);
      endPage = startPage + maxButtons - 1;
    } else {
      startPage = 1;
      endPage = pagesCount;
    }

    for (var page = startPage; page <= endPage; ++page) {
      pageButtons.push(this.renderPageButton(page, activePage));
    }

    if (startPage > 1) {
      if (startPage > 2) {
        pageButtons.unshift(this.renderEllipsis('elps1'));
      }

      pageButtons.unshift(this.renderPageButton(1, activePage));
    }

    if (endPage < pagesCount) {
      if (endPage < pagesCount - 1) {
        pageButtons.push(this.renderEllipsis('elps2'));
      }

      pageButtons.push(this.renderPageButton(pagesCount, activePage));
    }

    return pageButtons;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _this$props$paging2 = _this$props.paging,
        pagesCount = _this$props$paging2.pagesCount,
        pageIndex = _this$props$paging2.pageIndex,
        center = _this$props.center,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["paging", "center", "area", "dispatch", "autoHide"]);

    var isFirstPage = pageIndex == 0;
    var isLastPage = pageIndex >= pagesCount - 1;
    var invisible = pagesCount <= 1;
    return React__default.createElement(Pagination, Object.assign({
      className: classNames({
        invisible: invisible,
        'justify-content-center': center
      })
    }, otherProps), this.renderButton("\xAB", isFirstPage, this.handleSelectFirst, 'first'), this.renderButton("\u2039", isFirstPage, this.handleSelectPrev, 'prev'), this.renderPageButtons(), this.renderButton("\u203A", isLastPage, this.handleSelectNext, 'last'), this.renderButton("\xBB", isLastPage, this.handleSelectLast, 'end'));
  };

  return AdvancedPagination;
}(React__default.Component);

AdvancedPagination.propTypes = {
  area: PropTypes__default.string.isRequired,
  // area pagging! NE seznamu!!!
  paging: PropTypes__default.object,
  // store na paging, nastavuje se dle area v této komponentě
  center: PropTypes__default.bool,
  // Centrovani tlacitek
  autoHide: PropTypes__default.bool
};
AdvancedPagination.defaultProps = {
  center: true,
  autoHide: true
};

function mapStateToProps$2(state, props) {
  return {
    paging: storeFromArea(state, props.area)
  };
}

var AdvancedPagination$1 = /*#__PURE__*/connect(mapStateToProps$2)(AdvancedPagination);

function getDataKey$3() {
  var dataKey = ''; // @ts-ignore

  dataKey += JSON.stringify(this.filter); // @ts-ignore

  dataKey += '_' + this.parent;
  return dataKey;
}
/**
 * Stav pro reset načteých dat - mimo filtr.
 */


var resetState = {
  fetched: false,
  isFetching: false,
  loadingMore: false,
  dirty: true,
  allIds: [],
  rows: [],
  deletedIds: {},
  needUpdateIds: {},
  needUpdateMetaIds: {},
  addedIds: {},
  checkingMyIds: false,
  hasNewIds: false
};
var initialState$5 = {
  loadingMore: false,
  // zde se ukládá, zda již načítá další data pro load more
  checkingMyIds: false,
  // zda probíhá akce zjišťování svých id
  hasNewIds: false,
  // true, pokud kontrola checkingMyIds nalezna reálné id pro nás
  hasMore: false,
  // boolean, který má informaci o tom, zda existují další záznamy na donačtení
  dirty: false,
  // pokud je true, neodpovídají data filtru, i když jsou načtená, při filtrování neodebráme data
  allIds: [],
  // řádky, které odpovídají filtru, jen seznam id
  rows: [],
  // řádky, které odpovídají aktuálnímu zobrazení, seznam načtených dat - objektů
  isFetching: false,
  fetched: false,
  filter: {},
  currentDataKey: '',
  allMetaMap: null,
  getDataKey: getDataKey$3,
  loadMoreCount: 150,
  // počet záznamů, které se mají donačíst při dalším načítání seznamu dat - počet donačtených řádků
  reducer: list$1,
  parent: null,
  addedIds: [],
  // pole seznamu id, které byly přidány
  deletedIds: {},
  // mapa id->true, že je smazané, týká se pouze id, pro které máme již donačtené objety
  needUpdateIds: {},
  // mapa id->true, že se má daný objekt při příštím zobrazení aktualizovat ze serveru
  needUpdateMetaIds: {}
};

function loadMoreResponse$1(state, action) {
  // Pokud jsou nějaká id smazána, nemusejí se pro ně vrátit objekt, stejně tak result nemusí pořadím odpovídat pořadí předaných id
  var rowsMap = getMapFromList(action.rows);
  var loadedIds = []; // upravený seznam id omezený o ty id, které již server nevrátil

  var loadedRows = [];
  action.requiredIds.forEach(function (id) {
    if (rowsMap[id]) {
      // objekt byl na serveru načten a existuje (nebo je na něj oprávnění pro zobrazení)
      loadedIds.push(id);
      loadedRows.push(rowsMap[id]);
    }
  });
  var newRows = [].concat(state.rows, loadedRows);
  var newAllIds = [].concat(state.allIds.slice(0, state.rows.length), loadedIds, state.allIds.slice(state.rows.length + action.requiredIds.length));
  return _extends({}, state, {
    rows: newRows,
    allIds: newAllIds,
    hasMore: newRows.length < newAllIds.length,
    loadingMore: false
  });
}

function response$4(state, action) {
  return _extends({}, state, {
    isFetching: false,
    fetched: true,
    dirty: false,
    loadingMore: false,
    allIds: action.rows,
    rows: [],
    hasMore: action.rows.length > 0,
    count: action.count,
    deletedIds: {},
    needUpdateIds: {},
    needUpdateMetaIds: {},
    addedIds: {},
    checkingMyIds: false,
    hasNewIds: false,
    allMetaMap: action.allMetaMap
  });
}

function mergeWithConfig(state, config) {
  // Konfigurace
  if (config) {
    state = _extends({}, state); // Inicializace na základě konfigu

    if (config.loadMoreCount != null) {
      state.loadMoreCount = config.loadMoreCount;
    }

    if (config.filter) {
      // inicializační filtr
      state.filter = config.filter;
    }
  }

  return state;
}

function list$1(state, action, config) {
  if (state === void 0) {
    state = initialState$5;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  state = mergeWithConfig(state, config); // Vlastní akce

  switch (action.type) {
    case UPDATED_REQUEST:
      {
        return _extends({}, state, {
          needUpdateIds: {}
        });
      }

    case UPDATED_META_REQUEST:
      {
        return _extends({}, state, {
          needUpdateMetaIds: {}
        });
      }

    case UPDATED_RESPONSE:
      {
        var updatedObjectsMap = getMapFromList(action.rows);
        var updatedRows = state.rows.map(function (row) {
          // Pokud je objekt v seznamu aktualizovaných, použijeme ten, jinak použijeme ten, co máme ve store
          return updatedObjectsMap[row.id] ? updatedObjectsMap[row.id] : row;
        });
        return _extends({}, state, {
          rows: updatedRows
        });
      }

    case UPDATED_META_RESPONSE:
      {
        var newAllMetaMap = _extends({}, state.allMetaMap);

        state.rows.forEach(function (row) {
          newAllMetaMap[row.id] = row;
        });
        return _extends({}, state, {
          allMetaMap: newAllMetaMap
        });
      }

    case CHECKING_MY_IDS_REQUEST:
      return _extends({}, state, {
        checkingMyIds: true
      });

    case CHECKING_MY_IDS_RESPONSE:
      return _extends({}, state, {
        checkingMyIds: false,
        hasNewIds: action.hasNewIds,
        addedIds: action.hasNewIds ? [] : state.addedIds
      });

    case CHANGES:
      {
        // DELETED
        var newDeletedIds;
        var newAllIds;
        var newRows = state.rows;

        var _newAllMetaMap = state.allMetaMap ? _extends({}, state.allMetaMap) : null;

        if (action.deletedIds.length > 0) {
          if (action.removeDeleted) {
            // Kompletně odebereme deleted id a objekty
            var deletedIdsMap = getSetFromIdsList(action.deletedIds);
            newDeletedIds = state.deletedIds;
            newRows = [];
            state.rows.forEach(function (x) {
              if (!deletedIdsMap[x.id]) {
                // nebyl smazán, necháme
                newRows.push(x);
              }
            });
            newAllIds = [];
            state.allIds.forEach(function (id) {
              if (!deletedIdsMap[id]) {
                // nebyl smazán, necháme
                newAllIds.push(id);
              } else {
                // byl smazán, odebereme meta, pokud máme
                if (_newAllMetaMap) {
                  delete _newAllMetaMap[id];
                }
              }
            });
          } else {
            // U objektů, které máme již načtené si můžeme uchovat příznak, že jsou smazány
            // Smazaná id odebereme ze seznamu id, pro které ještě nemáme načtené objekty
            var _deletedIdsMap = getSetFromIdsList(action.deletedIds);

            newDeletedIds = _extends({}, state.deletedIds);
            newAllIds = [];
            state.allIds.forEach(function (id, index) {
              if (index < state.rows.length) {
                // id, pro které máme načtený objekt
                newAllIds.push(id); // id v seznamu musíme zachovat, protože si necháváme i objekt, jen si u něj pamatujeme, že je smazaný

                if (_deletedIdsMap[id]) {
                  // máme objekt, ale byl smazaný
                  newDeletedIds[id] = true;
                }
              } else {
                // id, pro které ještě načtený objekt nemáme
                if (!_deletedIdsMap[id]) {
                  // pokud není smazané, zachováme ho v seznamu id
                  newAllIds.push(id);
                }
              }
            });
          }
        } else {
          newDeletedIds = state.deletedIds;
          newAllIds = state.allIds;
        } // CREATED
        // U objektů které přibily nic neděláme - zatím, v budoucnu můžeme např. uživateli zobrazit info, že jsou nové - ale musíme si být jisti, že dané id jsou opravdu pro něho např. s respektováním aktuálního filtru
        // Jen si uložíme příznak, že si myslíme, že máme nové id - můžeme využít např. v případě did mount na reload


        var newAddedIds = [].concat(state.addedIds, action.createdIds); // UPDATED
        // Pokud mám pro nějaké předané id načtený objekt, měl by se (pokud se list zobrazuje uživateli) načíst znovu ze serveru

        var newNeedUpdateIds;
        var newNeedUpdateMetaIds;

        if (action.updatedIds.length > 0) {
          var updatedIdsMap = getSetFromIdsList(action.updatedIds); // Aktualizace seznamu id objektů, které se změnily a máme pro ně načtené objekty ze serveru

          newNeedUpdateIds = _extends({}, state.needUpdateIds);

          for (var a = 0; a < state.rows.length; a++) {
            var id = state.allIds[a];

            if (updatedIdsMap[id]) {
              newNeedUpdateIds[id] = true; // máme ho jako objekt a chceme ho aktualizovat při příštím zobrazení
            }
          } // Aktualizace seznamu id pro meta - změnily se objekty, pro které máme načtené meta informace


          if (state.allMetaMap) {
            newNeedUpdateMetaIds = _extends({}, state.needUpdateMetaIds);

            for (var _a = 0; _a < action.updatedIds.length; _a++) {
              var _id = action.updatedIds[_a];

              if (state.allMetaMap[_id]) {
                // evidujeme pro něj meta, budeme ho chtít aktualizovat
                newNeedUpdateMetaIds[_id] = true;
              }
            }
          } else {
            newNeedUpdateMetaIds = {};
          }
        } else {
          newNeedUpdateIds = state.needUpdateIds;
          newNeedUpdateMetaIds = state.needUpdateMetaIds;
        }

        return _extends({}, state, {
          rows: newRows,
          allIds: newAllIds,
          addedIds: newAddedIds,
          deletedIds: newDeletedIds,
          needUpdateIds: newNeedUpdateIds,
          needUpdateMetaIds: newNeedUpdateMetaIds,
          allMetaMap: _newAllMetaMap
        });
      }

    case LOAD_MORE_REQUEST:
      {
        return _extends({}, state, {
          loadingMore: true
        });
      }

    case LOAD_MORE_RESPONSE:
      {
        return loadMoreResponse$1(state, action);
      }

    case RELOAD:
      var responseAction = {
        rows: action.ids,
        count: 0,
        allMetaMap: action.allMetaMap,
        needUpdateMetaIds: {}
      };
      var loadMoreAction = {
        rows: action.rows,
        requiredIds: action.requiredIds
      };
      return loadMoreResponse$1(response$4(state, responseAction), loadMoreAction);

    case INVALIDATE$2:
      return _extends({}, state, {
        dirty: true,
        currentDataKey: '',
        loadingMore: false
      });

    case REQUEST$2:
      return _extends({}, state, {
        isFetching: true,
        currentDataKey: action.dataKey,
        loadingMore: false
      });

    case SELECT_PARENT$1:
      // Při změně parenta invaildujeme všechna data
      return _extends({}, state, {
        parent: action.parent
      }, resetState);

    case RESPONSE$2:
      {
        return response$4(state, action);
      }

    case FILTER$2:
      {
        return _extends({}, state, {
          filter: action.filter,
          dirty: true
        }, action.resetData ? resetState : {});
      }

    case REMOVE:
      {
        var idsSet = getSetFromIdsList(action.ids);
        return _extends({}, state, {
          allIds: state.allIds.filter(function (id) {
            return !idsSet[id];
          }),
          rows: state.rows.filter(function (row) {
            return !idsSet[row.id];
          })
        });
      }

    case RESET$1:
      {
        return _extends({}, mergeWithConfig(initialState$5, action.config));
      }

    default:
      return state;
  }
} // let store = list();
//
// console.log("INIT", store);
//
// store = list(store, {
//     type: REQUEST,
//     dataKey: "X"
// });
// console.log("after REQUEST", store);
//
// store = list(store, {
//     type: RESPONSE,
//     rows: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
//     count: 10,
// });
// console.log("after RESPONSE", store);
//
// store = list(store, {
//         type: LOAD_MORE_RESPONSE,
//         rows: [{id: 1}, {id: 4}, {id: 5}],
//         requiredIds: [1, 2, 3, 4, 5]
//     }
// );
// console.log("after LOAD_MORE_RESPONSE", store);
//
// store = list(store, {
//         type: LOAD_MORE_RESPONSE,
//         rows: [{id: 8}, {id: 9}, {id: 10}],
//         requiredIds: [6, 7, 8, 9, 10]
//     }
// );
// console.log("after LOAD_MORE_RESPONSE", store);

var initialState$6 = /*#__PURE__*/_extends({
  reducer: list$2,
  checkedIds: {},
  // seznam vybraných id - mapa id na true
  allChecked: false
}, /*#__PURE__*/list$1());

function calcAllChecked(allIds, checkedIds) {
  for (var a = 0; a < allIds.length; a++) {
    if (!checkedIds[allIds[a]]) {
      return false;
    }
  }

  return true;
}

function list$2(state, action, config) {
  if (state === void 0) {
    state = initialState$6;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  // Konfigurace
  if (config) {
    state = _extends({}, state, list$1(undefined, {}, config), {
      reducer: list$2
    });
  } // Vlastní akce


  switch (action.type) {
    case TOGGLE:
      {
        var newCheckedIds;

        if (state.checkedIds[action.id]) {
          // je vybraná
          newCheckedIds = _extends({}, state.checkedIds);
          delete newCheckedIds[action.id];
        } else {
          var _extends2;

          // není vybraná
          newCheckedIds = _extends({}, state.checkedIds, (_extends2 = {}, _extends2[action.id] = true, _extends2));
        }

        return _extends({}, state, {
          checkedIds: newCheckedIds,
          allChecked: calcAllChecked(state.allIds, newCheckedIds)
        });
      }

    case TOGGLE_ALL:
      {
        if (state.allChecked) {
          return _extends({}, state, {
            checkedIds: {},
            allChecked: false
          });
        } else {
          return _extends({}, state, {
            checkedIds: getSetFromIdsList(state.allIds),
            allChecked: true
          });
        }
      }

    case CHECKED_ALL:
      {
        if (action.checked) {
          return _extends({}, state, {
            checkedIds: getSetFromIdsList(state.allIds),
            allChecked: true
          });
        } else {
          return _extends({}, state, {
            checkedIds: {},
            allChecked: false
          });
        }
      }

    case REMOVE:
      {
        var checkedIds = _extends({}, state.checkedIds);

        for (var _iterator = _createForOfIteratorHelperLoose(action.ids), _step; !(_step = _iterator()).done;) {
          var id = _step.value;
          delete checkedIds[id];
        }

        var allChecked = state.allChecked && action.ids.length === 0; // Zachovame příznak pokud bychom nic neubrali

        return _extends({}, state, list$1(state, action), {
          checkedIds: checkedIds,
          allChecked: allChecked
        });
      }

    default:
      return _extends({}, state, list$1(state, action), {
        reducer: list$2
      });
  }
}

/**
 * Loader pro načítání dat. Pokud má obsah (children), je zobrazen jako načítací text, jinak se typicky použije implicitní.
 */

function Loader(_ref) {
  var _ref$noPadding = _ref.noPadding,
      noPadding = _ref$noPadding === void 0 ? false : _ref$noPadding,
      _ref$CardBody = _ref.CardBody,
      CardBody = _ref$CardBody === void 0 ? false : _ref$CardBody,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutPropertiesLoose(_ref, ["noPadding", "CardBody", "className", "children"]);

  var cls = classNames('loader', className, {
    'no-padding': noPadding,
    'card-body': CardBody
  });
  return createElement("div", Object.assign({
    className: cls
  }, other), createElement(FAIcon, {
    icon: "circle-o-notch",
    animation: FAIcon.animation.spin,
    fixedWidth: true
  }), createElement("span", null, children || 'Načítají se data'));
}

/**
 * Komkponenta pro nekonečný scroll - jedná se o wrapper, který doplňuje některé vlastnosti externí InfiniteScroll komponentě.
 */

function InfiniteScroll(_ref) {
  var _ref$initialLoad = _ref.initialLoad,
      initialLoad = _ref$initialLoad === void 0 ? true : _ref$initialLoad,
      _ref$threshold = _ref.threshold,
      threshold = _ref$threshold === void 0 ? 6 : _ref$threshold,
      _ref$pageStart = _ref.pageStart,
      pageStart = _ref$pageStart === void 0 ? 0 : _ref$pageStart,
      _ref$loader = _ref.loader,
      loader = _ref$loader === void 0 ? createElement(Loader, null) : _ref$loader,
      _ref$useWindow = _ref.useWindow,
      useWindow = _ref$useWindow === void 0 ? false : _ref$useWindow,
      _ref$bordered = _ref.bordered,
      bordered = _ref$bordered === void 0 ? false : _ref$bordered,
      className = _ref.className,
      children = _ref.children,
      other = _objectWithoutPropertiesLoose(_ref, ["initialLoad", "threshold", "pageStart", "loader", "useWindow", "bordered", "className", "children"]);

  return createElement(InfiniteScrollExternal, Object.assign({
    className: classNames('items-list', className, {
      bordered: bordered
    }),
    initialLoad: initialLoad,
    threshold: threshold,
    pageStart: pageStart,
    loader: loader,
    useWindow: useWindow
  }, other), children);
}

var ListComponent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ListComponent, _React$Component);

  function ListComponent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListComponent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        store = _this$props.store,
        renderItem = _this$props.renderItem,
        renderContainer = _this$props.renderContainer;
    return renderContainer(store.rows.map(renderItem));
  };

  return ListComponent;
}(React__default.Component);

ListComponent.defaultProps = {
  renderContainer: function renderContainer(child) {
    return React__default.createElement("div", null, child);
  }
};
ListComponent.propTypes = {
  area: PropTypes__default.string.isRequired,
  renderItem: PropTypes__default.func.isRequired,
  renderContainer: PropTypes__default.func
};
var ListComponent$1 = /*#__PURE__*/connect(function (state, props) {
  return {
    store: storeFromArea(state, props.area)
  };
})(ListComponent);

var simpleFilter = function simpleFilter(rows, filter) {
  return rows;
};

function getDataKey$4() {
  var dataKey = ''; // Filter
  // @ts-ignore

  dataKey += JSON.stringify(this.filter); // Parent
  // @ts-ignore

  dataKey += '_' + this.parent; // Stránkování, pokud je povoleno
  // @ts-ignore

  if (this.supportPaging) {
    // @ts-ignore
    dataKey += '_' + this.paging.getDataKey();
  } // ---


  return dataKey;
}

var initialState$7 = {
  sourceRows: [],
  // zdrojové řádky
  filteredRows: [],
  // filtrované řádky
  count: 0,
  rows: [],
  // vyfiltrované řádky a případně jinak upravené řádky = určené pro konkrétní zobrazení
  isFetching: false,
  fetched: false,
  filter: {},
  filterRows: simpleFilter,
  currentDataKey: '',
  getDataKey: getDataKey$4,
  reducer: list$3,
  parent: null
};

function mergeWithConfig$1(state, config) {
  // Konfigurace
  if (config) {
    state = _extends({}, state);

    if (config.filterRows) {
      // metoda pro filtr
      state.filterRows = config.filterRows;
    }

    if (config.filter) {
      // inicializační filtr
      state.filter = config.filter;
    }
  }

  return state;
}

function list$3(state, action, config) {
  if (state === void 0) {
    state = initialState$7;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  state = mergeWithConfig$1(state, config);

  switch (action.type) {
    case INIT_REDUCER:
      return _extends({}, action.store);

    case REQUEST$3:
      return _extends({}, state, {
        isFetching: true,
        currentDataKey: action.dataKey
      });

    case SELECT_PARENT$2:
      return _extends({}, state, {
        parent: action.parent,
        fetched: false,
        isFetching: false,
        sourceRows: [],
        filteredRows: [],
        rows: [],
        count: 0
      });

    case INVALIDATE$3:
      {
        return _extends({}, state, {
          currentDataKey: initialState$7.currentDataKey
        });
      }

    case RESPONSE$3:
      {
        var sourceRows = action.rows;
        var filteredRows = state.filterRows(sourceRows, state.filter);
        var rows = filteredRows;
        return _extends({}, state, {
          isFetching: false,
          fetched: true,
          sourceRows: sourceRows,
          filteredRows: filteredRows,
          rows: rows,
          count: action.count
        });
      }

    case FILTER$3:
      {
        var _filteredRows = state.filterRows(state.sourceRows, action.filter);

        var _rows = _filteredRows;
        return _extends({}, state, {
          filter: action.filter,
          filteredRows: _filteredRows,
          rows: _rows
        });
      }

    case RESET$2:
      {
        return _extends({}, mergeWithConfig$1(initialState$7, action.config));
      }

    default:
      return state;
  }
}

var initialState$8 = /*#__PURE__*/_extends({
  reducer: list$4,
  checkedIds: {},
  // seznam vybraných id - mapa id na true
  allChecked: false
}, /*#__PURE__*/list$3());

function getAllIds(rows) {
  return rows.map(function (x) {
    return x.id;
  });
}

function calcAllChecked$1(allIds, checkedIds) {
  for (var a = 0; a < allIds.length; a++) {
    if (!checkedIds[allIds[a]]) {
      return false;
    }
  }

  return true;
}

function list$4(state, action, config) {
  if (state === void 0) {
    state = initialState$8;
  }

  if (action === void 0) {
    action = {};
  }

  if (config === void 0) {
    config = null;
  }

  // Konfigurace
  if (config) {
    state = _extends({}, state, list$3(undefined, {}, config), {
      reducer: list$4
    });
  } // Vlastní akce


  switch (action.type) {
    case TOGGLE$1:
      {
        var newCheckedIds;

        if (state.checkedIds[action.id]) {
          // je vybraná
          newCheckedIds = _extends({}, state.checkedIds);
          delete newCheckedIds[action.id];
        } else {
          var _extends2;

          // není vybraná
          newCheckedIds = _extends({}, state.checkedIds, (_extends2 = {}, _extends2[action.id] = true, _extends2));
        }

        return _extends({}, state, {
          checkedIds: newCheckedIds,
          allChecked: calcAllChecked$1(getAllIds(state.rows), newCheckedIds)
        });
      }

    case TOGGLE_ALL$1:
      {
        if (state.allChecked) {
          return _extends({}, state, {
            checkedIds: {},
            allChecked: false
          });
        } else {
          return _extends({}, state, {
            checkedIds: getSetFromIdsList(getAllIds(state.rows)),
            allChecked: true
          });
        }
      }

    case CHECKED_ALL$1:
      {
        if (action.checked) {
          return _extends({}, state, {
            checkedIds: getSetFromIdsList(getAllIds(state.rows)),
            allChecked: true
          });
        } else {
          return _extends({}, state, {
            checkedIds: {},
            allChecked: false
          });
        }
      }

    default:
      return _extends({}, state, list$3(state, action), {
        reducer: list$4
      });
  }
}



var index$6 = {
  __proto__: null,
  AdvancedListActions: AdvancedListActions,
  InfiniteCheckListActions: InfiniteCheckListActions,
  InfiniteListActions: InfiniteListActions,
  SimpleListActions: SimpleListActions,
  SimpleCheckListActions: SimpleCheckListActions,
  AdvancedListReducer: list,
  AdvancedPagination: AdvancedPagination$1,
  InfiniteCheckListReducer: list$2,
  InfiniteListReducer: list$1,
  InfiniteScroll: InfiniteScroll,
  ListComponent: ListComponent$1,
  SimpleListReducer: list$3,
  SimpleCheckListReducer: list$4
};

/**
 * Akce pro číselník právních forem.
 */

function getList() {
  return PravniFormaApi.getPravniFormy(null, false);
}

function fetchListIfNeeded(area) {
  return function (dispatch, getState) {
    dispatch(initIfNeeded(area, list$3));
    dispatch(fetchIfNeeded$3(area, null, function () {
      return getList();
    }));
  };
}

function getArea(props) {
  return props.area ? props.area : 'shared.pravniFormy';
} // TODO StoreSuggest

/**
 * Právní forma field
 * Suggest
 */


var PravniFormaField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PravniFormaField, _React$Component);

  function PravniFormaField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      var pravniFormy = _this.props.pravniFormy;
      return new Promise(function (resolve, reject) {
        if (pravniFormy.fetched) {
          var rows = filterObjectsByPropertyFulltext(pravniFormy.rows, value, 'nazev');
          resolve(rows);
        } else {
          resolve([]);
        }
      });
    };

    return _this;
  }

  var _proto = PravniFormaField.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var area = getArea(this.props);
    this.props.dispatch(fetchListIfNeeded(area));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pravniFormy = _this$props.pravniFormy,
        other = _objectWithoutPropertiesLoose(_this$props, ["pravniFormy"]);

    if (!pravniFormy || !pravniFormy.fetched) {
      return React__default.createElement(Input, {
        type: "text",
        disabled: true
      });
    }

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      dropdown: true,
      filterSuggestions: this.handleFilterSuggestions,
      apiRequestDelay: 0,
      getItemValue: function getItemValue(item) {
        return item ? item.nazev : '';
      },
      renderSuggestion: function renderSuggestion(i, active, getItemValue) {
        return React__default.createElement("div", {
          className: active ? 'active' : ''
        }, i.nazev);
      }
    }, other));
  };

  return PravniFormaField;
}(React__default.Component);

PravniFormaField.propTypes = {
  pravniFormy: PropTypes__default.object,
  // není required kvůli shared store, který nemusí být inicializovaný
  area: PropTypes__default.string,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

function mapStateToProps$3(state, props) {
  var useArea = getArea(props);
  var pravniFormyStore = storeFromArea(state, useArea, false);
  return {
    pravniFormy: pravniFormyStore
  };
}

var PravniFormaField$1 = /*#__PURE__*/connect(mapStateToProps$3)(PravniFormaField);

/**
 * Field pro výběr šablony.
 */

var SablonaField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SablonaField, _React$Component);

  function SablonaField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      typDokumentKod: _this.props.typDokumentKod,
      list: null
    };

    _this.requestData = function (typDokumentKod) {
      _this.setState({
        typDokumentKod: typDokumentKod,
        list: null
      });

      TypDokumentApi.getSablonyProTypDokumentu(typDokumentKod).then(function (list) {
        if (typDokumentKod === _this.state.typDokumentKod) {
          _this.setState({
            list: list
          });
        }
      });
    };

    return _this;
  }

  var _proto = SablonaField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var typDokumentKod = this.props.typDokumentKod;
    this.requestData(typDokumentKod);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var typDokumentKod = nextProps.typDokumentKod;

    if (typDokumentKod !== this.props.typDokumentKod) {
      this.requestData(typDokumentKod);
    }
  };

  _proto.render = function render() {
    var list = this.state.list;

    var _this$props = this.props,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["typDokumentKod"]);

    return React__default.createElement(ObjectSuggestField, Object.assign({
      dropdown: true,
      removable: false,
      items: list,
      itemValueAttrName: "nazev"
    }, otherProps));
  };

  return SablonaField;
}(React__default.Component);

SablonaField.propTypes = {
  typDokumentKod: PropTypes__default.string.isRequired
};

/**
 * Input pro datumy.
 * Nutné speciálně řešit onBlur, protože react widgets ho nepodporují.
 */

var DateField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(DateField, _AbstractField);

  function DateField(props) {
    var _this;

    _this = _AbstractField.call(this, props) || this;
    /**
     * Konverze hodnoty z props na editovanou hodnotu.
     * @param value props hodnota
     * @return {null} hodnota, kterou potřebuje field pro editaci
     */

    _this.getValueFromProps = function (value) {
      return value && value != '' ? localUTCToDate(value) : null;
    };
    /**
     * Konverze editované hodnoty pro poslání ven.
     * @param value editovaná hodnota
     * @return {null} hodnota pro odeslání ven
     */


    _this.getValueForReturn = function (value) {
      if (!(value instanceof Date)) {
        return null;
      }

      var year = value.getFullYear();
      var yearStr = year.toString();

      if (yearStr.length > 4) {
        // Uživatel se asi přepsal, vezmeme jen první 4 číslice.
        // Nepočítáme zatím s tím, že by chtěl někdo zadávat data po roce 9999.
        value = new Date(value.getTime()); // Clone

        value.setFullYear(parseInt(yearStr.substring(0, 4)));
      } else if (yearStr.length <= 2) {
        // Uživatel zadal 1 nebo 2 číslice.
        // Spočteme rok v aktuálním a minulém století s tímto koncovým dvojčíslem.
        // Použijeme rok, který je bližší k aktuálnímu datu.
        // Nepočítáme s tím, že by chtěl někdo zadávat datum z roku 0-99.
        var currentYear = new Date().getFullYear();
        var currentCentury = Math.floor(currentYear / 100) * 100;
        var prevCentury = currentCentury - 100;
        var yearInCurrentCentury = currentCentury + year;
        var yearInPrevCentury = prevCentury + year;
        value = new Date(value.getTime()); // Clone

        if (Math.abs(currentYear - yearInCurrentCentury) < Math.abs(currentYear - yearInPrevCentury)) {
          value.setFullYear(yearInCurrentCentury);
        } else {
          value.setFullYear(yearInPrevCentury);
        }
      }

      return dateToLocalUTC(value);
    };

    _this.handleChange = function (value, _) {
      var onChange = _this.props.onChange;

      _this.setState({
        value: value
      });

      var formValue = _this.getValueForReturn(value);

      var val = {
        type: 'text',
        value: formValue,
        addEventListener: function addEventListener() {},
        removeEventListener: function removeEventListener() {},
        dispatchEvent: function dispatchEvent(_) {
          return false;
        }
      };
      var event = {
        target: val,
        currentTarget: val,
        stopPropagation: function stopPropagation() {},
        preventDefault: function preventDefault() {}
      };
      onChange == null ? void 0 : onChange(event);
    };

    _this.handleBlur = function () {
      var onBlur = _this.props.onBlur;
      onBlur == null ? void 0 : onBlur(_this.getValueForReturn(_this.state.value));
    };

    _this.handleKeyPress = function (event) {
      if (event.key === 'Enter') {
        // Očekáváme DD.MM.YYYY formát
        var value = event.target.value || '';
        var parts = value.replace(/\s/g, '').split('.');
        var day = parseInt(parts[0]);
        var month = parseInt(parts[1]);
        var year = parseInt(parts[2]);

        if (day > 0 && month > 0 && year >= 0) {
          var date = new Date(0, month - 1, day);
          date.setFullYear(year); // Nepoužívat konstruktor, má speciální chování pro 0-99

          if (!isNaN(+date)) {
            _this.handleChange(date);
          }
        }
      }

      var onKeyPress = _this.props.onKeyPress;
      onKeyPress == null ? void 0 : onKeyPress(event);
    };

    _this.state = {
      value: _this.getValueFromProps(props.value)
    };
    _this.picker = React__default.createRef();
    return _this;
  }

  var _proto = DateField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    /*
    this.picker!.current!.children[0].className += ' form-control';
    this.picker!.current!.children[1].className += ' input-group-btn';
    this.picker!.current!.children[1].children[0].className +=
      ' btn btn-secondary';
    this.picker!.current!.children[1].children[0].removeAttribute('tabindex');
    */
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      value: this.getValueFromProps(nextProps.value)
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        addonsAfter = _this$props.addonsAfter,
        value = _this$props.value,
        className = _this$props.className,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter", "value", "className", "onChange", "onBlur", "groupClass", "noLabelInputClass", "labelInFieldComponent", "labelClass", "inputClass"]);

    var objValue = this.getValueFromProps(value);
    var cls = classNames('input-group', className);
    var field = React__default.createElement(Localization, {
      date: new DateLocalizer({
        firstOfWeek: 1
      })
    }, React__default.createElement(DatePicker, Object.assign({
      ref: this.picker,
      className: cls,
      value: objValue,
      onBlur: this.handleBlur,
      onChange: this.handleChange,
      onKeyPress: this.handleKeyPress,
      messages: {
        dateButton: i18n('dateTimePicker.calendarButton'),
        moveBack: i18n('dateTimePicker.moveBack'),
        moveForward: i18n('dateTimePicker.moveForward'),
        moveToday: i18n('dateTimePicker.moveToday')
      }
    }, props)));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return DateField;
}(AbstractField);

var SUGGEST_THEME$1 = {
  container: 'react-autosuggest__container',
  containerOpen: 'react-autosuggest__container--open',
  input: 'form-control react-autosuggest__input',
  suggestionsContainer: 'react-autosuggest__suggestions-container',
  suggestion: 'react-autosuggest__suggestion',
  suggestionFocused: 'react-autosuggest__suggestion--focused',
  sectionContainer: 'react-autosuggest__section-container',
  sectionTitle: 'react-autosuggest__section-title',
  sectionSuggestionsContainer: 'react-autosuggest__section-suggestions-container'
};
/**
 * Simple suggest field.
 *
 * Klasický autocomplete - napovídá hodnoty, uživatel může vybrat hodnotu nebo ji ručně napsat - i jinou, než je v seznamu.
 */

var SimpleSuggestField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(SimpleSuggestField, _AbstractField);

  function SimpleSuggestField(props) {
    var _this;

    _this = _AbstractField.call(this, props) || this;
    _this.autosuggestRef = React__default.createRef();

    _this.handleKeyDown = function (event) {
      if (event.key === 'Enter') {
        event.stopPropagation();
        event.preventDefault();
      }
    };

    _this.handleSuggestionsUpdateRequested = function (_ref) {
      var value = _ref.value;
      var _this$props = _this.props,
          filterSuggestions = _this$props.filterSuggestions,
          items = _this$props.items;

      _this.setState({
        suggestions: filterSuggestions(value, items)
      });
    };

    _this.shouldRenderSuggestions = function () {
      return true;
    };

    _this.handleClear = function () {
      var onChange = _this.props.onChange;
      onChange(null);

      _this.setState({
        value: ""
      });
    };

    _this.handleDropdown = function (e) {
      if (!_this.componentIsUnmounting) {
        e.stopPropagation();
        e.preventDefault();
        console.warn('handleDropdown');

        _this.autosuggestRef.current.input.focus();
      }
    };

    _this.componentIsUnmounting = false;
    _this.state = {
      suggestions: props.filterSuggestions(null, props.items),
      value: ""
    };
    return _this;
  }

  var _proto = SimpleSuggestField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (!this.state.value && this.props.value) {
      this.setState({
        value: this.props.value
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentIsUnmounting = true;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        renderSuggestion = _this$props2.renderSuggestion,
        getItemValue = _this$props2.getItemValue,
        value = _this$props2.value,
        className = _this$props2.className,
        addonsBefore = _this$props2.addonsBefore,
        addonsAfter = _this$props2.addonsAfter,
        onChange = _this$props2.onChange,
        onFocus = _this$props2.onFocus,
        _onBlur = _this$props2.onBlur,
        dropdown = _this$props2.dropdown,
        placeholder = _this$props2.placeholder,
        removable = _this$props2.removable;
    var shouldRenderSuggestions = dropdown ? this.shouldRenderSuggestions : undefined;
    var field = React__default.createElement("div", {
      className: "autosuggest-container " + className
    }, React__default.createElement(Autosuggest, {
      ref: this.autosuggestRef,
      theme: SUGGEST_THEME$1,
      getSuggestionValue: getItemValue,
      renderSuggestion: renderSuggestion,
      shouldRenderSuggestions: shouldRenderSuggestions,
      suggestions: this.state.suggestions,
      onSuggestionsFetchRequested: this.handleSuggestionsUpdateRequested,
      inputProps: {
        value: this.state.value,
        placeholder: placeholder,
        onChange: function onChange(e, _ref2) {
          var newValue = _ref2.newValue;

          // Původně se zde volalo onChange(newValue), nicméně to způsobovalo přesun kurzoru na konec řetězce
          // po každém znaku a nešlo tedy psát na začátek nebo doprostřed. Vyřešeno tak, že aktuální hodnota
          // se drží ve state a onChange se volá až při onBlur.
          _this2.setState({
            value: newValue
          });
        },
        onBlur: function onBlur() {
          onChange(_this2.state.value);
          _onBlur && _onBlur();
        },
        onFocus: onFocus,
        onKeyDown: this.handleKeyDown
      }
    }));
    var hasAddonInline = false;
    var editAddons = [];
    var inlineAddon;

    if (dropdown) {
      if (value) {
        hasAddonInline = true;
        inlineAddon = React__default.createElement("div", {
          className: "input-group-btn input-addon-inline"
        }, React__default.createElement(Button, {
          type: "button",
          tabIndex: -1,
          ref: "dropdownButton",
          onMouseDown: this.handleClear
        }, React__default.createElement(FAIcon, {
          fixedWidth: true,
          icon: "remove"
        })));
      } else {
        hasAddonInline = true;
        inlineAddon = React__default.createElement("div", {
          className: "input-group-btn input-addon-inline"
        }, React__default.createElement(Button, {
          type: "button",
          tabIndex: -1,
          ref: "dropdownButton",
          onMouseDown: this.handleDropdown
        }, React__default.createElement(FAIcon, {
          fixedWidth: true,
          icon: "caret-down"
        })));
      }
    } else if (removable) {
      if (value) {
        hasAddonInline = true;
        inlineAddon = React__default.createElement("div", {
          className: "input-group-btn input-addon-inline"
        }, React__default.createElement(Button, {
          type: "button",
          tabIndex: -1,
          ref: "dropdownButton",
          onMouseDown: this.handleClear
        }, React__default.createElement(FAIcon, {
          fixedWidth: true,
          icon: "remove"
        })));
      }
    }

    var fieldWrapper = React__default.createElement("div", {
      className: "autosuggest-dropdown-field " + (hasAddonInline ? 'has-addon-inline' : '')
    }, field, inlineAddon);
    return this.renderFieldWithAddons(fieldWrapper, addonsBefore, mergeAddons(addonsAfter, editAddons));
  };

  return SimpleSuggestField;
}(AbstractField);

SimpleSuggestField.propTypes = /*#__PURE__*/_extends({
  renderSuggestion: PropTypes__default.func,
  filterSuggestions: PropTypes__default.func,
  getItemValue: PropTypes__default.func,
  items: PropTypes__default.array.isRequired,
  dropdown: PropTypes__default.bool
}, AbstractField.propTypes);
SimpleSuggestField.defaultProps = {
  dropdown: false,
  renderSuggestion: function renderSuggestion(i) {
    return React__default.createElement("div", null, i);
  },
  filterSuggestions: function filterSuggestions(value, list) {
    if (value === null || value.length === 0) {
      return list;
    }

    var inputValue = value.trim().toLowerCase();
    var inputLength = inputValue.length;
    return inputLength === 0 ? [] : list.filter(function (item // item.toLowerCase().slice(0, inputLength) === inputValue
    ) {
      return item.toLowerCase().indexOf(inputValue) !== -1;
    });
  },
  getItemValue: function getItemValue(i) {
    return i;
  }
};

/**
 * Základní formátování názvu typu dokumentu.
 *
 * @param typDokument typ dokumentu
 */

function getNazev(typDokument) {
  var result = typDokument.nazev;

  if (typDokument.kod) {
    result = typDokument.kod + ' - ' + typDokument.nazev;
  }

  return result;
}
/**
 * Field pro hledání typu dokumentů spisové služby.
 */


var SpsTypDokumentField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SpsTypDokumentField, _React$Component);

  function SpsTypDokumentField(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.getData = function (kodOrganizace) {
      return SpisovaSluzbaApi.getCiselnikTypuDokumentu(kodOrganizace).then(function (rows) {
        return rows.map(function (r) {
          return _extends({}, r, {
            _name: getNazev(r)
          });
        });
      }).then(function (rows) {
        rows.sort(function (a, b) {
          return a._name.localeCompare(b._name);
        }); // pokud se nepodarilo nacist ciselnik, tak chceme zakazat editaci pole

        if (rows.length === 0) {
          _this.setState({
            disabled: true
          });
        }

        return rows;
      });
    };

    _this.handleOnChange = function (value) {
      var onChange = _this.props.onChange;

      if (value) {
        var rest = _objectWithoutPropertiesLoose(value, ["_name"]);

        onChange(rest);
      } else {
        onChange(null);
      }
    };

    _this.handleOnBlur = function (value) {
      var onBlur = _this.props.onBlur;

      if (value) {
        var rest = _objectWithoutPropertiesLoose(value, ["_name"]);

        onBlur(rest);
      } else {
        onBlur(null);
      }
    };

    _this.state = {
      disabled: false
    };
    return _this;
  }

  var _proto = SpsTypDokumentField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        disabled = _this$props.disabled,
        kodOrganizace = _this$props.kodOrganizace,
        other = _objectWithoutPropertiesLoose(_this$props, ["onChange", "onBlur", "disabled", "kodOrganizace"]);

    return React__default.createElement(StateSuggestField, Object.assign({
      getItemName: function getItemName(item) {
        return item ? item._name || getNazev(item) : '';
      },
      getItemId: function getItemId(item) {
        return item ? item.kod : null;
      },
      apiCall: function apiCall() {
        return _this2.getData(kodOrganizace);
      }
    }, other, {
      disabled: disabled || this.state.disabled,
      onChange: this.handleOnChange,
      onBlur: this.handleOnBlur
    }));
  };

  return SpsTypDokumentField;
}(React__default.Component);

SpsTypDokumentField.propTypes = {
  kodOrganizace: PropTypes__default.string.isRequired
};
SpsTypDokumentField.defaultProps = {};

/**
 * Field se statickým vlastním pbsahem, který je uveden jako children.
 */

var StaticField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(StaticField, _AbstractField);

  function StaticField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = StaticField.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        addonsBefore = _this$props.addonsBefore,
        children = _this$props.children,
        addonsAfter = _this$props.addonsAfter,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "inputClass", "children", "addonsAfter"]);

    var field = React__default.createElement("div", Object.assign({}, props), children);
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return StaticField;
}(AbstractField);

/**
 * Akce pro storeSuggest
 */
function fetchListIfNeeded$1(area, apiCall) {
  return function (dispatch, getState) {
    dispatch(initIfNeeded(area, list$3));
    dispatch(fetchIfNeeded$3(area, null, apiCall));
  };
}

/**
 * Store suggest
 *
 * Field který automatický vytvoří store pod danou AREA a zavolá api a zobrazí autocompleteField
 */

var StoreSuggestField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(StoreSuggestField, _AbstractField);

  function StoreSuggestField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = StoreSuggestField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this$props = this.props,
        area = _this$props.area,
        apiCall = _this$props.apiCall;
    this.props.dispatch(fetchListIfNeeded$1(area, apiCall));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        addonsBefore = _this$props2.addonsBefore,
        addonsAfter = _this$props2.addonsAfter,
        store = _this$props2.store,
        other = _objectWithoutPropertiesLoose(_this$props2, ["addonsBefore", "addonsAfter", "store"]);

    if (!store || !store.fetched) {
      return React__default.createElement(Input, {
        type: "text",
        disabled: true
      });
    }

    var field = React__default.createElement(Autocomplete, Object.assign({
      items: store.rows
    }, other));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return StoreSuggestField;
}(AbstractField);

StoreSuggestField.propTypes = {
  area: PropTypes__default.string.isRequired,
  apiCall: PropTypes__default.func.isRequired,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

function mapStateToProps$4(state, props) {
  return {
    store: storeFromArea(state, props.area, false)
  };
}

var StoreSuggestField$1 = /*#__PURE__*/connect(mapStateToProps$4)(StoreSuggestField);

var StatField = function StatField(props) {
  var showKod = props.showKod,
      useId = props.useId;
  return React__default.createElement(StoreSuggestField$1, Object.assign({
    apiCall: function apiCall() {
      return AdresaApi.getStaty(true, true);
    },
    inputProps: {
      placeholder: 'Stát'
    },
    area: "shared.statField",
    getItemId: function getItemId(item) {
      return item ? useId ? item.id : item.kodA3 : null;
    },
    getItemName: function getItemName(item) {
      return item ? showKod ? item.kodA3 + " (" + item.nazev + ")" : item.nazev : '';
    }
  }, props));
};

StatField.propTypes = {
  useId: PropTypes__default.bool.isRequired
};

/**
 * Field pro editaci dokladu.
 */

var SubjektDokladField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(SubjektDokladField, _AbstractField);

  function SubjektDokladField() {
    var _this;

    _this = _AbstractField.apply(this, arguments) || this;

    _this.getInputValue = function (value) {
      return value ? value.dokladCislo ? value.dokladCislo : '' : '';
    };

    _this.getObjValue = function (e) {
      var _this$props = _this.props,
          value = _this$props.value,
          typDoklad = _this$props.typDoklad;
      var objValue;

      if (value) {
        objValue = _extends({
          typDoklad: typDoklad
        }, value, {
          dokladCislo: e.target.value
        });
      } else {
        objValue = {
          typDoklad: typDoklad,
          dokladCislo: e.target.value
        };
      }

      return objValue;
    };

    _this.handleOnChange = function (e) {
      var onChange = _this.props.onChange;
      onChange(_this.getObjValue(e));
    };

    _this.handleBlur = function (e) {
      var onBlur = _this.props.onBlur;
      onBlur(_this.getObjValue(e));
    };

    return _this;
  }

  var _proto = SubjektDokladField.prototype;

  _proto.render = function render() {
    var _this$props2 = this.props,
        addonsBefore = _this$props2.addonsBefore,
        addonsAfter = _this$props2.addonsAfter,
        value = _this$props2.value,
        props = _objectWithoutPropertiesLoose(_this$props2, ["addonsBefore", "addonsAfter", "onChange", "onBlur", "typDoklad", "value"]);

    var field = React__default.createElement(Input, Object.assign({
      type: "text",
      onChange: this.handleOnChange,
      onBlur: this.handleBlur,
      value: this.getInputValue(value)
    }, props));
    return this.renderFieldWithAddons(field, addonsBefore, addonsAfter);
  };

  return SubjektDokladField;
}(AbstractField);

SubjektDokladField.propTypes = /*#__PURE__*/_extends({
  // Typ dokladu, konstanta z EnumTypDoklad
  typDoklad: PropTypes__default.string.isRequired,
  // Objekt typu SubjektDokladRO
  value: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.object, PropTypes__default.string])
}, AbstractField.propTypes);

if (window.serverContextPath === null) {
  console.error('Global variable serverContextPath is not defined (is null)!');
}

var EsbApi = /*#__PURE__*/function () {
  function EsbApi() {}

  EsbApi.getSubjekty = function getSubjekty(fulltext, kodOrganizace, kodRole, max) {
    var uri = EsbApi.subjekty + "?fulltext=" + encodeURIComponent(fulltext) + "&kodOrganizace=" + encodeURIComponent(kodOrganizace) + "&kodRole=" + encodeURIComponent(kodRole) + "&max=" + max;
    return ErrorApi.responseResolver(JsonFetch.get(uri, undefined));
  };

  EsbApi.getSubjekt = function getSubjekt(id) {
    var uri = EsbApi.subjekty + "/" + id;
    return ErrorApi.responseResolver(JsonFetch.get(uri, undefined));
  };

  EsbApi.updateSubjekt = function updateSubjekt(id, data) {
    var uri = EsbApi.subjekty + "/" + id;
    return ErrorApi.responseResolver(JsonFetch.put(uri, null, data));
  };

  EsbApi.getPravniFormy = function getPravniFormy() {
    var uri = EsbApi.pravniFormy;
    return ErrorApi.responseResolver(JsonFetch.get(uri, undefined));
  };

  EsbApi.zaevidujSubjekt = function zaevidujSubjekt(subjekt, kodRole, kodOrganizace) {
    var uri = EsbApi.subjekty;
    var params = {
      kodRole: kodRole,
      kodOrganizace: kodOrganizace
    };
    return ErrorApi.responseResolver(JsonFetch.post(uri, params, subjekt));
  };

  EsbApi.vyhledejSubjekt = function vyhledejSubjekt(subjekt, kodRole, kodOrganizace) {
    var uri = EsbApi.subjektyVyhledat;
    var params = {
      kodRole: kodRole,
      kodOrganizace: kodOrganizace
    };
    return ErrorApi.responseResolver(JsonFetch.post(uri, params, subjekt));
  };

  return EsbApi;
}();
EsbApi.baseUrl = window.serverContextPath + "/api";
EsbApi.esb = EsbApi.baseUrl + '/esb';
EsbApi.subjekty = EsbApi.esb + '/subjekty';
EsbApi.pravniFormy = EsbApi.esb + '/pravniFormy';
EsbApi.subjektyVyhledat = EsbApi.esb + '/subjekty/vyhledat';

/**
 * Subjekt field
 *
 * Suggest
 */

var SubjektField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(SubjektField, _React$Component);

  function SubjektField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      var _this$props = _this.props,
          kodOrganizace = _this$props.kodOrganizace,
          kodRole = _this$props.kodRole;
      return EsbApi.getSubjekty(value, kodOrganizace, kodRole, 20);
    };

    return _this;
  }

  var _proto = SubjektField.prototype;

  _proto.render = function render() {
    var other = _extends({}, this.props);

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      filterSuggestions: this.handleFilterSuggestions,
      getItemValue: function getItemValue(item) {
        return item ? item.nazev : '';
      },
      renderSuggestion: function renderSuggestion(i, active, getItemValue) {
        return React__default.createElement("div", {
          className: active ? 'active' : ''
        }, i.nazev);
      }
    }, other));
  };

  return SubjektField;
}(React__default.Component);

SubjektField.propTypes = {
  kodOrganizace: PropTypes__default.string.isRequired,
  kodRole: PropTypes__default.string.isRequired,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};
SubjektField.defaultProps = {
  apiRequestDelay: 250
};

/**
 * TextArea
 */

var TextareaField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(TextareaField, _AbstractField);

  function TextareaField() {
    return _AbstractField.apply(this, arguments) || this;
  }

  var _proto = TextareaField.prototype;

  _proto.render = function render() {
    // Ignore componentClass
    var _this$props = this.props,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter"]);

    var field = React__default.createElement(Input, Object.assign({
      type: "textarea"
    }, props));
    return this.renderFieldWithAddons(field, null, null);
  };

  return TextareaField;
}(AbstractField);

TextareaField.propTypes = /*#__PURE__*/_extends({
  rows: PropTypes__default.number
}, AbstractField.propTypes);
TextareaField.defaultProps = {
  rows: 3
};

/**
 * Legacy input pro datumy v podobě dropdown selectu.
 * Původně se místo toho používal TimePicker z react-widgets, ten už ale neexistuje.
 * Umožňuje zadat minimální a maximální čas a minimální časový rozestup mezi jednotlivými položkami.
 * Podporuje přesnost pouze na minuty!
 */

var TimeField = /*#__PURE__*/function (_AbstractField) {
  _inheritsLoose(TimeField, _AbstractField);

  function TimeField(props) {
    var _this;

    _this = _AbstractField.call(this, props) || this;
    /**
     * Konverze hodnoty z props na editovanou hodnotu.
     * @param value props hodnota
     * @return {null} hodnota, kterou potřebuje field pro editaci
     */

    _this.getValueFromProps = function (value) {
      if (value && value != '') {
        return value instanceof Date ? formatTime(_this.normalizeDateTime(value)) : formatTime(value);
      }

      return null;
    };
    /**
     * Ponechá v Date objektu jen hodiny a minuty.
     * @param date datum a čas
     */


    _this.normalizeDateTime = function (date) {
      if (!date) {
        return null;
      }

      date.setFullYear(0, 0, 1);
      date.setSeconds(0);
      date.setMilliseconds(0);
      return date;
    };
    /**
     * Ze zadaného rozsahu a kroku vrátí pole Date objektů vzdálených od sebe daný počet minut.
     *
     * @param start       počáteční datum a čas
     * @param end         koncové datum a čas
     * @param stepMinutes počet minut mezi jednotlivými objekty
     */


    _this.getTimeSlices = function (start, end, stepMinutes) {
      if (!start || !end) {
        return [];
      }

      var slices = [];

      while (end >= start) {
        var timeStr = formatTime(start);

        if (timeStr) {
          slices.push(timeStr);
        }

        start = new Date(start.getTime() + stepMinutes * 60 * 1000);
      }

      return slices;
    };

    _this.getItems = function (props) {
      var minDateTime = props.min || new Date(0, 0, 1, 0, 0, 0, 0);

      if (props.min instanceof String) {
        minDateTime = localUTCToDateTime(props.min);
      }

      minDateTime = _this.normalizeDateTime(minDateTime);
      var maxDateTime = props.max || new Date(0, 0, 1, 23, 59, 0, 0);

      if (props.max instanceof String) {
        maxDateTime = localUTCToDateTime(props.max);
      }

      maxDateTime = _this.normalizeDateTime(maxDateTime);
      var step = props.step || 15;
      return _this.getTimeSlices(_this.normalizeDateTime(minDateTime), _this.normalizeDateTime(maxDateTime), step);
    };

    _this.handleChange = function (event) {
      var onChange = _this.props.onChange;
      var value = event.target.value;

      _this.setState({
        value: value
      });

      onChange && onChange(value);
    };

    _this.state = {
      items: _this.getItems(props),
      value: _this.getValueFromProps(props.value)
    };
    return _this;
  }

  var _proto = TimeField.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    this.setState({
      value: this.getValueFromProps(nextProps.value),
      items: this.getItems(nextProps)
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        props = _objectWithoutPropertiesLoose(_this$props, ["addonsBefore", "addonsAfter", "value", "className", "onChange", "onBlur"]);

    return React__default.createElement(SelectField, Object.assign({
      onChange: this.handleChange,
      value: this.state.value
    }, props), this.state.items.map(function (item, index) {
      return React__default.createElement("option", {
        key: index
      }, item);
    }));
  };

  return TimeField;
}(AbstractField);

var TypDokumentField = function TypDokumentField(props) {
  return React__default.createElement(StoreSuggestField$1, Object.assign({
    apiCall: function apiCall() {
      return TypDokumentApi.findTypyDokumentu();
    },
    inputProps: {
      placeholder: 'Typ dokumentu'
    },
    area: "shared.typDokumentField",
    getItemId: function getItemId(item) {
      return item ? item.kod : null;
    },
    getItemName: function getItemName(item) {
      return item ? item.nazev : '';
    }
  }, props));
};

/**
 * Akce pro číselník štítků šablon.
 */

function getList$1() {
  return ObalkaApi.getSablony().then(function (data) {
    return {
      rows: data,
      count: 0
    };
  });
}

function fetchListIfNeeded$2(area) {
  return function (dispatch, getState) {
    dispatch(initIfNeeded(area, list$3));
    dispatch(fetchIfNeeded$3(area, null, function () {
      return getList$1();
    }));
  };
}

function getArea$1(props) {
  return props.area ? props.area : 'shared.adresniStitkySablona';
}
/**
 * Field pro výběr šablony typu obálky.
 */


var TypObalkyField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TypObalkyField, _React$Component);

  function TypObalkyField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      var sablony = _this.props.sablony;
      return new Promise(function (resolve, reject) {
        if (sablony.fetched) {
          var rows = filterObjectsByPropertyFulltext(sablony.rows, value, 'popis');
          resolve(rows);
        } else {
          resolve([]);
        }
      });
    };

    return _this;
  }

  var _proto = TypObalkyField.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var area = getArea$1(this.props);
    this.props.dispatch(fetchListIfNeeded$2(area));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        sablony = _this$props.sablony,
        other = _objectWithoutPropertiesLoose(_this$props, ["sablony"]);

    if (!sablony || !sablony.fetched) {
      return React__default.createElement(Input, {
        type: "text",
        disabled: true
      });
    }

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      dropdown: true,
      filterSuggestions: this.handleFilterSuggestions,
      apiRequestDelay: 0,
      getItemValue: function getItemValue(item) {
        return item ? item.popis : '';
      },
      renderSuggestion: function renderSuggestion(i, active, getItemValue) {
        return React__default.createElement("div", {
          className: active ? 'active' : ''
        }, i.popis);
      }
    }, other));
  };

  return TypObalkyField;
}(React__default.Component);

TypObalkyField.propTypes = {
  sablony: PropTypes__default.object,
  // není required kvůli shared store, který nemusí být inicializovaný
  area: PropTypes__default.string,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

function mapStateToProps$5(state, props) {
  var useArea = getArea$1(props);
  return {
    sablony: storeFromArea(state, useArea, false)
  };
}

var TypObalkyField$1 = /*#__PURE__*/connect(mapStateToProps$5)(TypObalkyField);

if (window.serverContextPath === null) {
  console.error('Global variable serverContextPath is not defined (is null)!');
}

var EprApi = /*#__PURE__*/function () {
  function EprApi() {}

  EprApi.findTypyPrestupku = function findTypyPrestupku(recidiva) {
    if (recidiva === void 0) {
      recidiva = null;
    }

    return ErrorApi.responseResolver(JsonFetch.get(EprApi.typy, {
      recidiva: recidiva
    }));
  };

  return EprApi;
}();
EprApi.baseUrl = window.serverContextPath + "/api";
EprApi.epr = EprApi.baseUrl + '/prestupky';
EprApi.typy = EprApi.epr + '/typy';

function getList$2() {
  return EprApi.findTypyPrestupku(null).then(function (data) {
    var newData = data.map(function (tp) {
      var popis = tp.zakon.cislo + "/" + tp.zakon.rok + " - \xA7" + tp.paragraf;

      if (tp.odstavec && tp.odstavec.trim().length > 0) {
        popis += " odst. " + tp.odstavec.trim();
      }

      if (tp.pismeno && tp.pismeno.trim().length > 0) {
        popis += " p\xEDsm. " + tp.pismeno.trim();
      }

      return _extends({}, tp, {
        popis: popis
      });
    });
    return {
      rows: newData,
      count: 0
    };
  });
}

function fetchListIfNeeded$3(area) {
  return function (dispatch, getState) {
    dispatch(initIfNeeded(area, list$3));
    dispatch(fetchIfNeeded$3(area, null, function () {
      return getList$2();
    }));
  };
}

function getArea$2(props) {
  return props.area || 'shared.typyPrestupku';
}
/**
 * Typ přestupku field
 * Suggest
 */


var TypPrestupkuField = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TypPrestupkuField, _React$Component);

  function TypPrestupkuField() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleFilterSuggestions = function (value) {
      var _this$props = _this.props,
          typyPrestupku = _this$props.typyPrestupku,
          recidiva = _this$props.recidiva,
          platneKDatu = _this$props.platneKDatu;
      return new Promise(function (resolve, reject) {
        if (typyPrestupku.fetched) {
          var rows = filterObjectsByPropertyFulltext(typyPrestupku.rows, value, 'popis');

          if (typeof recidiva !== 'undefined') {
            rows = rows.filter(function (i) {
              return i.recidiva === recidiva;
            });
          }

          if (platneKDatu) {
            var dateSpachani = localUTCToDate(platneKDatu);
            rows = rows.filter(function (i) {
              return !i.ucinnostDo || localUTCToDate(i.ucinnostDo) >= dateSpachani;
            });
          }

          resolve(rows);
        } else {
          resolve([]);
        }
      });
    };

    return _this;
  }

  var _proto = TypPrestupkuField.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var area = getArea$2(this.props);
    this.props.dispatch(fetchListIfNeeded$3(area));
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        typyPrestupku = _this$props2.typyPrestupku,
        other = _objectWithoutPropertiesLoose(_this$props2, ["typyPrestupku"]);

    if (!typyPrestupku || !typyPrestupku.fetched) {
      return React__default.createElement(Input, {
        type: "text",
        disabled: true
      });
    }

    return React__default.createElement(ApiObjectSuggestField, Object.assign({
      dropdown: true,
      filterSuggestions: this.handleFilterSuggestions,
      apiRequestDelay: 0,
      getItemValue: function getItemValue(item) {
        return item ? item.popis : '';
      },
      renderSuggestion: function renderSuggestion(i, active, getItemValue) {
        return React__default.createElement("div", {
          className: active ? 'active' : ''
        }, i.popis);
      }
    }, other));
  };

  return TypPrestupkuField;
}(React__default.Component);

TypPrestupkuField.propTypes = {
  platneKDatu: PropTypes__default.object,
  area: PropTypes__default.string,
  recidiva: PropTypes__default.bool,
  addonsBefore: COMPONENT_CHILDREN,
  addonsAfter: COMPONENT_CHILDREN
};

function mapStateToProps$6(state, props) {
  var useArea = getArea$2(props);
  var stateStore = storeFromArea(state, useArea, false);
  return {
    typyPrestupku: stateStore
  };
}

var TypPrestupkuField$1 = /*#__PURE__*/connect(mapStateToProps$6)(TypPrestupkuField);

/**
 * Label pro field, pokud se fieldy použijí s label=false, lze pro zobrazení jejich labelu použít tuto komponentu.
 * Label se případně přeloží (pokud je pole (seznam stringů) nebo string).
 * Použití:
 * <FieldLabel label="aaaaaaa"/>
 */

var FieldLabel = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FieldLabel, _PureComponent);

  function FieldLabel() {
    return _PureComponent.apply(this, arguments) || this;
  }

  var _proto = FieldLabel.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        component = _this$props.component,
        other = _objectWithoutPropertiesLoose(_this$props, ["label", "component"]);

    var labelComponent;

    if (Array.isArray(label) || typeof label === 'string') {
      var labelProps = _extends({
        message: label,
        component: component
      }, other);

      labelComponent = React__default.createElement(TranslateComponent, Object.assign({}, labelProps));
    } else {
      labelComponent = label;
    }

    return labelComponent;
  };

  return FieldLabel;
}(PureComponent);

FieldLabel.propTypes = {
  component: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array, PropTypes__default.func, PropTypes__default.bool]),
  // komponenta pro label, pokud je vstupem pole nebo string - převádí se přes TranslateComponent, standardně Label
  label: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.string, PropTypes__default.array])
};
FieldLabel.defaultProps = {
  component: Label
};

/**
 * field pro range date
 */

var DateRangeField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DateRangeField, _Component);

  function DateRangeField() {
    var _this;

    _this = _Component.apply(this, arguments) || this;

    _this.handleOnChange = function (inputValue, key) {
      var _extends2;

      var _this$props = _this.props,
          value = _this$props.value,
          onChange = _this$props.onChange;

      var formValue = _extends({}, value, (_extends2 = {}, _extends2[key] = inputValue.target.value, _extends2));

      onChange == null ? void 0 : onChange(formValue);
    };

    return _this;
  }

  var _proto = DateRangeField.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        value = _this$props2.value,
        dateFromKey = _this$props2.dateFromKey,
        dateToKey = _this$props2.dateToKey;
    return React__default.createElement(Row, {
      className: 'no-gutters posv-date-range-field'
    }, React__default.createElement(Col, {
      sm: 6
    }, React__default.createElement(Row, {
      className: 'no-gutters'
    }, React__default.createElement(Col, {
      sm: 2,
      className: 'date-range-label'
    }, React__default.createElement(FieldLabel, {
      label: 'Od'
    })), React__default.createElement(Col, {
      sm: 10
    }, React__default.createElement(DateField, {
      value: value && value[dateFromKey],
      onChange: function onChange(inputValue) {
        return _this2.handleOnChange(inputValue, dateFromKey);
      }
    })))), React__default.createElement(Col, {
      sm: 6
    }, React__default.createElement(Row, {
      className: 'no-gutters'
    }, React__default.createElement(Col, {
      sm: 2,
      className: 'date-range-label'
    }, React__default.createElement(FieldLabel, {
      label: 'Do'
    })), React__default.createElement(Col, {
      sm: 10
    }, React__default.createElement(DateField, {
      value: value && value[dateToKey],
      onChange: function onChange(inputValue) {
        return _this2.handleOnChange(inputValue, dateToKey);
      }
    })))));
  };

  return DateRangeField;
}(Component);

DateRangeField.propTypes = {
  dateFromKey: string.isRequired,
  dateToKey: string.isRequired
};
DateRangeField.defaultProps = {
  dateFromKey: 'datumOd',
  dateToKey: 'datumDo'
};

var FixedDropDownButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FixedDropDownButton, _React$Component);

  function FixedDropDownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FixedDropDownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        color = _this$props.color,
        dropdownProps = _this$props.dropdownProps,
        className = _this$props.className,
        caret = _this$props.caret,
        title = _this$props.title,
        children = _this$props.children,
        uncontrolled = _this$props.uncontrolled,
        isOpen = _this$props.isOpen,
        toggle = _this$props.toggle,
        right = _this$props.right,
        pullRight = _this$props.pullRight;
    var cls = classNames('new-fixed-dropdown', className);
    var Container = UncontrolledDropdown;

    var myProps = _extends({}, dropdownProps);

    if (uncontrolled) {
      Container = Dropdown;
      myProps.toggle = toggle;
      myProps.isOpen = isOpen;
    }
    /*if (dropup) {
      if ()
      myProps.direction =
    }*/


    return createElement(Container, Object.assign({
      className: cls
    }, myProps), createElement(DropdownToggle, {
      caret: caret,
      color: color,
      disabled: disabled,
      onClick: function onClick(e) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, title), createElement(DropdownMenu, {
      className: "new-fixed-dropdown-dropdown-menu",
      positionFixed: true,
      right: right || pullRight
    }, children));
  };

  return FixedDropDownButton;
}(Component); // TODO [R: dokumentace]


FixedDropDownButton.propTypes = {
  disabled: PropTypes__default.bool,
  // color: Button.propTypes.color,
  // bsSize: Button.propTypes.bsSize,
  // uncontrolled

  /**
   * true, pokud ma byt sipka dolu
   */
  caret: PropTypes__default.bool,
  title: PropTypes__default.node.isRequired,
  right: PropTypes__default.bool,
  // TODO pullRight

  /**
   * Pokud chceme "uncontrolled" AKA kontrolovaný (ve starém MC je to špatně obráceně)
   */
  uncontrolled: PropTypes__default.bool,
  isOpen: PropTypes__default.bool,
  toggle: PropTypes__default.func
}; // TODO [R: dokumentace]

FixedDropDownButton.defaultProps = {
  disabled: false,
  pullRight: false,
  dropup: false,
  navItem: false,
  caret: false,
  uncontrolled: false
};

/**
 * Dropdown multiselect - vyber M z N moznosti
 */

var MultiSelectField = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MultiSelectField, _Component);

  function MultiSelectField(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.toggle = function () {
      _this.setState(function (prevState) {
        return {
          dropdownOpen: !prevState.dropdownOpen
        };
      });
    };

    _this.handleFilter = function (filter) {
      _this.setState({
        filter: filter
      });
    };

    _this.handleCheckboxChange = function (event) {
      var value = event.target.dataset.value;
      var values = [].concat(_this.props.value);
      var index = values.indexOf(value);

      if (index < 0) {
        values.push(value);
      } else {
        values.splice(index, 1);
      }

      _this.props.onChange(values);
    };

    _this.renderItems = function () {
      var _this$props = _this.props,
          values = _this$props.values,
          value = _this$props.value,
          showTitlesCount = _this$props.showTitlesCount,
          titleMore = _this$props.titleMore,
          titleDefault = _this$props.titleDefault,
          filtering = _this$props.filtering,
          resetSelection = _this$props.resetSelection,
          resetSelectionCaption = _this$props.resetSelectionCaption;
      var _this$state = _this.state,
          dropdownOpen = _this$state.dropdownOpen,
          filter = _this$state.filter;
      var title = [];

      if (_this.props.title) {
        title.push(React__default.createElement("span", {
          key: "title",
          className: "title"
        }, _this.props.title));
      }

      var valuesMap = {};
      values.forEach(function (item) {
        valuesMap[item.id] = item;
      });

      if (value.length > 0) {
        var container = [];

        if (value.length > showTitlesCount) {
          var names = [];
          value.forEach(function (v) {
            return names.push(valuesMap[v].title);
          });
          container.push(React__default.createElement("span", {
            key: "selected",
            title: names.join(','),
            className: "selected"
          }, "[", titleMore, ": ", value.length, "]"));
        } else {
          Object.keys(value).map(function (item) {
            var id = value[item];
            var itemPos = Object.keys(values).map(function (x) {
              return values[x].id;
            }).indexOf(id);
            container.push(React__default.createElement("span", {
              key: 'selected-' + id,
              className: "selected"
            }, values[itemPos].title));
          });
        }

        title.push(React__default.createElement("span", {
          key: "selected",
          className: "selected-container"
        }, container));
      } else {
        var _container = [];

        _container.push(React__default.createElement("span", {
          key: "selected",
          className: "selected"
        }, titleDefault));

        title.push(React__default.createElement("span", {
          key: "selected",
          className: "selected-container"
        }, _container));
      }

      var menuItems = [];
      values.map(function (item) {
        var checked = value.indexOf(item.id) >= 0;

        if (filter === '' || item.title.toLowerCase().indexOf(filter.toLowerCase()) >= 0) {
          menuItems.push(React__default.createElement("div", {
            key: item.id
          }, React__default.createElement(Label, {
            check: true
          }, React__default.createElement(Input, {
            type: "checkbox",
            "data-value": item.id,
            checked: checked,
            onChange: _this.handleCheckboxChange
          }), ' ' + item.title)));
        }
      });
      return React__default.createElement(FixedDropDownButton, {
        uncontrolled: true,
        toggle: _this.toggle,
        isOpen: dropdownOpen,
        caret: true,
        className: "link-inline",
        color: "link",
        title: title
      }, React__default.createElement("div", {
        className: "p-3"
      }, filtering && React__default.createElement(InputGroup, {
        className: "multiselect-filtering"
      }, React__default.createElement(Input, {
        onChange: function onChange(e) {
          return _this.handleFilter(e.target.value);
        }
      }), React__default.createElement(InputGroupAddon, {
        addonType: "append"
      }, React__default.createElement(Icon, {
        icon: "search"
      }))), resetSelection && React__default.createElement(Button, {
        type: "button",
        color: "link",
        onClick: _this.handleReset
      }, resetSelectionCaption), menuItems));
    };

    _this.handleReset = function () {
      _this.props.onChange([]);

      _this.toggle();
    };

    _this.state = {
      dropdownOpen: false,
      filter: ''
    };
    return _this;
  }

  var _proto = MultiSelectField.prototype;

  _proto.render = function render() {
    return React__default.createElement("div", {
      className: "multiselect"
    }, this.renderItems());
  };

  return MultiSelectField;
}(Component);
MultiSelectField.defaultProps = {
  values: [],
  value: [],
  showTitlesCount: 2,
  titleMore: /*#__PURE__*/i18n('global.multiselect.title.select'),
  titleDefault: /*#__PURE__*/i18n('global.multiselect.title.all'),
  filtering: false,
  resetSelection: false,
  resetSelectionCaption: 'Zrušit označení'
};

// export { default as SelectCertificateField } from './SelectCertificateField';

var Fields = {
  __proto__: null,
  Adresa: AdresaField$1,
  ApiObjectSuggest: ApiObjectSuggestField,
  Autocomplete: Autocomplete,
  CastkaMena: CastkaMenaField,
  Checkbox: CheckboxField,
  Ctecka: CteckaField,
  Currency: CurrencyField,
  CustomSelect: CustomSelectField,
  File: FileField,
  ImageSelect: ImageSelectField,
  JednotkaTyp: JednotkaTypField,
  KategorieUredniDesky: KategorieUredniDeskyField,
  Kontakt: KontaktField,
  ListSelect: ListSelectField,
  McField: McField,
  Number: NumberField,
  Obec: ObecField,
  ObjectSuggest: ObjectSuggestField,
  ObjectTag: ObjectTagField,
  Objekt: ObjektField,
  Pracovnik: PracovnikField,
  PravniForma: PravniFormaField$1,
  Sablona: SablonaField,
  Search: SearchField,
  Select: SelectField,
  SimpleDate: DateField,
  SimpleSuggest: SimpleSuggestField,
  SpsTypDokument: SpsTypDokumentField,
  StateSuggest: StateSuggestField,
  Static: StaticField,
  Stat: StatField,
  StoreSuggest: StoreSuggestField$1,
  String: StringField,
  SubjektDoklad: SubjektDokladField,
  Subjekt: SubjektField,
  Textarea: TextareaField,
  Time: TimeField,
  TypDokument: TypDokumentField,
  TypObalky: TypObalkyField$1,
  TypPrestupku: TypPrestupkuField$1,
  OrgJednotka: OrgJednotkaField,
  DateRangeField: DateRangeField,
  MultiSelectField: MultiSelectField
};

var BlankField = function BlankField(props) {
  var field = props.field,
      input = props.input,
      otherProps = _objectWithoutPropertiesLoose(props, ["field", "input"]);

  return createElement(field, _extends({}, input, otherProps));
};

var BlankCheckboxField = function BlankCheckboxField(props) {
  var title = props.title,
      field = props.field,
      label = props.label,
      checkboxLabel = props.checkboxLabel,
      input = props.input,
      otherProps = _objectWithoutPropertiesLoose(props, ["title", "field", "label", "checkboxLabel", "input"]);

  var useLabel = label || checkboxLabel;
  var labelComponent;

  if (useLabel) {
    labelComponent = React__default.createElement(FieldLabel, {
      label: useLabel,
      title: title,
      component: "span"
    });
  }

  return createElement(field, _extends({}, input, {
    title: title
  }, otherProps, {
    label: labelComponent
  }));
};

var Base = function Base(props) {
  var componentClass = props.componentClass,
      field = props.field,
      otherProps = _objectWithoutPropertiesLoose(props, ["componentClass", "field"]);

  var fieldComponent;
  var fieldProps = otherProps;

  if (field === false) {
    if (props.check) {
      fieldComponent = BlankCheckboxField;
    } else {
      fieldComponent = BlankField;
    }
  } else {
    fieldComponent = field;
  }

  return React__default.createElement(Field, Object.assign({
    component: fieldComponent,
    field: componentClass
  }, fieldProps));
};

Base.propTypes = {};
Base.defaultProps = {
  field: FieldForm
};

/**
 * Dynamický export
 *
 * Všechny existující třídy obalíme
 */

/**
 * Seznam custom export tříd
 */

var exclude = ['McField'];
var toExport = {};
Object.keys(Fields).forEach(function (key) {
  if (exclude.indexOf(key) !== -1) {
    return;
  }

  var customProps = {};

  if ('Checkbox' === key) {
    customProps.check = true;
  }

  var value = Fields[key];

  var McReduxWrapp = function McReduxWrapp(props) {
    return createElement(Base, Object.assign({
      componentClass: value
    }, props, customProps));
  };

  toExport[key] = McReduxWrapp;
});
/**
 * Přidání custom export třídy
 */

toExport['Base'] = Base;

var index$7 = {
  __proto__: null,
  'default': toExport
};

function getRegisteredFields(formName) {
  return function (state) {
    return state.form[formName].registeredFields;
  };
}

function loadData(context) {
  return AutofillApi.load([context]).then(function (data) {
    return data && data[context];
  });
}

function loadAndFillData(formName, context, onlyFields, preferInit) {
  if (onlyFields === void 0) {
    onlyFields = null;
  }

  if (preferInit === void 0) {
    preferInit = false;
  }

  return function (dispatch, getStore) {
    loadData(context).then(function (data) {
      if (!data) {
        return;
      }

      var state = getStore();
      var fields = getRegisteredFields(formName)(state);
      var meta = getFormMeta(formName)(state) || {};
      var initialValues = getFormInitialValues(formName)(state) || {};
      var values = getFormValues(formName)(state) || {};

      var autofillField = function autofillField(field) {
        var fieldMeta = meta[field];
        var fieldValue = values[field];
        var fieldInitialValue = initialValues[field];
        var fieldDataValue = data[field];
        var itIsNotInitialValue = fieldInitialValue ? fieldInitialValue !== fieldValue : fieldValue;

        if (fieldMeta && fieldMeta.active && itIsNotInitialValue || fieldMeta && !fieldMeta.autofilled) {
          return;
        }

        if (preferInit && fieldInitialValue) {
          return;
        }

        dispatch(autofill(formName, field, fieldDataValue));
      };

      if (onlyFields !== null) {
        for (var n in fields) {
          fields.hasOwnProperty(n) && onlyFields.indexOf(n) !== -1 && autofillField(n);
        }
      } else {
        for (var _n in fields) {
          fields.hasOwnProperty(_n) && autofillField(_n);
        }
      }
    });
  };
}

function saveData(formName, context, onlyFields, autofillSaveCondition) {
  if (onlyFields === void 0) {
    onlyFields = null;
  }

  return function (dispatch, getStore) {
    var state = getStore();
    var values = getFormValues(formName)(state) || null;

    if (values !== null) {
      var dataToSave = {};

      if (onlyFields !== null) {
        for (var x in values) {
          if (values.hasOwnProperty(x) && onlyFields.indexOf(x) !== -1) {
            dataToSave[x] = values[x];
          }
        }
      } else {
        dataToSave = values;
      }

      if (!autofillSaveCondition || autofillSaveCondition(values)) {
        var _AutofillApi$save;

        AutofillApi.save((_AutofillApi$save = {}, _AutofillApi$save[context] = dataToSave, _AutofillApi$save));
      }
    }
  };
}
/**
 * High-order komponenta vytvářející formulář s podporou autofill.
 *
 * Ve formuláři budou dostupné následující properties:
 *
 *   loadAutofill(fields: Array<string>): void - Funkce, která zajistí načtení dat a vyplnění specifických polí formuláře.
 *                                               Při neuvedení seznamu polí se použijí pole z konfigurace.
 *
 *   loadAutofillData(): Promise<Object> - Low-level funkce, která pouze načte data pro vyplnění polí.
 *
 * @param config - konfigurace
 * @param {string} [config.autofillContext] - Kontext. Při neuvedení bude bude automatické naplňování/ukládání zakázáno.
 *                                            Alternativně lze kontext předat přes stejně pojmenovanou property.
 * @param {Array<string>} [config.autofillFields] - Pole, která se mají automaticky naplňovat/ukládat.
 *                                                  Při neuvedení se použíjí všechna pole formuláře.
 * @param {Array<string>} [config.initAutofillFields] - Podmnožina autofillFields, která se má naplnit při prvotní inicializaci.
 *                                                      Při neuvedení se použijí všechna pole autofillFields, případně všechna pole formuláře.
 * @param {function} [config.autofillSaveCondition] - Funkce, která podmiňuje, zda-li se má uložit autofill (nedefinovaná ukládá vždy)
 * @param {boolean} [config.autofillPreferInit] - Preferuje inicializační hodnoty formuláře - tzn. pokud existují, nepřepíšou se autofillem
 * @returns {function} výsledná komponenta
 */


function autofillReduxForm(config) {
  var autofillContext = config.autofillContext,
      autofillFields = config.autofillFields,
      initAutofillFields = config.initAutofillFields,
      autofillSaveCondition = config.autofillSaveCondition,
      autofillPreferInit = config.autofillPreferInit,
      restConfig = _objectWithoutPropertiesLoose(config, ["autofillContext", "autofillFields", "initAutofillFields", "autofillSaveCondition", "autofillPreferInit"]);

  function getContext(props) {
    return props.autofillContext || autofillContext;
  }

  function requireContext(props) {
    var context = getContext(props);

    if (context) {
      return context;
    }

    throw new Error('Nenastaven autofillContext');
  }

  var mapDispatchToProps = function mapDispatchToProps(dispatch, props) {
    return {
      loadAutofill: function loadAutofill(fields) {
        return dispatch(loadAndFillData(restConfig.form, requireContext(props), fields || autofillFields, autofillPreferInit));
      },
      loadAutofillData: function loadAutofillData() {
        return loadData(requireContext(props));
      }
    };
  };

  return function (ComponentToWrap) {
    return connect(undefined, mapDispatchToProps)( /*#__PURE__*/function (_Component) {
      _inheritsLoose(AutofillReduxForm, _Component);

      function AutofillReduxForm(props) {
        var _this;

        _this = _Component.call(this, props) || this;
        _this.x = null;
        _this.formRef = React__default.createRef();
        var _onSubmitSuccess = props.onSubmitSuccess;
        var context = getContext(props);
        _this.x = reduxForm(_extends({}, restConfig, {
          onSubmitSuccess: function onSubmitSuccess(result, dispatch, props) {
            context && dispatch(saveData(restConfig.form, context, autofillFields, autofillSaveCondition));

            if (_onSubmitSuccess) {
              _onSubmitSuccess(result, dispatch, props);
            } else if (config.onSubmitSuccess) {
              config.onSubmitSuccess(result, dispatch, props);
            }
          }
        }))(ComponentToWrap);
        return _this;
      }

      var _proto = AutofillReduxForm.prototype;

      _proto.componentDidMount = function componentDidMount() {
        if (getContext(this.props)) {
          this.props.loadAutofill(this.props.initAutofillFields || initAutofillFields);
        }
      };

      _proto.submit = function submit() {
        return this.formRef.current.submit();
      };

      _proto.reset = function reset() {
        return this.formRef.current.reset();
      };

      _proto.valid = function valid() {
        return this.formRef.current.valid;
      };

      _proto.invalid = function invalid() {
        return !this.valid;
      };

      _proto.pristine = function pristine() {
        return this.formRef.current.pristine;
      };

      _proto.dirty = function dirty() {
        return !this.pristine;
      };

      _proto.values = function values() {
        return this.formRef.current.values;
      };

      _proto.wrappedInstance = function wrappedInstance() {
        // for testing
        return this.formRef.current.wrappedInstance;
      };

      _proto.render = function render() {
        var _this$props = this.props,
            rest = _objectWithoutPropertiesLoose(_this$props, ["onSubmitSuccess"]);

        return createElement(this.x, _extends({}, rest, {
          ref: this.formRef
        }));
      };

      return AutofillReduxForm;
    }(Component));
  };
}

var _a;
/**
 * Třída, která slouží pro vložení formuláře do části FormSection, tato třída zpřístupní v propsech vkládaného formuláře metodu prefixName a formName hlavního formuláře a change metodu,
 * která správně vygeneruje prefix pro field ve vnořeném formuláři, např. pro použití ve field selectoru.
 *
 * Pro získání instance formuláře může sloužit VÝJIMEČNĚ metoda getWrappedInstance.
 *
 * Příklad použití:
 *
 * // Vložení
 * <FormSection name="subjekt.kontakt">
 *     <form.ReduxSectionForm form={KontaktForm} />
 * </FormSection>
 *
 * // Selektorv KontaktForm
 * const prefixName = props.prefixName || (x => x);
 * const formName = props.formName || KontaktForm.formName;
 * const selector = formValueSelector(formName);
 * const dorucovatNa = selector(state, prefixName("dorucovatNa"));
 *
 * @type {{contextTypes}}
 */

var ReduxSectionForm = (_a = /*#__PURE__*/function (_Component) {
  _inheritsLoose(_a, _Component);

  function _a() {
    var _this;

    _this = _Component.apply(this, arguments) || this;

    _this.getWrappedInstance = function () {
      return _this.refs.form;
    };

    return _this;
  }

  var _proto = _a.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        form = _this$props.form,
        children = _this$props.children,
        other = _objectWithoutPropertiesLoose(_this$props, ["form", "children"]);

    var _this$context = this.context,
        _reduxForm = _this$context._reduxForm,
        sectionPrefix = _this$context._reduxForm.sectionPrefix;

    var prefixName = function prefixName(name) {
      if (name === void 0) {
        name = '';
      }

      return !sectionPrefix ? name : name ? sectionPrefix + "." + name : "" + sectionPrefix;
    }; // Název prefixu pro použití v např. area pro dynamické store, tedy neobsahuje tečky


    var prefixNameArea = function prefixNameArea(name) {
      if (name === void 0) {
        name = '';
      }

      return (!sectionPrefix ? name : name ? sectionPrefix + "." + name : "" + sectionPrefix).replace(/\./g, '_');
    };

    var formChange = function formChange(field, value) {
      return change(_reduxForm.form, prefixName(field), value);
    }; // --------------
    // Funkce - chování jako standardní form
    // const array = {
    //     insert: bindActionCreators(formChange, _reduxForm.arrayInsert
    // };
    // --------------
    // Specifické pro form redux form section


    var parts = sectionPrefix.split('.');

    var sectionGetFormValues = function sectionGetFormValues(state) {
      var formValues = getFormValues(_reduxForm.form)(state);

      for (var a = 0; a < parts.length; a++) {
        if (!formValues) {
          break;
        }

        formValues = formValues[parts[a]];
      }

      return formValues;
    };

    var sectionSelector = function sectionSelector(state, field) {
      var selector = formValueSelector(_reduxForm.form);
      return selector(state, prefixName(field));
    }; // --------------


    var props = _extends({}, other, {
      prefixName: prefixName,
      // funkce, která vygeneruje správně název fieldu ve vnořeném formuláři
      dynamicArea: prefixNameArea(),
      // název area pro dynamické store
      change: bindActionCreators(formChange, _reduxForm.dispatch),
      formName: _reduxForm.form,
      // název hlavního formuláře, pro umístění konkrétního fieldu je nutné přidat cestu sectionPrefix
      ref: 'form',
      sectionForm: {
        getFormValues: sectionGetFormValues,
        selector: sectionSelector
      }
    });

    return createElement(form, props, children);
  };

  return _a;
}(Component), _a.contextTypes = {
  _reduxForm: PropTypes__default.object
}, _a);

var AUTH_INFO_AREA = 'authInfo';

var ErrorApi$1 = ErrorApi,
    JsonFetch$1 = JsonFetch;
var AUTH_INFO_AREA$1 = AUTH_INFO_AREA;
var AUTH_LOGIN = 'authLogin';
var AUTH_LOGOUT = 'authLogout';
var ID = '';
/**
 * Načtení informace o přihlášení.
 * @return {function(*, *)}
 */

function fetchAuthInfoIfNeeded() {
  return function (dispatch, getState) {
    var store = storeFromArea(getState(), AUTH_INFO_AREA$1);
    dispatch(fetchIfNeeded(AUTH_INFO_AREA$1, ID, function (id) {
      return MarbesAuthApi.check().then(function (authStatus) {
        setTimeout(function () {
          // Pokud načetl nová data, bereme jako nové přihlášení - pokud je jiný login než ten, co byl ve store
          if (authStatus.auth && (!store.data || authStatus.login !== store.data.login)) {
            dispatch(loginSucccess(authStatus));
          }
        }, 100);
        return authStatus;
      });
    }));
  };
}
/**
 * Odhlášení uživatele.
 * @param pokud je uveden, je zavolán po odhlášení a vyčištění store, vhodný např. pro následnou akci redirect po odhlášení apod. (je z důvodu, že logout je v reduxu jako asynchronní akce)
 * @return {function()}
 */

function logout(logoutCallback) {
  return function (dispatch, getState) {
    return MarbesAuthApi.logout().then(function () {
      var store = storeFromArea(getState(), AUTH_INFO_AREA$1);
      dispatch({
        area: AUTH_INFO_AREA$1,
        type: AUTH_LOGOUT,
        authInfo: store
      });
      dispatch(reset(AUTH_INFO_AREA$1));
      logoutCallback && logoutCallback();
    });
  };
}
/**
 * Informace o úspěšném přihlášení.
 * @param authStatus objekt přihlášení
 * @return {function()}
 */

function loginSucccess(authStatus) {
  return function (dispatch, getState) {
    var store = storeFromArea(getState(), AUTH_INFO_AREA$1);
    dispatch({
      area: AUTH_INFO_AREA$1,
      type: AUTH_LOGIN,
      prevAuthInfo: store,
      nextAuthInfo: {
        data: authStatus
      }
    });
    dispatch(setData(AUTH_INFO_AREA$1, ID, authStatus));
  };
}
/**
 * Zneplatnění informací o přihlášení.
 * @return {function(*, *)}
 */

function invalidate$4(id) {
  return function (dispatch, getState) {
    dispatch(invalidate(AUTH_INFO_AREA$1, ID));
  };
}
function check() {
  return function () {
    ErrorApi$1.responseResolver(JsonFetch$1.get('/api/auth/check', undefined)).then(function (data) {
      console.info(data);
    });
  };
}
function login(username, password) {
  return function () {
    ErrorApi$1.responseResolver(JsonFetch$1.post('/api/auth/login', null, {
      username: username,
      password: password
    }));
  };
}

var authActions = {
  __proto__: null,
  AUTH_INFO_AREA: AUTH_INFO_AREA$1,
  AUTH_LOGIN: AUTH_LOGIN,
  AUTH_LOGOUT: AUTH_LOGOUT,
  fetchAuthInfoIfNeeded: fetchAuthInfoIfNeeded,
  logout: logout,
  loginSucccess: loginSucccess,
  invalidate: invalidate$4,
  check: check,
  login: login
};

/**
 * Klientská validace.
 * @param formData data formuláře
 * @return {{}}
 */

var validateNtlmLogin = function validateNtlmLogin(formData) {
  var errors = {};

  if (!formData.username) {
    errors.username = 'Uživatelské jméno je povinné';
  }

  return errors;
};

var NtlmLogin = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(NtlmLogin, _React$Component);

  function NtlmLogin(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      ntlmFetched: false,
      canUseNtlm: true
    };
    return _this;
  }

  var _proto = NtlmLogin.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    if (!this.state.ntlmFetched) {
      MarbesAuthApi.canUseNtlm().then(function (canUseNtlm) {
        _this2.setState({
          ntlmFetched: true,
          canUseNtlm: canUseNtlm
        });
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClose = _this$props.onClose,
        handleSubmit = _this$props.handleSubmit,
        submitting = _this$props.submitting,
        error = _this$props.error;
    var _this$state = this.state,
        ntlmFetched = _this$state.ntlmFetched,
        canUseNtlm = _this$state.canUseNtlm;
    var disabled = submitting;
    var commons = {
      disabled: disabled
    };

    if (!ntlmFetched) {
      return React__default.createElement(Loader, null);
    }

    return React__default.createElement(CustomForm, {
      onSubmit: handleSubmit,
      horizontal: true
    }, React__default.createElement(FormBody, null, React__default.createElement(toExport.String, Object.assign({
      label: "U\u017Eivatelsk\xE9 jm\xE9no",
      name: "username",
      autoComplete: "username"
    }, commons)), React__default.createElement(toExport.String, Object.assign({
      label: "Heslo",
      name: "password",
      type: "password",
      autoComplete: "current-password"
    }, commons))), error && React__default.createElement("h2", {
      style: {
        textAlign: 'center',
        marginTop: '2em'
      }
    }, React__default.createElement(Label, {
      className: "text-danger"
    }, error)), React__default.createElement(FormActions, {
      onClose: onClose,
      disabled: disabled,
      submitButton: 'Přihlásit'
    }, NtlmLogin.isWindows() && canUseNtlm && React__default.createElement(Button, {
      type: "button",
      onClick: NtlmLogin.redirectNtlmLogin
    }, React__default.createElement(FAIcon, {
      icon: "windows"
    }), " P\u0159evz\xEDt p\u0159ihl\xE1\u0161en\xED z Windows")));
  };

  return NtlmLogin;
}(React__default.Component);

NtlmLogin.formName = 'ntlmLoginForm';

NtlmLogin.redirectNtlmLogin = function () {
  window.location.href = window.serverContextPath + '/api/auth/ntlm?redir=' + encodeURIComponent(window.location.href);
};

NtlmLogin.isWindows = function () {
  var winPlatforms = ['Win32', 'Win64', 'Windows'];
  return winPlatforms.indexOf(window.navigator.platform) > -1;
};

var NtlmLoginForm = /*#__PURE__*/reduxForm({
  form: NtlmLogin.formName,
  validate: validateNtlmLogin
})(NtlmLogin);

var LoginForm = /*#__PURE__*/function (_Component) {
  _inheritsLoose(LoginForm, _Component);

  function LoginForm() {
    var _this3;

    _this3 = _Component.apply(this, arguments) || this;

    _this3.handleNtlmLogin = function (credentials) {
      return MarbesAuthApi.login(credentials).then(function (data) {
        if (data.auth) {
          // je přihlášen
          return data;
        } else {
          // chyba, zobrazíme ji uživateli
          throw new SubmissionError({
            _error: data.error
          });
        }
      });
    };

    return _this3;
  }

  var _proto2 = LoginForm.prototype;

  _proto2.render = function render() {
    return React__default.createElement(NtlmLoginForm, {
      onSubmit: this.handleNtlmLogin,
      onSubmitSuccess: function onSubmitSuccess(result, dispatch) {
        dispatch(loginSucccess(result));
      }
    });
  };

  return LoginForm;
}(Component);



var index$8 = {
  __proto__: null,
  field: index$7,
  AdresaForm: AdresaForm$1,
  autofillReduxForm: autofillReduxForm,
  BaseField: Base,
  FieldForm: FieldForm,
  FieldGrid: FieldGrid,
  FormActions: FormActions,
  FormBody: FormBody,
  Form: CustomForm,
  getRegisteredFields: getRegisteredFields,
  Label: FieldLabel,
  ReduxSectionForm: ReduxSectionForm,
  ValidationErrors: ValidationErrors,
  LoginForm: LoginForm
};

function Deprecated() {
  throw new Error('Use @mc/react-frame');
}

var Frame = Deprecated;
var FrameActions = {};
var FrameReducer = Deprecated;

var index$9 = {
  __proto__: null,
  Frame: Frame,
  FrameActions: FrameActions,
  FrameReducer: FrameReducer
};

var pw = 21;
var ph = 21;
var MINE = -1;
var NONE = 0;
var NO_FLAG = 0;
var MINE_FLAG = 1;
var UNDEFINED_FLAG = 2;
var difficulties = {
  1: {
    x: 20,
    y: 20,
    mines: 25
  },
  2: {
    x: 30,
    y: 20,
    mines: 50
  },
  3: {
    x: 30,
    y: 30,
    mines: 150
  }
};

var Mines = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Mines, _Component);

  function Mines(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.newGame = function () {
      var difficult = difficulties[_this.state.difficult];
      var x = difficult.x,
          y = difficult.y;
      var mines = difficult.mines;
      var fields = new Array(x);

      for (var i = 0; i < x; i++) {
        fields[i] = new Array(y);

        for (var j = 0; j < y; j++) {
          fields[i][j] = {
            visible: false,
            value: NONE,
            i: i,
            j: j,
            flag: NO_FLAG
          };
        }
      }

      var minesXY = [];

      while (mines > 0) {
        var _i = Math.floor(Math.random() * x);

        var _j = Math.floor(Math.random() * y);

        if (fields[_i][_j].value !== MINE) {
          minesXY.push({
            i: _i,
            j: _j
          });
          fields[_i][_j].value = MINE;
          mines--;
        }
      }

      minesXY.forEach(function (v) {
        var ki = v.i,
            kj = v.j;

        _this.checkNeighbors(ki, kj, function (o, p) {
          if (_this.isInArea(o, p, x, y) && fields[o][p].value !== MINE) {
            fields[o][p].value++;
          }
        });
      });

      _this.setState({
        end: false,
        explosion: false,
        fields: fields,
        fx: x,
        fy: y,
        mines: minesXY.length,
        leaves: x * y - minesXY.length
      });
    };

    _this.isInArea = function (x, y, dx, dy) {
      var _this$state = _this.state,
          fx = _this$state.fx,
          fy = _this$state.fy;
      var kx = dx || fx;
      var ky = dy || fy;
      return x >= 0 && x < kx && y >= 0 && y < ky;
    };

    _this.checkNeighbors = function (x, y, callback) {
      for (var k = -1; k <= 1; k++) {
        for (var l = -1; l <= 1; l++) {
          if (k === 0 && l === 0) {
            continue;
          }

          callback(k + x, l + y);
        }
      }
    };

    _this.handleClickField = function (field) {
      var _this$state2 = _this.state,
          fields = _this$state2.fields,
          end = _this$state2.end,
          leaves = _this$state2.leaves,
          explosion = _this$state2.explosion;
      var explosionNew = explosion;

      if (end || field.visible) {
        return;
      }

      var leavesNew = leaves;

      switch (field.value) {
        case MINE:
          {
            leavesNew = 0;
            field.explode = true;
            explosionNew = true;
            break;
          }

        case NONE:
          {
            var _ret = function () {
              var checkFields = [field];

              var _loop = function _loop() {
                var tmp = checkFields.shift();
                var i = tmp.i,
                    j = tmp.j;
                fields[i][j].visible = true;
                leavesNew--;

                _this.checkNeighbors(i, j, function (o, p) {
                  if (_this.isInArea(o, p) && fields[o][p].value >= NONE && fields[o][p].flag === NO_FLAG && fields[o][p].visible === false) {
                    if (fields[i][j].value === NONE && !fields[o][p].visited) {
                      fields[o][p].visited = true;
                      checkFields.push(fields[o][p]);
                    }
                  }
                });
              };

              while (checkFields.length > 0) {
                _loop();
              }

              return "break";
            }();

            if (_ret === "break") break;
          }

        default:
          {
            leavesNew--;
            field.visible = true;
          }
      }

      var newEnd = leavesNew <= 0;

      if (newEnd) {
        for (var i = 0; i < fields.length; i++) {
          for (var j = 0; j < fields[i].length; j++) {
            fields[i][j].visible = true;
          }
        }
      }

      _this.setState({
        fields: fields,
        explosion: explosionNew,
        leaves: leavesNew,
        end: newEnd
      });
    };

    _this.toggleField = function (e, field) {
      var fields = _this.state.fields;
      e.preventDefault();
      e.stopPropagation();

      if (field.visible) {
        return;
      }

      switch (field.flag) {
        case NO_FLAG:
          {
            fields[field.i][field.j].flag = MINE_FLAG;
            break;
          }

        case MINE_FLAG:
          {
            fields[field.i][field.j].flag = UNDEFINED_FLAG;
            break;
          }

        case UNDEFINED_FLAG:
          {
            fields[field.i][field.j].flag = NO_FLAG;
            break;
          }
      }

      _this.setState({
        fields: fields
      });
    };

    _this.renderField = function () {
      var fields = _this.state.fields;
      var values = [];

      for (var i = 0; i < fields.length; i++) {
        var _loop2 = function _loop2(j) {
          var field = fields[i][j];
          var x = i * pw;
          var y = j * ph;
          var visible = field.visible;
          values.push(React__default.createElement("rect", {
            key: i + 'f' + j,
            className: visible ? 'visible' : 'field',
            onContextMenu: function onContextMenu(e) {
              return _this.toggleField(e, field);
            },
            onClick: function onClick() {
              if (!field.flag) _this.handleClickField(field);
            },
            x: x,
            y: y,
            width: pw,
            height: ph
          }));

          if (field.flag && !visible) {
            values.push(React__default.createElement("use", {
              key: i + 'd' + j,
              className: "field",
              onContextMenu: function onContextMenu(e) {
                return _this.toggleField(e, field);
              },
              href: field.flag === UNDEFINED_FLAG ? '#undefined' : '#flag',
              x: x,
              y: y,
              width: pw,
              height: ph
            }));
          }

          if (field.value === MINE && visible) {
            if (field.explode) {
              values.push(React__default.createElement("use", {
                key: i + 'm' + j,
                href: "#explode",
                x: x,
                y: y,
                width: pw,
                height: ph
              }));
            } else {
              values.push(React__default.createElement("use", {
                key: i + 'm' + j,
                href: "#mine",
                x: x,
                y: y,
                width: pw,
                height: ph
              }));
            }
          }

          if (visible && field.value > 0) {
            values.push(React__default.createElement("text", {
              key: i + 't' + j,
              fill: "black",
              className: 'val-' + field.value,
              fontFamily: "Verdana",
              style: {
                userSelect: 'none'
              },
              textAnchor: "middle",
              alignmentBaseline: "baseline",
              x: x + 10,
              y: y + 15
            }, field.value));
          }
        };

        for (var j = 0; j < fields[i].length; j++) {
          _loop2(j);
        }
      }

      return values;
    };

    _this.handleDifficult = function (difficult) {
      _this.setState({
        difficult: difficult
      }, _this.newGame);
    };

    _this.renderDefs = function () {
      return React__default.createElement("defs", null, React__default.createElement("linearGradient", {
        id: "r1",
        x1: "0%",
        y1: "8%",
        x2: "100%",
        y2: "92%"
      }, React__default.createElement("stop", {
        offset: "5%",
        stopColor: "#EEE"
      }), React__default.createElement("stop", {
        offset: "95%",
        stopColor: "#DDD"
      })), React__default.createElement("linearGradient", {
        id: "r2",
        x1: "0%",
        y1: "8%",
        x2: "100%",
        y2: "92%"
      }, React__default.createElement("stop", {
        offset: "5%",
        stopColor: "#CCC"
      }), React__default.createElement("stop", {
        offset: "95%",
        stopColor: "#CCC"
      })), React__default.createElement("g", {
        id: "explode",
        width: pw,
        height: ph
      }, React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: pw,
        viewBox: "0 0 100 100",
        height: ph
      }, React__default.createElement("g", null, React__default.createElement("path", {
        d: "M92.178,73.093l-4.883-1.766l-2.442-0.883c-0.813-0.295-1.631-0.579-2.459-0.822c-0.826-0.251-1.661-0.481-2.494-0.71   c-0.829-0.24-1.662-0.475-2.488-0.727l-0.739-0.223l14.626-13.185l5.769-5.198l-7.713,0.888l-18.507,2.127l2.387-21.484   l0.761-6.852l-4.955,4.793L56.374,41.3L44.949,17.351l-3.08-6.456l-1.582,6.976l-5.785,25.49L21.994,32.441l-6.438-5.619   l2.423,8.194l6.435,21.762L9.947,53.732l-7.146-1.504l4.747,5.548l3.436,4.014c1.15,1.335,2.275,2.688,3.39,4.053   c0.562,0.679,1.136,1.346,1.728,1.999c0.596,0.648,1.207,1.285,1.816,1.921l2.183,2.281c-2.886,2.4-5.778,4.791-8.641,7.222   l-1.708,1.451l1.91,0.801l9.133,3.829c3.056,1.251,6.1,2.525,9.167,3.757c-2.837-1.694-5.696-3.345-8.544-5.017l-6.645-3.828   c3.229-2.104,6.436-4.236,9.654-6.351l1.785-1.172l-1.439-1.885l-3.212-4.206c-0.534-0.701-1.069-1.403-1.618-2.092   c-0.553-0.686-1.123-1.356-1.707-2.016c-0.723-0.809-1.44-1.622-2.152-2.439l11.38,2.395l4.073,0.857l-1.18-3.99l-5.192-17.559   l9.206,8.037l3.134,2.736l0.921-4.057l5.121-22.572l9.831,20.608l1.486,3.116l2.481-2.4l10.19-9.856l-1.969,17.73l-0.344,3.096   l3.094-0.355l13.891-1.597L70.069,67.229l-3.278,2.956l4.228,1.268l4.966,1.489c0.829,0.244,1.651,0.507,2.478,0.764   c0.821,0.268,1.645,0.533,2.472,0.779c0.827,0.253,1.665,0.466,2.507,0.668l2.524,0.606l0.077,0.019l-2.465,1.354l-7.125,3.965   l-7.115,3.981l-7.096,4.025l7.581-3.011l7.562-3.052l7.554-3.072l7.534-3.109l4.727-1.951L92.178,73.093z"
      }), React__default.createElement("path", {
        d: "M64.805,83.72L62.8,82.988l-1.852-0.676c-0.618-0.22-1.229-0.465-1.857-0.651l-1.892-0.544l-0.193-0.058l5.482-4.943   l2.307-2.078l-3.085,0.354l-6.958,0.8l0.898-8.089l0.305-2.741l-1.982,1.918l-4.755,4.599l-4.305-9.023l-1.231-2.583l-0.633,2.79   l-2.177,9.59l-4.683-4.088l-2.574-2.248l0.969,3.277l2.418,8.176l-5.406-1.138l-2.844-0.6l1.885,2.218   c0.865,1.018,1.748,2.021,2.588,3.062c0.426,0.516,0.879,1.007,1.348,1.484l0.803,0.834c-1.08,0.903-2.161,1.804-3.231,2.719   l-0.683,0.584l0.763,0.316l3.472,1.441l3.484,1.413l-3.236-1.916l-2.475-1.438c1.215-0.788,2.424-1.586,3.637-2.378l0.713-0.464   l-0.574-0.758l-1.215-1.6c-0.398-0.538-0.814-1.062-1.26-1.561c-0.239-0.267-0.473-0.539-0.708-0.809l4.161,0.875l1.629,0.344   l-0.473-1.598l-1.92-6.493l3.36,2.934l1.253,1.095l0.369-1.623l1.91-8.421l3.668,7.687l0.594,1.246l0.992-0.96l3.766-3.642   l-0.731,6.587l-0.138,1.239l1.238-0.143l5.112-0.587l-4.487,4.044l-1.312,1.183l1.691,0.507l1.884,0.566l1.878,0.585   c0.607,0.186,1.231,0.314,1.849,0.466c-1.183,0.655-2.366,1.309-3.544,1.974c-1.802,1.005-3.591,2.034-5.384,3.059   c1.921-0.756,3.845-1.505,5.756-2.281c1.917-0.765,3.826-1.544,5.733-2.328L64.805,83.72z"
      })))), React__default.createElement("g", {
        id: "mine",
        width: pw,
        height: ph
      }, React__default.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        version: "1.1",
        width: pw,
        x: "0",
        y: "2",
        viewBox: "0 0 60 75",
        height: ph
      }, React__default.createElement("g", null, React__default.createElement("path", {
        d: "M58.32,28.53l-3.38-.89a3.08,3.08,0,0,0-1.25-.07,23.11,23.11,0,0,0-3.4-9.43l2.89-4.9c.67-1.13.4-1.79.06-2.14s-1-.63-2.14,0l-4.48,2.55A23.74,23.74,0,0,0,32.47,7.16L31,1.67C30.64.4,30,.13,29.49.13h0C29,.13,28.35.4,28,1.67L26.48,7.29a23.83,23.83,0,0,0-13.31,6.59L8.33,11.12c-1.14-.65-1.79-.37-2.14,0s-.61,1,.06,2.14L9.42,18.6a22.71,22.71,0,0,0-3.1,9,3.08,3.08,0,0,0-1.25.08l-3.38.89C.4,28.86.14,29.51.14,30s.27,1.14,1.54,1.48L5,32.34a4.64,4.64,0,0,0,1.17.16h.07a23.13,23.13,0,0,0,2.92,9.39L6.25,46.77c-.67,1.14-.4,1.79-.06,2.14a1.22,1.22,0,0,0,.9.37,2.55,2.55,0,0,0,1.24-.39l4.21-2.4a23.71,23.71,0,0,0,14.22,7.28L28,58.33c.34,1.27,1,1.53,1.49,1.53s1.14-.27,1.49-1.53l1.21-4.46A23.73,23.73,0,0,0,47.26,46.7l3.83,2.18a2.55,2.55,0,0,0,1.24.39,1.22,1.22,0,0,0,.9-.37c.34-.35.61-1-.06-2.14l-2.58-4.39a23,23,0,0,0,3.19-9.89h.07A4.64,4.64,0,0,0,55,32.34l3.3-.87c1.28-.33,1.54-1,1.54-1.47S59.6,28.86,58.32,28.53ZM41.89,18.66l.89-.51,7.78-4.43-2.3,3.91h0l-2.69,4.57a.5.5,0,0,1-.88.11l-2.91-2.86a.45.45,0,0,1,.11-.81Zm-15-5.33,2.58-9.51,1.22,4.5h0l1.12,4.14.23.86h0a.47.47,0,0,1-.51.67H27.42a.47.47,0,0,1-.51-.67Zm-9.37,28-5.31,3h0L8.87,46.28l5-8.48a.59.59,0,0,1,.4-.32h0a.63.63,0,0,1,.42.21l2.9,2.86h0a.45.45,0,0,1-.11.81Zm.1-21.87-2.9,2.86a.5.5,0,0,1-.88-.11l0-.08L8.86,13.72l4,2.26h0l4.71,2.68a.45.45,0,0,1,.11.81Zm14.43,27.2-2.58,9.51-1-3.56h0l-1.61-5.94a.47.47,0,0,1,.51-.67h4.14a.47.47,0,0,1,.51.67ZM29.49,33a3,3,0,1,1,3.07-3A3,3,0,0,1,29.49,33Zm18.1,11.58h0l-5.7-3.24a.45.45,0,0,1-.11-.81L43.35,39l1.35-1.32a.63.63,0,0,1,.42-.21h0a.59.59,0,0,1,.4.32l.38.65,4.61,7.84Z"
      })))), React__default.createElement("g", {
        id: "flag",
        width: pw,
        height: ph
      }, React__default.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: pw,
        height: ph,
        viewBox: "0 0 100 100"
      }, React__default.createElement("polygon", {
        points: "20,40 60,20 60,60",
        style: {
          fill: 'red'
        }
      }), React__default.createElement("polygon", {
        points: "20,80 80,80 60,60",
        style: {
          fill: 'black'
        }
      }))), React__default.createElement("g", {
        id: "undefined",
        width: pw,
        height: ph
      }, React__default.createElement("svg", {
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        width: pw,
        height: ph,
        viewBox: "-50 -50 620 620"
      }, React__default.createElement("path", {
        d: "M197.653 314.102c-8.673-135.209 97.628-94.188 98.212-151.378 0-24.279-21.371-33.516-42.752-33.516-27.126 0-37.581 18.473-37.581 47.954h-119.562c2.314-46.224 21.945-79.728 51.978-102.257 29.481-21.954 69.356-32.368 112.097-32.368 88.965 0 155.976 39.885 155.976 117.893 0 99.952-123.065 79.135-112.097 153.692h-106.27zM310.303 357.427v112.046h-119.010v-112.046h119.010z",
        strokeWidth: "10",
        stroke: "black",
        fill: "yellow"
      }))));
    };

    _this.state = {
      end: true,
      explosion: false,
      fx: difficulties[1].x,
      fy: difficulties[1].y,
      fields: [],
      leaves: 0,
      difficult: 1,
      mines: 0
    };
    return _this;
  }

  var _proto = Mines.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.newGame();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {};

  _proto.render = function render() {
    var _this2 = this;

    var _this$state3 = this.state,
        end = _this$state3.end,
        fx = _this$state3.fx,
        fy = _this$state3.fy,
        difficult = _this$state3.difficult,
        mines = _this$state3.mines,
        explosion = _this$state3.explosion,
        leaves = _this$state3.leaves;
    var texts = [];
    texts.push(React__default.createElement("span", null, "Po\u010Det min: ", React__default.createElement("strong", null, mines)));

    if (explosion) {
      texts.push(React__default.createElement("div", null, React__default.createElement("strong", null, "Prohra, zkuste to znovu.")));
    } else {
      if (leaves === 0 && mines > 0 && end) {
        texts.push(React__default.createElement("div", null, React__default.createElement("strong", null, "V\xFDhra, gratulujeme!")));
      }
    }

    return React__default.createElement("div", {
      className: "mines"
    }, React__default.createElement("div", {
      className: "actions"
    }, React__default.createElement("button", {
      onClick: this.newGame
    }, "Nov\xE1 hra"), React__default.createElement("input", {
      type: "radio",
      name: "level",
      checked: difficult === 1,
      onClick: function onClick() {
        return _this2.handleDifficult(1);
      }
    }), ' ', "Norm\xE1ln\xED", React__default.createElement("input", {
      type: "radio",
      name: "level",
      checked: difficult === 2,
      onClick: function onClick() {
        return _this2.handleDifficult(2);
      }
    }), ' ', "St\u0159edn\xED", React__default.createElement("input", {
      type: "radio",
      name: "level",
      checked: difficult === 3,
      onClick: function onClick() {
        return _this2.handleDifficult(3);
      }
    }), ' ', "T\u011B\u017Ek\xE9"), React__default.createElement("div", {
      className: "game"
    }, React__default.createElement("svg", {
      className: 'board' + (end ? ' end' : ''),
      ref: "board",
      style: {
        width: fx * pw,
        height: fy * ph
      },
      tabIndex: 0,
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, this.renderDefs(), this.renderField())), React__default.createElement("div", {
      className: "score"
    }, texts));
  };

  return Mines;
}(Component);

var icons = ['aa', 'autoprovoz', 'cgc', 'cnr', 'cpl', 'dms', 'doc', 'dpl', 'dpv', 'elg', 'eno', 'eos', 'esp', 'ezam', 'helpdesk', 'kevis', 'mapio', 'mcadmin', 'mis', 'os', 'pes', 'pp', 'rb', 'ren', 'rob', 'rzp', 'spub', 'tech', 'usn', 'vlb', 'xbanka', 'xrn', 'xspis', 'xzr'];

var Pexeso = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Pexeso, _Component);

  function Pexeso() {
    var _this;

    _this = _Component.apply(this, arguments) || this;
    _this.state = {
      fields: null,
      flipped: 0,
      previous: null,
      lock: false
    };

    _this.newGame = function () {
      var x = 5;
      var y = 6;
      var iconsRandom = shuffle(icons);
      var cards = x * y;
      var cardsArray = [];

      for (var i = 0; i < cards / 2; i++) {
        cardsArray.push(iconsRandom[i]);
        cardsArray.push(iconsRandom[i]);
      }

      cardsArray = shuffle(cardsArray);
      var fields = new Array(x);

      for (var _i = 0; _i < x; _i++) {
        fields[_i] = new Array(y);

        for (var j = 0; j < y; j++) {
          fields[_i][j] = {
            visible: false,
            check: false,
            icon: cardsArray[_i * y + j],
            i: _i,
            j: j
          };
        }
      }

      _this.setState({
        fields: fields,
        flipped: 0,
        previous: null,
        lock: false
      });
    };

    _this.flip = function (i, j) {
      var _this$state = _this.state,
          fields = _this$state.fields,
          previous = _this$state.previous,
          lock = _this$state.lock;

      if (lock || previous !== null && previous.i === i && previous.j === j) {
        return;
      }

      fields[i][j].visible = true;
      var previousNew;
      var lockNew = false;

      if (previous) {
        lockNew = true;
        var c1 = fields[i][j];
        var c2 = fields[previous.i][previous.j];

        if (c1.icon !== c2.icon) {
          setTimeout(function () {
            c1.visible = false;
            c2.visible = false;

            _this.setState({
              fields: fields,
              lock: false
            });
          }, 1500);
        } else {
          setTimeout(function () {
            c1.check = true;
            c2.check = true;

            _this.setState({
              fields: fields
            });
          }, 600);
          lockNew = false;
        }

        previousNew = null;
      } else {
        previousNew = {
          i: i,
          j: j
        };
      }

      _this.setState({
        fields: fields,
        previous: previousNew,
        lock: lockNew
      });
    };

    _this.renderMcIcon = function () {
      return React__default.createElement("svg", {
        className: "frontIcon",
        version: "1.0",
        xmlns: "http://www.w3.org/2000/svg",
        width: "80px",
        height: "60px",
        viewBox: "0 0 2900 2180",
        preserveAspectRatio: "xMidYMid meet"
      }, React__default.createElement("g", {
        id: "layer101",
        fill: "#8a95c5",
        stroke: "none"
      }, React__default.createElement("path", {
        d: "M2107 2004 c-4 -4 -7 -190 -7 -413 l0 -406 303 -303 c167 -167 306 -300 310 -296 4 4 7 190 7 413 l0 406 -303 303 c-167 167 -306 300 -310 296z"
      })), React__default.createElement("g", {
        id: "layer102",
        fill: "#2295a7",
        stroke: "none"
      }, React__default.createElement("path", {
        d: "M147 1993 c-4 -3 -7 -187 -7 -407 l0 -401 503 -502 c516 -515 525 -523 597 -523 63 0 97 24 258 183 l163 161 -748 748 c-411 411 -751 748 -754 748 -3 0 -9 -3 -12 -7z"
      }), React__default.createElement("path", {
        d: "M1132 1988 c-9 -9 -12 -109 -12 -408 l0 -395 503 -502 c451 -451 506 -503 546 -513 51 -13 103 -6 146 20 17 11 96 86 177 167 l148 148 -748 748 c-589 589 -750 745 -760 735z"
      })));
    };

    return _this;
  }

  var _proto = Pexeso.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.newGame();
  };

  _proto.render = function render() {
    var _this2 = this;

    var fields = this.state.fields;
    return React__default.createElement("div", {
      className: "pexeso"
    }, React__default.createElement("div", {
      className: "actions"
    }, React__default.createElement("button", {
      onClick: this.newGame
    }, "Nov\xE1 hra")), React__default.createElement("table", null, fields && fields.map(function (arr, xIndex) {
      return React__default.createElement("tr", {
        key: xIndex
      }, arr.map(function (item, yIndex) {
        var cn = 'flip-container' + (item.visible ? ' flip' : '');
        var cnCheck = 'back' + (item.check ? ' check' : '');
        return React__default.createElement("td", {
          className: cn,
          key: xIndex + ',' + yIndex
        }, React__default.createElement("div", {
          className: "flipper"
        }, React__default.createElement("div", {
          className: "front",
          onClick: function onClick() {
            return _this2.flip(xIndex, yIndex);
          }
        }, _this2.renderMcIcon()), React__default.createElement("div", {
          className: cnCheck
        }, React__default.createElement(Icon, {
          icon: item.icon,
          size: "4x"
        }))));
      }));
    })));
  };

  return Pexeso;
}(Component);

var levels = [];
var passwords = [];
passwords[0] = 'aajh';
levels[0] = ['                   ', '                   ', '    11111          ', '    1   1          ', '    1a  1          ', '  111  a11         ', '  1  a a 1         ', '111 1 11 1   111111', '1   1 11 11111  xx1', '1 a  a          xx1', '11111 111 1#11  xx1', '    1     111111111', '    1111111        ', '                   ', '                   ', '                   '];
passwords[1] = 'hhwe';
levels[1] = ['                   ', '                   ', '                   ', '  111111111111     ', '  1xx  1     111   ', '  1xx  1 a  a  1   ', '  1xx  1a1111  1   ', '  1xx    # 11  1   ', '  1xx  1 1  a 11   ', '  111111 11a a 1   ', '    1 a  a a a 1   ', '    1    1     1   ', '    111111111111   ', '                   ', '                   ', '                   '];
passwords[2] = '232d';
levels[2] = ['                   ', '                   ', '                   ', '         11111111  ', '         1     #1  ', '         1 a1a 11  ', '         1 a  a1   ', '         11a a 1   ', ' 111111111 a 1 111 ', ' 1xxxx  11 a  a  1 ', ' 11xxx    a  a   1 ', ' 1xxxx  1111111111 ', ' 11111111          ', '                   ', '                   ', '                   '];
passwords[3] = 'bh2d';
levels[3] = ['           11111111', '           1  xxxx1', '111111111111  xxxx1', '1    1  a a   xxxx1', '1 aaa1a  a 1  xxxx1', '1  a     a 1  xxxx1', '1 aa 1a a a11111111', '1  a 1     1       ', '11 111111111       ', '1    1    11       ', '1     a   11       ', '1  aa1aa  #1       ', '1    1    11       ', '11111111111        ', '                   ', '                   '];
passwords[4] = 'rrh7';
levels[4] = ['                   ', '        11111      ', '        1   11111  ', '        1 1a11  1  ', '        1     a 1  ', '111111111 111   1  ', '1xxxx  11 a  a111  ', '1xxxx    a aa 11   ', '1xxxx  11a  a #1   ', '111111111  a  11   ', '        1 a a  1   ', '        111 11 1   ', '          1    1   ', '          111111   ', '                   ', '                   '];
passwords[5] = 'ssk1';
levels[5] = ['                   ', '                   ', '   222222  222     ', '   2xx  2 22#22    ', '   2xx  222   2    ', '   2xx     aa 2    ', '   2xx  2 2 a 2    ', '   2xx222 2 a 2    ', '   2222 a 2a  2    ', '      2  a2 a 2    ', '      2 a  a  2    ', '      2  22   2    ', '      222222222    ', '                   ', '                   ', '                   '];
passwords[6] = 'pol1';
levels[6] = ['                   ', '        22222      ', '  2222222   22     ', ' 22 2 #22 aa 2     ', ' 2    a      2     ', ' 2  a  222   2     ', ' 222 22222a222     ', ' 2 a  222 xx2      ', ' 2 a a a xxx2      ', ' 2    222xxx2      ', ' 2 aa 2 2xxx2      ', ' 2  222 22222      ', ' 2222              ', '                   ', '                   ', '                   ']; // passwords[34] = "bh2d";
// levels[34] = [
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
//     "                   ",
// ];

var levelsData = {
  levels: levels,
  passwords: passwords
};

var levels$1 = levelsData.levels;
var passwords$1 = levelsData.passwords;
var ww = 19;
var hh = 16;
var pw$1 = 32;
var ph$1 = 32;

var Sokoban = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Sokoban, _React$Component);

  function Sokoban() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      level: 0,
      rocks: undefined,
      player: undefined,
      board: undefined
    };
    _this.boardRef = React__default.createRef();
    _this.passRef = React__default.createRef();

    _this.initLevel = function (number) {
      var board = levels$1[number];
      var gameBoard = [];
      var player;
      var rocks = 0;

      for (var y = 0; y < hh; y++) {
        gameBoard[y] = [];

        for (var x = 0; x < ww; x++) {
          var i = board[y][x];

          if (i === '#') {
            player = {
              x: x,
              y: y
            };
            gameBoard[y][x] = ' ';
          } else {
            gameBoard[y][x] = i;

            if (i === 'a') {
              rocks++;
            }
          }
        }
      }

      _this.setState({
        board: gameBoard,
        player: player,
        rocks: rocks,
        level: number
      });

      _this.boardRef.current.focus();
    };

    _this.renderGradient = function (i, color) {
      return React__default.createElement("radialGradient", {
        id: "g" + i,
        cx: "0.3",
        cy: "0.3",
        r: "1.0",
        fx: "0.3",
        fy: "0.3"
      }, React__default.createElement("stop", {
        offset: "0%",
        stopColor: color
      }), React__default.createElement("stop", {
        offset: "100%",
        stopColor: "rgb(200, 200, 200)"
      }));
    };

    _this.renderGradients = function () {
      return React__default.createElement("defs", null, React__default.createElement("filter", {
        id: "innerbevel",
        x: "0%",
        y: "0%",
        width: "100%",
        height: "100%"
      }, React__default.createElement("feGaussianBlur", {
        stdDeviation: "0 0",
        result: "glow"
      }), React__default.createElement("feMerge", null, React__default.createElement("feMergeNode", {
        "in": "glow"
      }), React__default.createElement("feMergeNode", {
        "in": "glow"
      }), React__default.createElement("feMergeNode", {
        "in": "glow"
      }))), _this.renderGradient(1, 'blue'), _this.renderGradient(2, 'red'), _this.renderGradient(3, 'green'), _this.renderGradient(4, 'orange'));
    };

    _this.renderPlayer = function (player) {
      var x = player.x,
          y = player.y;
      return React__default.createElement("g", {
        key: "player"
      }, React__default.createElement("g", {
        key: "111",
        fill: "purple",
        transform: "translate(" + (x * pw$1 - 2) + "," + y * ph$1 + ") scale(0.035,0.03)"
      }, React__default.createElement("path", {
        d: "M500,206c54.1,0,98-43.9,98-98c0-54.1-43.9-98-98-98s-98,43.9-98,98C402,162.1,445.9,206,500,206z M792.9,577.6c-18.9-87-51.8-229.7-100.1-288.8C646,231.3,551.5,228.9,500,228.9l0,0c-51.5,0-146,2.4-192.9,59.9c-48.2,59.1-81.2,201.8-100.1,288.8c-10.4,48.2,56.5,65.9,74,17.4c26-72.2,46.1-132.8,90.1-183.1C394.4,554.3,309,802.2,304,941c0,27,22,49,49,49c20.9,0,38.7-13,45.8-31.5C421.2,880.8,500,664.4,500,664.4l0,0l0,0c0,0,78.8,216.4,101.2,294.1C608.3,977,626.1,990,647,990c27,0,49-22,49-49c-5-138.8-90.4-386.7-67.2-529.1c44,50.3,64.1,110.9,90.1,183.1C736.3,643.4,803.4,625.7,792.9,577.6L792.9,577.6z"
      })));
    };

    _this.checkNextLevel = function () {
      var rocks = _this.state.rocks;

      if (rocks === 0) {
        _this.nextLevel();
      }
    };

    _this.movePlayer = function (rx, ry) {
      var _this$state = _this.state,
          rocks = _this$state.rocks,
          player = _this$state.player,
          board = _this$state.board;
      var i = board[player.y + ry][player.x + rx];

      if (i === ' ' || i === 'x') {
        _this.setState({
          player: {
            x: player.x + rx,
            y: player.y + ry
          }
        });
      } else if (i === 'a' || i === 'X') {
        var i2 = board[player.y + 2 * ry][player.x + 2 * rx];

        if (i2 === 'x' || i2 === ' ') {
          var newEocks = rocks;

          if (i2 === 'x') {
            newEocks--;
          }

          if (i === 'X') {
            newEocks++;
          }

          board[player.y + 2 * ry][player.x + 2 * rx] = i2 === ' ' ? 'a' : 'X';
          board[player.y + ry][player.x + rx] = i === 'X' ? 'x' : ' ';

          _this.setState({
            player: {
              x: player.x + rx,
              y: player.y + ry
            },
            board: board,
            rocks: newEocks
          }, function () {
            _this.checkNextLevel();
          });
        }
      }
    };

    _this.handleKeyDown = function (e) {
      switch (e.key) {
        case 'ArrowLeft':
          _this.movePlayer(-1, 0);

          break;

        case 'ArrowRight':
          _this.movePlayer(1, 0);

          break;

        case 'ArrowDown':
          _this.movePlayer(0, 1);

          break;

        case 'ArrowUp':
          _this.movePlayer(0, -1);

          break;
      }
    };

    _this.restartLevel = function () {
      var level = _this.state.level;

      _this.initLevel(level);

      _this.boardRef.current.focus();
    };

    _this.nextLevel = function () {
      var level = _this.state.level;

      if (level + 1 < levels$1.length) {
        _this.setState({
          level: level + 1
        });

        _this.initLevel(level + 1);
      }

      _this.boardRef.current.focus();
    };

    _this.setPassword = function () {
      var password = _this.passRef.current.value;
      var level = null;

      for (var a = 0; a < passwords$1.length; a++) {
        if (passwords$1[a] === password) {
          level = a;
          break;
        }
      }

      if (level !== null) {
        _this.passRef.current.value = '';

        _this.initLevel(level);
      }
    };

    _this.newGame = function () {
      _this.initLevel(0);
    };

    return _this;
  }

  var _proto = Sokoban.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var level = this.state.level;
    this.setState({}, function () {
      _this2.initLevel(level);
    });
  };

  _proto.render = function render() {
    var _this$state2 = this.state,
        rocks = _this$state2.rocks,
        level = _this$state2.level,
        player = _this$state2.player,
        board = _this$state2.board;
    var items = [];

    if (board) {
      for (var y = 0; y < hh; y++) {
        for (var x = 0; x < ww; x++) {
          var i = board[y][x];
          var key = x + "," + y;

          switch (i) {
            case ' ':
              items.push(React__default.createElement("rect", {
                key: key,
                className: "empty",
                width: pw$1,
                height: ph$1,
                x: x * pw$1,
                y: y * ph$1
              }));
              break;

            case '1':
            case '2':
            case '3':
            case '4':
              items.push(React__default.createElement("g", {
                key: key
              }, React__default.createElement("g", {
                key: key,
                fill: "url(#g" + i + ")",
                filter: 'url(#innerbevel)',
                transform: "translate(" + (x * pw$1 - 2) + "," + (y * ph$1 + 16) + ") scale(0.0035,-0.0049)"
              }, React__default.createElement("path", {
                d: "M281.8,3161.2c-179.9-93.8-183.7-118.7-178-901.5c5.7-629.7,7.7-656.5,45.9-708.2c21.1-28.7,68.9-72.7,103.4-95.7l63.2-44h1611.6h1611.6l63.2,44c34.4,23,82.3,67,103.4,95.7c38.3,53.6,40.2,74.7,40.2,750.3c0,673.8-1.9,696.7-40.2,748.4c-21.1,28.7-63.2,70.8-91.9,91.9c-51.7,40.2-70.8,40.2-1663.3,45.9C515.4,3191.8,333.5,3188,281.8,3161.2z"
              }), React__default.createElement("path", {
                d: "M4272.7,3170.7c-26.8-11.5-68.9-38.3-91.9-61.2c-99.5-91.9-99.5-99.5-99.5-809.7v-664.2l45.9-80.4c90-153.1-15.3-145.5,1805-139.7c1604,5.7,1611.7,5.7,1665.2,45.9c28.7,23,70.8,68.9,91.9,105.3c36.4,61.2,38.3,99.5,38.3,735c0,637.4-1.9,673.8-38.3,736.9c-23,40.2-74.7,84.2-124.4,111l-84.2,42.1l-1581-1.9C4898.6,3189.9,4303.3,3182.2,4272.7,3170.7z"
              }), React__default.createElement("path", {
                d: "M8215.6,3149.7c-49.8-26.8-101.4-70.8-124.4-111c-36.4-63.2-38.3-99.5-38.3-736.9c0-635.5,1.9-673.8,38.3-735c21-36.4,63.2-82.3,91.9-105.3c53.6-38.3,72.7-40.2,788.6-40.2c712,0,735,1.9,786.7,40.2c28.7,21.1,70.8,63.2,91.9,91.9c38.3,49.8,40.2,80.4,45.9,706.3c5.7,738.8,0,773.3-126.3,870.9l-67,51.7l-700.6,5.7C8305.6,3193.7,8301.8,3191.8,8215.6,3149.7z"
              }), React__default.createElement("path", {
                d: "M339.3,992.5c-91.9-23-157-74.6-201-162.7C101.9,753.3,100,715,100,110.1c0-606.8,1.9-643.1,40.2-719.7c23-49.8,68.9-101.5,109.1-126.3c68.9-44,82.3-44,725.4-49.8c434.5-3.8,679.5,1.9,731.2,15.3c105.3,26.8,201,114.8,227.8,206.7c30.6,101.4,32.5,1253.7,1.9,1345.6c-32.5,97.6-124.4,183.8-220.1,206.7C1623.6,1011.7,435,1015.5,339.3,992.5z"
              }), React__default.createElement("path", {
                d: "M2492.6,986.8c-88-24.9-187.6-120.6-210.5-206.7c-24.9-88-24.9-1253.7,0-1337.9c28.7-103.3,124.4-189.5,237.3-212.5c67-15.3,568.5-19.1,1638.4-15.3c1500.6,5.7,1542.7,7.6,1605.9,44c36.4,21.1,82.3,63.2,105.3,91.9c38.3,53.6,40.2,72.7,40.2,759.9s-1.9,706.3-40.2,759.9c-23,28.7-68.9,70.8-105.3,91.9c-63.2,38.3-103.4,38.3-1634.6,42.1C3131.9,1005.9,2534.7,1000.2,2492.6,986.8z"
              }), React__default.createElement("path", {
                d: "M6475.7,990.6c-86.1-21.1-153.1-72.7-195.2-153.1c-32.5-61.3-36.4-120.6-36.4-723.5c0-614.4,1.9-660.3,38.3-729.3c21-42.1,68.9-95.7,109.1-118.7l72.7-45.9h1607.8h1607.8l70.8,44c40.2,24.9,86.1,76.6,109.1,126.3c38.3,76.6,40.2,112.9,40.2,719.7c0,606.8-1.9,643.1-40.2,719.7c-23,49.8-68.9,101.4-109.1,126.3l-70.8,44l-1569.5,3.8C7247.1,1005.9,6512.1,1000.2,6475.7,990.6z"
              }), React__default.createElement("path", {
                d: "M281.8-1218.2c-70.8-30.6-134-99.5-160.8-170.3c-13.4-34.5-21.1-285.2-21.1-691c0-620.2,1.9-637.4,44-719.7c30.6-63.2,65.1-97.6,128.2-130.2l86.1-42.1l1602.1,3.8c1582.9,5.7,1602.1,5.7,1653.7,45.9c28.7,21.1,70.8,63.2,91.9,91.9c38.3,51.7,40.2,74.6,40.2,748.4c0,675.7-1.9,696.7-40.2,750.3c-21.1,28.7-68.9,72.7-103.4,97.6l-63.2,42.1H1939.4C649.3-1193.3,327.8-1197.1,281.8-1218.2z"
              }), React__default.createElement("path", {
                d: "M4226.7-1235.4c-143.6-82.3-145.5-88.1-145.5-847.9c0-666.1,0-671.8,44-735c23-34.5,67-82.3,95.7-103.4c53.6-40.2,65.1-40.2,1646.1-45.9c1797.3-5.7,1711.2-11.5,1808.8,135.9l51.7,78.5v669.9c0,637.4-1.9,675.7-38.3,736.9c-21,36.4-63.2,82.3-91.9,105.3c-53.6,40.2-61.3,40.2-1674.8,44l-1621.2,5.7L4226.7-1235.4z"
              }), React__default.createElement("path", {
                d: "M8223.3-1218.2c-74.7-32.5-135.9-111-160.8-206.7c-13.4-47.9-19.1-302.4-15.3-700.5c7.6-905.3-57.4-844.1,924.5-846c658.4,0,673.8,0,756.1,44c63.2,30.6,97.6,65.1,130.2,128.2c42.1,86.1,44,91.9,38.3,750.3c-5.7,639.3-7.6,666.1-45.9,717.8c-21.1,28.7-68.9,72.7-103.4,97.6c-63.2,42.1-68.9,42.1-763.7,42.1C8439.6-1193.3,8269.2-1199.1,8223.3-1218.2z"
              }))));
              break;

            case 'x':
              items.push(React__default.createElement("g", {
                key: key
              }, React__default.createElement("rect", {
                key: "1",
                className: "empty",
                width: pw$1,
                height: ph$1,
                x: x * pw$1,
                y: y * ph$1
              }), React__default.createElement("path", {
                key: "2",
                className: "cross",
                d: "M" + (x * pw$1 + 6) + "," + (y * ph$1 + 6) + "," + (x * pw$1 + pw$1 - 6) + "," + (y * ph$1 + ph$1 - 6) + "z M" + (x * pw$1 + 6) + "," + (y * ph$1 + ph$1 - 6) + "," + (x * pw$1 + pw$1 - 6) + "," + (y * ph$1 + 6) + "z"
              })));
              break;

            case 'a':
              items.push(React__default.createElement("g", {
                key: key
              }, React__default.createElement("rect", {
                key: key,
                className: "empty",
                width: pw$1,
                height: ph$1,
                x: x * pw$1,
                y: y * ph$1
              }), React__default.createElement("g", {
                key: key + 'a',
                fill: "black",
                transform: "translate(" + (x * pw$1 - 2) + "," + (y * ph$1 + 17) + ") scale(0.0035,-0.0028)"
              }, React__default.createElement("path", {
                d: "M4039.3,4997.4c-502.5-43.5-1103.8-150.3-1438.2-257.2c-366-116.7-639-271-803.1-451c-221.6-245.3-251.2-567.7-71.2-763.6l73.2-79.1l7.9-1428.3l5.9-1426.3l-65.3-85.1C1645.7,368.4,1622,311,1612.1,182.4c-9.9-112.8-4-128.6,95-326.4l104.8-205.7l2-1366.9c2-995-2-1386.7-19.8-1446.1c-13.9-43.5-57.4-132.5-100.9-197.8c-75.2-112.8-77.2-122.7-77.2-284.9v-168.1l98.9-124.6c405.5-518.3,1426.3-811.1,2937.6-848.7c1537.1-35.6,2975.2,229.5,3434.1,631.1c128.6,112.8,243.3,282.9,267.1,393.7c37.6,178-19.8,395.6-136.5,518.3l-53.4,55.4l5.9,1408.5l5.9,1408.5l63.3,98.9c114.7,184,152.3,273,152.3,356.1c0,124.6-49.5,267-142.4,407.5l-85.1,126.6v751.7c0,413.4,4,1050.4,7.9,1416.4l5.9,666.6l67.2,65.3c75.2,73.2,126.6,213.6,126.6,342.2c0,45.5-25.7,148.4-55.4,231.5c-45.5,130.6-67.3,164.2-162.2,243.3c-261.1,223.5-512.4,342.2-959.4,457c-263.1,67.3-743.8,146.4-1167.1,187.9C5748.5,5009.2,4310.3,5021.1,4039.3,4997.4z M3600.2,4415.8c67.3-15.8,158.3-47.5,199.8-67.3c77.1-39.6,199.8-164.2,199.8-203.8c0-11.9-37.6-59.3-85.1-104.8c-128.6-128.6-241.3-156.3-615.2-142.4c-348.2,9.9-480.7,43.5-579.6,142.4c-35.6,35.6-65.3,79.1-65.3,96.9C2654.6,4358.4,3184.7,4512.7,3600.2,4415.8z M2245.1,3765c326.4-148.4,510.4-205.7,927.8-286.8c1076.1-209.7,2379.8-215.6,3556.8-19.8c435.2,73.2,662.7,140.5,987.1,292.8c166.2,77.1,308.6,140.5,318.5,140.5c9.9,0,7.9-25.7-2-57.4c-67.3-191.9-551.9-429.3-1125.6-551.9c-623.1-134.5-1545-195.8-2387.7-162.2c-565.8,23.7-937.7,63.3-1315.5,140.5c-682.5,138.5-1086,312.6-1232.4,536.1C1887,3925.2,1891,3923.2,2245.1,3765z M7754.4,1521.7c4-888.2,2-1641.9-5.9-1671.6c-17.8-67.3-120.7-122.7-387.7-207.7c-761.6-243.3-2435.2-366-3420.3-251.2c-367.9,41.5-838.8,122.6-1062.3,178c-174.1,45.5-609.3,223.5-753.7,312.6c-102.9,59.3-221.6,223.5-221.6,298.7c0,35.6,5.9,71.2,11.9,77.1c7.9,7.9,57.4-27.7,112.8-77.1c223.5-201.8,591.5-362,963.4-423.3c81.1-13.8,211.7-39.6,286.8-61.3c77.1-19.8,213.6-45.5,306.6-55.4c93-11.9,288.8-35.6,435.2-53.4c464.9-61.3,1774.4-45.5,2120.6,23.8l55.4,11.9l4,1574.6l5.9,1574.7l257.2,35.6c302.7,41.5,631.1,120.7,999,241.3c146.4,47.5,271,87,277,89C7744.5,3139.8,7752.4,2411.9,7754.4,1521.7z M7758.3-2175.6c0-858.5,5.9-1590.4,11.9-1630c15.8-93-25.7-132.5-259.1-245.3c-290.8-142.4-757.7-247.3-1374.9-310.6c-322.4-33.6-1636-33.6-1998,0c-1113.7,102.9-1766.5,271-2057.3,532.1c-100.9,89-176.1,213.6-178,288.8c0,47.5,31.7,41.5,94.9-15.8c156.3-148.4,364-251.3,712.1-358c443.1-134.6,985.2-223.6,1636-267.1c510.4-35.6,1667.6-2,1825.9,51.4c17.8,5.9,23.7,340.3,23.7,1580.6v1574.7l45.5,9.9c23.7,5.9,189.9,27.7,366,49.5c407.5,49.5,526.2,77.1,844.7,197.8c142.4,51.4,269,96.9,282.9,96.9C7752.4-618.7,7758.3-943.2,7758.3-2175.6z"
              }))));
              break;

            case 'X':
              items.push(React__default.createElement("g", {
                key: key
              }, React__default.createElement("rect", {
                key: key,
                className: "empty",
                width: pw$1,
                height: ph$1,
                x: x * pw$1,
                y: y * ph$1
              }), React__default.createElement("g", {
                key: key + 'a',
                fill: "green",
                transform: "translate(" + (x * pw$1 - 2) + "," + (y * ph$1 + 17) + ") scale(0.0035,-0.0028)"
              }, React__default.createElement("path", {
                d: "M4039.3,4997.4c-502.5-43.5-1103.8-150.3-1438.2-257.2c-366-116.7-639-271-803.1-451c-221.6-245.3-251.2-567.7-71.2-763.6l73.2-79.1l7.9-1428.3l5.9-1426.3l-65.3-85.1C1645.7,368.4,1622,311,1612.1,182.4c-9.9-112.8-4-128.6,95-326.4l104.8-205.7l2-1366.9c2-995-2-1386.7-19.8-1446.1c-13.9-43.5-57.4-132.5-100.9-197.8c-75.2-112.8-77.2-122.7-77.2-284.9v-168.1l98.9-124.6c405.5-518.3,1426.3-811.1,2937.6-848.7c1537.1-35.6,2975.2,229.5,3434.1,631.1c128.6,112.8,243.3,282.9,267.1,393.7c37.6,178-19.8,395.6-136.5,518.3l-53.4,55.4l5.9,1408.5l5.9,1408.5l63.3,98.9c114.7,184,152.3,273,152.3,356.1c0,124.6-49.5,267-142.4,407.5l-85.1,126.6v751.7c0,413.4,4,1050.4,7.9,1416.4l5.9,666.6l67.2,65.3c75.2,73.2,126.6,213.6,126.6,342.2c0,45.5-25.7,148.4-55.4,231.5c-45.5,130.6-67.3,164.2-162.2,243.3c-261.1,223.5-512.4,342.2-959.4,457c-263.1,67.3-743.8,146.4-1167.1,187.9C5748.5,5009.2,4310.3,5021.1,4039.3,4997.4z M3600.2,4415.8c67.3-15.8,158.3-47.5,199.8-67.3c77.1-39.6,199.8-164.2,199.8-203.8c0-11.9-37.6-59.3-85.1-104.8c-128.6-128.6-241.3-156.3-615.2-142.4c-348.2,9.9-480.7,43.5-579.6,142.4c-35.6,35.6-65.3,79.1-65.3,96.9C2654.6,4358.4,3184.7,4512.7,3600.2,4415.8z M2245.1,3765c326.4-148.4,510.4-205.7,927.8-286.8c1076.1-209.7,2379.8-215.6,3556.8-19.8c435.2,73.2,662.7,140.5,987.1,292.8c166.2,77.1,308.6,140.5,318.5,140.5c9.9,0,7.9-25.7-2-57.4c-67.3-191.9-551.9-429.3-1125.6-551.9c-623.1-134.5-1545-195.8-2387.7-162.2c-565.8,23.7-937.7,63.3-1315.5,140.5c-682.5,138.5-1086,312.6-1232.4,536.1C1887,3925.2,1891,3923.2,2245.1,3765z M7754.4,1521.7c4-888.2,2-1641.9-5.9-1671.6c-17.8-67.3-120.7-122.7-387.7-207.7c-761.6-243.3-2435.2-366-3420.3-251.2c-367.9,41.5-838.8,122.6-1062.3,178c-174.1,45.5-609.3,223.5-753.7,312.6c-102.9,59.3-221.6,223.5-221.6,298.7c0,35.6,5.9,71.2,11.9,77.1c7.9,7.9,57.4-27.7,112.8-77.1c223.5-201.8,591.5-362,963.4-423.3c81.1-13.8,211.7-39.6,286.8-61.3c77.1-19.8,213.6-45.5,306.6-55.4c93-11.9,288.8-35.6,435.2-53.4c464.9-61.3,1774.4-45.5,2120.6,23.8l55.4,11.9l4,1574.6l5.9,1574.7l257.2,35.6c302.7,41.5,631.1,120.7,999,241.3c146.4,47.5,271,87,277,89C7744.5,3139.8,7752.4,2411.9,7754.4,1521.7z M7758.3-2175.6c0-858.5,5.9-1590.4,11.9-1630c15.8-93-25.7-132.5-259.1-245.3c-290.8-142.4-757.7-247.3-1374.9-310.6c-322.4-33.6-1636-33.6-1998,0c-1113.7,102.9-1766.5,271-2057.3,532.1c-100.9,89-176.1,213.6-178,288.8c0,47.5,31.7,41.5,94.9-15.8c156.3-148.4,364-251.3,712.1-358c443.1-134.6,985.2-223.6,1636-267.1c510.4-35.6,1667.6-2,1825.9,51.4c17.8,5.9,23.7,340.3,23.7,1580.6v1574.7l45.5,9.9c23.7,5.9,189.9,27.7,366,49.5c407.5,49.5,526.2,77.1,844.7,197.8c142.4,51.4,269,96.9,282.9,96.9C7752.4-618.7,7758.3-943.2,7758.3-2175.6z"
              }))));
              break;
          }
        }
      }
    }

    return React__default.createElement("div", {
      className: "sokoban"
    }, React__default.createElement("div", {
      className: "actions"
    }, React__default.createElement("button", {
      onClick: this.restartLevel
    }, "Restart levelu"), "Zadat heslo: ", React__default.createElement("input", {
      ref: this.passRef,
      type: "text"
    }), React__default.createElement("button", {
      onClick: this.setPassword
    }, "OK"), React__default.createElement("button", {
      onClick: this.newGame
    }, "Za\u010D\xEDt novou hru")), "Level ", level + 1, "/", levels$1.length, ", zb\xFDv\xE1 um\xEDstit ", rocks, ", heslo:", ' ', passwords$1[level], React__default.createElement("div", {
      className: "game"
    }, React__default.createElement("svg", {
      className: 'board',
      // @ts-ignore
      ref: this.boardRef,
      tabIndex: 0,
      onKeyDown: this.handleKeyDown,
      style: {
        width: ww * pw$1,
        height: hh * ph$1
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, this.renderGradients(), items, player && this.renderPlayer(player))));
  };

  return Sokoban;
}(React__default.Component);

var p0 = [1, 0, 0, 1, 1, 1, 0, 0, 0];
var p1 = [0, 2, 0, 2, 2, 2, 0, 0, 0];
var p2 = [0, 0, 3, 0, 0, 0, 3, 0, 0, 0, 3, 0, 0, 0, 3, 0];
var p3 = [0, 0, 4, 4, 4, 4, 0, 0, 0];
var p4 = [0, 0, 5, 0, 5, 5, 0, 5, 0];
var p5 = [0, 6, 0, 0, 6, 6, 0, 0, 6];
var p6 = [7, 7, 7, 7];
var pieces = [p0, p1, p2, p3, p4, p5, p6];
var sizes = [3, 3, 4, 3, 3, 3, 2];
var levels$2 = [];
var levelInfo = [];
levels$2[0] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[0] = {
  l1: 3,
  l2: 2,
  l3: 0,
  l4: 0
};
levels$2[1] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 9, 0, 0, 0, 0, 9, 9, 9, 9, 9, 9, 9, 0, 0, 9, 9, 9, 9];
levelInfo[1] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[2] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[2] = {
  l1: 5,
  l2: 4,
  l3: 1,
  l4: 0
};
levels$2[3] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 0, 0, 0, 0, 0, 9, 9, 9, 9, 9, 9, 0, 0, 0, 9, 9, 9, 9, 9, 9, 9, 9, 0];
levelInfo[3] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[4] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9];
levelInfo[4] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[5] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[5] = {
  l1: 6,
  l2: 5,
  l3: 3,
  l4: 2
};
levels$2[6] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 3, 3, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0];
levelInfo[6] = {
  l1: 2,
  l2: 2,
  l3: 2,
  l4: 0
};
levels$2[7] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 6, 6, 6, 6, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 1, 1, 1, 1, 1, 1, 1, 1, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[7] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[8] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 6, 0, 0, 0, 6, 6, 6, 6, 6, 6, 6, 6, 0, 0, 2, 2, 2, 6, 6, 2, 2, 2, 0, 2, 2, 0, 2, 2, 2, 2, 0, 2, 2, 7, 2, 2, 2, 0, 0, 2, 2, 2, 7, 7, 7, 7, 7, 0, 0, 7, 7, 7, 7, 7, 7, 7, 7, 0, 0, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 7, 0, 7, 5, 7, 7, 7, 7, 5, 7, 0, 0, 7, 7, 5, 5, 5, 5, 7, 7, 0, 0, 0, 7, 7, 7, 7, 7, 7, 0, 0];
levelInfo[8] = {
  l1: 8,
  l2: 8,
  l3: 0,
  l4: 0
};
levels$2[9] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[9] = {
  l1: 1,
  l2: 2,
  l3: 3,
  l4: 2
};
levels$2[10] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[10] = {
  l1: 5,
  l2: 10,
  l3: 0,
  l4: 0
};
levels$2[11] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 9, 9, 9, 9, 9, 0, 9, 9, 9, 9, 9, 9, 9, 9, 0, 0, 9, 9, 9, 9, 9, 9, 9, 0, 0, 0, 9, 9, 9, 9, 9, 9, 0, 0, 0, 0, 9, 9, 9, 9, 9, 0, 0, 0, 0, 0, 9, 9, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[11] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[12] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1, 3, 1, 0, 0, 0, 0, 0, 0, 3, 1];
levelInfo[12] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[13] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 5, 3, 4, 5, 3, 4, 5, 0, 0, 3, 4, 5, 3, 4, 5, 3, 4, 0, 0, 5, 3, 4, 5, 3, 4, 5, 3, 0, 0, 4, 5, 3, 4, 5, 3, 4, 5, 0, 0, 3, 4, 5, 3, 4, 5, 3, 4, 0, 0, 5, 3, 4, 5, 3, 4, 5, 3, 0, 0, 4, 5, 3, 4, 5, 3, 4, 5, 0, 0, 3, 4, 5, 3, 4, 5, 3, 4, 0];
levelInfo[13] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 4
};
levels$2[14] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5, 0, 0, 0, 0, 0, 0, 0, 5, 7, 7, 5, 0, 0, 0, 0, 0, 6, 5, 7, 7, 5, 0, 0, 0, 0, 0, 0, 6, 5, 5, 0, 0, 0, 0, 6, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 6, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 0, 0, 0, 0, 6, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 6, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0];
levelInfo[14] = {
  l1: 3,
  l2: 3,
  l3: 3,
  l4: 1
};
levels$2[15] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 0, 0, 4, 4, 4, 4, 4, 4, 4, 4, 4, 9, 9, 9, 9, 0, 0, 0, 0, 0, 0];
levelInfo[15] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[16] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
levelInfo[16] = {
  l1: 6,
  l2: 5,
  l3: 4,
  l4: 3
};
levels$2[17] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 0, 0, 9, 9, 9, 9, 9, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 7, 7, 7, 0, 0, 0, 0, 0, 0, 7, 7, 7, 1, 0, 0, 0, 0, 0, 7, 7, 7, 7, 7, 0, 0, 0, 0, 7, 7, 7, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 7, 7, 5, 0, 0, 0, 0, 0, 0, 0, 5, 5, 7, 0, 0, 0, 0, 0, 0, 0, 7, 7, 7, 0, 0, 0, 0, 0, 0, 0, 0, 7, 7];
levelInfo[17] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[18] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 9, 9, 9, 0, 0, 0, 0, 9, 9, 9, 9, 9, 0, 0, 0, 0, 0, 0, 9, 9, 9, 0, 0, 0, 0, 0, 0, 0, 0, 9, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0, 0, 2, 2, 2, 2, 2, 0, 0, 0, 0, 0, 0, 2, 2, 2, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 6, 0, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 0, 0, 0, 0, 6, 6, 6, 6, 6, 0, 0, 0, 0, 0, 0, 6, 6, 6, 0, 0, 0, 0, 0, 0, 0, 0, 6, 0, 0, 9, 9, 9, 9, 9, 9, 0, 0];
levelInfo[18] = {
  l1: 0,
  l2: 0,
  l3: 0,
  l4: 0
};
levels$2[19] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 6, 6, 0, 0, 0, 0, 0, 0, 0, 6, 6, 6, 6, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 6, 0, 0, 0, 6, 6, 6, 6, 6, 6, 6, 6, 0, 0, 0, 0, 6, 6, 6, 6, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 6, 0, 0, 0, 6, 6, 6, 6, 6, 6, 6, 6, 0, 0, 0, 0, 6, 6, 6, 6, 0, 0, 0, 0, 0, 6, 6, 6, 6, 6, 6, 0, 0, 0, 6, 6, 6, 6, 6, 6, 6, 6, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0, 0, 0, 0, 0, 4, 4, 0, 0, 0, 0];
levelInfo[19] = {
  l1: 2,
  l2: 2,
  l3: 2,
  l4: 2
};
levels$2[20] = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 0, 7, 0, 0, 0, 0, 0, 0, 0, 0, 5, 5, 5, 5, 5, 0, 0, 0, 0, 5, 5, 5, 5, 5, 5, 5, 0, 0, 5, 5, 5, 5, 5, 5, 5, 5, 5, 0, 0, 7, 7, 7, 7, 7, 7, 7, 0, 0, 0, 7, 4, 4, 7, 4, 4, 7, 0, 0, 0, 7, 4, 4, 7, 4, 4, 7, 0, 0, 0, 7, 4, 4, 7, 7, 7, 7, 0, 0, 0, 7, 4, 4, 7, 7, 7, 7, 0];
levelInfo[20] = {
  l1: 3,
  l2: 3,
  l3: 3,
  l4: 3
};
var lev = {
  levels: levels$2,
  levelInfo: levelInfo,
  pieces: pieces,
  sizes: sizes
};

var ww$1 = 10;
var hh$1 = 20;
var pw$2 = 22;
var ph$2 = 22;
var BRICK = 9;

var nextId = function nextId() {
  return Math.ceil(Math.random() * 6);
};

var Tetris = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tetris, _Component);

  function Tetris(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.boardRef = React__default.createRef();

    _this.createBoard = function (levelNum) {
      var level = lev.levels[levelNum];
      var bricksCount = 0;
      var board = [];

      for (var y = 0; y < hh$1; y++) {
        board[y] = [];

        for (var x = 0; x < ww$1; x++) {
          board[y][x] = level[y * ww$1 + x];

          if (board[y][x] === BRICK) {
            bricksCount++;
          }
        }
      }

      return {
        board: board,
        bricksCount: bricksCount
      };
    };

    _this.newGame = function () {
      var boardInfo = _this.createBoard(0);

      _this.setState({
        end: false,
        nextPieceId: nextId(),
        levelNum: 0,
        score: 0,
        lives: 5,
        board: boardInfo.board,
        bricksCount: boardInfo.bricksCount,
        levelInfo: _extends({}, lev.levelInfo[0])
      }, function () {
        _this.nextPiece();
      });

      _this.changeSpeed(1000);

      _this.boardRef.current.focus();
    };

    _this.clearTimer = function () {
      if (_this.timer) {
        clearTimeout(_this.timer);
        _this.timer = null;
      }
    };

    _this.nextLevel = function () {
      var _this$state = _this.state,
          score = _this$state.score,
          levelNum = _this$state.levelNum;
      var newLevelNum = levelNum + 1;

      if (newLevelNum >= lev.levels.length) {
        _this.clearTimer();

        _this.setState({
          end: true,
          endInfo: 'Výborně, jsi vítěz!!!!!!'
        });

        return;
      }

      var boardInfo = _this.createBoard(newLevelNum);

      _this.setState({
        score: score + 5000 * newLevelNum,
        nextPieceId: nextId(),
        levelNum: newLevelNum,
        board: boardInfo.board,
        bricksCount: boardInfo.bricksCount,
        levelInfo: _extends({}, lev.levelInfo[newLevelNum])
      }, function () {
        _this.nextPiece();

        _this.changeSpeed(1000 - 15 * newLevelNum);
      });
    };

    _this.changeSpeed = function (speed) {
      var pause = _this.state.pause;

      _this.setState({
        speed: speed
      });

      if (speed && !pause) {
        _this.clearTimer();

        _this.timer = setTimeout(_this.tick, speed);
      }
    };

    _this.tick = function (doMove) {
      if (doMove === void 0) {
        doMove = true;
      }

      _this.boardRef.current.focus();

      doMove && _this.movePieceDown();
      var _this$state2 = _this.state,
          pause = _this$state2.pause,
          speed = _this$state2.speed;

      if (speed && !pause) {
        _this.clearTimer();

        _this.timer = setTimeout(_this.tick, speed);
      }
    };

    _this.nextPiece = function () {
      var nextPieceId = _this.state.nextPieceId;
      var id = nextPieceId;
      var newNextPieceId = nextId();
      var newPiece = {
        x: ww$1 / 2 - Math.floor(lev.sizes[id] / 2),
        y: -lev.sizes[id],
        id: id,
        content: [].concat(lev.pieces[id])
      };

      _this.setState({
        piece: newPiece,
        nextPieceId: newNextPieceId
      });
    };

    _this.isCollision = function (piece, tx, ty) {
      var board = _this.state.board;

      for (var y = 0; y < lev.sizes[piece.id]; y++) {
        var yy = ty + y;

        for (var x = 0; x < lev.sizes[piece.id]; x++) {
          var i = piece.content[y * lev.sizes[piece.id] + x];
          var xx = tx + x;

          if (i && (xx < 0 || xx >= ww$1 || yy >= hh$1)) {
            // je mimo, je kolize
            return true;
          }

          var boardi = void 0;

          if (yy < 0) {
            boardi = 0;
          } else if (yy >= hh$1) {
            boardi = 1;
          } else {
            boardi = board[yy][xx];
          }

          if (i && boardi) {
            // kolize
            return true;
          }
        }
      }

      return false;
    };

    _this.movePieceHorizontal = function (rx) {
      var piece = _this.state.piece;

      if (!_this.isCollision(piece, piece.x + rx, piece.y)) {
        _this.setState({
          piece: _extends({}, piece, {
            x: piece.x + rx
          })
        });
      }
    };

    _this.placePiece = function (board, piece) {
      var linesToCheck = [];
      var linesInView = 0;

      for (var y = 0; y < lev.sizes[piece.id]; y++) {
        var placed = false;
        var yy = piece.y + y;
        if (yy < 0) continue;

        for (var x = 0; x < lev.sizes[piece.id]; x++) {
          var i = piece.content[y * lev.sizes[piece.id] + x];
          var xx = piece.x + x;

          if (i) {
            placed = true;
            board[yy][xx] = i;
          }
        }

        if (placed) {
          linesInView++;
          var isFull = true;

          for (var _x = 0; _x < ww$1; _x++) {
            if (!board[yy][_x]) {
              isFull = false;
              break;
            }
          }

          if (isFull) {
            linesToCheck.push(yy);
          }
        }
      }

      return {
        linesToCheck: linesToCheck,
        linesInView: linesInView
      };
    };

    _this.movePieceDown = function () {
      var piece = _this.state.piece;

      if (!piece) {
        return;
      }

      if (!_this.isCollision(piece, piece.x, piece.y + 1)) {
        _this.setState({
          piece: _extends({}, piece, {
            y: piece.y + 1
          })
        });
      } else {
        // umístění dílku a nový
        var _this$state3 = _this.state,
            lives = _this$state3.lives,
            levelNum = _this$state3.levelNum,
            score = _this$state3.score,
            bricksCount = _this$state3.bricksCount,
            board = _this$state3.board; // Umístění dílku

        var _this$placePiece = _this.placePiece(board, piece),
            linesToCheck = _this$placePiece.linesToCheck,
            linesInView = _this$placePiece.linesInView;

        var levelInfo = _this.state.levelInfo;

        var newLevelInfo = _extends({}, levelInfo); // Pokud je dílek mimo obrazovku, končíme hru


        var linesScore = 0;

        if (linesInView) {
          // umístěn na board
          var count = linesToCheck.length;

          while (true) {
            if (count >= 4 && newLevelInfo.l4) {
              count -= 4;
              newLevelInfo.l4--;
              linesScore += 100;
            } else if (count >= 3 && newLevelInfo.l3) {
              count -= 3;
              newLevelInfo.l3--;
              linesScore += 70;
            } else if (count >= 2 && newLevelInfo.l2) {
              count -= 2;
              newLevelInfo.l2--;
              linesScore += 40;
            } else if (count >= 1 && newLevelInfo.l1) {
              count -= 1;
              newLevelInfo.l1--;
              linesScore += 10;
            } else {
              break;
            }
          } // Odebrání plných linek


          var removedBricks = 0;
          linesToCheck.forEach(function (ddy) {
            for (var x = 0; x < ww$1; x++) {
              if (board[ddy][x] === BRICK) {
                removedBricks++;
              }
            }

            for (var y = ddy; y >= 0; y--) {
              for (var _x2 = 0; _x2 < ww$1; _x2++) {
                if (y > 0) {
                  board[y][_x2] = board[y - 1][_x2];
                } else {
                  board[y][_x2] = 0;
                }
              }
            }
          }); // Nový stav

          var newBricksCount = bricksCount - removedBricks;

          _this.setState({
            board: board,
            bricksCount: newBricksCount,
            levelInfo: newLevelInfo,
            score: score + linesScore + (levelNum + 1) * 50 * linesToCheck.length + 5 + 20 * removedBricks
          }); // Kontrola, zda již nedokončil level


          var doNextLevel = false;

          if (newBricksCount === 0) {
            if (newLevelInfo.l1 === 0 && newLevelInfo.l2 === 0 && newLevelInfo.l3 === 0 && newLevelInfo.l4 === 0) {
              doNextLevel = true;
            }
          }

          _this.setState({}, function () {
            if (doNextLevel) {
              _this.nextLevel();
            } else {
              _this.nextPiece();
            }
          });
        } else {
          // je mimo, konec hry, pokud nema jeste zivoty
          if (lives) {
            // pokračujeme
            _this.setState({
              lives: lives - 1
            });

            _this.nextLevel();
          } else {
            // opravdový konec hry
            _this.clearTimer();

            _this.setState({
              piece: null,
              speed: 0,
              board: board,
              end: true,
              endInfo: 'Hmmm, nic moc, prohrál jsi!!!!!!'
            });
          }
        }
      }
    };

    _this.rotatePiece = function () {
      var piece = _this.state.piece;
      var newPieceContent = [];

      for (var y = 0; y < lev.sizes[piece.id]; y++) {
        for (var x = 0; x < lev.sizes[piece.id]; x++) {
          newPieceContent[(lev.sizes[piece.id] - x - 1) * lev.sizes[piece.id] + y] = piece.content[y * lev.sizes[piece.id] + x];
        }
      }

      var newPiece = _extends({}, piece, {
        content: newPieceContent
      });

      if (!_this.isCollision(newPiece, piece.x, piece.y)) {
        _this.setState({
          piece: newPiece
        });
      }
    };

    _this.handleKeyDown = function (e) {
      var piece = _this.state.piece;

      if (!piece) {
        return;
      }

      switch (e.key) {
        case 'ArrowLeft':
          _this.movePieceHorizontal(-1);

          break;

        case 'ArrowRight':
          _this.movePieceHorizontal(+1);

          break;

        case 'ArrowDown':
          _this.movePieceDown();

          break;

        case 'ArrowUp':
          _this.rotatePiece();

          break;
      }
    };

    _this.togglePause = function () {
      var pause = _this.state.pause;

      if (!pause) {
        _this.clearTimer();
      }

      _this.setState({
        pause: !pause
      }, function () {
        if (pause) {
          _this.tick(false);
        }
      });

      _this.boardRef.current.focus();
    };

    _this.renderPoint = function (x, y, i) {
      if (i === BRICK) {
        return _this.renderBrick(x, y);
      } else {
        return React__default.createElement("rect", {
          key: "" + x + y + i,
          fill: "url(#g" + i + ")",
          filter: i ? 'url(#innerbevel)' : '',
          className: "item is" + i,
          width: pw$2,
          height: ph$2,
          x: x * pw$2,
          y: y * ph$2
        });
      }
    };

    _this.renderGradient = function (i, color) {
      return React__default.createElement("radialGradient", {
        id: "g" + i,
        cx: "0.3",
        cy: "0.3",
        r: "1.0",
        fx: "0.3",
        fy: "0.3"
      }, React__default.createElement("stop", {
        offset: "0%",
        stopColor: color
      }), React__default.createElement("stop", {
        offset: "100%",
        stopColor: "rgb(200, 200, 200)"
      }));
    };

    _this.renderGradients = function () {
      return React__default.createElement("defs", null, React__default.createElement("filter", {
        id: "innerbevel",
        x: "0%",
        y: "0%",
        width: "100%",
        height: "100%"
      }, React__default.createElement("feGaussianBlur", {
        stdDeviation: "0 0",
        result: "glow"
      }), React__default.createElement("feMerge", null, React__default.createElement("feMergeNode", {
        "in": "glow"
      }), React__default.createElement("feMergeNode", {
        "in": "glow"
      }), React__default.createElement("feMergeNode", {
        "in": "glow"
      }))), _this.renderGradient(0, 'rgb(215, 215, 215)'), _this.renderGradient(1, 'blue'), _this.renderGradient(2, 'purple'), _this.renderGradient(3, 'cyan'), _this.renderGradient(4, 'orange'), _this.renderGradient(5, 'red'), _this.renderGradient(6, 'green'), _this.renderGradient(7, 'yellow'), React__default.createElement("radialGradient", {
        id: "gb",
        cx: "0.5",
        cy: "0.5",
        r: "0.9",
        fx: "0.5",
        fy: "0.5"
      }, React__default.createElement("stop", {
        offset: "0%",
        stopColor: "#a64413"
      }), React__default.createElement("stop", {
        offset: "100%",
        stopColor: "rgb(255, 0, 0)"
      })));
    };

    _this.renderBrick = function (x, y) {
      var hx = pw$2 / 2;
      var hy = ph$2 / 2;
      return React__default.createElement("g", {
        key: "" + x + y + "b"
      }, React__default.createElement("rect", {
        fill: "url(#gb)",
        className: "brick",
        width: pw$2,
        height: ph$2 / 2,
        x: x * pw$2,
        y: y * ph$2
      }), React__default.createElement("rect", {
        fill: "url(#gb)",
        className: "brick",
        width: pw$2 / 2,
        height: ph$2 / 2,
        x: x * pw$2,
        y: y * ph$2 + ph$2 / 2,
        strokeDasharray: hx + hy + hx + " " + hy
      }), React__default.createElement("rect", {
        fill: "url(#gb)",
        className: "brick",
        width: pw$2 / 2,
        height: ph$2 / 2,
        x: x * pw$2 + pw$2 / 2,
        y: y * ph$2 + ph$2 / 2,
        strokeDasharray: hx + " " + hy + " " + (hx + hy)
      }));
    };

    _this.showHelp = function () {
      window.alert('Máš omezený počet životů, pokud se ti nepovede dokončit daný level, ztratíš jeden život a dostaneš se do dalšího levelu.\n\n' + "K dokončení levelu se musí splnit úkoly. Existují dva druhy úkolů: zničení všech cihel a zničení určitého počtu linek. Pokud je cílem levelu např. zničení typu 'Linky-4: 2', tak se musí celkem dvakrát zničit současně 4 linky jedním položením elementu (v tomto případě musí jít pouze o tyčku).\n\n" + 'Hra se ovládá pomocí klávesových šipek.');
    };

    var boardInfo = _this.createBoard(0);

    _this.state = {
      nextPieceId: null,
      board: boardInfo.board,
      bricksCount: boardInfo.bricksCount,
      lives: 5,
      pause: false,
      score: 0,
      end: true,
      endInfo: null
    };
    return _this;
  }

  var _proto = Tetris.prototype;

  _proto.componentDidMount = function componentDidMount() {};

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.clearTimer();
  };

  _proto.render = function render() {
    var _this$state4 = this.state,
        endInfo = _this$state4.endInfo,
        lives = _this$state4.lives,
        score = _this$state4.score,
        bricksCount = _this$state4.bricksCount,
        levelInfo = _this$state4.levelInfo,
        levelNum = _this$state4.levelNum,
        nextPieceId = _this$state4.nextPieceId,
        end = _this$state4.end,
        pause = _this$state4.pause,
        piece = _this$state4.piece,
        board = _this$state4.board;
    var itemsBack = [];
    var items = [];

    for (var y = 0; y < hh$1; y++) {
      for (var x = 0; x < ww$1; x++) {
        var i = board[y][x];

        if (i) {
          items.push(this.renderPoint(x, y, i));
        } else {
          itemsBack.push(this.renderPoint(x, y, 0));
        }
      }
    } // Dílek


    if (piece) {
      for (var _y = 0; _y < lev.sizes[piece.id]; _y++) {
        for (var _x3 = 0; _x3 < lev.sizes[piece.id]; _x3++) {
          var _i = piece.content[_y * lev.sizes[piece.id] + _x3];

          if (_i) {
            items.push(this.renderPoint(piece.x + _x3, piece.y + _y, _i));
          }
        }
      }
    } // Dopad dílku


    if (piece) {
      var ty = piece.y + 1;

      while (true) {
        if (this.isCollision(piece, piece.x, ty)) {
          ty--;

          for (var _y2 = 0; _y2 < lev.sizes[piece.id]; _y2++) {
            for (var _x4 = 0; _x4 < lev.sizes[piece.id]; _x4++) {
              var _i2 = piece.content[_y2 * lev.sizes[piece.id] + _x4];

              if (_i2) {
                itemsBack.push(this.renderPoint(piece.x + _x4, ty + _y2, 99));
              }
            }
          }

          break;
        }

        ty++;
      }
    } // Další dílek


    var info = [];

    if (nextPieceId !== null) {
      var off = Math.floor((5 - lev.sizes[nextPieceId]) / 2);

      for (var _y3 = 0; _y3 < lev.sizes[nextPieceId]; _y3++) {
        for (var _x5 = 0; _x5 < lev.sizes[nextPieceId]; _x5++) {
          var _i3 = lev.pieces[nextPieceId][_y3 * lev.sizes[nextPieceId] + _x5];

          if (_i3) {
            info.push(this.renderPoint(_x5 + off, _y3 + off + 1, _i3));
          }
        }
      }
    }

    return React__default.createElement("div", {
      className: "tetris",
      key: pw$2
    }, React__default.createElement("div", {
      className: "actions"
    }, React__default.createElement("button", {
      onClick: this.newGame
    }, end ? 'Nová hra' : 'Restart hry'), React__default.createElement("button", {
      disabled: end,
      onClick: this.togglePause
    }, pause ? 'Pokračovat' : 'Pauza'), React__default.createElement("button", {
      onClick: this.showHelp
    }, "N\xE1pov\u011Bda"), false ), end && React__default.createElement("h1", null, endInfo), levelNum >= 0 && React__default.createElement("div", null, React__default.createElement("b", null, "Level ", levelNum + 1, "/", lev.levels.length)), React__default.createElement("div", {
      className: "game"
    }, React__default.createElement("svg", {
      className: 'board' + (end ? ' end' : ''),
      // @ts-ignore
      ref: this.boardRef,
      tabIndex: 0,
      onKeyDown: this.handleKeyDown,
      style: {
        width: ww$1 * pw$2,
        height: hh$1 * ph$2
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, this.renderGradients(), itemsBack, items), React__default.createElement("div", {
      className: "info-container"
    }, React__default.createElement("svg", {
      className: 'piece-info' + (end ? ' end' : ''),
      style: {
        width: 5 * pw$2,
        height: 6 * ph$2
      },
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, info), levelInfo && React__default.createElement("div", {
      className: "level-info"
    }, React__default.createElement("div", null, React__default.createElement("b", null, "Score: ", score)), React__default.createElement("br", null), React__default.createElement("div", null, "\u017Divoty: ", lives), React__default.createElement("br", null), React__default.createElement("div", null, "Linky-1: ", levelInfo.l1), React__default.createElement("div", null, "Linky-2: ", levelInfo.l2), React__default.createElement("div", null, "Linky-3: ", levelInfo.l3), React__default.createElement("div", null, "Linky-4: ", levelInfo.l4), React__default.createElement("br", null), React__default.createElement("div", null, "Zni\u010Dit cihel: ", bricksCount)))));
  };

  return Tetris;
}(Component);



var index$a = {
  __proto__: null,
  Mines: Mines,
  Pexeso: Pexeso,
  Sokoban: Sokoban,
  Tetris: Tetris
};

/**
 * Abstraktní předek pro modální dialogy.
 */

var AbstractModal = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AbstractModal, _React$Component);

  function AbstractModal() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleDialogClose = function () {
      var submitting = _this.props.submitting;
      !submitting && _this.props.dispatch(hide$1());
    };

    _this.content = function () {
      return React__default.createElement("div", null, _this.body(), _this.footer());
    };

    _this.body = function () {
      return React__default.createElement(ModalBody, null, "...dialog body...");
    };

    _this.header = function (title) {
      return React__default.createElement(ModalHeader, {
        title: title
      });
    };

    _this.footer = function (saveTitle) {
      if (saveTitle === void 0) {
        saveTitle = i18n('accept');
      }

      var _this$props = _this.props,
          pristine = _this$props.pristine,
          submitting = _this$props.submitting;
      return React__default.createElement(ModalFooter, null, React__default.createElement(Button, {
        color: "success",
        type: "submit",
        disabled: pristine || submitting
      }, React__default.createElement(FAIcon, {
        icon: "check"
      }), " ", saveTitle), React__default.createElement(Button, {
        color: "danger",
        disabled: submitting,
        onClick: _this.handleDialogClose
      }, React__default.createElement(FAIcon, {
        icon: "times"
      }), " Close"));
    };

    return _this;
  }

  var _proto = AbstractModal.prototype;

  _proto.render = function render() {
    var dialogTitle = this.props.dialogTitle;
    return React__default.createElement("div", null, this.header(dialogTitle), this.content());
  };

  return AbstractModal;
}(React__default.Component);

//const CLOSE_CLOSE = 'CLOSE_CLOSE';

var DIALOG_ZINDEX = 1050;
/**
 * Komponenta vykreslující modální dialogy (podle toho, kolik je jich aktuálně otevřeno).
 */

var ModalDialog = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ModalDialog, _React$Component);

  function ModalDialog() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;

    _this.handleClose = function (e) {
      var components = _this.props.modalDialog.components;
      var c = components[components.length - 1];

      if (!c) {
        console.error('Komponenta není definovaná.' + ' Je možné, že voláte onClose z unmountnuté komponenty např. kvůli nezrušenému history.listen');
      }

      var _ref = c && c.componentProps || {},
          onClose = _ref.onClose;

      var defaultPrevented = false;
      onClose && onClose(_extends({}, e, {
        preventDefault: function preventDefault() {
          defaultPrevented = true;
          e && e.preventDefault();
        }
      }));

      if (!defaultPrevented) {
        _this.props.dispatch(hide$1());
      }
    };

    _this.handleToggle = function (e) {
      _this.handleClose(e);
    };

    return _this;
  }

  var _proto = ModalDialog.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      isModal: true
    };
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        className = _this$props.className,
        _this$props$modalDial = _this$props.modalDialog,
        components = _this$props$modalDial.components,
        customSize = _this$props$modalDial.customSize;
    var modalDialogClassName = className;

    if (components.length === 0) {
      return React__default.createElement("div", null);
    }

    var dialogs = components.map(function (c, index) {
      var _classNames;

      var _c$modalProps = c.modalProps,
          size = _c$modalProps.size,
          className = _c$modalProps.className,
          noHeader = _c$modalProps.noHeader,
          transparent = _c$modalProps.transparent,
          otherModalProps = _objectWithoutPropertiesLoose(_c$modalProps, ["size", "className", "noHeader", "transparent"]);

      var useSize = customSize[index] || size;
      var modalCls = classNames(modalDialogClassName, className, (_classNames = {
        'dialog-lg': useSize && useSize === 'full',
        'dialog-fullscreen': useSize && useSize === 'fullscreen',
        'dialog-transparent': transparent && 'transparent'
      }, _classNames["modal-dialog-" + useSize] = useSize, _classNames));
      var topModal = index == components.length - 1;
      return React__default.createElement(Modal, Object.assign({
        isOpen: true,
        topWrapperClassName: "dialog-top-wrapper-" + index,
        backdrop: index === 0,
        zIndex: DIALOG_ZINDEX,
        keyboard: true,
        key: index,
        wrapClassName: topModal ? 'modal-top' : 'modal-bottom',
        modalClassName: "modal-fade-wrapper",
        className: modalCls,
        ref: "modal" + index,
        toggle: _this2.handleToggle
      }, otherModalProps), !noHeader && React__default.createElement(ModalHeader, {
        toggle: _this2.handleClose
      }, c.title), React__default.createElement(c.component, Object.assign({
        isDialog: true
      }, c.componentProps, {
        onClose: _this2.handleClose
      })));
    });
    return React__default.createElement("div", {
      className: "dialogs-container"
    }, dialogs);
  };

  return ModalDialog;
}(React__default.Component);

ModalDialog.childContextTypes = {
  isModal: PropTypes__default.bool.isRequired
};

function mapStateToProps$7(state) {
  return {
    modalDialog: state.modalDialog
  };
}

var ModalDialog$1 = /*#__PURE__*/connect(mapStateToProps$7)(ModalDialog);

/** Init state. */

var initialState$9 = {
  components: [],
  // pole aktuálně otevřených dialogů, obsahuje objekty {component: <odkaz na komponentu, jen reference, ne instance>, componentProps: <props pro komponentu>, title: <titulek dialogu>}
  customSize: []
};
function modalDialog(state, action) {
  if (state === void 0) {
    state = initialState$9;
  }

  switch (action.type) {
    case SHOW$1:
      return _extends({}, state, {
        components: [].concat(state.components, [{
          component: action.component,
          componentProps: action.componentProps,
          title: action.title,
          modalProps: action.modalProps
        }]),
        customSize: [].concat(state.customSize, [null])
      });

    case HIDE$1:
      return _extends({}, state, {
        components: [].concat(state.components.slice(0, state.components.length - 1)),
        customSize: [].concat(state.customSize.slice(0, state.components.length - 1))
      });

    case CHANGE_SIZE:
      return _extends({}, state, {
        customSize: [].concat(state.customSize.slice(0, state.components.length - 1), [action.size])
      });

    case CHANGE_TITLE:
      return _extends({}, state, {
        components: [].concat(state.components.slice(0, state.components.length - 1), [_extends({}, state.components[state.components.length - 1], {
          title: action.title
        })])
      });

    default:
      return state;
  }
}



var index$b = {
  __proto__: null,
  ModalActions: ModalActions,
  AbstractModal: AbstractModal,
  ModalDialog: ModalDialog$1,
  ModalReducer: modalDialog
};

/**
 * Komponenta ikony s nějakým textem (nebo komponentou), možné uspořádání - ikony vedle a ikona nad.
 */

function NavIconText(_ref) {
  var icon = _ref.icon,
      text = _ref.text;
  return createElement("div", {
    className: "icon-text-wrapper"
  }, createElement("div", {
    className: "icon-text-container"
  }, createElement("div", {
    className: "icon-text-icon"
  }, icon), text && createElement("div", {
    className: "icon-text-text"
  }, text)));
}

var _gameRunner = null;

var AppNavbarWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(AppNavbarWrapper, _React$Component);

  function AppNavbarWrapper() {
    var _this;

    _this = _React$Component.apply(this, arguments) || this;
    _this.state = {
      collapseIsOpen: false,
      canStartGame: false
    }; // componentDidMount() {
    //     this.handleShowGame(2)
    // }

    _this.handleGameStartLeave = function () {
      if (_gameRunner) {
        clearTimeout(_gameRunner);
        _gameRunner = null;
      }

      _this.setState({
        canStartGame: false
      });
    };

    _this.handleGameStartOver = function () {
      if (_gameRunner) {
        clearTimeout(_gameRunner);
        _gameRunner = null;
      }

      _gameRunner = setTimeout(function () {
        _this.setState({
          canStartGame: true
        });
      }, 1000);
    };

    _this.historyGoBack = function (e) {
      var _this$props = _this.props,
          onHistoryGoBack = _this$props.onHistoryGoBack,
          goBackBase = _this$props.goBackBase,
          homeLink = _this$props.homeLink;
      e.stopPropagation();
      e.preventDefault();
      onHistoryGoBack(goBackBase, homeLink);
    };

    _this.handleShowGame = function (game) {
      if (window.confirm('Opravdu si chcete zahrát hru? Hraní této hry je pouze na vašem rozhodnutí a společnost Marbes Consulting s.r.o. za toto nenese žádnou odpovědnost.')) {
        switch (game) {
          case 1:
            _this.props.dispatch(show$1(Tetris, null, 'Tetris', {
              size: 'md'
            }));

            break;

          case 2:
            _this.props.dispatch(show$1(Sokoban, null, 'Sokoban', {
              size: 'md'
            }));

            break;

          case 3:
            _this.props.dispatch(show$1(Mines, null, 'Hledání min', {
              size: 'md'
            }));

            break;

          case 4:
            _this.props.dispatch(show$1(Pexeso, null, 'Pexeso', {
              size: 'xl'
            }));

            break;
        }
      }
    };

    return _this;
  }

  var _proto = AppNavbarWrapper.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (_gameRunner) {
      clearTimeout(_gameRunner);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props2 = this.props,
        homeLinkComponent = _this$props2.homeLinkComponent,
        fluid = _this$props2.fluid,
        appCode = _this$props2.appCode,
        centerAddons = _this$props2.centerAddons,
        collapseAddons = _this$props2.collapseAddons,
        areas = _this$props2.areas,
        areasTitle = _this$props2.areasTitle,
        detail = _this$props2.detail,
        homeLink = _this$props2.homeLink,
        goBack = _this$props2.goBack,
        backButtonIcon = _this$props2.backButtonIcon,
        appName = _this$props2.appName,
        testEnvironment = _this$props2.testEnvironment,
        expand = _this$props2.expand;
    var canStartGame = this.state.canStartGame; // Brand logo - ikona, název a případně popis

    var brandLogo;
    var icon;

    if (backButtonIcon) {
      icon = React__default.createElement(FAIcon, {
        fixedWidth: true,
        className: "header-app-icon",
        icon: "chevron-left"
      });
    } else {
      icon = React__default.createElement(Icon, {
        fixedWidth: true,
        className: "header-app-icon",
        icon: appCode
      });
    }

    var classLogo = 'header-logo';

    if (testEnvironment) {
      classLogo += ' test';
    }

    brandLogo = React__default.createElement("div", {
      key: "logo",
      className: classLogo
    }, icon, React__default.createElement("div", {
      className: "header-app-name-container"
    }, React__default.createElement("span", {
      className: "header-app-name"
    }, appName))); // Celý brand včetně klikání

    var brand;

    if (goBack && this.props.history.length > 0) {
      // máme aplikační historii a chceme jít zpět - jako v prohlížeči
      brand = React__default.createElement(NavbarBrand, {
        key: "brand-left",
        href: "",
        className: "app-header-left",
        onClick: this.historyGoBack
      }, brandLogo);
    } else {
      if (typeof homeLink === 'function') {
        brand = React__default.createElement(NavbarBrand, {
          key: "brand",
          className: "app-header-left",
          href: "#",
          onClick: homeLink
        }, brandLogo);
      } else if (homeLink) {
        brand = createElement(homeLinkComponent, {
          to: homeLink,
          key: 'brand'
        }, React__default.createElement(NavbarBrand, {
          className: "app-header-left",
          key: "header"
        }, brandLogo));
      } else {
        brand = React__default.createElement(NavbarBrand, {
          key: "brand",
          className: "app-header-left"
        }, brandLogo);
      }
    } // Oblasti


    var appMainAreas;

    if (areas) {
      appMainAreas = React__default.createElement(Dropdown, {
        key: "main-areas",
        noCaret: true,
        id: "user",
        className: "app-main-areas",
        title: React__default.createElement("span", null, React__default.createElement(FAIcon, {
          icon: "bars"
        }))
      }, areas);
    }

    var appRightAreas;

    if (areas) {
      appRightAreas = React__default.createElement(Dropdown, {
        key: "main-areas-right",
        className: "",
        title: React__default.createElement("span", {
          className: "hidden-md hidden-lg hidden-xl"
        }, React__default.createElement(NavIconText, {
          icon: React__default.createElement(FAIcon, {
            icon: "bars"
          }),
          text: areasTitle
        }))
      }, areas);
    }

    return React__default.createElement(Navbar, {
      key: "navbar",
      className: 'app-header navbar-light',
      expand: expand
    }, React__default.createElement("div", {
      key: "container",
      className: fluid ? 'app-container-fluid' : 'app-container'
    }, React__default.createElement("div", {
      key: "game1",
      onClick: function onClick() {
        canStartGame && _this2.handleShowGame(1);
      },
      onMouseEnter: this.handleGameStartOver,
      onMouseLeave: this.handleGameStartLeave,
      className: 'game-placeholder ' + (canStartGame ? 'canStart' : '')
    }, "\xA0"), React__default.createElement("div", {
      key: "game2",
      onClick: function onClick() {
        canStartGame && _this2.handleShowGame(2);
      },
      onMouseEnter: this.handleGameStartOver,
      onMouseLeave: this.handleGameStartLeave,
      className: 'game-placeholder2 ' + (canStartGame ? 'canStart' : '')
    }, "\xA0"), React__default.createElement("div", {
      key: "game3",
      onClick: function onClick() {
        canStartGame && _this2.handleShowGame(3);
      },
      onMouseEnter: this.handleGameStartOver,
      onMouseLeave: this.handleGameStartLeave,
      className: 'game-placeholder3 ' + (canStartGame ? 'canStart' : '')
    }, "\xA0"), React__default.createElement("div", {
      key: "game4",
      onClick: function onClick() {
        canStartGame && _this2.handleShowGame(4);
      },
      onMouseEnter: this.handleGameStartOver,
      onMouseLeave: this.handleGameStartLeave,
      className: 'game-placeholder4 ' + (canStartGame ? 'canStart' : '')
    }, "\xA0"), brand, React__default.createElement(NavbarToggler, {
      key: "toggler",
      right: true,
      className: "mt-1",
      onClick: function onClick() {
        return _this2.setState({
          collapseIsOpen: !_this2.state.collapseIsOpen
        });
      }
    }), React__default.createElement(Nav, {
      key: "main-areas",
      className: "app-menu pull-right hidden-xs"
    }, appMainAreas), React__default.createElement("span", {
      key: "header-detail",
      className: "app-header-detail"
    }, detail), React__default.createElement(Collapse, {
      key: "right-menu",
      navbar: true,
      isOpen: this.state.collapseIsOpen
    }, centerAddons, React__default.createElement("div", {
      key: "others",
      className: "ml-auto"
    }, React__default.createElement(Nav, {
      key: "nav",
      className: "app-menu",
      navbar: true
    }, collapseAddons), appRightAreas))));
  };

  return AppNavbarWrapper;
}(React__default.Component);

AppNavbarWrapper.propTypes = {
  appCode: PropTypes__default.string,
  // název aplikace, který se zobrazuje jako brand, mu6e se jednat i o název globální logické sekce, např. skprávní řízení apod.
  appName: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.array, PropTypes__default.node]),
  // pokud je true, jedná se o kontejner fluid - na celou stránku, implicitně je false
  fluid: PropTypes__default.bool,
  // detail informace aplikace, např. text detailu stránky, globální filtr stránky atp.
  detail: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.array, PropTypes__default.node]),
  homeLink: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.string]),
  // komponenta pro renderování home linku (ne back), implicitně LinkContainer
  homeLinkComponent: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.string]),
  // funkce pro zpracování posunu back, předpis: (goBackBase, homeLink) => {}
  onHistoryGoBack: PropTypes__default.func.isRequired,
  // má se místo loga aplikace zobrazit back button?
  backButtonIcon: PropTypes__default.bool,
  // collapseAddons
  // centerAddons
  // pokud je true, je kliknutí na brand bráno jako back
  goBack: PropTypes__default.bool,
  // základní url, která reprezentuje základ aktuálně zobrazované stránky - při stisku back se půjde na první, která namá prefix uvedený v goBackBase
  goBackBase: PropTypes__default.string,
  // pokud je true, jedná se o testovací prostředí
  testEnvironment: PropTypes__default.bool,
  // velikost pri ktere se stredni navbar sbali
  expand: PropTypes__default.string
};
AppNavbarWrapper.defaultProps = {
  homeLinkComponent: LinkContainer,
  fluid: false,
  backButtonIcon: false,
  goBack: false,
  testEnvironment: false,
  expand: 'md'
};
var AppNavbarWrapper$1 = /*#__PURE__*/connect()( /*#__PURE__*/withRouter(AppNavbarWrapper));

var appThemes = {
  "default": {
    color: 'blue',
    className: ''
  },
  'retro-green': {
    color: 'black',
    className: 'retro-green'
  },
  'retro-white': {
    color: 'white',
    className: 'retro-white'
  }
};
/**
 * Wrapper pro PAGE stránky aplikace.
 *
 * Použití:
 *
 * 1. Vytvořit novou komponentu AppWrapper
 *
 * class AppWrapper extends React.Component<any, any> {
 *   render() {
 *      const {a, b, c, d, ...other} = this.props;
 *      return <layout.BaseAppWrapper
 *          {...other}
 *          onHistoryGoBack=...
 *          centerAddons=...
 *          onLogout=...
 *          collapseAddons=...
 *          userMenuAddons=...
 *          authStatus=...
 *      />
 *   }
 * }
 *
 * 2. Použít komponentu aplikace
 *        return <AppWrapper appName="Správní řízení" views={modules.getModulePohledViews(MODULE_CODE_SR, null, authInfo)}>
 *            <layout.PageWrapper>
 *                <layout.PageContent
 *                    leftPanel={<OznameniListPanel area={oznameniActions.OZNAMENI_PREHLED_AREA} />}
 *                    rightPanel={<PripominkaListPanel area={pripominkaActions.PRIPOMINKY_PREHLED_AREA} />}
 *                >
 *                    <ReferentPripadyList
 *                        kodTypPripad={kodTypPripad}
 *                        vlastnik={typyPripadu}
 *                    />
 *                </layout.PageContent>
 *            </layout.PageWrapper>
 *        </AppWrapper
 */

var BaseAppWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(BaseAppWrapper, _React$Component);

  function BaseAppWrapper(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.applyTheme = function (themeKey) {
      var theme = appThemes[themeKey];
      document.getElementsByTagName('BODY')[0].className = theme.className;
    };

    _this.handleChangeTheme = function (themeKey) {
      localStorage.setItem('proxio-app-theme', themeKey);

      _this.setState({
        selectedThemeKey: themeKey
      });

      _this.applyTheme(themeKey);
    };

    var themeKey = localStorage.getItem('proxio-app-theme') || 'default';
    _this.state = {
      selectedThemeKey: themeKey
    };

    _this.applyTheme(themeKey);

    return _this;
  }

  var _proto = BaseAppWrapper.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onHistoryGoBack = _this$props.onHistoryGoBack,
        appCode = _this$props.appCode,
        onLogin = _this$props.onLogin,
        onLogout = _this$props.onLogout,
        userMenuAddons = _this$props.userMenuAddons,
        collapseAddons = _this$props.collapseAddons,
        centerAddons = _this$props.centerAddons,
        authStatus = _this$props.authStatus,
        className = _this$props.className,
        leftPanelCollapsed = _this$props.leftPanelCollapsed,
        rightPanelCollapsed = _this$props.rightPanelCollapsed,
        hasLeftPanel = _this$props.hasLeftPanel,
        hasRightPanel = _this$props.hasRightPanel,
        children = _this$props.children,
        goBackBase = _this$props.goBackBase,
        appName = _this$props.appName,
        detail = _this$props.detail,
        homeLink = _this$props.homeLink,
        backButtonIcon = _this$props.backButtonIcon,
        goBack = _this$props.goBack,
        testEnvironment = _this$props.testEnvironment,
        navbarToggleableSize = _this$props.navbarToggleableSize;
    var selectedThemeKey = this.state.selectedThemeKey;
    var userNameInfo;

    if (authStatus && authStatus.auth) {
      userNameInfo = authStatus.fullname || authStatus.login;
    } else {
      userNameInfo = 'Nepřihlášen';
    }

    var useCollapseAddons = [].concat(collapseAddons);
    var themesAction;

    if (process.env.NODE_ENV !== "production") {
      themesAction = React__default.createElement("div", {
        className: "theme-changer"
      }, Object.keys(appThemes).map(function (themeKey, index) {
        var theme = appThemes[themeKey];
        return React__default.createElement("span", {
          key: index,
          className: themeKey === selectedThemeKey ? 'active' : '',
          onClick: function onClick() {
            return _this2.handleChangeTheme(themeKey);
          },
          style: {
            backgroundColor: theme.color
          }
        }, "\xA0");
      }));
    }

    useCollapseAddons.push(React__default.createElement(UncontrolledDropdown, {
      id: "user"
    }, React__default.createElement(DropdownToggle, {
      nav: true,
      className: "icon-text"
    }, React__default.createElement(NavIconText, {
      icon: React__default.createElement(FAIcon, {
        icon: authStatus && authStatus.auth ? 'user' : 'user-times'
      }),
      text: userNameInfo
    })), React__default.createElement(DropdownMenu, {
      right: true
    }, userMenuAddons, authStatus && authStatus.auth && React__default.createElement(DropdownItem, {
      onClick: onLogout
    }, "Odhl\xE1sit"), !(authStatus && authStatus.auth) && React__default.createElement(DropdownItem, {
      onClick: onLogin
    }, "P\u0159ihl\xE1sit"), themesAction)));
    var wrapperClassNames = classNames(className, 'app-wrapper', {
      'has-left-panel': hasLeftPanel,
      'has-right-panel': hasRightPanel,
      'left-panel-collapsed': leftPanelCollapsed,
      'right-panel-collapsed': rightPanelCollapsed
    });
    return React__default.createElement("div", {
      key: "base-app-wrapper",
      className: wrapperClassNames
    }, React__default.createElement("div", {
      key: "navbar",
      className: 'app-wrapper-navbar'
    }, React__default.createElement(AppNavbarWrapper$1, {
      key: "bar",
      onHistoryGoBack: onHistoryGoBack,
      appName: appName,
      appCode: appCode,
      detail: detail,
      homeLink: homeLink,
      backButtonIcon: backButtonIcon,
      goBack: goBack,
      goBackBase: goBackBase,
      collapseAddons: useCollapseAddons,
      centerAddons: centerAddons,
      testEnvironment: testEnvironment,
      navbarToggleableSize: navbarToggleableSize
    })), React__default.createElement("div", {
      key: "content",
      className: 'app-wrapper-content'
    }, children));
  };

  return BaseAppWrapper;
}(React__default.Component);

BaseAppWrapper.propTypes = {
  appCode: PropTypes__default.string,
  appName: /*#__PURE__*/PropTypes__default.oneOfType([// název aplikace, který se zobrazuje jako brand, mu6e se jednat i o název globální logické sekce, např. skprávní řízení apod.
  PropTypes__default.array, PropTypes__default.node]),
  detail: /*#__PURE__*/PropTypes__default.oneOfType([// detail informace aplikace, např. text detailu stránky, globální filtr stránky atp.
  PropTypes__default.array, PropTypes__default.node]),
  homeLink: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.string]),
  onHistoryGoBack: PropTypes__default.func.isRequired,
  // funkce pro zpracování posunu back, předpis: (goBackBase, homeLink) => {}
  centerAddons: /*#__PURE__*/PropTypes__default.oneOfType([// addony do prostřední oblasti navbaru, typicky fulltext hledání apod.
  PropTypes__default.array, PropTypes__default.node]),
  onLogout: PropTypes__default.func,
  // logout funkce
  onLogin: PropTypes__default.func,
  // login funkce
  collapseAddons: PropTypes__default.array,
  // pole dalších tlačítek, které se zobrazí vedle tlačítka pohled (nalevo), typicky pole NavItem
  userMenuAddons: PropTypes__default.array,
  // pole dalších tlačítek do menu pod uživatelem, typicky pole DropdownItem
  views: PropTypes__default.array,
  // seznam objektů { name: "", route: "/xxx" }, které představují jednotlivé pohledy v aplikaci
  currentView: PropTypes__default.string,
  // aktuálně přepnutý pohled - route
  backButtonIcon: PropTypes__default.bool,
  // má se místo loga aplikace zobrazit back button?
  goBack: PropTypes__default.bool,
  // pokud je true, je kliknutí na brand bráno jako back
  goBackBase: PropTypes__default.string,
  // základní url, která reprezentuje základ aktuálně zobrazované stránky - při stisku back se půjde na první, která namá prefix uvedený v goBackBase
  hasLeftPanel: PropTypes__default.bool,
  // aplikace má levý panel, jedná se o případný zasouvací panel
  hasRightPanel: PropTypes__default.bool,
  // aplikace má pravý panel, jedná se o případný zasouvací panel
  leftPanelCollapsed: PropTypes__default.bool,
  // pokud je true, je levý panel změnšen a není dokován
  authStatus: PropTypes__default.object,
  // informace o přihlášeném uživateli, předpis: {auth: bool, fullname: string, login: string}, pokud je null nebo je auth false, není přihlášen
  testEnvironment: PropTypes__default.bool,
  // pokud je true, jedná se o testovací prostředí
  navbarToggleableSize: PropTypes__default.string
};
BaseAppWrapper.defaultProps = {
  appName: 'Agendio',
  collapseAddons: [],
  userMenuAddons: [],
  backButtonIcon: false,
  views: [],
  currentView: '',
  goBack: false,
  hasLeftPanel: false,
  hasRightPanel: false,
  leftPanelCollapsed: false,
  rightPanelCollapsed: false,
  testEnvironment: false,
  navbarToggleableSize: 'sm'
};

/**
 * Komponenta pro vlastní obsah stránky, podporuje vložení hlavičky stránky, která je nad všemi sekcemi a není scrolovatelná.
 * Komponenta podporuje sekce: leftPanel, rightPanel, ty jsou předávány jako props a mohou být zabalovatelné.
 * Komponenta podporuje center panel, který je předáván jako children.
 */

var PageContent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageContent, _React$Component);

  function PageContent() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageContent.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        centerPanelClassName = _this$props.centerPanelClassName,
        leftPanelClassName = _this$props.leftPanelClassName,
        rightPanelClassName = _this$props.rightPanelClassName,
        fullWidth = _this$props.fullWidth,
        appContainer = _this$props.appContainer,
        className = _this$props.className,
        header = _this$props.header,
        fluid = _this$props.fluid,
        children = _this$props.children,
        leftPanel = _this$props.leftPanel,
        rightPanel = _this$props.rightPanel;
    var wrapperClassNames = classNames(className, 'page-content-wrapper', {
      'has-header': header ? true : false,
      'full-width': fullWidth
    });
    var contentClassNames = classNames('page-content-content');
    var headerClassNames = classNames('page-content-header');
    var rightPanelClassNames = classNames('page-content-right-panel', rightPanelClassName);
    var centerPanelClassNames = classNames('page-content-center-panel', centerPanelClassName);
    var leftPanelClassNames = classNames('page-content-left-panel', leftPanelClassName);
    return createElement("div", {
      className: wrapperClassNames
    }, header && createElement("div", {
      className: headerClassNames
    }, createElement("div", {
      className: appContainer ? fluid ? 'app-container-fluid' : 'app-container' : ''
    }, header)), createElement("div", {
      className: appContainer ? fluid ? 'page-content-container app-container-fluid' : 'page-content-container app-container' : 'page-content-container'
    }, createElement("div", {
      className: contentClassNames
    }, leftPanel && createElement("div", {
      className: leftPanelClassNames
    }, leftPanel), createElement("div", {
      className: centerPanelClassNames
    }, children), rightPanel && createElement("div", {
      className: rightPanelClassNames
    }, rightPanel))));
  };

  return PageContent;
}(Component);

PageContent.propTypes = {
  fluid: PropTypes__default.bool,
  // pokud je true, vytvoří se fluid container, jinak se vytvoří standardní kontainer, implicitně je false
  fullWidth: PropTypes__default.bool,
  // pokud je true, nejsou u jednotlivých sekcí žádné okraje, stejně tak má při fullWidth pozadí pro umisťování kartiček
  header: /*#__PURE__*/PropTypes__default.oneOfType([// pokud je uvedeno, obsahuje hlavičku stránky, ta je nescrolovatelná
  PropTypes__default.array, PropTypes__default.node]),
  leftPanel: /*#__PURE__*/PropTypes__default.oneOfType([// pokud je uvedeno, obsahuje obsah levého panelu, pokud není uvedeno, levý panel se vůbec nezobrazí
  PropTypes__default.array, PropTypes__default.node]),
  rightPanel: /*#__PURE__*/PropTypes__default.oneOfType([// pokud je uvedeno, obsahuje obsah pravého panelu, pokud není uvedeno, pravý panel se vůbec nezobrazí
  PropTypes__default.array, PropTypes__default.node]),
  rightPanelClassName: PropTypes__default.string,
  // class name pro pravý panel
  leftPanelClassName: PropTypes__default.string,
  // class name pro levý panel
  centerPanelClassName: PropTypes__default.string,
  // class name pro prostřední panel
  appContainer: PropTypes__default.bool
};
PageContent.defaultProps = {
  fluid: false,
  appContainer: true
};

/**
 * Komponenta pro vlastní obsah stránky.
 * Komponenta podporuje sekce: leftPanel, rightPanel, které jsou předávány přes props, levý a pravý může být typu zasouvací.
 * Komponenta podporuje center panel, který je předáván jako children.
 */

var PageWrapper = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(PageWrapper, _React$Component);

  function PageWrapper() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageWrapper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        leftPanel = _this$props.leftPanel,
        rightPanel = _this$props.rightPanel;
    var wrapperClassNames = classNames(className, 'page-wrapper', {
      'has-left-panel': leftPanel ? true : false,
      'has-right-panel': rightPanel ? true : false
    });
    return React__default.createElement("div", {
      className: wrapperClassNames
    }, leftPanel && React__default.createElement("div", {
      className: "page-wrapper-left-panel"
    }, leftPanel), React__default.createElement("div", {
      className: 'page-wrapper-center-panel'
    }, children), rightPanel && React__default.createElement("div", {
      className: "page-wrapper-right-panel"
    }, rightPanel));
  };

  return PageWrapper;
}(React__default.Component);

PageWrapper.propTypes = {
  leftPanel: /*#__PURE__*/PropTypes__default.oneOfType([// pokud je uvedeno, obsahuje obsah levého panelu, pokud není uvedeno, levý panel se vůbec nezobrazí
  PropTypes__default.array, PropTypes__default.node]),
  rightPanel: /*#__PURE__*/PropTypes__default.oneOfType([// pokud je uvedeno, obsahuje obsah pravého panelu, pokud není uvedeno, pravý panel se vůbec nezobrazí
  PropTypes__default.array, PropTypes__default.node])
};
PageWrapper.defaultProps = {};



var index$c = {
  __proto__: null,
  AppNavbarWrapper: AppNavbarWrapper$1,
  BaseAppWrapper: BaseAppWrapper,
  PageContent: PageContent,
  PageWrapper: PageWrapper
};

/**
 * Zachováno pouze pro zpětnou kompatilitu.
 * Nově se používá přímo artefakt @mc/react-mapio.
 */
var _LegacyMapioApi$state = LegacyMapioApi.stateful,
    FeatureEditor = _LegacyMapioApi$state.FeatureEditor,
    FeatureEditorActions = _LegacyMapioApi$state.FeatureEditorActions,
    FeatureEditorReducer = _LegacyMapioApi$state.FeatureEditorReducer,
    Map$1 = _LegacyMapioApi$state.Map,
    MapActions = _LegacyMapioApi$state.MapActions,
    MapReducer = _LegacyMapioApi$state.MapReducer;

/**
 * Zachováno pouze pro zpětnou kompatilitu.
 * Nově se používá přímo artefakt @mc/react-mapio.
 */
var _LegacyMapioApi$base = LegacyMapioApi.base,
    FeatureEditor$1 = _LegacyMapioApi$base.FeatureEditor,
    FeatureEditorActions$1 = _LegacyMapioApi$base.FeatureEditorActions,
    FeatureEditorReducer$1 = _LegacyMapioApi$base.FeatureEditorReducer,
    Map$2 = _LegacyMapioApi$base.Map,
    MapActions$1 = _LegacyMapioApi$base.MapActions,
    MapReducer$1 = _LegacyMapioApi$base.MapReducer;

function Deprecated$1() {
  throw new Error('Use @mc/react-mapio');
}

var addFeatureProperties = Deprecated$1;
var removeFeatureProperties = Deprecated$1;

var index$d = {
  __proto__: null,
  BaseMap: Map$2,
  BaseMapActions: MapActions$1,
  BaseMapReducer: MapReducer$1,
  BaseFeatureEditor: FeatureEditor$1,
  BaseFeatureEditorActions: FeatureEditorActions$1,
  BaseFeatureEditorReducer: FeatureEditorReducer$1,
  Map: Map$1,
  MapReducer: MapReducer,
  MapActions: MapActions,
  FeatureEditor: FeatureEditor,
  FeatureEditorReducer: FeatureEditorReducer,
  FeatureEditorActions: FeatureEditorActions,
  addFeatureProperties: addFeatureProperties,
  removeFeatureProperties: removeFeatureProperties
};



var index$e = {
  __proto__: null,
  NavIconText: NavIconText
};

var COLLAPSED = 'COLLAPSED';
var EXPANDED = 'EXPANDED';
var EXPANDED_POPUP = 'EXPANDED_POPUP'; // Position

var LEFT = 'left';
var RIGHT = 'right';
var CLASS_NAME = 'collapsible-side-panel';

var CollapsibleSidePanel = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(CollapsibleSidePanel, _React$Component);

  function CollapsibleSidePanel(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.handleToggleCollapse = function () {
      var _this$props = _this.props,
          onCollapseChange = _this$props.onCollapseChange,
          collapsed = _this$props.collapsed;
      onCollapseChange(!collapsed);
    };

    _this.handleShowPopup = function () {
      var showDelay = _this.props.showDelay; // Hide timer

      if (_this.hideTimer) {
        clearTimeout(_this.hideTimer);
        _this.hideTimer = null;
      } // Show


      if (_this.showTimer) {
        clearTimeout(_this.showTimer);
      }

      _this.showTimer = setTimeout(function () {
        _this.setState(_extends({}, _this.state, {
          popupVisible: true
        }));
      }, showDelay);
    };

    _this.handleHidePopup = function () {
      var hideDelay = _this.props.hideDelay; // Show timer

      if (_this.showTimer) {
        clearTimeout(_this.showTimer);
        _this.showTimer = null;
      } // Hide


      if (_this.hideTimer) {
        clearTimeout(_this.hideTimer);
      }

      _this.hideTimer = setTimeout(function () {
        _this.setState(_extends({}, _this.state, {
          popupVisible: false
        }));
      }, hideDelay);
    };

    _this.state = {
      popupVisible: false
    };
    _this.showTimer = null;
    _this.hideTimer = null;
    return _this;
  }

  var _proto = CollapsibleSidePanel.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(props) {
    if (!props.collapsed && this.state.popupVisible) {
      this.setState(_extends({}, this.state, {
        popupVisible: false
      }));
    }
  };

  _proto.render = function render() {
    if (this.props.collapsed) {
      return this.renderWithMode(COLLAPSED);
    }

    return this.renderWithMode(EXPANDED);
  };

  _proto.renderWithMode = function renderWithMode(renderMode) {
    var popupVisible = this.state.popupVisible;

    var _this$props2 = this.props,
        position = _this$props2.position,
        content = _this$props2.content,
        className = _this$props2.className,
        otherProps = _objectWithoutPropertiesLoose(_this$props2, ["position", "onCollapseChange", "content", "className", "hideDelay", "showDelay", "collapsed"]);

    var collapsed = renderMode === COLLAPSED;
    var popup = renderMode === EXPANDED_POPUP;
    var header = null;

    if (!collapsed) {
      var arrowOrientation = popup ? position === LEFT ? RIGHT : LEFT : position;
      header = React__default.createElement("div", {
        className: CLASS_NAME + "-header"
      }, React__default.createElement(Button, {
        color: "link",
        onClick: this.handleToggleCollapse
      }, !popup && 'Miminalizovat panel ', React__default.createElement(FAIcon, {
        icon: "arrow-" + arrowOrientation
      }), popup && ' Připnout panel'));
    }

    return React__default.createElement("div", Object.assign({
      className: classNames(CLASS_NAME, className, position, {
        collapsed: collapsed,
        popup: popup
      }),
      onMouseEnter: collapsed ? this.handleShowPopup : undefined,
      onMouseLeave: this.handleHidePopup
    }, otherProps), header, React__default.createElement("div", {
      className: CLASS_NAME + "-content"
    }, content(collapsed)), collapsed && popupVisible && this.renderWithMode(EXPANDED_POPUP));
  };

  return CollapsibleSidePanel;
}(React__default.Component);

CollapsibleSidePanel.Position = {
  LEFT: LEFT,
  RIGHT: RIGHT
};
CollapsibleSidePanel.propTypes = {
  position: /*#__PURE__*/PropTypes__default.oneOf([LEFT, RIGHT]).isRequired,
  collapsed: PropTypes__default.bool.isRequired,
  onCollapseChange: PropTypes__default.func.isRequired,
  content: PropTypes__default.func.isRequired,
  showDelay: PropTypes__default.number,
  // doba před zobrazením po najetí myši
  hideDelay: PropTypes__default.number
};
CollapsibleSidePanel.defaultProps = {
  position: LEFT,
  collapsed: true,
  onCollapseChange: function onCollapseChange() {},
  content: function content() {
    return null;
  },
  showDelay: 300,
  hideDelay: 300
};



var index$f = {
  __proto__: null,
  CollapsibleSidePanel: CollapsibleSidePanel
};

var initialState$a = {
  reducer: areaGroupReducer
};
var __AGR_INIT = '___AGR_INIT';
function areaGroupReducer(state, action) {
  if (action === void 0) {
    action = {
      type: __AGR_INIT
    };
  }

  if (action.area) {
    return processAreaStores(state, action);
  }

  switch (action.type) {
    case __AGR_INIT:
      {
        return _extends({}, initialState$a, state);
      }

    default:
      return state;
  }
}



var index$g = {
  __proto__: null,
  SharedActions: SharedActions,
  AreaGroupReducer: areaGroupReducer,
  SharedReducer: shared
};

/**
 * Kontakty pro použití ve formulářích subjektu.
 */
var AREA_ZR = 'AREA_ZR';
var AREA_ARES = 'AREA_ARES';
var AREA_ZR_ARES = 'AREA_ZR_ARES';

var SubjektFormConst = {
  __proto__: null,
  AREA_ZR: AREA_ZR,
  AREA_ARES: AREA_ARES,
  AREA_ZR_ARES: AREA_ZR_ARES
};

/**
 * Načtení titulku dialogu pro editační formulář.
 * @param subjektAddFormTitle prefix dialogu, např. "Zástupce" nebo null
 * @param typSubjektu typ subjektu
 * @param sharedSubjekt true, pokud se upravuje centrální subjekt v shared
 * @return {*} editační text, např. "Zástupce - Upravit fyzickou osobu"
 */

function getEditDialogTitle(subjektAddFormTitle, typSubjektu, sharedSubjekt) {
  var caption;

  switch (typSubjektu) {
    case FO:
      caption = 'Upravit fyzickou osobu';
      break;

    case PO:
      caption = 'Upravit právnickou osobu';
      break;

    case FOP:
      caption = 'Upravit podnikající fyzickou osobu';
      break;

    case NO:
      caption = 'Upravit neznámou osobu';
      break;
  }

  if (subjektAddFormTitle) {
    caption = subjektAddFormTitle + ' - ' + caption;
  }

  if (sharedSubjekt) {
    caption += ' (číselník subjektů)';
  }

  return caption;
}
/**
 * Otestuje, zda je nějak vyplněna odpovědná osoba - pro uložení.
 * @param odpovednaOsoba true, pokud je na ní alespoň něco vyplněno
 */

function checkOdpovednaOsobaFilled(odpovednaOsoba) {
  if (odpovednaOsoba.jmeno || odpovednaOsoba.prijmeni || odpovednaOsoba.email && odpovednaOsoba.email.kontakt || odpovednaOsoba.telefon && odpovednaOsoba.telefon.kontakt) {
    // něco je vyplněno na uložení
    return true;
  } else {
    // odpovědnou osobu nechceme
    return false;
  }
}
function getSubjektClass(typSubjektu) {
  switch (typSubjektu) {
    case FO:
      return 'FyzickaOsobaVO';

    case PO:
      return 'PravnickaOsobaVO';

    case FOP:
      return 'FyzickaOsobaPodVO';

    case NO:
      return 'NeznamaOsobaVO';
  }

  return null;
}
function doplnTriduSubjektu(typSubjektu, subjekt) {
  var subjektData;

  switch (typSubjektu.toLowerCase()) {
    case 'fo':
      subjektData = _extends({}, subjekt, {
        '@class': 'FyzickaOsobaVO'
      });
      break;

    case 'fop':
      subjektData = _extends({}, subjekt, {
        '@class': 'FyzickaOsobaPodVO'
      });
      break;

    case 'po':
      subjektData = _extends({}, subjekt, {
        '@class': 'PravnickaOsobaVO'
      });
      break;

    case 'no':
      subjektData = _extends({}, subjekt, {
        '@class': 'NeznamaOsobaVO'
      });
      break;

    default:
      showInfo('Nepodporovaný typ osoby', 'Nepodporovaný typ osoby');
      return;
  }

  return subjektData;
}
/**
 * Vrátí datum narození z rodného čísla.
 * @param rc
 * @returns {*}
 */

function getDatumNarozeniFromRC(rc) {
  if (!rc) {
    return null;
  }

  var rok = Number(rc.substring(0, 2));

  if (rc.length === 10 && rok < 54) {
    rok += 2000;
  } else if (rc.length === 9 && rok >= 54) {
    rok += 1800;
  } else {
    rok += 1900;
  }

  var mesicAPohlavi = Number(rc.substring(2, 4));
  var mesic = mesicAPohlavi % 50;

  if (mesic > 12) {
    mesic -= 20;
  }

  var den = Number(rc.substring(4, 6));
  return new Date(rok, mesic - 1, den);
}
/**
 * Zjistí, zda lze subjekt aktualizovat ze ZR - tedy zda má vazbu na zr a je ve stavu, kdy je možné volat aktualizaci (např. není ve stavu pozastaven, neztotožněn  apod.)
 * @param subjekt subjekt
 * @return true, pokud lze aktualizovat - lze volat aktualizaci na serveru
 */

function lzeAktualizovatZeZr(subjekt) {
  if (subjekt.vazbaZr && subjekt.stavZr) {
    switch (subjekt.stavZr.stavZtotozneni) {
      case ZTOTOZNEN:
      case CHYBA:
        return true;
    }
  }

  return false;
}
/**
 * Načtení informací o úmrtí nebo zániku subjektu
 * @param subjekt subjekt
 * @return {{dead: boolean, title: *}}
 */

function getDeadInfo(subjekt) {
  var title;
  var dead = false;

  if (subjekt.typSubjektu === FO && subjekt.datumUmrti != null) {
    dead = true;
    var misto = subjekt.mistoUmrti ? " v m\xEDst\u011B " + subjekt.mistoUmrti : '';
    title = "Datum \xFAmrt\xED dne " + dateToDateString(localUTCToDate(subjekt.datumUmrti)) + misto;
  } else if ((subjekt.typSubjektu === PO || subjekt.typSubjektu === FOP) && subjekt.datumZanik != null) {
    dead = true;
    title = "Datum z\xE1niku dne " + dateToDateString(localUTCToDate(subjekt.datumZanik));
  }

  return {
    dead: dead,
    title: title
  };
}

var SubjektTools = {
  __proto__: null,
  getEditDialogTitle: getEditDialogTitle,
  checkOdpovednaOsobaFilled: checkOdpovednaOsobaFilled,
  getSubjektClass: getSubjektClass,
  doplnTriduSubjektu: doplnTriduSubjektu,
  getDatumNarozeniFromRC: getDatumNarozeniFromRC,
  lzeAktualizovatZeZr: lzeAktualizovatZeZr,
  getDeadInfo: getDeadInfo
};

var _labels;
var labels = (_labels = {}, _labels[ID$1] = 'Občanský průkaz', _labels[P] = 'Cestovní doklad', _labels[OSTATNI] = 'Ostatní', _labels[IR] = 'Povolení k pobytu', _labels[VS] = 'Vízový štítek', _labels[PS] = 'Pobytový štítek', _labels[RP] = 'Řidičský průkaz', _labels);
function label(typ) {
  return labels[typ];
}

var TypDokladuInfo = {
  __proto__: null,
  label: label
};

/**
 * Základní formátování názvu subjektu, BEZ adresy, a BEZ dalších údajů jako např. IČO apod.
 * @param subjekt objekt subjektu
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka" nebo "Obec Testovací" apod.
 */

function getNazev$1(subjekt) {
  var result = null;

  switch (subjekt.typSubjektu) {
    case FO:
      {
        var parts = [];
        subjekt.titulPred && parts.push(subjekt.titulPred);
        subjekt.jmeno && parts.push(subjekt.jmeno);
        subjekt.prijmeni && parts.push(subjekt.prijmeni);
        subjekt.titulZa && parts.push(subjekt.titulZa);
        result = parts.join(' ');
      }
      break;

    case FOP:
      if (subjekt.nazev) {
        result = subjekt.nazev;
      } else {
        if (subjekt.fyzickaOsoba) {
          var _parts = [];
          subjekt.fyzickaOsoba.titulPred && _parts.push(subjekt.fyzickaOsoba.titulPred);
          subjekt.fyzickaOsoba.jmeno && _parts.push(subjekt.fyzickaOsoba.jmeno);
          subjekt.fyzickaOsoba.prijmeni && _parts.push(subjekt.fyzickaOsoba.prijmeni);
          subjekt.fyzickaOsoba.titulZa && _parts.push(subjekt.fyzickaOsoba.titulZa);
          result = _parts.join(' ');

          if (subjekt.ico) {
            var dopln = subjekt.ico ? ", (" + subjekt.ico + ")" : '';
            result += dopln;
          }
        } else {
          result = '-';
        }
      }

      break;

    case PO:
      result = subjekt.nazev;
      break;

    case NO:
      result = subjekt.nazev;
      break;
  }

  return result;
}
/**
 * Úplný název subjektu BEZ adresy.
 * @param subjekt subjekt
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka csc, RČ: 8555191873" nebo "Obec Testovací, IČO: 00234897" apod.
 */

function getUplnyNazev(subjekt) {
  var nazev = getNazev$1(subjekt);

  switch (subjekt.typSubjektu) {
    case FO:
      {
        var dopln = '';

        if (subjekt.rc) {
          dopln = ", R\u010C: " + subjekt.rc;
        } else if (subjekt.datumNarozeni) {
          dopln = ', nar.: ' + formatDate(localUTCToDate(subjekt.datumNarozeni));
        }

        return nazev + dopln;
      }

    case FOP:
      {
        var _dopln = '';

        if (subjekt.ico) {
          _dopln = ", I\u010CO: " + subjekt.ico;
        }

        return nazev + _dopln;
      }

    case PO:
      {
        var _dopln2 = '';
        var doplnUtvar = '';

        if (subjekt.utvar) {
          doplnUtvar = ", " + subjekt.utvar;
        }

        if (subjekt.ico) {
          _dopln2 = ", I\u010CO: " + subjekt.ico;
        }

        return nazev + doplnUtvar + _dopln2;
      }

    case NO:
      return nazev;

    default:
      throw new Error('Neznámý typ Subjektu');
  }
}
/**
 * Formátování adresy pro subjekt.
 * @param adresa adresa
 * @returns {*}
 */

function getAdresa(adresa) {
  return adresa.popis; // zatím takto, nemáme adresa formatter
}
/**
 * Úplná indentifikace subjektu včetně adresy. Pro formát adresy je použito pole popis u adresy.
 * @param subjekt subjekt
 * @return naformátový řetězec popisu subjektu, např. "ing. jan metelka csc, RČ: 8555191873, Brojova 1909/1, Plzeň, 326 00 Plzeň 26" nebo "Obec Testovací, IČO: 00234897, Brojova 1909/1, Plzeň, 326 00 Plzeň 26" apod.
 */

function getUplnaIdentifikace(subjekt) {
  var uplnyNazev = getUplnyNazev(subjekt);

  if (subjekt.adresaTrv) {
    return uplnyNazev + ', ' + getAdresa(subjekt.adresaTrv);
  } else {
    return uplnyNazev;
  }
}

var subjektFormatter = {
  __proto__: null,
  getNazev: getNazev$1,
  getUplnyNazev: getUplnyNazev,
  getAdresa: getAdresa,
  getUplnaIdentifikace: getUplnaIdentifikace
};

/**
 * Render subjektu.
 */

var SubjektRowDetail = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubjektRowDetail, _Component);

  function SubjektRowDetail() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SubjektRowDetail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        subjekt = _this$props.subjekt,
        bezAdresy = _this$props.bezAdresy;
    return React__default.createElement("div", null, React__default.createElement("div", {
      className: "subjekt-name"
    }, getUplnyNazev(subjekt)), !bezAdresy && subjekt.adresaTrv && React__default.createElement("div", null, React__default.createElement("small", null, subjekt.adresaTrv.popis)));
  };

  return SubjektRowDetail;
}(Component);
SubjektRowDetail.propTypes = {
  subjekt: PropTypes__default.object.isRequired,
  // subjekt
  bezAdresy: PropTypes__default.bool
};
SubjektRowDetail.defaultProps = {
  bezAdresy: false
};

/**
 * Kompoennta pro zobrazení subjektu, který je zobrazen v řádku např. jako seznam.
 * Výpis subjektu je 2/3 řádkový.
 * 1. řádek - Plný název, např. i včetně IČ, BEZ adresy, např. "ing. jan metelka csc, RČ: 8555191873" nebo "Obec Testovací, IČO: 00234897" apod.
 * 2. řádek - Adresa
 * 3, řádek - zástupce, pokud je předaný
 */

var RubjektRow = /*#__PURE__*/function (_Component) {
  _inheritsLoose(RubjektRow, _Component);

  function RubjektRow() {
    var _this;

    _this = _Component.apply(this, arguments) || this;
    /**
     * Renderování ikony ověření subjektu vůči ZR.
     * @param dead true, pokud je zemřelý nebo zaniklý
     * @return {XML}
     */

    _this.renderIcon = function (dead) {
      var subjekt = _this.props.subjekt; // TODO [stanekpa] - přepsat shared stavy a upravit i toto

      var icon;
      var cls;
      var title;

      if (dead) {
        icon = 'user-times';
      } else {
        if (subjekt.vazbaZr && subjekt.stavZr) {
          switch (subjekt.stavZr.stavZtotozneni) {
            case ZTOTOZNEN:
              icon = 'check';
              title = 'Ztotožněn vůči základním registrům';

              if (subjekt.stavZr.zpochybneneUdaje) {
                cls = 'text-warning';
                title += ' (zpochybněné údaje: ' + subjekt.stavZr.zpochybneneUdaje + ')';
              }

              break;

            case NEZTOTOZNEN:
              icon = 'exclamation-triangle';
              title = 'Neztotožněn vůči základním registrům';

              if (subjekt.stavZr.duvodNeztotozneni) {
                title += ' (' + subjekt.stavZr.duvodNeztotozneni + ')';
              }

              break;

            case POZASTAVEN:
              icon = 'pause';
              title = 'Pozastaveno vůči základním registrům';
              break;

            case CHYBA:
              icon = 'remove';
              title = 'Chyba při ztotožnění vůči základním registrům';
              break;
          }
        } else {
          icon = 'minus';
          title = 'Subjekt je bez vazby na ZR';
        }
      }

      return React__default.createElement(FAIcon, {
        className: cls,
        icon: icon,
        title: title
      });
    };

    return _this;
  }

  var _proto = RubjektRow.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        zastupceLabel = _this$props.zastupceLabel,
        showZRIcon = _this$props.showZRIcon,
        className = _this$props.className,
        subjekt = _this$props.subjekt,
        zastupce = _this$props.zastupce,
        renderZastupce = _this$props.renderZastupce,
        bezAdresy = _this$props.bezAdresy,
        subjektRenderComponent = _this$props.subjektRenderComponent;
    var zastupceComp;

    if (zastupce) {
      zastupceComp = React__default.createElement("div", null, React__default.createElement("small", null, "(", zastupceLabel, ":", ' ', renderZastupce(zastupce, getUplnyNazev(zastupce)), ")"));
    } // Úmrtí nebo ukončení subjektu


    var _SubjektTools$getDead = getDeadInfo(subjekt),
        title = _SubjektTools$getDead.title,
        dead = _SubjektTools$getDead.dead;

    var cls = classNames(className, 'subjekt-row-container', {
      dead: dead
    });
    var sbjRender = createElement(subjektRenderComponent, {
      subjekt: subjekt,
      bezAdresy: bezAdresy
    });

    if (showZRIcon) {
      return React__default.createElement(DetailLeftIcon, {
        title: title,
        className: cls,
        icon: this.renderIcon(dead)
      }, sbjRender, zastupceComp);
    } else {
      return React__default.createElement("div", {
        title: title,
        className: cls
      }, React__default.createElement("div", {
        className: "subjekt-row-subjekt"
      }, sbjRender, zastupceComp), children && React__default.createElement("div", {
        className: "subjekt-row-additional-info"
      }, children));
    }
  };

  return RubjektRow;
}(Component);
RubjektRow.propTypes = {
  subjekt: PropTypes__default.object.isRequired,
  // subjekt
  subjektRenderComponent: /*#__PURE__*/PropTypes__default.oneOfType([// renderovací komponenta pro subjekt
  PropTypes__default.func, PropTypes__default.string]),
  zastupce: PropTypes__default.object,
  // zástupce, pokud jej chceme zobrazovat, bere se tento zástupce, NEBERE se zástupce přímo z objektu subjekt
  renderZastupce: PropTypes__default.func,
  // pokud je uvedeno, renderuje zástupce, předpis (zastupce, label) => {}, kde label je text, který je doporučený pro zobrazení zástupce a zastupce je vlastní objekt zástupce
  showZRIcon: PropTypes__default.bool,
  // pokud je true, zobrazuje se u subjektu ikona s informací o stavu vůči ZR, standardně false
  zastupceLabel: PropTypes__default.string,
  // text který je uveden před zástupcem, implicitně "zástupce"
  bezAdresy: PropTypes__default.bool
};
RubjektRow.defaultProps = {
  renderZastupce: function renderZastupce(zastupce, label) {
    var _SubjektTools$getDead2 = getDeadInfo(zastupce),
        title = _SubjektTools$getDead2.title,
        dead = _SubjektTools$getDead2.dead;

    return React__default.createElement("span", {
      className: dead ? 'zastupce dead' : 'zastupce',
      title: title
    }, React__default.createElement("span", {
      className: "subjekt-name"
    }, label));
  },
  subjektRenderComponent: SubjektRowDetail,
  showZRIcon: false,
  zastupceLabel: 'zástupce',
  bezAdresy: false
};

/**
 * FormuLář vybrání jednoho subjektu z více, které byly na základě vyhledávání vráceny ze ZR.
 */

var SubjektAddSelectRegForm = function SubjektAddSelectRegForm(props) {
  var subjekt = props.subjekt,
      onClose = props.onClose,
      handleSubmit = props.handleSubmit,
      overeniResultList = props.overeniResultList;
  return React__default.createElement(CustomForm, {
    onSubmit: handleSubmit,
    horizontal: true
  }, React__default.createElement(FormBody, null, React__default.createElement(toExport.ListSelect, {
    name: "subjekt",
    field: false,
    idAttrName: "overeniId",
    renderItem: function renderItem(x) {
      return React__default.createElement(RubjektRow, {
        subjekt: x.subjekt,
        zastupce: x.subjekt.zastupce
      });
    },
    items: overeniResultList
  })), React__default.createElement(FormActions, {
    submitButton: "Vybrat",
    cancelButton: true,
    submitDisabled: !subjekt,
    onClose: onClose
  }));
};

SubjektAddSelectRegForm.formName = 'subjektAddSelectRegForm';
SubjektAddSelectRegForm.propTypes = {//overeniResultList
};
SubjektAddSelectRegForm.defaultProps = {};
var reduxSubjektForm = /*#__PURE__*/reduxForm({
  form: SubjektAddSelectRegForm.formName
})(SubjektAddSelectRegForm);

function mapStateToProps$8(state, props) {
  var selector = formValueSelector(SubjektAddSelectRegForm.formName);
  return {
    subjekt: selector(state, 'subjekt')
  };
}

var SubjektAddSelectRegForm$1 = /*#__PURE__*/connect(mapStateToProps$8)(reduxSubjektForm);

/**
 * Komponenta zobrazující informace o datových schránkách pro subjekt, který má pouze id ověření.
 */

var SubjektOvereniDsInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubjektOvereniDsInfo, _Component);

  function SubjektOvereniDsInfo(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.fetchDs = function (props) {
      var overeniId = props.overeniId;
      KontaktOvereniApi.getSubjektKontakty(overeniId, [DS]).then(function (list) {
        if (!_this.componentIsUnmounting) {
          _this.setState({
            dsList: list
          });
        }
      });
    };

    _this.state = {
      dsList: null
    };
    _this.componentIsUnmounting = false;
    return _this;
  }

  var _proto = SubjektOvereniDsInfo.prototype;

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.componentIsUnmounting = true;
  };

  _proto.componentDidMount = function componentDidMount() {
    this.fetchDs(this.props);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.overeniId !== nextProps.overeniId) {
      this.fetchDs(nextProps);
    }
  };

  _proto.render = function render() {
    var dsList = this.state.dsList;

    if (dsList === null) {
      return React__default.createElement(Loader, null);
    } else {
      return React__default.createElement("span", null, dsList.length > 0 ? dsList.map(function (ds) {
        return ds.kontakt;
      }).join(', ') : '-');
    }
  };

  return SubjektOvereniDsInfo;
}(Component);

var OVERENI_ID_NONE = -23675;
/**
 * Komponenta pro zobrazení informace o dohledání (ověření) subjektu vůči registrům.
 */

var SubjektOvereniInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubjektOvereniInfo, _Component);

  function SubjektOvereniInfo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SubjektOvereniInfo.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        vazbaZr = _this$props.vazbaZr,
        roleConf = _this$props.roleConf,
        overeniIdInt = _this$props.overeniIdInt;
    var overeniInfo = [];
    var color;

    if (vazbaZr || roleConf.ares) {
      if (overeniIdInt != null) {
        if (overeniIdInt === OVERENI_ID_NONE) {
          // pokus o dohledání, ale nebyl dohledán - je neztotožněn
          color = 'warning';
          overeniInfo.push(React__default.createElement("div", null, React__default.createElement(Icon, {
            icon: "exclamation-triangle"
          }), ' ', roleConf.ares ? 'Neztotožněn' : 'Neztotožněn vůči základním registrům'));
        } else {
          color = 'success';
          overeniInfo.push(React__default.createElement("div", null, React__default.createElement(Icon, {
            icon: "check"
          }), ' ', roleConf.zr ? 'Ověřen v základních registrech' : 'Dohledán v ARES'));
        }
      } else {
        color = 'danger';

        if (roleConf.zr) {
          overeniInfo.push(React__default.createElement("div", null, React__default.createElement(Icon, {
            icon: "remove"
          }), " Neov\u011B\u0159en v z\xE1kladn\xEDch registrech"));
        }
      }
    } else {
      color = 'info';

      if (roleConf.zr) {
        overeniInfo.push(React__default.createElement("div", null, React__default.createElement(Icon, {
          icon: "chain"
        }), " Bez vazby na z\xE1kladn\xED registry"));
      }
    }

    if (overeniInfo.length > 0) {
      return React__default.createElement(Alert, {
        className: className,
        color: color
      }, overeniInfo);
    } else {
      return React__default.createElement("span", null);
    }
  };

  return SubjektOvereniInfo;
}(Component);
SubjektOvereniInfo.propTypes = {
  subjekt: PropTypes__default.object.isRequired
};

/**
 * Komponenta pro zobrazení stavu subjektu vůči ZR.
 */

var SubjektStavZr = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubjektStavZr, _Component);

  function SubjektStavZr() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SubjektStavZr.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        subjekt = _this$props.subjekt;
    var color;
    var icon;
    var infos = [];
    var title;

    if (subjekt.vazbaZr && subjekt.stavZr) {
      switch (subjekt.stavZr.stavZtotozneni) {
        case ZTOTOZNEN:
          icon = 'check';
          title = 'Ztotožněn vůči základním registrům';
          color = 'success';
          break;

        case NEZTOTOZNEN:
          icon = 'exclamation-triangle';
          title = 'Neztotožněn vůči základním registrům';
          color = 'warning';

          if (subjekt.stavZr.duvodNeztotozneni) {
            infos.push(React__default.createElement(FieldGrid, {
              label: "D\u016Fvod neztoto\u017En\u011Bn\xED"
            }, subjekt.stavZr.duvodNeztotozneni));
          }

          break;

        case POZASTAVEN:
          icon = 'pause';
          title = 'Pozastaveno vůči základním registrům';
          color = 'info';
          break;

        case CHYBA:
          icon = 'remove';
          title = 'Chyba při ztotožnění vůči základním registrům';
          color = 'error';
          break;
      } // Důvod neztotožnění


      switch (subjekt.stavZr.stavZtotozneni) {
        case ZTOTOZNEN:
        case POZASTAVEN:
        case CHYBA:
          if (subjekt.stavZr.zpochybneneUdaje) {
            color = 'warning';
            infos.push(React__default.createElement(FieldGrid, {
              label: "Zpochybn\u011Bn\xE9 \xFAdaje"
            }, subjekt.stavZr.zpochybneneUdaje));
          }

          break;
      } // Notifikace


      if (subjekt.stavZr.notifikaceOd && subjekt.stavZr.notifikaceDo) {
        infos.push(React__default.createElement(FieldGrid, {
          label: "Notifikace"
        }, dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceOd)), ' ', "-", ' ', dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceDo))));
      } else {
        if (subjekt.stavZr.notifikaceOd) {
          infos.push(React__default.createElement(FieldGrid, {
            label: "Notifikace od"
          }, dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceOd))));
        }

        if (subjekt.stavZr.notifikaceDo) {
          infos.push(React__default.createElement(FieldGrid, {
            label: "Notifikace od"
          }, dateToDateTimeString(localUTCToDate(subjekt.stavZr.notifikaceDo))));
        }
      } // Datum aktualizace a posledního ověření změny


      if (subjekt.stavZr.stavZtotozneni !== NEZTOTOZNEN) {
        var posleniOvereniZmeny = localUTCToDate(subjekt.stavZr.posleniOvereniZmeny);
        var posleniAktualizace = localUTCToDate(subjekt.stavZr.posleniAktualizace);

        if (+posleniOvereniZmeny === +posleniAktualizace) {
          // stejné datumy, zobrazíme jen jeden text
          infos.push(React__default.createElement(FieldGrid, {
            label: "Ov\u011B\u0159en v z\xE1kladn\xEDch registrech"
          }, dateToDateTimeString(posleniOvereniZmeny)));
        } else {
          // zobrazíme oba a s jiným textem
          infos.push(React__default.createElement(FieldGrid, {
            label: "Posledn\xED aktualizace ze z\xE1kladn\xEDch registr\u016F"
          }, dateToDateTimeString(posleniAktualizace)));
          infos.push(React__default.createElement(FieldGrid, {
            label: "Posledn\xED ov\u011B\u0159en\xED zm\u011Bny"
          }, dateToDateTimeString(posleniOvereniZmeny)));
        }
      }
    } else {
      icon = 'minus';
      title = 'Subjekt je bez vazby na ZR';
      color = 'info';
    }

    return React__default.createElement("div", {
      className: className
    }, React__default.createElement(Alert, {
      className: infos.length > 0 ? 'mb-2' : '',
      color: color
    }, React__default.createElement(DetailLeftIcon, {
      icon: React__default.createElement(FAIcon, {
        icon: icon
      })
    }, title)), infos);
  };

  return SubjektStavZr;
}(Component);
SubjektStavZr.propTypes = {
  subjekt: PropTypes__default.object.isRequired
};

/**
 * Komponenta pro zobrazení informace o úmrtí nebo zániku subjektu.
 */

var SubjektUmrtiInfo = /*#__PURE__*/function (_Component) {
  _inheritsLoose(SubjektUmrtiInfo, _Component);

  function SubjektUmrtiInfo() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = SubjektUmrtiInfo.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        subjekt = _this$props.subjekt;

    if (!subjekt) {
      return React__default.createElement("span", null);
    }

    var deadInfo = getDeadInfo(subjekt);

    if (deadInfo.dead) {
      return React__default.createElement(Alert, {
        className: className,
        color: "warning"
      }, React__default.createElement(DetailLeftIcon, {
        icon: React__default.createElement(FAIcon, {
          icon: "user-times"
        })
      }, deadInfo.title));
    } else {
      return React__default.createElement("span", null);
    }
  };

  return SubjektUmrtiInfo;
}(Component);
SubjektUmrtiInfo.propTypes = {
  subjekt: PropTypes__default.object
};



var index$h = {
  __proto__: null,
  SubjektFormConst: SubjektFormConst,
  SubjektTools: SubjektTools,
  TypDokladuInfo: TypDokladuInfo,
  SubjektAddSelectRegForm: SubjektAddSelectRegForm$1,
  SubjektOvereniDsInfo: SubjektOvereniDsInfo,
  SubjektOvereniInfo: SubjektOvereniInfo,
  SubjektRow: RubjektRow,
  SubjektStavZr: SubjektStavZr,
  SubjektUmrtiInfo: SubjektUmrtiInfo
};

/**
 * Dialog s informacemi o aplikaci (nová sjednocená verze).
 */
function AboutApp(props) {
  return createElement("div", {
    id: "o-aplikaci-wrapper"
  }, createElement(CardBody, null, createElement(Row, {
    className: "mt-3"
  }, createElement(Col, null, createElement("div", {
    className: "icon-about"
  }, createElement("div", {
    className: 'modal-shade'
  }), createElement("div", {
    className: 'square-bck full-color-square',
    style: {
      backgroundColor: props.tileColor
    }
  }, createElement("div", {
    className: 'square-bck half-color-square',
    style: {
      backgroundColor: props.tileColor
    }
  }, createElement("div", {
    className: 'square-bck no-color-square'
  }))), createElement(Icon, {
    icon: props.appCode,
    size: "4x"
  })))), createElement(Row, {
    className: "about-main-content"
  }, createElement(Col, {
    className: 'align-text-right'
  }, createElement(Row, null, createElement(Col, null, createElement("h1", null, props.appName))), createElement(Row, null, createElement(Col, null, createElement("h3", null, props.version))))), createElement(Row, {
    className: "about-footer"
  }, createElement(Col, {
    xs: 6,
    sm: 6
  }, createElement("a", {
    href: 'https://www.marbes.cz'
  }, "www.marbes.cz")), createElement(Col, {
    xs: 6,
    sm: 6,
    className: 'align-text-right'
  }, createElement("a", {
    href: 'https://www.marbes.cz'
  }, createElement("svg", {
    width: "70",
    height: "15",
    viewBox: "0 0 51 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, createElement("path", {
    d: "M7.36041 1.63879L5.98559 0.263966C5.63363 -0.0879887 5.06406 -0.0879887 4.71211 0.263966L0 4.97686V8.9992L7.36041 1.63879Z",
    fill: "white"
  }), createElement("path", {
    d: "M12.1874 1.63923L10.8126 0.264404C10.4607 -0.0875508 9.89109 -0.0867652 9.53913 0.264404L4.82703 4.9773V8.99964L12.1874 1.63923Z",
    fill: "white"
  }), createElement("path", {
    d: "M12.59 2.04175L9.65417 4.9768V8.99992L12.5892 6.06409L12.59 2.04175Z",
    fill: "white"
  }), createElement("path", {
    d: "M15.0334 7.69951V1.41154H16.152L18.113 6.25871L20.0647 1.41154H21.1879V7.69951H20.4054V2.41043L18.2741 7.69951H17.9565L15.816 2.41043V7.69951H15.0334Z",
    fill: "white"
  }), createElement("path", {
    d: "M22.0027 7.69951L24.5391 1.41154H25.5103L28.0375 7.69951H27.1445L26.5875 6.29554H23.4573L22.9003 7.69951H22.0027ZM23.6921 5.60505H26.3619L25.0224 2.21249L23.6921 5.60505Z",
    fill: "white"
  }), createElement("path", {
    d: "M28.8615 7.69951V1.41154H31.3886C31.9717 1.41154 32.4474 1.58492 32.8156 1.9317C33.1839 2.27541 33.368 2.73419 33.368 3.30806C33.368 3.58118 33.322 3.83129 33.2299 4.05838C33.1409 4.28547 33.0197 4.4742 32.8663 4.62457C32.7128 4.77188 32.5379 4.89002 32.3415 4.97902C32.1482 5.06495 31.9425 5.11712 31.7247 5.13553L33.4232 7.69951H32.498L30.9053 5.19997H29.644V7.69951H28.8615ZM29.644 4.5141H31.292C31.6633 4.5141 31.9671 4.40208 32.2034 4.17806C32.4397 3.95404 32.5578 3.66404 32.5578 3.30806C32.5578 2.95208 32.4397 2.66361 32.2034 2.44265C31.9702 2.2217 31.6664 2.11122 31.292 2.11122H29.644V4.5141Z",
    fill: "white"
  }), createElement("path", {
    d: "M34.6063 7.69951V1.41154H37.405C37.9451 1.41154 38.3732 1.55884 38.6893 1.85345C39.0085 2.14805 39.168 2.53472 39.168 3.01345C39.168 3.39091 39.0606 3.70854 38.8458 3.96631C38.631 4.22409 38.3701 4.38674 38.0633 4.45425C38.3978 4.50642 38.6862 4.68441 38.9287 4.98823C39.1711 5.28897 39.2923 5.62654 39.2923 6.00093C39.2923 6.51342 39.1297 6.92464 38.8044 7.23459C38.4822 7.54454 38.0372 7.69951 37.4695 7.69951H34.6063ZM35.3888 6.99983H37.3222C37.6843 6.99983 37.9666 6.90316 38.1691 6.70982C38.3748 6.51649 38.4776 6.25257 38.4776 5.91807C38.4776 5.61119 38.3763 5.35341 38.1737 5.14473C37.9712 4.93606 37.6873 4.83172 37.3222 4.83172H35.3888V6.99983ZM35.3888 4.13663H37.2715C37.6152 4.13663 37.8822 4.04303 38.0725 3.85584C38.2627 3.66864 38.3579 3.42621 38.3579 3.12853C38.3579 2.83393 38.2627 2.59149 38.0725 2.40123C37.8822 2.20789 37.6152 2.11122 37.2715 2.11122H35.3888V4.13663Z",
    fill: "white"
  }), createElement("path", {
    d: "M40.5352 7.69951V1.41154H44.6551V2.11122H41.3177V4.13663H44.586V4.83172H41.3177V6.99983H44.6551V7.69951H40.5352Z",
    fill: "white"
  }), createElement("path", {
    d: "M45.5251 6.81109L45.9946 6.20807C46.2217 6.47199 46.5025 6.68988 46.837 6.86173C47.1745 7.03051 47.5505 7.1149 47.9648 7.1149C48.2317 7.1149 48.465 7.08115 48.6644 7.01363C48.867 6.94612 49.022 6.85713 49.1294 6.74665C49.2398 6.63617 49.3196 6.52109 49.3687 6.40141C49.4209 6.27866 49.447 6.1513 49.447 6.01934C49.447 5.84749 49.404 5.69712 49.3181 5.56823C49.2352 5.43627 49.1217 5.3304 48.9775 5.25061C48.8332 5.16775 48.6675 5.09563 48.4803 5.03426C48.2962 4.96981 48.1013 4.90997 47.8957 4.85473C47.6901 4.79949 47.483 4.74272 47.2743 4.68441C47.0687 4.62611 46.8723 4.55246 46.6851 4.46346C46.5009 4.37447 46.3368 4.27166 46.1925 4.15505C46.0483 4.03536 45.9332 3.88346 45.8473 3.69933C45.7644 3.51213 45.723 3.29885 45.723 3.05948C45.723 2.54393 45.9271 2.1235 46.3352 1.79821C46.7464 1.46984 47.2651 1.30566 47.8911 1.30566C48.8117 1.30566 49.5529 1.6018 50.1145 2.19408L49.6449 2.76948C49.2 2.2662 48.5939 2.01456 47.8267 2.01456C47.4523 2.01456 47.1423 2.10816 46.8968 2.29535C46.6544 2.47948 46.5332 2.71885 46.5332 3.01345C46.5332 3.16382 46.5746 3.29578 46.6574 3.40933C46.7434 3.52287 46.8585 3.61647 47.0027 3.69012C47.1469 3.7607 47.3111 3.82515 47.4952 3.88346C47.6824 3.94176 47.8788 3.99854 48.0844 4.05378C48.2931 4.10901 48.5003 4.16886 48.7059 4.2333C48.9115 4.29468 49.1063 4.37447 49.2905 4.47267C49.4777 4.5678 49.6434 4.67981 49.7876 4.8087C49.9319 4.93452 50.0454 5.09563 50.1283 5.29204C50.2142 5.48844 50.2572 5.71246 50.2572 5.9641C50.2572 6.20347 50.2142 6.42903 50.1283 6.64078C50.0423 6.85252 49.9119 7.04893 49.737 7.22998C49.5621 7.40798 49.3196 7.55067 49.0097 7.65808C48.7028 7.76242 48.3453 7.81459 47.9371 7.81459C47.4185 7.81459 46.9551 7.7256 46.547 7.54761C46.1419 7.36655 45.8013 7.12104 45.5251 6.81109Z",
    fill: "white"
  })))))));
}

var AbstractReactComponent = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AbstractReactComponent, _Component);

  function AbstractReactComponent() {
    var _this;

    _this = _Component.call(this, {}) || this;
    throw new Error('Dont use AbstractReactComponent use React.Component');
  }

  return AbstractReactComponent;
}(Component);

/**
 * Třída slouží pro obalení seznamu položek v Card komponentě, položkou seznamu je typicky CardBody.
 *
 * Použití:
 * <Card>
 *   <CardHeader>Hlavicka</CardHeader>
 *   <CardBody>nejaky obsah...</CardBody>
 *   <CardItems>
 *       <CardBody>polozka seznamu 1</CardBody>
 *       <CardBody>polozka seznamu 2</CardBody>
 *       <CardBody>polozka seznamu 3</CardBody>
 *   </CardItems>
 * </Card>
 */

function CardItems(_ref) {
  var bordered = _ref.bordered,
      className = _ref.className,
      children = _ref.children;
  var cls = classNames('items-list', className, {
    bordered: bordered
  });
  return createElement("div", {
    className: cls
  }, children);
}

function ContentPagination(_ref) {
  var onPrev = _ref.onPrev,
      prev = _ref.prev,
      onNext = _ref.onNext,
      next = _ref.next,
      children = _ref.children;
  return createElement("div", {
    className: "content-pagination"
  }, createElement("div", {
    className: 'content-pagination-left mr-2' + (prev ? '' : ' disabled')
  }, createElement(Button, {
    disabled: !prev,
    onClick: onPrev,
    color: "action"
  }, createElement(FAIcon, {
    icon: "chevron-left"
  }))), createElement("div", {
    className: "content-pagination-center"
  }, children), createElement("div", {
    className: 'content-pagination-right ml-2' + (next ? '' : ' disabled')
  }, createElement(Button, {
    disabled: !next,
    onClick: onNext,
    color: "action"
  }, createElement(FAIcon, {
    icon: "chevron-right"
  }))));
}

function CountButton(_ref) {
  var _ref$component = _ref.component,
      component = _ref$component === void 0 ? 'a' : _ref$component,
      _ref$type = _ref.type,
      type = _ref$type === void 0 ? 'box' : _ref$type,
      count = _ref.count,
      colorCount = _ref.colorCount,
      colorContent = _ref.colorContent,
      icon = _ref.icon,
      children = _ref.children,
      className = _ref.className,
      colorTextCount = _ref.colorTextCount,
      onClick = _ref.onClick,
      other = _objectWithoutPropertiesLoose(_ref, ["component", "type", "count", "colorCount", "colorContent", "icon", "children", "className", "colorTextCount", "onClick"]);

  var showIcon = type !== 'circle' && icon;
  var child = React__default.createElement("div", Object.assign({
    className: className ? className + ' count-button ' + type : 'count-button ' + type
  }, other), (showIcon || typeof count !== 'undefined' && count !== null) && React__default.createElement("div", {
    className: 'count-button-count ' + colorCount + ' ' + (colorTextCount && colorTextCount + '-text')
  }, showIcon && icon && React__default.createElement(FAIcon, {
    size: "3x",
    icon: icon
  }), React__default.createElement("span", {
    className: "count-button-count-label"
  }, count)), React__default.createElement("div", {
    className: 'count-button-content w-' + (showIcon ? '75 ' : '100 ') + colorContent
  }, React__default.createElement("span", {
    className: "count-button-text"
  }, children)));
  return createElement(component, {
    onClick: onClick
  }, child);
}

/**
 * Velké tlačítko s ikonou, které se umisťuje přímo na stránku, nikam jinam.
 * Tlačítko má ikonu a text.
 */

function PageButton(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick;
  var cls = classNames('page-button', className);
  return createElement(Button, {
    onClick: onClick,
    disabled: disabled,
    className: cls,
    color: "primary"
  }, createElement(FAIcon, {
    icon: icon
  }), createElement("div", null, children));
}

/**
 * Badge na určení statusu hlavního objektu. Zobrazuje se jako ikona stavu a k němu text. Je určen pouze ke dospecifikování stavu hlavního objektu, typicky se umisťuje do hlaviščky stránky nebo na kartu objektu na detaiul stránce.
 */

function StatusBagde(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'info' : _ref$color,
      icon = _ref.icon,
      children = _ref.children;
  var cls = classNames('status-badge', className);
  return createElement(Badge, {
    className: cls,
    color: color,
    pill: true
  }, icon && createElement(FAIcon, {
    className: classNames('status-badge-icon', {
      'mr-2': Boolean(children)
    }),
    icon: icon
  }), children);
}

var FocusableReactComponent = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FocusableReactComponent, _React$Component);

  function FocusableReactComponent() {
    var _this;

    _this = _React$Component.call(this, {}) || this;
    throw new Error('Dont use FocusableReactComponent - useLocalState');
  }

  return FocusableReactComponent;
}(React__default.Component);

/**
 * Loader pro načítání dat - horizontální, typicky pro dlouhé seznamy položek apod.
 */

function HorizontalLoader(_ref) {
  var className = _ref.className,
      hover = _ref.hover,
      other = _objectWithoutPropertiesLoose(_ref, ["className", "hover"]);

  var clsCont = classNames('loaderInf-container', className, {
    hover: hover
  });
  var cls = classNames('loaderInf');
  return createElement("div", {
    className: clsCont
  }, createElement("div", Object.assign({
    className: cls
  }, other)));
}

/**
 * Komponenta panelu, který je na výšku 100% a má scrolovatelný pouze obsah, hlaviška scrolovatelná není.
 */

function ScrollableCard(_ref) {
  var transparentHeader = _ref.transparentHeader,
      detail = _ref.detail,
      header = _ref.header,
      children = _ref.children,
      className = _ref.className,
      contentClassName = _ref.contentClassName;

  if (transparentHeader) {
    var wrapperClassNames = classNames(className, 'card-scrollable container-fluid card-scrollable-transparentHeader');
    return createElement("div", {
      className: wrapperClassNames
    }, header && createElement("div", {
      className: "card-scrollable-header"
    }, header), createElement(Card, null, createElement("div", {
      className: "card-scrollable-content"
    }, children)));
  } else {
    var _wrapperClassNames = classNames(className, 'card-scrollable container-fluid', {
      card: !detail,
      'card-detail': detail
    });

    var contentClassNames = classNames(contentClassName, 'card-scrollable-content');
    return createElement("div", {
      className: _wrapperClassNames
    }, header && createElement("div", {
      className: "card-scrollable-header"
    }, header), createElement("div", {
      className: contentClassNames
    }, children));
  }
}

var SouborLink = function SouborLink(_ref) {
  var soubor = _ref.soubor,
      onClick = _ref.onClick,
      hlavni = _ref.hlavni,
      children = _ref.children,
      _ref$buttonProps = _ref.buttonProps,
      buttonProps = _ref$buttonProps === void 0 ? {} : _ref$buttonProps,
      className = _ref.className,
      icon = _ref.icon,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["soubor", "onClick", "hlavni", "children", "buttonProps", "className", "icon"]);

  var buttonCls = classNames(buttonProps.className, {
    'font-weight-bold': hlavni
  });
  var iconComponent;

  if (icon !== false || icon !== null) {
    if (typeof icon === 'string') {
      iconComponent = createElement(FAIcon, {
        icon: icon
      });
    } else {
      iconComponent = icon;
    }
  } else if (icon === undefined) {
    var realIcon;

    switch (soubor.contentType) {
      case 'application/pdf':
        realIcon = 'file-pdf-o';
        break;

      case 'application/msword':
        realIcon = 'file-word-o';
        break;

      default:
        realIcon = 'file-o';
        break;
    }

    iconComponent = createElement(FAIcon, {
      icon: realIcon
    });
  }

  return createElement(Row, Object.assign({
    className: className
  }, otherProps), createElement(Col, null, createElement(Button, Object.assign({
    color: "link"
  }, buttonProps, {
    onClick: onClick,
    className: buttonCls
  }), iconComponent, " ", soubor.jmenoSoubor)), children);
};

SouborLink.formName = 'souborLink';
SouborLink.defaultProps = {
  hlavni: false
};

/**
 * Naformátuje spisový, skartační znak se skartační lhůtou do požadovaného tvaru.
 * Pokud je některá z hodnot null, bude vynechána a formát tomu uzpůsoben.
 *
 * @param vecnaSkupina věcná skupina
 * @returns {string} formátovaný řetězec věcné skupiny, nebo prázdný řetězec
 */
function getVecnaSkupina(vecnaSkupina, skartacniRezim) {
  var result = '';

  if (vecnaSkupina) {
    var spisovyZnak = vecnaSkupina.spisovyZnak;

    if (spisovyZnak) {
      if (skartacniRezim) {
        var sr = skartacniRezim.skartacniZnak + skartacniRezim.skartacniLhuta;
        result += spisovyZnak.kod + '/' + sr + ' - ' + spisovyZnak.nazev;
      } else {
        result += spisovyZnak.kod + ' - ' + spisovyZnak.nazev;
      }
    }

    return result;
  }

  return result;
}

/**
 * Kartička s detailem spisu.
 */

function SpisCard(_ref) {
  var spis = _ref.spis;
  var stavSpisuCaption = '-';

  if (spis.stavSpisu) {
    stavSpisuCaption = getCaption(spis.stavSpisu);
  }

  var zpracovatel = '-';

  if (spis.zpracovatel) {
    zpracovatel = spis.zpracovatel.uplneJmeno;
  }

  var vecnaSkupina = '-';

  if (spis.vecnaSkupina && spis.skartacniRezim) {
    vecnaSkupina = getVecnaSkupina(spis.vecnaSkupina, spis.skartacniRezim);
  }

  var spsTypDokument = '-';

  if (spis.spsTypDokument) {
    spsTypDokument = spis.spsTypDokument.nazev;
  }

  return createElement(Card, null, createElement(CardHeader, null, createElement("h2", null, "Spis")), createElement(CardBody, null, createElement(Row, null, createElement(Col, {
    xs: 12,
    md: 6
  }, createElement(DetailValue, {
    label: "Spisov\xE1 zna\u010Dka"
  }, createElement("strong", null, spis.spisovaZnacka))), createElement(Col, {
    xs: 12,
    md: 3
  }, createElement(DetailValue, {
    label: "Stav"
  }, stavSpisuCaption)), createElement(Col, {
    xs: 12,
    md: 3
  }, createElement(DetailValue, {
    label: "Datum vytvo\u0159en\xED"
  }, formatDate(localUTCToDate(spis.datumVytvoreni))))), createElement(Row, null, createElement(Col, {
    xs: 12,
    md: 6
  }, createElement(DetailValue, {
    label: "V\u011Bcn\xE1 skupina"
  }, vecnaSkupina)), createElement(Col, {
    xs: 12,
    md: 3
  }, createElement(DetailValue, {
    label: "Zpracovatel"
  }, zpracovatel)), createElement(Col, {
    xs: 12,
    md: 3
  }, createElement(DetailValue, {
    label: "Datum uzav\u0159en\xED"
  }, formatDate(localUTCToDate(spis.datumUzavreni))))), createElement(Row, null, createElement(Col, {
    xs: 12
  }, createElement(DetailValue, {
    label: "N\xE1zev"
  }, spis.nazev))), createElement(Row, null, createElement(Col, {
    xs: 12,
    md: 3
  }, createElement(DetailValue, {
    label: "Typ ve spisov\xE9 slu\u017Eb\u011B"
  }, spsTypDokument)))));
}

/**
 * Komponenta panelu - tabulky, který je na výšku 100% a má scrolovatelný pouze obsah, hlavička scrolovatelná není.
 */

function TableCard(_ref) {
  var detail = _ref.detail,
      header = _ref.header,
      children = _ref.children,
      className = _ref.className;
  var wrapperClassNames = classNames(className, 'card-scrollable container-fluid card-table', {
    card: !detail,
    'card-detail': detail
  });
  return createElement("div", {
    className: wrapperClassNames
  }, header && createElement("div", {
    className: "card-scrollable-header"
  }, header), createElement("div", {
    className: "card-scrollable-content"
  }, children));
}

/**
 * Is React Native check
 * @type {boolean}
 */
var isReactNative = !!window.WebViewBridge;

var LEFT$1 = 'LEFT';
var RIGHT$1 = 'RIGHT';
/**
 * Time line položka.
 */

function TimeLine(_ref) {
  var className = _ref.className,
      label = _ref.label,
      color = _ref.color,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? LEFT$1 : _ref$position,
      _ref$rounded = _ref.rounded,
      rounded = _ref$rounded === void 0 ? false : _ref$rounded,
      children = _ref.children,
      others = _objectWithoutPropertiesLoose(_ref, ["className", "label", "color", "position", "rounded", "children"]);

  var cls = classNames('time-line');
  var clsLabel = classNames('label', position === LEFT$1 ? 'label-left' : 'label-right', 'bg-' + color, {
    rounded: rounded
  });

  if (isReactNative) {
    return createElement(Row, {
      className: cls
    }, createElement(Col, Object.assign({
      className: "p-0"
    }, others), label && createElement(CardBody, {
      className: "float-label",
      title: label
    }, label), children));
  } else {
    var itemPosition = position === LEFT$1 ? 'item-left' : 'item-right';
    var col = createElement(Col, {
      className: classNames(label ? 'item col-auto' : 'item-small col-auto', itemPosition)
    }, label && !rounded && position === RIGHT$1 && createElement("div", {
      className: classNames('arrow', 'arrow-' + color, 'arrow-right')
    }), label && createElement("div", {
      className: clsLabel,
      title: label
    }, label), label && !rounded && position === LEFT$1 && createElement("div", {
      className: classNames('arrow', 'arrow-' + color, 'arrow-left')
    }), createElement("div", {
      className: position === LEFT$1 ? 'pit pit-left' : 'pit pit-right'
    }));
    return createElement(Row, {
      className: cls
    }, position === LEFT$1 && col, createElement(Col, Object.assign({
      className: 'timeline-content bordered' + (className ? ' ' + className : '')
    }, others), children), position === RIGHT$1 && col);
  }
}

/**
 * Komponenta pro výběr viditelných filtrovacích polí.
 */

var FilterFieldSelector = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FilterFieldSelector, _PureComponent);

  function FilterFieldSelector() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.state = {
      dropdownOpen: false,
      // Zda je dropdown v otevřeném stavu.
      searchQuery: ''
    };

    _this.isFieldCheckboxVisible = function (_ref) {
      var label = _ref.label;

      var searchQuery = _this.state.searchQuery.trim().toLowerCase();

      return searchQuery === '' || label.toLowerCase().indexOf(searchQuery) >= 0;
    };

    _this.isFieldCheckboxChecked = function (name) {
      return _this.props.visibleFieldNames.indexOf(name) >= 0;
    };

    _this.handlePopoverToggle = function () {
      _this.setState({
        dropdownOpen: !_this.state.dropdownOpen
      });
    };

    _this.handleSearchQueryChange = function (event) {
      _this.setState({
        searchQuery: event.target.value
      });
    };

    _this.handleFieldCheckboxChange = function (event) {
      var _event$target = event.target,
          name = _event$target.dataset.name,
          checked = _event$target.checked;

      _this.props.onFieldVisibilityChange(name, checked); // Vlivem toho, že se objeví nový field, může dojít k posunutí komponenty. Toto bohužel neposune otevřenou
      // dropdown nabídku. Tím, že ji zavřeme a znovu otevřeme, ji veresetujeme pozici na správné místo.


      _this.setState({
        dropdownOpen: false
      });

      setTimeout(function () {
        return _this.setState({
          dropdownOpen: true
        });
      });
    };

    _this.renderFieldCheckbox = function (_ref2) {
      var name = _ref2.name,
          label = _ref2.label;
      return React__default.createElement("div", {
        key: name
      }, React__default.createElement(Label, {
        check: true
      }, React__default.createElement(Input, {
        type: "checkbox",
        "data-name": name,
        checked: _this.isFieldCheckboxChecked(name),
        onChange: _this.handleFieldCheckboxChange
      }), ' ' + label));
    };

    return _this;
  }

  var _proto = FilterFieldSelector.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        dropdownOpen = _this$state.dropdownOpen,
        searchQuery = _this$state.searchQuery;
    var fields = this.props.fields;
    var visibleFields = fields.filter(this.isFieldCheckboxVisible);
    return React__default.createElement(FixedDropDownButton, {
      className: "filter-field-selector",
      color: "link",
      title: React__default.createElement("span", null, React__default.createElement(FAIcon, {
        icon: "plus"
      }), " P\u0159idat podm\xEDnku"),
      uncontrolled: true,
      isOpen: dropdownOpen,
      toggle: this.handlePopoverToggle
    }, React__default.createElement("div", {
      className: "p-3"
    }, React__default.createElement(InputGroup, {
      className: "mb-3"
    }, React__default.createElement(Input, {
      type: "text",
      placeholder: "Vyhledat...",
      value: searchQuery,
      onChange: this.handleSearchQueryChange
    }), React__default.createElement(InputGroupAddon, {
      addonType: "append"
    }, React__default.createElement(FAIcon, {
      icon: "search"
    }))), visibleFields.map(this.renderFieldCheckbox), visibleFields.length === 0 && React__default.createElement("i", null, "\u017D\xE1dn\xE9 dostupn\xE9 podm\xEDnky")));
  };

  return FilterFieldSelector;
}(PureComponent);
FilterFieldSelector.propTypes = {
  fields: /*#__PURE__*/PropTypes__default.arrayOf( /*#__PURE__*/PropTypes__default.shape({
    // Konfigurace polí dostupných ve filtru.
    name: PropTypes__default.string.isRequired,
    // Jméno pole.
    label: PropTypes__default.string.isRequired
  })).isRequired,
  visibleFieldNames: /*#__PURE__*/PropTypes__default.arrayOf(PropTypes__default.string).isRequired,
  // Pole názvů viditelných polí.
  onFieldVisibilityChange: PropTypes__default.func.isRequired
};

function getComponentValue(eventOrValue) {
  if (eventOrValue) {
    var target = eventOrValue.target;

    if (target) {
      if (target.type === 'checkbox') {
        return target.checked;
      }

      if (target.type === 'number') {
        return parseInt(target.value);
      }

      return target.value;
    }
  }

  return eventOrValue;
}
/**
 * Komponenta pro vykreslení filtrovacího pole.
 */


var FilterField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(FilterField, _PureComponent);

  function FilterField() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;

    _this.handleChange = function (eventOrValue) {
      // Předpokládáme jednu následující komponentu uvnitř pole:
      // 1) Nativní komponenta, jako např. <input>, které v onChange vrací SyntheticEvent.
      // 2) Vlastní komponenta, která v onChange vrací přímo novou hodnotu namísto event.
      var _this$props = _this.props,
          name = _this$props.name,
          onChange = _this$props.onChange;
      onChange(name, getComponentValue(eventOrValue));
    };

    _this.handleRemove = function () {
      var _this$props2 = _this.props,
          name = _this$props2.name,
          onRemove = _this$props2.onRemove;
      onRemove(name);
    };

    return _this;
  }

  var _proto = FilterField.prototype;

  _proto.renderComponent = function renderComponent() {
    var _this$props3 = this.props,
        value = _this$props3.value,
        Component = _this$props3.component,
        componentProps = _this$props3.componentProps;
    return React__default.createElement(Component, Object.assign({}, componentProps, {
      value: value,
      onChange: this.handleChange
    }));
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        label = _this$props4.label,
        checkbox = _this$props4.checkbox;
    return React__default.createElement("div", {
      className: "filter-field"
    }, React__default.createElement("div", {
      className: "filter-field-label"
    }, React__default.createElement(Label, {
      checked: checkbox
    }, checkbox && this.renderComponent(), checkbox && ' ', React__default.createElement("span", null, label))), !checkbox && React__default.createElement("div", {
      className: "filter-field-component"
    }, this.renderComponent()), React__default.createElement(Button, {
      className: "filter-field-remove-button",
      color: "action",
      onClick: this.handleRemove
    }, React__default.createElement(FAIcon, {
      icon: "times-circle-o"
    })));
  };

  return FilterField;
}(PureComponent);
FilterField.propTypes = {
  name: PropTypes__default.any.isRequired,
  // Jméno pole.
  label: PropTypes__default.any.isRequired,
  // Popisek pole.
  value: PropTypes__default.any,
  // Hodnota pole.
  checkbox: PropTypes__default.bool,
  // Zda komponentu pole renderovat jako checkbox, tzn. nalevo od popisku.
  component: PropTypes__default.func.isRequired,
  // Komponenta uvnitř pole. Očekává se, že bude podporovat properties "value" a "onChange".
  componentProps: PropTypes__default.object.isRequired,
  // Properties předané komponentě uvnitř pole.
  onChange: PropTypes__default.func.isRequired,
  // Callback volaný při změně hodnoty pole.
  onRemove: PropTypes__default.func.isRequired
};

var ORDER_PROPERTY = '_order'; // Jméno "speciální" property hodnoty filtru, ve které držíme pořadí položek filtru.

var defaultFieldComponentProps = {};

function getFieldName(field) {
  return field.name;
}

function appendNameToOrder(names, name) {
  if (!names) {
    return [name];
  }

  if (names.indexOf(name) < 0) {
    return [].concat(names, [name]);
  }

  return names; // Už tam je.
}

function removeNameFromOrder(names, name) {
  if (!names) {
    return [];
  }

  var index = names.indexOf(name);

  if (index >= 0) {
    return [].concat(names.splice(0, index), names.slice(index + 1));
  }

  return names; // Není tam.
}
/**
 * Komponenta filtru.
 * Skládá se z nakonfigurovaných polí, které může uživatel dynamicky přidávat a odebírat.
 */


var Filter = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(Filter, _PureComponent);

  function Filter() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;

    _this.isFieldVisible = function (_ref) {
      var name = _ref.name;
      return _this.getFieldValue(name) !== undefined;
    };

    _this.compareFieldOrder = function (_ref2, _ref3) {
      var name1 = _ref2.name;
      var name2 = _ref3.name;
      return _this.getFieldOrder(name1) - _this.getFieldOrder(name2);
    };

    _this.handleFieldChange = function (name, value) {
      _this.changeValues(function (newValues) {
        newValues[name] = value;
      });
    };

    _this.handleFieldAddition = function (name) {
      _this.changeValues(function (newValues) {
        newValues[name] = _this.getFieldInitialValue(name);
        newValues[ORDER_PROPERTY] = appendNameToOrder(newValues[ORDER_PROPERTY], name);
      });
    };

    _this.handleFieldRemoval = function (name) {
      _this.changeValues(function (newValues) {
        delete newValues[name];
        newValues[ORDER_PROPERTY] = removeNameFromOrder(newValues[ORDER_PROPERTY], name);
      });
    };

    _this.handleFieldVisibilityChange = function (name, visible) {
      if (visible) {
        _this.handleFieldAddition(name);
      } else {
        _this.handleFieldRemoval(name);
      }
    };

    _this.renderField = function (_ref4) {
      var name = _ref4.name,
          label = _ref4.label,
          checkbox = _ref4.checkbox,
          component = _ref4.component,
          componentProps = _ref4.componentProps;
      var Field = _this.props.Field;
      return createElement(Field, {
        key: name,
        name: name,
        label: label,
        checkbox: checkbox,
        component: component,
        componentProps: componentProps || defaultFieldComponentProps,
        value: _this.getFieldValue(name),
        onChange: _this.handleFieldChange,
        onRemove: _this.handleFieldRemoval
      });
    };

    return _this;
  }

  Filter.purifyValues = function purifyValues(values) {
    if (ORDER_PROPERTY in values) {
      var newValues = _extends({}, values);

      delete newValues[ORDER_PROPERTY];
      return newValues;
    }

    return values;
  };

  var _proto = Filter.prototype;

  _proto.getField = function getField(name) {
    return this.props.fields[this.getFieldIndex(name)];
  };

  _proto.getFieldIndex = function getFieldIndex(name) {
    var fields = this.props.fields;

    for (var i = 0; i < fields.length; i++) {
      if (fields[i].name === name) {
        return i;
      }
    }

    throw new Error('Unknown filter field ' + name);
  };

  _proto.getFieldValue = function getFieldValue(name) {
    var values = this.props.values;
    return values ? values[name] : undefined;
  };

  _proto.getFieldInitialValue = function getFieldInitialValue(name) {
    var _this$getField = this.getField(name),
        initialValue = _this$getField.initialValue;

    if (typeof initialValue === 'function') {
      return initialValue(name);
    }

    if (initialValue !== undefined) {
      return initialValue;
    } // Nesmíme vrátit undefined, to odpovídá skrytému fieldu.
    // Budeme předpokládat, že nečastější "use case" je použití <input> jako komponenty fieldu.
    // V takové případě vracíme prázdný string jako výchozí hodnotu.


    return '';
  };

  _proto.getFieldOrder = function getFieldOrder(name) {
    // Primárně bereme pořadí ze speciální property hodnot filtru.
    var values = this.props.values;

    if (values) {
      var names = values[ORDER_PROPERTY];

      if (names) {
        var index = names.indexOf(name);

        if (index >= 0) {
          return 1000 + index; // Přídáme váhu, aby pole s definovaným pořadím byly až na konci.
        }
      }
    } // Sekundárně bereme pořadí z konfigurace filtru.


    return this.getFieldIndex(name);
  };

  _proto.changeValues = function changeValues(updater) {
    var _this$props = this.props,
        values = _this$props.values,
        onChange = _this$props.onChange;

    if (onChange) {
      var newValues = values ? _extends({}, values) : {};
      updater(newValues);
      onChange(newValues);
    }
  };

  _proto.renderFieldSelector = function renderFieldSelector() {
    var _this$props2 = this.props,
        fields = _this$props2.fields,
        FieldSelector = _this$props2.FieldSelector;
    var visibleFieldNames = fields.filter(this.isFieldVisible).map(getFieldName);
    return createElement(FieldSelector, {
      key: '_add',
      fields: fields,
      visibleFieldNames: visibleFieldNames,
      onFieldVisibilityChange: this.handleFieldVisibilityChange
    });
  };

  _proto.render = function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        layout = _this$props3.layout,
        fields = _this$props3.fields;
    return createElement("div", {
      className: classNames('filter', className, layout)
    }, fields.filter(this.isFieldVisible).sort(this.compareFieldOrder).map(this.renderField), this.renderFieldSelector());
  };

  return Filter;
}(PureComponent);
Filter.Layout = {
  HORIZONTAL: 'horizontal'
};
Filter.propTypes = {
  className: PropTypes__default.string,
  // Vlastní className
  fields: /*#__PURE__*/PropTypes__default.arrayOf( /*#__PURE__*/PropTypes__default.shape({
    // Konfigurace polí dostupných ve filtru.
    name: PropTypes__default.string.isRequired,
    // Jméno pole.
    label: PropTypes__default.string.isRequired,
    // Popisek pole.
    checkbox: PropTypes__default.bool,
    // Zda komponentu pole renderovat jako checkbox, tzn. nalevo od popisku.
    component: PropTypes__default.func.isRequired,
    // Komponenta uvnitř pole. Očekává se, že bude podporovat properties "value" a "onChange".
    componentProps: PropTypes__default.object,
    // Properties předané komponentě uvnitř pole.
    initialValue: PropTypes__default.any
  })).isRequired,
  layout: /*#__PURE__*/PropTypes__default.oneOf( /*#__PURE__*/Object.values(Filter.Layout)),
  // Layout filtru.
  values: PropTypes__default.object,
  // Hodnota filtru.
  onChange: PropTypes__default.func,
  // Callback volaný při změně hodnoty filtru.
  Field: PropTypes__default.func,
  // Komponenta pro vykreslení pole. Obaluje komponentu "component" specifikovanou v property "fields".
  FieldSelector: PropTypes__default.func
};
Filter.defaultProps = {
  layout: Filter.Layout.HORIZONTAL,
  Field: FilterField,
  FieldSelector: FilterFieldSelector
};

/**
 * Položka menu.
 */

var MenuItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(MenuItem, _Component);

  function MenuItem() {
    var _this;

    _this = _Component.apply(this, arguments) || this;

    _this.redirect = function (route) {
      _this.props.history.push(route);
    };

    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        route = _this$props.route,
        subItem = _this$props.subItem,
        match = _this$props.match;
    var active = match.path.startsWith(route);
    return React__default.createElement(CardBody, {
      className: "menu-item" + (active ? ' active' : '') + (subItem ? ' menu-subitem' : ''),
      onClick: this.redirect.bind(this, route)
    }, React__default.createElement("div", null, subItem && React__default.createElement(FAIcon, {
      icon: "arrow-right"
    }), " ", title));
  };

  return MenuItem;
}(Component);

MenuItem.propTypes = {
  title: PropTypes__default.string.isRequired,
  // název položky menu
  route: PropTypes__default.string.isRequired,
  // route pro přesměrování při kliknutí na položku
  subItem: PropTypes__default.bool
};
MenuItem.defaultProps = {
  subItem: false
};
var MenuItem$1 = /*#__PURE__*/withRouter(MenuItem);

var MenuPanel = function MenuPanel(props) {
  var children = props.children;
  return React__default.createElement(Card, {
    className: "items-list bordered menu-panel"
  }, children);
};

MenuPanel.propTypes = {
  children: COMPONENT_CHILDREN
};

var Menu = function Menu(props) {
  var items = props.items;
  return React__default.createElement(MenuPanel, null, items.map(function (item) {
    return React__default.createElement(MenuItem$1, {
      key: item.key,
      title: item.title,
      route: item.path,
      subItem: item.subItem
    });
  }));
};

Menu.propTypes = {
  items: PropTypes__default.array.isRequired
};

/**
 * Wrapper pro stránky aplikace.
 */

var AppWrapper = /*#__PURE__*/function (_Component) {
  _inheritsLoose(AppWrapper, _Component);

  function AppWrapper() {
    var _this;

    _this = _Component.apply(this, arguments) || this;

    _this.handleLogout = function () {
      _this.props.dispatch(logout());
    };

    _this.historyGoBackCall = function (n) {
      _this.props.history.go(-n);
    };

    _this.handleHistoryGoBack = function (goBackBase, homeLink) {
      if (goBackBase) {
        // jdeme na nejbližší, která NEBUDE mít goBackBase
        var i = window.appHistory.length - 1;
        var found = false;

        while (i >= 0) {
          if (window.appHistory[i].substring(0, goBackBase.length) !== goBackBase) {
            // Pokud se liší první, který je v historii, přeskočíme ho, protože by se při back nic nestalo
            var size = window.appHistory.length - i - 1;

            if (size > 0) {
              found = true;

              _this.historyGoBackCall(size);

              break;
            }
          }

          i--;
        } // Jdeme na homeLink


        if (!found) {
          if (typeof homeLink === 'function') {
            homeLink();
          } else {
            _this.props.history.push(homeLink);
          }
        }
      } else {
        _this.props.history.goBack();
      }
    }; // showOAplikaci = () => {
    //     this.props.dispatch(modal.ModalActions.show(OAplikaci, {}, "O aplikaci", {size: "md"}));
    // };


    _this.renderViewMenuItem = function (v, i) {
      var authInfo = _this.props.authInfo;
      var items = [];
      var subViewCount = 0;

      if (v.subViewGenerator) {
        var result = v.subViewGenerator(authInfo.data);
        subViewCount = result.length;

        if (subViewCount > 0) {
          items.push(React__default.createElement(DropdownItem, {
            divider: true
          }));
          items.push(React__default.createElement(DropdownItem, {
            header: true
          }, v.name));
          items.push(result.map(function (v, i) {
            return _this.renderViewMenuItem(v, i * 10);
          }));
          items.push(React__default.createElement(DropdownItem, {
            divider: true
          }));
        }
      }

      if (subViewCount === 0) {
        items.push(React__default.createElement(LinkContainer, {
          to: v.route,
          key: i,
          exact: true
        }, React__default.createElement(DropdownItem
        /*className={currentView === v.route ? "active" : ""}*/
        , null, v.name)));
      }

      return items;
    };

    return _this;
  }

  var _proto = AppWrapper.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        userMenuAddons = _this$props.userMenuAddons,
        authInfo = _this$props.authInfo,
        other = _objectWithoutPropertiesLoose(_this$props, ["userMenuAddons", "authInfo"]);

    var authStatus = authInfo.data;
    var collapseAddons = [];
    collapseAddons.push(React__default.createElement(UncontrolledDropdown, {
      id: "help"
    }, React__default.createElement(DropdownToggle, {
      nav: true,
      className: "icon-text"
    }, React__default.createElement(NavIconText, {
      icon: React__default.createElement(FAIcon, {
        icon: "question-circle"
      })
    })), React__default.createElement(DropdownMenu, {
      right: true
    }, React__default.createElement(DropdownItem, {
      href: window.serverContextPath + "/napoveda",
      target: "blank"
    }, "N\xE1pov\u011Bda")))); // Render

    return React__default.createElement(BaseAppWrapper, Object.assign({}, other, {
      appCode: "dpl",
      onHistoryGoBack: this.handleHistoryGoBack,
      //     <FormGroup>
      //         <AgFulltextField tags renderDetailLink/>
      //     </FormGroup>
      // </Form>}
      onLogout: this.handleLogout,
      collapseAddons: collapseAddons,
      userMenuAddons: userMenuAddons,
      authStatus: authStatus,
      testEnvironment: window.testEnvironment
    }));
  };

  return AppWrapper;
}(Component);

AppWrapper.propTypes = {
  appName: /*#__PURE__*/PropTypes__default.oneOfType([// název aplikace, který se zobrazuje jako brand, mu6e se jednat i o název globální logické sekce, např. skprávní řízení apod.
  PropTypes__default.array, PropTypes__default.node]),
  detail: /*#__PURE__*/PropTypes__default.oneOfType([// detail informace aplikace, např. text detailu stránky, globální filtr stránky atp.
  PropTypes__default.array, PropTypes__default.node]),
  homeLink: /*#__PURE__*/PropTypes__default.oneOfType([PropTypes__default.func, PropTypes__default.string]),
  views: PropTypes__default.array,
  // seznam objektů { name: "", route: "/xxx" }, které představují jednotlivé pohledy v aplikaci
  userMenuAddons: PropTypes__default.array,
  // pole dalších tlačítek do menu pod uživatelem, typicky pole DropdownItem
  currentView: PropTypes__default.string,
  // aktuálně přepnutý pohled - route
  backButtonIcon: PropTypes__default.bool,
  // má se místo loga aplikace zobrazit back button?
  goBack: PropTypes__default.bool,
  // pokud je true, je kliknutí na brand bráno jako back
  goBackBase: PropTypes__default.string,
  // základní url, která reprezentuje základ aktuálně zobrazované stránky - při stisku back se půjde na první, která namá prefix uvedený v goBackBase
  hasLeftPanel: PropTypes__default.bool,
  // aplikace má levý panel, jedná se o případný zasouvací panel
  hasRightPanel: PropTypes__default.bool,
  // aplikace má pravý panel, jedná se o případný zasouvací panel
  leftPanelCollapsed: PropTypes__default.bool,
  // pokud je true, je levý panel změnšen a není dokován
  rightPanelCollapsed: PropTypes__default.bool
};
AppWrapper.defaultProps = {
  appName: 'DPL',
  backButtonIcon: false,
  goBack: false,
  hasLeftPanel: false,
  hasRightPanel: false,
  leftPanelCollapsed: false,
  rightPanelCollapsed: false
};

function mapStateToProps$9(state) {
  return {
    authInfo: storeFromArea(state, AUTH_INFO_AREA$1)
  };
}

var AppWrapper$1 = /*#__PURE__*/connect(mapStateToProps$9)( /*#__PURE__*/withRouter(AppWrapper));

var AdminPage = function AdminPage(props) {
  var homeLink = props.homeLink,
      location = props.location,
      items = props.items,
      title = props.title;
  var activeItem = items.find(function (item) {
    return location.pathname.includes(item.path);
  });
  return createElement(AppWrapper$1, {
    appName: 'Administrace',
    homeLink: homeLink || ''
  }, createElement("div", {
    className: "admin-page"
  }, createElement("div", {
    className: 'admin-page-sidebar'
  }, createElement(ScrollableCard, null, createElement(Card, null, title && createElement(CardHeader, null, createElement("h2", null, title)), createElement(Menu, {
    items: items
  })))), createElement("div", {
    className: 'admin-page-table-wrapper'
  }, createElement(Card, {
    className: "admin-page-header"
  }, createElement(CardBody, null, createElement(ActionsRow, {
    className: "my-2"
  }, createElement("h1", null, activeItem && activeItem.title)))), createElement(Switch, null, items.map(function (item, index) {
    return createElement(Route, {
      path: item.path,
      component: item.component,
      key: index
    });
  }), createElement(Redirect, {
    to: items[0].path,
    replace: true
  })))));
};

AdminPage.propTypes = {
  title: PropTypes__default.string,
  // nadpis menu
  items: PropTypes__default.array.isRequired
};
var AdminPage$1 = /*#__PURE__*/withRouter(AdminPage);

var DocIndexField = /*#__PURE__*/function (_PureComponent) {
  _inheritsLoose(DocIndexField, _PureComponent);

  function DocIndexField() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.state = {
      localValue: null,
      focus: false
    };

    _this.onEnter = function (event) {
      event.preventDefault();
      event.stopPropagation();

      if (event.keyCode === 13) {
        _this.handleOnChange(event, true);
      }
    };

    _this.handleFocus = function () {
      _this.setState({
        focus: true
      });
    };

    _this.handleOnChange = function (event, focus) {
      if (focus === void 0) {
        focus = false;
      }

      event.preventDefault();
      var onChange = _this.props.onChange;
      var localValue = _this.state.localValue;

      if (onChange) {
        var index = _this.props.min - 1;
        var localIndex = parseInt(localValue) - 1;

        if (index < localIndex) {
          if (localIndex > _this.props.max - 1) {
            index = _this.props.max - 1;
          } else {
            index = localIndex;
          }
        }

        console.warn('index', index);

        _this.setState({
          localValue: index + 1,
          focus: focus
        }, function () {
          onChange(index);
        });
      }
    };

    _this.handleLocalChange = function (event) {
      event.preventDefault();

      _this.setState({
        localValue: parseInt(event.target.value)
      });
    };

    return _this;
  }

  var _proto = DocIndexField.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.setState({
      localValue: parseInt(this.props.value)
    });
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (parseInt(nextProps.value) !== parseInt(this.state.localValue) && !this.state.focus) {
      this.setState({
        localValue: nextProps.value
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var localValue = this.state.localValue;
    var number = localValue ? parseInt(localValue) : null;
    return React__default.createElement(AutosizeInput, {
      onChange: this.handleLocalChange,
      onFocus: this.handleFocus,
      onBlur: function onBlur(e) {
        return _this2.handleOnChange(e, false);
      },
      value: number,
      className: 'doc-index-field',
      onKeyUp: this.onEnter
    });
  };

  return DocIndexField;
}(PureComponent);

DocIndexField.propTypes = {};

var PdfPage = function PdfPage(props) {
  return React__default.createElement(Page, Object.assign({}, props));
};

/**
 * PDF čtečka.
 */

var PdfViewer = /*#__PURE__*/function (_Component) {
  _inheritsLoose(PdfViewer, _Component);

  function PdfViewer(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    /**
     * Funkce pro odregistrování posluchače historie
     */

    _this.unlisten = null;
    /**
     * Ovládání přepínání dokumentů šipkami (left,right)
     * @param e
     */

    _this.handleKeyUp = function (e) {
      if (e.keyCode === 37) {
        _this.handlePrev();
      } else if (e.keyCode === 39) {
        _this.handleNext();
      }
    };
    /**
     * Callback po načtení dokumentu
     * Zde je vhodné přidávat listenery, které souvisí s dokumntem a volá se zde načtení informací o stránkách do cache
     * také se nastaví počet stran a reference na samotné pdf.js do state (state.pdf)
     * @param pdf
     */


    _this.onDocumentLoad = function (pdf) {
      var _this$document$curren;

      _this.setState({
        pdf: pdf
      });

      _this.setState({
        numPages: pdf.numPages
      });

      _this.chachePageInfo(pdf);

      (_this$document$curren = _this.document.current) == null ? void 0 : _this$document$curren.addEventListener('wheel', _this.handleZoom, false);
    };
    /**
     * Načte všechny strany dokumentu a do state uloží mapu s informacemi o pdf dokumentu. Výšky a rotace.
     *
     * @param {object} pdf
     * @return {void|null}
     */


    _this.chachePageInfo = function (pdf) {
      var promises = Array.from({
        length: pdf.numPages
      }, function (v, i) {
        return i + 1;
      }).map(function (pageNumber) {
        return pdf.getPage(pageNumber);
      });
      Promise.all(promises).then(function (values) {
        var _this$list;

        var rotationOffset = _this.state.rotationOffset;
        var pageCache = values.reduce(function (accpageCache, page) {
          var pageHeight = 0;
          var toatlOffset = page._pageInfo.rotate + rotationOffset;

          if (toatlOffset === 0 || toatlOffset === 180 || toatlOffset === 360) {
            pageHeight = page.view[3];
          } else {
            pageHeight = page.view[2];
          }

          accpageCache.set(page._pageIndex, {
            pageHeight: pageHeight * _this.state.scale,
            rotate: page.rotate
          });
          return accpageCache;
        }, new Map());

        _this.setState(function () {
          return {
            pageCache: pageCache
          };
        }); //kvůli zoomu resetujeme list, aby se znovu přereneroval.
        //jinak se strany překrývají, nebo se mezi nimi tvoří mezery


        (_this$list = _this.list) == null ? void 0 : _this$list.current.resetAfterIndex(0);
      });
    };
    /**
     * Zajišťuje zoom při skrolování ctrl + kolečko myši
     * Převezme scroll event a spočte/nastaví scale pro stránky pdf čtečky
     * @param event
     */


    _this.handleZoom = function (event) {
      if (event.ctrlKey) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.stopPropagation();

        _this.setZoomScale(event.deltaY);

        _this.chachePageInfo(_this.state.pdf);
      }
    };
    /**
     * Kalkulace zoomu, překlad směru scrollu na scale pro react-pdf
     *
     * @param deltaY
     */


    _this.zoomIn = function (zoomAmount) {
      _this.setState(function (state) {
        var oldScale = state.scale;
        var newScale = oldScale + zoomAmount;

        if (!(newScale > PdfViewer.MAX_SCALE) && !(newScale < PdfViewer.MIN_SCALE)) {
          return {
            scale: newScale
          };
        } else {
          return {
            scale: oldScale
          };
        }
      });
    };

    _this.zoomOut = function (zoomAmount) {
      _this.setState(function (state) {
        var oldScale = state.scale;
        var newScale = oldScale - zoomAmount;

        if (!(newScale > PdfViewer.MAX_SCALE) && !(newScale < PdfViewer.MIN_SCALE)) {
          return {
            scale: newScale
          };
        } else {
          return {
            scale: oldScale
          };
        }
      });
    };
    /**
     * Zobrazí následující dokument, pokud se akce provede vrátí true, pokue ne tak false.
     * Je ošetřeno přetečení
     * @returns {boolean}
     */


    _this.handleNext = function () {
      var _this$state = _this.state,
          documentIndex = _this$state.documentIndex,
          view = _this$state.view;

      if (view && documentIndex + 1 < view.documents.length) {
        _this.setState({
          documentIndex: documentIndex + 1
        });

        _this.resetState();

        return true;
      }

      return false;
    };
    /**
     * Zobrazí předchozí dokument, pokud se akce provede vrátí true, pokue ne tak false.
     * Je ošetřeno přetečení
     * @returns {boolean}
     */


    _this.handlePrev = function () {
      var documentIndex = _this.state.documentIndex;

      if (documentIndex > 0) {
        _this.setState({
          documentIndex: documentIndex - 1
        });

        _this.resetState();

        return true;
      }

      return false;
    };
    /**
     * Přesune prohlížečku na poslední stranu dokumentu
     */


    _this.handleLastPage = function () {
      //dojede na konec seznamu. funguje to i bez přesné výšky.
      _this.list.current._outerRef.scrollTop = 10000000;
    };
    /**
     * Přesune prohlížečku na první stranu dokumentu
     */


    _this.handleFirstPage = function () {
      _this.list.current._outerRef.scrollTop = 0;
    };
    /**
     * Otočí dokument po směru hodinových ručiček o 90 stupňů
     */


    _this.handleRotateRight = function () {
      _this.setState({
        rotationOffset: _this.getRotationRight()
      });

      _this.chachePageInfo(_this.state.pdf);
    };
    /**
     * Otočí dokument proti směru hodinových ručiček o 90 stupňů
     */


    _this.handleRotateLeft = function () {
      _this.setState({
        rotationOffset: _this.getRotationLeft()
      });

      _this.chachePageInfo(_this.state.pdf);
    };
    /**
     * Hlavní metoda pro tisk dokumentu. Vytiskne dokument podle prohlížeče.
     * !! Správné fungování tisku je jenom v prohlížeči Google Chrome.
     *
     * @param index
     */


    _this.handlePrint = function (index) {
      if (index != null && _this.state.view) {
        printJS(window.serverContextPath + _this.state.view.documents[index].url);
      }
    };
    /**
     * Přepne state fullscreen
     */


    _this.toggleFullscreenState = function () {
      _this.setState(function (state) {
        return {
          fullscreen: !state.fullscreen
        };
      });
    };
    /**
     * Zobrazí stránku ve fullscreen a pokud je ve fullscreen, tak zase vrátí zobrazení na výchozí.
     */


    _this.handleFullScreen = function () {
      var fullscreen = _this.state.fullscreen;

      _this.toggleFullscreenState();

      if (fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        var requestFullscreen = Element.prototype.requestFullscreen || Element.prototype.webkitRequestFullscreen || Element.prototype.mozRequestFullScreen || Element.prototype.msRequestFullscreen;
        requestFullscreen.call(document.body);
      }
    };
    /**
     * Vyresetuje state, použití při změně dokumentu
     */


    _this.resetState = function () {
      _this.setState({
        numPages: undefined,
        pageNum: 0,
        scale: _this.props.screenWidth || 1.6,
        pdf: null,
        pageCache: null,
        documentMeta: undefined
      }, _this.loadMeta);
    };
    /**
     * Načte metadata o dokumentu dle ID do state
     */


    _this.loadMeta = function () {
      var viewId = _this.props.viewId;
      var _this$state2 = _this.state,
          view = _this$state2.view,
          documentIndex = _this$state2.documentIndex;
      var documentId = documentIndex != null ? view.documents[documentIndex].id : null;

      if (documentId != null) {
        var apiPromise = PdfViewerApi.getDocumentMeta(viewId, documentId);
        apiPromise.then(function (documentMeta) {
          _this.setState({
            documentMeta: documentMeta
          });

          return documentMeta;
        });
        return apiPromise;
      }

      return Promise.reject();
    };
    /**
     * Zavírá dialog s pdfViewer
     * Pokud existuje prop onClose, tak jí zavoláme.
     */


    _this.handleClose = function () {
      var onClose = _this.props.onClose;

      if (onClose) {
        onClose();
      }
    };
    /**
     * Pokud nějaká ze stran vstoupí při scrollu do viewportu a je vidět, tak nastavíme její index jako aktuální stránku
     * @param pageNum
     */


    _this.handleOnPageEnter = function (pageNum) {
      _this.setState(function () {
        return {
          pageNum: pageNum
        };
      });
    };

    _this.getRotationOffset = function () {
      var rotationOffset = _this.state.rotationOffset;

      if (!rotationOffset) {
        return 0;
      }

      return rotationOffset;
    };

    _this.getRotate = function (index) {
      var _this$state3 = _this.state,
          rotationOffset = _this$state3.rotationOffset,
          pageCache = _this$state3.pageCache;

      if (!pageCache) {
        return null;
      }

      var page = pageCache.get(index);

      if (!page) {
        return null;
      }

      if (page.rotate == null) {
        return null;
      }

      return page.rotate + rotationOffset;
    };

    _this.handlePageMouseDown = function (event) {
      var onPageMouseDown = _this.props.onPageMouseDown;

      if (onPageMouseDown) {
        _this.getCursorPosition(event, onPageMouseDown);
      }
    };

    _this.handlePageMouseUp = function (event) {
      var onPageMouseUp = _this.props.onPageMouseUp;

      if (onPageMouseUp) {
        _this.getCursorPosition(event, onPageMouseUp);
      }
    };

    _this.handlePageMouseMove = function (event) {
      var onPageMouseMove = _this.props.onPageMouseMove;

      if (onPageMouseMove) {
        _this.getCursorPosition(event, onPageMouseMove);
      }
    };

    _this.getCursorPosition = function (event, callback) {
      if (event.target) {
        var canvas = event.target;
        var paddingLeft = parseFloat(window.getComputedStyle(canvas, null).getPropertyValue('padding-left'));
        var paddingTop = parseFloat(window.getComputedStyle(canvas, null).getPropertyValue('padding-top'));
        var marginLeft = parseFloat(window.getComputedStyle(canvas, null).getPropertyValue('margin-left'));
        var marginTop = parseFloat(window.getComputedStyle(canvas, null).getPropertyValue('margin-top'));
        var pageNumber = parseInt(canvas.parentNode.dataset.pageNumber);
        var rect = event.target.getBoundingClientRect();
        var x = event.clientX - rect.left - paddingLeft;
        var y = event.clientY - rect.top - paddingTop;
        var width = rect.width,
            height = rect.height;
        callback({
          pageNumber: pageNumber,
          x: x,
          y: y,
          width: width,
          height: height,
          paddingTop: paddingTop,
          paddingLeft: paddingLeft,
          marginLeft: marginLeft,
          marginTop: marginTop
        });
      }
    };

    _this.processRef = function (node) {
      if (node) {
        var canvas = node.getElementsByTagName('canvas')[0];

        if (canvas) {
          canvas.addEventListener('mouseup', _this.handlePageMouseUp);
          canvas.addEventListener('mousedown', _this.handlePageMouseDown);
          canvas.addEventListener('mousemove', _this.handlePageMouseMove);
        }
      }
    };
    /**
     * Render stránky pdf, obaleno komponentou Waypoint,
     * která se používá pro zjištění zda je stránka vidět
     * a podle toho se řídí index právě zobrazované stránky
     *
     * @param index
     * @param style
     * @returns {*}
     */


    _this.renderPage = function (_ref) {
      var index = _ref.index,
          style = _ref.style;
      var pageNumber = index + 1;

      var rotate = _this.getRotate(index);

      return React__default.createElement("div", {
        style: style,
        key: index
      }, React__default.createElement(Waypoint, {
        onEnter: function onEnter() {
          return _this.handleOnPageEnter(index);
        }
      }, React__default.createElement("div", {
        className: "pdf-page",
        key: index
      }, _this.renderPageLayer(pageNumber), React__default.createElement(PdfPage, {
        pageNumber: pageNumber,
        scale: _this.state.scale,
        rotate: rotate && rotate,
        renderTextLayer: false,
        inputRef: function inputRef(node) {
          return _this.processRef(node);
        }
      }))));
    };

    _this.renderPageLayer = function (pageNumber) {
      if (_this.props.renderPageLayer) {
        return _this.props.renderPageLayer(pageNumber);
      }

      return null;
    };
    /**
     * Spočte průměrnou výšku všech stránek kvůli
     * renderu seznamu a zobrazení scrollbaru v plném roszsahu
     * @returns {number}
     */


    _this.getAverageItemSize = function () {
      var pageCache = _this.state.pageCache;
      var sum = 0;
      var len = 0;

      for (var _iterator = _createForOfIteratorHelperLoose(pageCache.values()), _step; !(_step = _iterator()).done;) {
        var v = _step.value;
        sum = sum + v.pageHeight * _this.state.scale;
        len++;
      }

      return sum / len;
    };
    /**
     * Spustí stažení dokumentu
     */


    _this.triggerDownload = function () {
      var _this$state4 = _this.state,
          view = _this$state4.view,
          documentIndex = _this$state4.documentIndex;
      var documentUrl = documentIndex != null ? view.documents[documentIndex].url : null;

      if (documentUrl != null) {
        // chceme originální souboru stáhnout
        documentUrl = generateUrl(documentUrl, {
          originalFile: true
        });
      }

      window.open(window.serverContextPath + documentUrl);
    };
    /**
     * Vybrání konkrétního dokumentu ze seznamu.
     *
     * @param selectDocument dokument, který si přejeme vybrat
     * @returns {boolean}
     */


    _this.handleSelect = function (selectDocument) {
      var view = _this.state.view;

      if (selectDocument && view) {
        var documentIndex = indexById(view.documents, selectDocument);

        if (documentIndex != null) {
          _this.setState({
            documentIndex: documentIndex
          });

          _this.resetState();

          return true;
        } else {
          console.warn('Nebyl dohledán dokument ' + selectDocument + '');
        }
      }

      return false;
    };

    _this.renderPdfWrapper = function (height, noData, loading, error) {
      var _this$state5 = _this.state,
          view = _this$state5.view,
          numPages = _this$state5.numPages,
          documentIndex = _this$state5.documentIndex,
          pageCache = _this$state5.pageCache;
      var file = view != null && documentIndex != null ? window.serverContextPath + view.documents[documentIndex].url : null;
      console.log('height', isNaN(parseInt(height)));
      return React__default.createElement("div", {
        className: 'pdf-wrapper'
      }, view && React__default.createElement(Document, {
        noData: noData || 'Žádný dokument',
        loading: loading || React__default.createElement("div", {
          className: 'document-loading'
        }, React__default.createElement(Loader, null, "Na\u010D\xEDt\xE1 se dokument")),
        error: error || React__default.createElement("div", {
          className: 'document-error'
        }, React__default.createElement("div", null, React__default.createElement("div", {
          className: "warning"
        }, "Dokument se nepoda\u0159ilo na\u010D\xEDst"), React__default.createElement("div", {
          className: "reason"
        }, "Mo\u017En\xE9 d\u016Fvody selh\xE1n\xED:", React__default.createElement("ul", null, React__default.createElement("li", null, "Dokument je po\u0161kozen"), React__default.createElement("li", null, "Nem\xE1te dostate\u010Dn\xE1 opr\xE1vn\u011Bn\xED pro zobrazen\xED dokumentu"), React__default.createElement("li", null, "Dokument ji\u017E nen\xED k dispozici"))))),
        inputRef: _this.document,
        file: file,
        onLoadSuccess: _this.onDocumentLoad
      }, React__default.createElement("div", null, pageCache && React__default.createElement(VariableSizeList, {
        ref: _this.list,
        estimatedItemSize: _this.getAverageItemSize(),
        height: isNaN(parseInt(height)) ? 800 : parseInt(height),
        itemCount: numPages,
        itemSize: function itemSize(index) {
          return pageCache && pageCache.get(index) ? pageCache.get(index).pageHeight : 0;
        },
        width: '100%'
      }, _this.renderPage))));
    };

    _this.refreshPDF = function () {
      var oldDocIndex = _this.state.documentIndex;

      _this.setState({
        documentIndex: null
      });

      _this.setState({
        documentIndex: oldDocIndex
      });
    };
    /**
     * Propsy pro render akcí z parent komponenty
     *
     * @returns {{next: void, prev: void, back: void}}
     */


    _this.getCallbackActions = function () {
      return {
        refresh: _this.loadMeta,
        refreshPDF: _this.refreshPDF,
        next: _this.handleNext,
        prev: _this.handlePrev,
        close: _this.handleClose,
        select: _this.handleSelect,
        download: _this.triggerDownload,
        print: _this.handlePrint,
        firstPage: _this.handleFirstPage,
        lastPage: _this.handleLastPage,
        rotateRight: _this.handleRotateRight,
        rotateLeft: _this.handleRotateLeft,
        fullScreen: _this.handleFullScreen,
        setZoom: _this.handleZoom,
        zoomIn: _this.zoomIn,
        zoomOut: _this.zoomOut
      };
    };

    _this.getCallbackState = function () {
      return {
        zoom: _this.state.scale,
        totalPageCount: _this.state.numPages,
        actualPage: _this.state.pageNum,
        view: _this.state.view,
        documentIndex: _this.state.documentIndex,
        documentMeta: _this.state.documentMeta,
        pageCache: _this.state.pageCache,
        fullscreen: _this.state.fullscreen
      };
    };

    _this.state = {
      view: undefined,
      //objekt ze serveru s pdf dokumenty a informacemi o nich
      numPages: undefined,
      //celkový počet stran
      documentIndex: 0,
      //index právě zobrazeného pdf dokumentu
      scale: _this.props.screenWidth || 1.6,
      //přiblížení stran pdf dokumentu
      pageNum: 0,
      //inex právě zobrazované strany pdf dokumentu
      pageCache: null,
      //cache s informacemi o stránkách, velikost, rotace
      pdf: null,
      //reference na samotné pdf.js
      rotationOffset: 0,
      //delta rotace
      fullscreen: false
    };
    _this.document = React__default.createRef(); //ref na cel pdf dokument

    _this.list = React__default.createRef(); //ref na react-window list (lazy load stran)

    return _this;
  }

  var _proto = PdfViewer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.unlisten = this.props.history.listen(function (location, action) {
      _this2.handleClose();
    });
    PdfViewerApi.getView(this.props.viewId).then(function (view) {
      var documentIndex = _this2.state.documentIndex;
      var selectDocument = _this2.props.selectDocument;

      if (selectDocument) {
        var documentIndexFound = indexById(view.documents, selectDocument);

        if (documentIndexFound) {
          documentIndex = documentIndexFound;
        } else {
          console.warn('Nebyl dohledán dokument' + selectDocument + ', bude vybrán první');
        }
      }

      _this2.setState({
        view: view,
        documentIndex: documentIndex
      }, _this2.loadMeta);
    });
    window.addEventListener('keyup', this.handleKeyUp);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this$unlisten;

    PdfViewerApi.removeView(this.props.viewId);
    (_this$unlisten = this.unlisten) == null ? void 0 : _this$unlisten.call(this);
    window.removeEventListener('keyup', this.handleKeyUp);
    window.removeEventListener('wheel', this.handleZoom);
  };

  _proto.setZoomScale = function setZoomScale(deltaY) {
    var zoomAmount = 0.1;
    var direction = deltaY > 0;

    if (direction) {
      this.zoomOut(zoomAmount);
    } else {
      this.zoomIn(zoomAmount);
    }
  }
  /**
   * Vrátí úhel o který se otočí PDF do leva na základě současného úhulu otočení
   * @returns {number}
   */
  ;

  _proto.getRotationLeft = function getRotationLeft() {
    switch (this.state.rotationOffset) {
      case 0:
        return 270;

      case 270:
        return 180;

      case 180:
        return 90;

      case 90:
        return 0;
    }

    return 0;
  }
  /**
   * Vrátí úhel o který se otočí PDF do prava na základě současného úhulu otočení
   * @returns {number}
   */
  ;

  _proto.getRotationRight = function getRotationRight() {
    switch (this.state.rotationOffset) {
      case 0:
        return 90;

      case 90:
        return 180;

      case 180:
        return 270;

      case 270:
        return 0;
    }

    return 0;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        render = _this$props.render,
        otherProps = _objectWithoutPropertiesLoose(_this$props, ["render", "initialDocument", "onClose", "screenWidth"]);

    var renderContent = render({
      actions: this.getCallbackActions(),
      state: this.getCallbackState(),
      pdfWrapper: this.renderPdfWrapper
    });
    return React__default.createElement("div", Object.assign({}, otherProps), renderContent);
  };

  return PdfViewer;
}(Component);

PdfViewer.MAX_SCALE = 2.7;
PdfViewer.MIN_SCALE = 0.3;
PdfViewer.VIEW_MODE = {
  SIDE: 'SIDE',
  HORIZONTAL: 'HORIZONTAL'
};
var PdfViewer$1 = /*#__PURE__*/withRouter(PdfViewer);

/**
 * Robrazit toastr..
 *
 * @param error chyba
 * @param defaultIntent pokud není určen, bude použit tento
 * @param apiIntent intent z api, nemusí být uveden, pak je použit defaultIntent
 */

var showToastr = function showToastr(error, defaultIntent, apiIntent) {
  var label = error.messageTitle;
  var finalIntent = apiIntent;

  if (apiIntent != ApiErrorIntent.DANGER && apiIntent != ApiErrorIntent.WARNING) {
    finalIntent = defaultIntent;
  }

  var showToastr;
  var toastrProps = {};

  switch (finalIntent) {
    case ApiErrorIntent.DANGER:
      showToastr = toastr.error;
      toastrProps.timeOut = 0;
      toastrProps.removeOnHover = false;
      break;

    case ApiErrorIntent.WARNING:
      showToastr = toastr.warning;
      toastrProps.timeOut = 0;
      toastrProps.removeOnHover = false;
      break;
  }

  if (error.messageDesc) {
    toastrProps.timeOut = 0;
    toastrProps.removeOnHover = false; // @ts-ignore

    toastrProps.component = React__default.createElement("div", null, error.messageDesc);
  }

  showToastr(label, toastrProps);
};

var legacyStandardErrorInterceptor = function legacyStandardErrorInterceptor(_error) {
  if (_error.stack && _error.message) {
    console.error(_error);
    toastr.error(_error.message);
    return Promise.reject(_error);
  } else {
    var error = _error;

    switch (error.status) {
      case 422:
        {
          throw new SubmissionError(error.formErrors);
        }

      default:
        {
          showToastr(error, ApiErrorIntent.DANGER, error.errorIntent);
          return Promise.reject(error);
        }
    }
  }
};

var ReactWidgetsLocaleProvider = function ReactWidgetsLocaleProvider(_ref) {
  var children = _ref.children;
  useEffect(function () {
    moment.locale('cs');
  });
  return createElement(Localization, {
    date: new MomentLocalizer(moment),
    messages: {
      moveToday: 'Dnes',
      moveForward: 'Vpřed',
      moveBack: 'Zpět'
    }
  }, children);
};

export { AboutApp, AbstractModal, AbstractReactComponent, ActionsRow, AdminPage$1 as AdminPage, AdresaForm$1 as AdresaForm, AdvancedListActions, list as AdvancedListReducer, AdvancedPagination$1 as AdvancedPagination, AppNavbarWrapper$1 as AppNavbarWrapper, areaGroupReducer as AreaGroupReducer, BaseAppWrapper, Base as BaseField, CachingLoader, CardItems, CompositeFocusBlur, ContentPagination, ContextMenu, CountButton, CurrencyValue, DetailActions, DetailLeftIcon, detail as DetailReducer, DetailValue, DocIndexField, ErrorApi, FAIcon, Fetch, FieldForm, FieldGrid, Filter, FixedDropDownButton, FocusableReactComponent, CustomForm as Form, FormActions, FormBody, HorizontalLoader, FAIcon as Icon, Image, InfiniteCheckListActions, list$2 as InfiniteCheckListReducer, InfiniteListActions, list$1 as InfiniteListReducer, InfiniteScroll, JsonFetch, FieldLabel as Label, ListComponent$1 as ListComponent, Loader, LoginForm, Icon as MCIcon, ModalActions, ModalDialog$1 as ModalDialog, modalDialog as ModalReducer, NavIconText, PageButton, PageContent, PageWrapper, ParamsFetch, PdfPage, PdfViewer$1 as PdfViewer, ReactWidgetsLocaleProvider, ReduxSectionForm, ScrollableCard, SharedActions, shared as SharedReducer, SimpleCheckListActions, list$4 as SimpleCheckListReducer, SimpleListActions, list$3 as SimpleListReducer, SouborLink, SpisCard, StatusBagde, StoreUtils, TableCard, TimeLine, Translate, Utils2 as Utils, ValidationErrors, apiErrorsTransform, index$1 as appbase, authActions, autofillReduxForm, index$2 as box, commons, index$3 as contextMenu, dateToLocalUTC, defaultImport, index$4 as detail, toExport as ff, Fields as field, filterObjectsByPropertyFulltext, index$8 as form, formatCurrency, formatDate, formatDateTime, formatTime, index$9 as frame, index$a as games, generateUrl, getDeepData, getMapFromList, getRegisteredFields, getScrollbarWidth, getSetFromIdsList, highlightText, i18n, index$5 as icon, indexById, index$c as layout, legacyStandardErrorInterceptor, index$6 as list, localStorageWrapper, localUTCToDate, localUTCToDateTime, localUTCToTime, index$d as mapio, mergeAddons, index$b as modal, index$e as navbar, objectById, index$f as panel, processAreaStores, removeDate, removeEmptyObjects, removeTime, renderFieldWithAddons, requireFields, setInputFocus, index$g as shared, storeFromArea, index$h as subjekt, subjektFormatter, subscribeToAreaChanges, index as utils, webDavOpen };
//# sourceMappingURL=mc-legacy.esm.js.map
